//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AccountingGeneratorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param statementOfAccountId (optional) 
     * @return Success
     */
    generateStatementOfAccountPdf(statementOfAccountId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/AccountingGenerator/GenerateStatementOfAccountPdf?";
        if (statementOfAccountId === null)
            throw new globalThis.Error("The parameter 'statementOfAccountId' cannot be null.");
        else if (statementOfAccountId !== undefined)
            url_ += "statementOfAccountId=" + encodeURIComponent("" + statementOfAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateStatementOfAccountPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateStatementOfAccountPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateStatementOfAccountPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param purchaseOrderId (optional) 
     * @return Success
     */
    generatePurchaseOrderPdf(purchaseOrderId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/AccountingGenerator/GeneratePurchaseOrderPdf?";
        if (purchaseOrderId === null)
            throw new globalThis.Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePurchaseOrderPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePurchaseOrderPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGeneratePurchaseOrderPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AgentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userIdFilter: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AgentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Agent/GetAll?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AgentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<AgentDto> {
        let url_ = this.baseUrl + "/api/services/app/Agent/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AgentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAgentDto | undefined): Observable<AgentDto> {
        let url_ = this.baseUrl + "/api/services/app/Agent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AgentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAgentDto | undefined): Observable<AgentDto> {
        let url_ = this.baseUrl + "/api/services/app/Agent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AgentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agent/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deletionReason (optional) 
     * @return Success
     */
    deleteWithReason(id: string, deletionReason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agent/DeleteWithReason?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deletionReason === null)
            throw new globalThis.Error("The parameter 'deletionReason' cannot be null.");
        else if (deletionReason !== undefined)
            url_ += "DeletionReason=" + encodeURIComponent("" + deletionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWithReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWithReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWithReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTopAgents(): Observable<AgentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Agent/GetTopAgents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopAgents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopAgents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentDto[]>;
        }));
    }

    protected processGetTopAgents(response: HttpResponseBase): Observable<AgentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AgentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deActivate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agent/DeActivate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agent/Activate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AnalyticsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getTotalSales(from: moment.Moment | undefined, to: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Analytics/GetTotalSales?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalSales(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getTotalPurchases(from: moment.Moment | undefined, to: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Analytics/GetTotalPurchases?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalPurchases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalPurchases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalPurchases(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getNetProfit(from: moment.Moment | undefined, to: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Analytics/GetNetProfit?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNetProfit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNetProfit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNetProfit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getTotalBookingInProgress(from: moment.Moment | undefined, to: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Analytics/GetTotalBookingInProgress?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalBookingInProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalBookingInProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalBookingInProgress(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getTotalBookingUnpaid(from: moment.Moment | undefined, to: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Analytics/GetTotalBookingUnpaid?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalBookingUnpaid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalBookingUnpaid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalBookingUnpaid(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getTotalBookingComplete(from: moment.Moment | undefined, to: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Analytics/GetTotalBookingComplete?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalBookingComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalBookingComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalBookingComplete(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRecentTransactions(): Observable<AccountingTransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Analytics/GetRecentTransactions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountingTransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountingTransactionDto[]>;
        }));
    }

    protected processGetRecentTransactions(response: HttpResponseBase): Observable<AccountingTransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AccountingTransactionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUpcomingDueDates(): Observable<AccountingTransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Analytics/GetUpcomingDueDates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpcomingDueDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpcomingDueDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountingTransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountingTransactionDto[]>;
        }));
    }

    protected processGetUpcomingDueDates(response: HttpResponseBase): Observable<AccountingTransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AccountingTransactionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBookingActivities(): Observable<BookingActivitiesDto> {
        let url_ = this.baseUrl + "/api/services/app/Analytics/GetBookingActivities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingActivitiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingActivitiesDto>;
        }));
    }

    protected processGetBookingActivities(response: HttpResponseBase): Observable<BookingActivitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingActivitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param count (optional) 
     * @return Success
     */
    getTopPerformers(count: number | undefined): Observable<TopPerformersDto> {
        let url_ = this.baseUrl + "/api/services/app/Analytics/GetTopPerformers?";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopPerformers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopPerformers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopPerformersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopPerformersDto>;
        }));
    }

    protected processGetTopPerformers(response: HttpResponseBase): Observable<TopPerformersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopPerformersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AppSettingOptionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userIdFilter: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AppSettingOptionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AppSettingOptions/GetAll?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingOptionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingOptionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AppSettingOptionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingOptionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param settingId (optional) 
     * @return Success
     */
    getBySettingsId(settingId: string | undefined): Observable<AppSettingOptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AppSettingOptions/GetBySettingsId?";
        if (settingId === null)
            throw new globalThis.Error("The parameter 'settingId' cannot be null.");
        else if (settingId !== undefined)
            url_ += "settingId=" + encodeURIComponent("" + settingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySettingsId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySettingsId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingOptionDto[]>;
        }));
    }

    protected processGetBySettingsId(response: HttpResponseBase): Observable<AppSettingOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AppSettingOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param settingName (optional) 
     * @return Success
     */
    getBySettingsName(settingName: string | undefined): Observable<AppSettingOptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AppSettingOptions/GetBySettingsName?";
        if (settingName === null)
            throw new globalThis.Error("The parameter 'settingName' cannot be null.");
        else if (settingName !== undefined)
            url_ += "settingName=" + encodeURIComponent("" + settingName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySettingsName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySettingsName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingOptionDto[]>;
        }));
    }

    protected processGetBySettingsName(response: HttpResponseBase): Observable<AppSettingOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AppSettingOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<AppSettingOptionDto> {
        let url_ = this.baseUrl + "/api/services/app/AppSettingOptions/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingOptionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AppSettingOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingOptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAppSettingOptionDto | undefined): Observable<AppSettingOptionDto> {
        let url_ = this.baseUrl + "/api/services/app/AppSettingOptions/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingOptionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AppSettingOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingOptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAppSettingOptionDto | undefined): Observable<AppSettingOptionDto> {
        let url_ = this.baseUrl + "/api/services/app/AppSettingOptions/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingOptionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AppSettingOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingOptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppSettingOptions/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AppSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userIdFilter: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AppSettingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AppSettings/GetAll?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AppSettingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<AppSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/AppSettings/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AppSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAppSettingDto | undefined): Observable<AppSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/AppSettings/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AppSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAppSettingDto | undefined): Observable<AppSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/AppSettings/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AppSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deActivate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppSettings/DeActivate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppSettings/Activate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppSettings/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @return Success
     */
    get(userIdFilter: number | undefined, keyword: string | undefined, sortColumn: string | undefined, sortOrder: string | undefined, page: number | undefined, size: number | undefined): Observable<PagedAuditLogsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLogs/Get?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sortColumn === null)
            throw new globalThis.Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedAuditLogsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedAuditLogsResultDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PagedAuditLogsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedAuditLogsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @return Success
     */
    getAuditLogs(userIdFilter: number | undefined, keyword: string | undefined, sortColumn: string | undefined, sortOrder: string | undefined, page: number | undefined, size: number | undefined): Observable<PagedAuditLogsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLogs/GetAuditLogs?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sortColumn === null)
            throw new globalThis.Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedAuditLogsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedAuditLogsResultDto>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedAuditLogsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedAuditLogsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param methodName (optional) 
     * @return Success
     */
    getMethodNameType(methodName: string | undefined): Observable<AuditLogsType> {
        let url_ = this.baseUrl + "/api/services/app/AuditLogs/GetMethodNameType?";
        if (methodName === null)
            throw new globalThis.Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "methodName=" + encodeURIComponent("" + methodName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMethodNameType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMethodNameType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditLogsType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditLogsType>;
        }));
    }

    protected processGetMethodNameType(response: HttpResponseBase): Observable<AuditLogsType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceName (optional) 
     * @return Success
     */
    getServiceNameType(serviceName: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AuditLogs/GetServiceNameType?";
        if (serviceName === null)
            throw new globalThis.Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "serviceName=" + encodeURIComponent("" + serviceName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceNameType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceNameType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetServiceNameType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BookingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userIdFilter: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BookingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Booking/GetAll?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BookingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<BookingDto> {
        let url_ = this.baseUrl + "/api/services/app/Booking/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateBookingDto | undefined): Observable<BookingDto> {
        let url_ = this.baseUrl + "/api/services/app/Booking/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateBookingDto | undefined): Observable<BookingDto> {
        let url_ = this.baseUrl + "/api/services/app/Booking/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Booking/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deletionReason (optional) 
     * @return Success
     */
    deleteWithReason(id: string, deletionReason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Booking/DeleteWithReason?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deletionReason === null)
            throw new globalThis.Error("The parameter 'deletionReason' cannot be null.");
        else if (deletionReason !== undefined)
            url_ += "DeletionReason=" + encodeURIComponent("" + deletionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWithReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWithReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWithReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param typeId (optional) 
     * @return Success
     */
    getBookingByTypeId(id: string | undefined, typeId: string | undefined): Observable<BookingDto> {
        let url_ = this.baseUrl + "/api/services/app/Booking/GetBookingByTypeId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingByTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingByTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDto>;
        }));
    }

    protected processGetBookingByTypeId(response: HttpResponseBase): Observable<BookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BookingGeneratorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param bookingId (optional) 
     * @param typeId (optional) 
     * @return Success
     */
    generateTravelBookingConfirmationPdf(bookingId: string | undefined, typeId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/BookingGenerator/GenerateTravelBookingConfirmationPdf?";
        if (bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateTravelBookingConfirmationPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateTravelBookingConfirmationPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateTravelBookingConfirmationPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingId (optional) 
     * @param typeId (optional) 
     * @return Success
     */
    generateTripAcknowledgementPdf(bookingId: string | undefined, typeId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/BookingGenerator/GenerateTripAcknowledgementPdf?";
        if (bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateTripAcknowledgementPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateTripAcknowledgementPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateTripAcknowledgementPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingId (optional) 
     * @param typeId (optional) 
     * @return Success
     */
    generateBookingRegistrationPdf(bookingId: string | undefined, typeId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/BookingGenerator/GenerateBookingRegistrationPdf?";
        if (bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateBookingRegistrationPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateBookingRegistrationPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateBookingRegistrationPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BookingModuleSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getBookingModuleSettings(): Observable<BookingModuleSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingModuleSettings/GetBookingModuleSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingModuleSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingModuleSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingModuleSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingModuleSettingsDto>;
        }));
    }

    protected processGetBookingModuleSettings(response: HttpResponseBase): Observable<BookingModuleSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingModuleSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateBookingModuleSettings(body: CreateOrUpdateBookingModuleSettingsDto | undefined): Observable<BookingModuleSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingModuleSettings/CreateOrUpdateBookingModuleSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateBookingModuleSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateBookingModuleSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingModuleSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingModuleSettingsDto>;
        }));
    }

    protected processCreateOrUpdateBookingModuleSettings(response: HttpResponseBase): Observable<BookingModuleSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingModuleSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBookingModuleSettingsContent(): Observable<BookingModuleSettingsContentDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingModuleSettings/GetBookingModuleSettingsContent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingModuleSettingsContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingModuleSettingsContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingModuleSettingsContentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingModuleSettingsContentDto>;
        }));
    }

    protected processGetBookingModuleSettingsContent(response: HttpResponseBase): Observable<BookingModuleSettingsContentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingModuleSettingsContentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BookingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new booking (requires authentication) - HYBRID: Real CustomerBooking + Static tour data
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTourBookingDto | undefined): Observable<TourBookingConfirmationDto> {
        let url_ = this.baseUrl + "/api/public/bookings/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourBookingConfirmationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourBookingConfirmationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TourBookingConfirmationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourBookingConfirmationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user's bookings (for dashboard) - HYBRID: Real CustomerBooking + Static tour data
     * @return Success
     */
    user(userId: number): Observable<TourBookingConfirmationDto[]> {
        let url_ = this.baseUrl + "/api/public/bookings/user/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourBookingConfirmationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourBookingConfirmationDto[]>;
        }));
    }

    protected processUser(response: HttpResponseBase): Observable<TourBookingConfirmationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TourBookingConfirmationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Book as guest (creates account and booking in one step) - HYBRID: Real CustomerBooking + Static tour data
     * @param body (optional) 
     * @return Success
     */
    guest(body: CreateTourBookingDto | undefined): Observable<TourBookingConfirmationDto> {
        let url_ = this.baseUrl + "/api/public/bookings/guest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGuest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGuest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourBookingConfirmationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourBookingConfirmationDto>;
        }));
    }

    protected processGuest(response: HttpResponseBase): Observable<TourBookingConfirmationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourBookingConfirmationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create or get existing customer booking draft (supports both authenticated and anonymous users)
     * @param sessionId (optional) 
     * @param body (optional) 
     * @return Success
     */
    draftPost(sessionId: string | undefined, body: CreateCustomerBookingDto | undefined): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/public/bookings/draft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "sessionId": sessionId !== undefined && sessionId !== null ? "" + sessionId : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraftPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraftPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processDraftPost(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update existing draft booking
     * @param body (optional) 
     * @return Success
     */
    draftPut(body: UpdateCustomerBookingDto | undefined): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/public/bookings/draft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraftPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraftPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processDraftPut(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get draft booking by ID
     * @return Success
     */
    draftGet(id: string): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/public/bookings/draft/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraftGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraftGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processDraftGet(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete/abandon a draft booking
     * @return Success
     */
    draftDelete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/public/bookings/draft/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraftDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraftDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDraftDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PublicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get booking details by ID (requires authentication) - HYBRID: Real CustomerBooking + Static tour data
     * @return Success
     */
    bookings(id: string): Observable<TourBookingConfirmationDto> {
        let url_ = this.baseUrl + "/api/public/bookings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourBookingConfirmationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourBookingConfirmationDto>;
        }));
    }

    protected processBookings(response: HttpResponseBase): Observable<TourBookingConfirmationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourBookingConfirmationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paymentReceiptsPost(body: CreateCustomerPaymentReceiptDto | undefined): Observable<PublicCustomerPaymentReceiptDto> {
        let url_ = this.baseUrl + "/api/public/payment-receipts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentReceiptsPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentReceiptsPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicCustomerPaymentReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicCustomerPaymentReceiptDto>;
        }));
    }

    protected processPaymentReceiptsPost(response: HttpResponseBase): Observable<PublicCustomerPaymentReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicCustomerPaymentReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    paymentReceiptsGet(id: string): Observable<PublicCustomerPaymentReceiptDto> {
        let url_ = this.baseUrl + "/api/public/payment-receipts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentReceiptsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentReceiptsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicCustomerPaymentReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicCustomerPaymentReceiptDto>;
        }));
    }

    protected processPaymentReceiptsGet(response: HttpResponseBase): Observable<PublicCustomerPaymentReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicCustomerPaymentReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get tour detail by ID - Now uses real Package entity data with fallback to static data
    Phase 3D: Dynamic tour data integration complete
     * @return Success
     */
    tours(id: string): Observable<TourDetailDto> {
        let url_ = this.baseUrl + "/api/public/tours/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourDetailDto>;
        }));
    }

    protected processTours(response: HttpResponseBase): Observable<TourDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DraftServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Progress to next step with auto-save
     * @param body (optional) 
     * @return Success
     */
    progress(body: ProgressStepDto | undefined): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/public/bookings/draft/progress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processProgress(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recover session - find active drafts for user/session
     * @param sessionId (optional) 
     * @param body (optional) 
     * @return Success
     */
    recover(sessionId: string | undefined, body: SessionRecoveryRequestDto | undefined): Observable<CustomerBookingDto[]> {
        let url_ = this.baseUrl + "/api/public/bookings/draft/recover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "sessionId": sessionId !== undefined && sessionId !== null ? "" + sessionId : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto[]>;
        }));
    }

    protected processRecover(response: HttpResponseBase): Observable<CustomerBookingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerBookingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Finalize draft booking (convert to real booking with pending review status)
     * @param body (optional) 
     * @return Success
     */
    finalize(body: FinalizeCustomerBookingDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/public/bookings/draft/finalize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFinalize(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all draft bookings for current user
     * @return Success
     */
    my(): Observable<CustomerBookingDto[]> {
        let url_ = this.baseUrl + "/api/public/bookings/draft/my";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto[]>;
        }));
    }

    protected processMy(response: HttpResponseBase): Observable<CustomerBookingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerBookingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Touch/update last accessed time for a draft
     * @return Success
     */
    touch(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/public/bookings/draft/{id}/touch";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTouch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTouch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTouch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if user has existing draft for a specific tour
     * @param sessionId (optional) 
     * @return Success
     */
    existing(tourId: number, sessionId: string | undefined): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/public/bookings/draft/existing/{tourId}";
        if (tourId === undefined || tourId === null)
            throw new globalThis.Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "sessionId": sessionId !== undefined && sessionId !== null ? "" + sessionId : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processExisting(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BookingTransactionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param bookingNoFilter (optional) 
     * @param typeIdFilter (optional) 
     * @param statusIdFilter (optional) 
     * @param overviewFilter (optional) 
     * @param addedByFilter (optional) 
     * @param createdFrom (optional) 
     * @param createdTo (optional) 
     * @param minClients (optional) 
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @return Success
     */
    getAll(userIdFilter: number | undefined, keyword: string | undefined, bookingNoFilter: string | undefined, typeIdFilter: string | undefined, statusIdFilter: string | undefined, overviewFilter: string | undefined, addedByFilter: string | undefined, createdFrom: moment.Moment | undefined, createdTo: moment.Moment | undefined, minClients: number | undefined, sortColumn: string | undefined, sortOrder: string | undefined, page: number | undefined, size: number | undefined): Observable<PagedBookingTransactionResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingTransaction/GetAll?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (bookingNoFilter === null)
            throw new globalThis.Error("The parameter 'bookingNoFilter' cannot be null.");
        else if (bookingNoFilter !== undefined)
            url_ += "BookingNoFilter=" + encodeURIComponent("" + bookingNoFilter) + "&";
        if (typeIdFilter === null)
            throw new globalThis.Error("The parameter 'typeIdFilter' cannot be null.");
        else if (typeIdFilter !== undefined)
            url_ += "TypeIdFilter=" + encodeURIComponent("" + typeIdFilter) + "&";
        if (statusIdFilter === null)
            throw new globalThis.Error("The parameter 'statusIdFilter' cannot be null.");
        else if (statusIdFilter !== undefined)
            url_ += "StatusIdFilter=" + encodeURIComponent("" + statusIdFilter) + "&";
        if (overviewFilter === null)
            throw new globalThis.Error("The parameter 'overviewFilter' cannot be null.");
        else if (overviewFilter !== undefined)
            url_ += "OverviewFilter=" + encodeURIComponent("" + overviewFilter) + "&";
        if (addedByFilter === null)
            throw new globalThis.Error("The parameter 'addedByFilter' cannot be null.");
        else if (addedByFilter !== undefined)
            url_ += "AddedByFilter=" + encodeURIComponent("" + addedByFilter) + "&";
        if (createdFrom === null)
            throw new globalThis.Error("The parameter 'createdFrom' cannot be null.");
        else if (createdFrom !== undefined)
            url_ += "CreatedFrom=" + encodeURIComponent(createdFrom ? "" + createdFrom.toISOString() : "") + "&";
        if (createdTo === null)
            throw new globalThis.Error("The parameter 'createdTo' cannot be null.");
        else if (createdTo !== undefined)
            url_ += "CreatedTo=" + encodeURIComponent(createdTo ? "" + createdTo.toISOString() : "") + "&";
        if (minClients === null)
            throw new globalThis.Error("The parameter 'minClients' cannot be null.");
        else if (minClients !== undefined)
            url_ += "MinClients=" + encodeURIComponent("" + minClients) + "&";
        if (sortColumn === null)
            throw new globalThis.Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedBookingTransactionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedBookingTransactionResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedBookingTransactionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedBookingTransactionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param travelId (optional) 
     * @return Success
     */
    getTotalBookedPassengerByPackageTravel(travelId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BookingTransaction/GetTotalBookedPassengerByPackageTravel?";
        if (travelId === null)
            throw new globalThis.Error("The parameter 'travelId' cannot be null.");
        else if (travelId !== undefined)
            url_ += "travelId=" + encodeURIComponent("" + travelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalBookedPassengerByPackageTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalBookedPassengerByPackageTravel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalBookedPassengerByPackageTravel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param passengerId (optional) 
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param bookingNoFilter (optional) 
     * @param typeIdFilter (optional) 
     * @param statusIdFilter (optional) 
     * @param overviewFilter (optional) 
     * @param addedByFilter (optional) 
     * @param createdFrom (optional) 
     * @param createdTo (optional) 
     * @param minClients (optional) 
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @return Success
     */
    getPassengerHistory(passengerId: string | undefined, userIdFilter: number | undefined, keyword: string | undefined, bookingNoFilter: string | undefined, typeIdFilter: string | undefined, statusIdFilter: string | undefined, overviewFilter: string | undefined, addedByFilter: string | undefined, createdFrom: moment.Moment | undefined, createdTo: moment.Moment | undefined, minClients: number | undefined, sortColumn: string | undefined, sortOrder: string | undefined, page: number | undefined, size: number | undefined): Observable<PagedBookingTransactionResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingTransaction/GetPassengerHistory?";
        if (passengerId === null)
            throw new globalThis.Error("The parameter 'passengerId' cannot be null.");
        else if (passengerId !== undefined)
            url_ += "PassengerId=" + encodeURIComponent("" + passengerId) + "&";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (bookingNoFilter === null)
            throw new globalThis.Error("The parameter 'bookingNoFilter' cannot be null.");
        else if (bookingNoFilter !== undefined)
            url_ += "BookingNoFilter=" + encodeURIComponent("" + bookingNoFilter) + "&";
        if (typeIdFilter === null)
            throw new globalThis.Error("The parameter 'typeIdFilter' cannot be null.");
        else if (typeIdFilter !== undefined)
            url_ += "TypeIdFilter=" + encodeURIComponent("" + typeIdFilter) + "&";
        if (statusIdFilter === null)
            throw new globalThis.Error("The parameter 'statusIdFilter' cannot be null.");
        else if (statusIdFilter !== undefined)
            url_ += "StatusIdFilter=" + encodeURIComponent("" + statusIdFilter) + "&";
        if (overviewFilter === null)
            throw new globalThis.Error("The parameter 'overviewFilter' cannot be null.");
        else if (overviewFilter !== undefined)
            url_ += "OverviewFilter=" + encodeURIComponent("" + overviewFilter) + "&";
        if (addedByFilter === null)
            throw new globalThis.Error("The parameter 'addedByFilter' cannot be null.");
        else if (addedByFilter !== undefined)
            url_ += "AddedByFilter=" + encodeURIComponent("" + addedByFilter) + "&";
        if (createdFrom === null)
            throw new globalThis.Error("The parameter 'createdFrom' cannot be null.");
        else if (createdFrom !== undefined)
            url_ += "CreatedFrom=" + encodeURIComponent(createdFrom ? "" + createdFrom.toISOString() : "") + "&";
        if (createdTo === null)
            throw new globalThis.Error("The parameter 'createdTo' cannot be null.");
        else if (createdTo !== undefined)
            url_ += "CreatedTo=" + encodeURIComponent(createdTo ? "" + createdTo.toISOString() : "") + "&";
        if (minClients === null)
            throw new globalThis.Error("The parameter 'minClients' cannot be null.");
        else if (minClients !== undefined)
            url_ += "MinClients=" + encodeURIComponent("" + minClients) + "&";
        if (sortColumn === null)
            throw new globalThis.Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPassengerHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPassengerHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedBookingTransactionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedBookingTransactionResultDto>;
        }));
    }

    protected processGetPassengerHistory(response: HttpResponseBase): Observable<PagedBookingTransactionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedBookingTransactionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<BookingTransactionOverviewDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingTransaction/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingTransactionOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingTransactionOverviewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BookingTransactionOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingTransactionOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingId (optional) 
     * @return Success
     */
    getBookingClients(bookingId: string | undefined): Observable<MinBookingClientDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BookingTransaction/GetBookingClients?";
        if (bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinBookingClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinBookingClientDto[]>;
        }));
    }

    protected processGetBookingClients(response: HttpResponseBase): Observable<MinBookingClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MinBookingClientDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingId (optional) 
     * @return Success
     */
    getBookingAttachments(bookingId: string | undefined): Observable<MinBookingAttachmentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BookingTransaction/GetBookingAttachments?";
        if (bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinBookingAttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinBookingAttachmentDto[]>;
        }));
    }

    protected processGetBookingAttachments(response: HttpResponseBase): Observable<MinBookingAttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MinBookingAttachmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param packageId (optional) 
     * @return Success
     */
    getPackageRooms(packageId: string | undefined): Observable<MinProcessedPackageRoomDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BookingTransaction/GetPackageRooms?";
        if (packageId === null)
            throw new globalThis.Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageRooms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageRooms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinProcessedPackageRoomDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinProcessedPackageRoomDto[]>;
        }));
    }

    protected processGetPackageRooms(response: HttpResponseBase): Observable<MinProcessedPackageRoomDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MinProcessedPackageRoomDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param visaId (optional) 
     * @return Success
     */
    getVisaRequirements(visaId: string | undefined): Observable<VisaRequirementsDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingTransaction/GetVisaRequirements?";
        if (visaId === null)
            throw new globalThis.Error("The parameter 'visaId' cannot be null.");
        else if (visaId !== undefined)
            url_ += "visaId=" + encodeURIComponent("" + visaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisaRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisaRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VisaRequirementsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VisaRequirementsDto>;
        }));
    }

    protected processGetVisaRequirements(response: HttpResponseBase): Observable<VisaRequirementsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VisaRequirementsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param visaId (optional) 
     * @param statusId (optional) 
     * @return Success
     */
    getVisaStatusAttachments(visaId: string | undefined, statusId: string | undefined): Observable<MinProcessedVisaStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BookingTransaction/GetVisaStatusAttachments?";
        if (visaId === null)
            throw new globalThis.Error("The parameter 'visaId' cannot be null.");
        else if (visaId !== undefined)
            url_ += "visaId=" + encodeURIComponent("" + visaId) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisaStatusAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisaStatusAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinProcessedVisaStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinProcessedVisaStatusDto[]>;
        }));
    }

    protected processGetVisaStatusAttachments(response: HttpResponseBase): Observable<MinProcessedVisaStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MinProcessedVisaStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBookingStatus(body: UpdateBookingStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BookingTransaction/UpdateBookingStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBookingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBookingStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBookingStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CmsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get packages homepage content with camelCase JSON serialization
     * @return Success
     */
    packagesHomepageGet(): Observable<void> {
        let url_ = this.baseUrl + "/api/cms/packages-homepage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPackagesHomepageGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPackagesHomepageGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPackagesHomepageGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create or update packages homepage content with camelCase JSON serialization
     * @param body (optional) 
     * @return Success
     */
    packagesHomepagePost(body: PackagesHomepageContentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/cms/packages-homepage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPackagesHomepagePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPackagesHomepagePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPackagesHomepagePost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get global settings content for admin
     * @return Success
     */
    globalSettingsGet(): Observable<GlobalSettingsPageDto> {
        let url_ = this.baseUrl + "/api/cms/global-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGlobalSettingsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGlobalSettingsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSettingsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSettingsPageDto>;
        }));
    }

    protected processGlobalSettingsGet(response: HttpResponseBase): Observable<GlobalSettingsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSettingsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create or update global settings content
     * @param body (optional) 
     * @return Success
     */
    globalSettingsPost(body: CreateOrUpdateGlobalSettingsDto | undefined): Observable<GlobalSettingsPageDto> {
        let url_ = this.baseUrl + "/api/cms/global-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGlobalSettingsPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGlobalSettingsPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSettingsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSettingsPageDto>;
        }));
    }

    protected processGlobalSettingsPost(response: HttpResponseBase): Observable<GlobalSettingsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSettingsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload image file for CMS content
     * @param body (optional) 
     * @return Success
     */
    uploadImage(body: CmsFileUploadDto | undefined): Observable<CmsFileUploadResultDto> {
        let url_ = this.baseUrl + "/api/cms/upload-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsFileUploadResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsFileUploadResultDto>;
        }));
    }

    protected processUploadImage(response: HttpResponseBase): Observable<CmsFileUploadResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CmsFileUploadResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete uploaded image
     * @return Success
     */
    deleteImage(documentId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/cms/delete-image/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteImage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get booking module settings for admin
     * @return Success
     */
    bookingModuleSettingsGet(): Observable<BookingModuleSettingsDto> {
        let url_ = this.baseUrl + "/api/cms/booking-module-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookingModuleSettingsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingModuleSettingsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingModuleSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingModuleSettingsDto>;
        }));
    }

    protected processBookingModuleSettingsGet(response: HttpResponseBase): Observable<BookingModuleSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingModuleSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create or update booking module settings
     * @param body (optional) 
     * @return Success
     */
    bookingModuleSettingsPost(body: CreateOrUpdateBookingModuleSettingsDto | undefined): Observable<BookingModuleSettingsDto> {
        let url_ = this.baseUrl + "/api/cms/booking-module-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookingModuleSettingsPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingModuleSettingsPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingModuleSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingModuleSettingsDto>;
        }));
    }

    protected processBookingModuleSettingsPost(response: HttpResponseBase): Observable<BookingModuleSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingModuleSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get contact inquiries for admin
     * @param name (optional) 
     * @param email (optional) 
     * @param status (optional) 
     * @param creationTimeStart (optional) 
     * @param creationTimeEnd (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    contactInquiriesmessages(name: string | undefined, email: string | undefined, status: ContactInquiryStatus | undefined, creationTimeStart: moment.Moment | undefined, creationTimeEnd: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ContactInquiryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/cms/contact-inquiriesmessages?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (creationTimeStart === null)
            throw new globalThis.Error("The parameter 'creationTimeStart' cannot be null.");
        else if (creationTimeStart !== undefined)
            url_ += "CreationTimeStart=" + encodeURIComponent(creationTimeStart ? "" + creationTimeStart.toISOString() : "") + "&";
        if (creationTimeEnd === null)
            throw new globalThis.Error("The parameter 'creationTimeEnd' cannot be null.");
        else if (creationTimeEnd !== undefined)
            url_ += "CreationTimeEnd=" + encodeURIComponent(creationTimeEnd ? "" + creationTimeEnd.toISOString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactInquiriesmessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactInquiriesmessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactInquiryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactInquiryDtoPagedResultDto>;
        }));
    }

    protected processContactInquiriesmessages(response: HttpResponseBase): Observable<ContactInquiryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactInquiryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get contact inquiry by ID for admin
     * @return Success
     */
    contactInquiryMessages(id: string): Observable<ContactInquiryDto> {
        let url_ = this.baseUrl + "/api/cms/contact-inquiry-messages/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactInquiryMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactInquiryMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactInquiryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactInquiryDto>;
        }));
    }

    protected processContactInquiryMessages(response: HttpResponseBase): Observable<ContactInquiryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactInquiryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete contact inquiry for admin
     * @return Success
     */
    contactInquiries(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/cms/contact-inquiries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactInquiries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactInquiries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processContactInquiries(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get packages homepage content for public site (no authentication required)
     * @return Success
     */
    packagesHomepageForSite(): Observable<void> {
        let url_ = this.baseUrl + "/api/public/cms/packages-homepage-for-site";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPackagesHomepageForSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPackagesHomepageForSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPackagesHomepageForSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get global settings for public site (no authentication required)
     * @return Success
     */
    globalSettingsForSite(): Observable<GlobalSettingsContentDto> {
        let url_ = this.baseUrl + "/api/public/cms/global-settings-for-site";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGlobalSettingsForSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGlobalSettingsForSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSettingsContentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSettingsContentDto>;
        }));
    }

    protected processGlobalSettingsForSite(response: HttpResponseBase): Observable<GlobalSettingsContentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSettingsContentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get about us page content (no authentication required)
     * @return Success
     */
    aboutUs(): Observable<void> {
        let url_ = this.baseUrl + "/api/public/cms/about-us";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAboutUs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAboutUs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAboutUs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get meet the team page content (no authentication required)
     * @return Success
     */
    meetTheTeam(): Observable<void> {
        let url_ = this.baseUrl + "/api/public/cms/meet-the-team";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMeetTheTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMeetTheTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMeetTheTeam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Submit contact inquiry from public site (no authentication required)
     * @param body (optional) 
     * @return Success
     */
    contactInquiry(body: CreateContactInquiryDto | undefined): Observable<ContactInquiryDto> {
        let url_ = this.baseUrl + "/api/public/cms/contact-inquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactInquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactInquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactInquiryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactInquiryDto>;
        }));
    }

    protected processContactInquiry(response: HttpResponseBase): Observable<ContactInquiryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactInquiryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Global_settingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get global settings content only for admin
     * @return Success
     */
    content(): Observable<GlobalSettingsContentDto> {
        let url_ = this.baseUrl + "/api/cms/global-settings/content";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSettingsContentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSettingsContentDto>;
        }));
    }

    protected processContent(response: HttpResponseBase): Observable<GlobalSettingsContentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSettingsContentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Packages_homepageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create or update packages homepage with batch file upload
     * @param body (optional) 
     * @return Success
     */
    withFiles(body: CreateOrUpdatePackagesHomepageDto | undefined): Observable<PackagesHomepageDto> {
        let url_ = this.baseUrl + "/api/cms/packages-homepage/with-files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackagesHomepageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackagesHomepageDto>;
        }));
    }

    protected processWithFiles(response: HttpResponseBase): Observable<PackagesHomepageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackagesHomepageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Booking_module_settingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get booking module settings content - accessible by public site
     * @return Success
     */
    content(): Observable<BookingModuleSettingsContentDto> {
        let url_ = this.baseUrl + "/api/cms/booking-module-settings/content";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingModuleSettingsContentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingModuleSettingsContentDto>;
        }));
    }

    protected processContent(response: HttpResponseBase): Observable<BookingModuleSettingsContentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingModuleSettingsContentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Contact_inquiriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Update contact inquiry status for admin
     * @param body (optional) 
     * @return Success
     */
    status(body: UpdateContactInquiryStatusDto | undefined): Observable<ContactInquiryDto> {
        let url_ = this.baseUrl + "/api/cms/contact-inquiries/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactInquiryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactInquiryDto>;
        }));
    }

    protected processStatus(response: HttpResponseBase): Observable<ContactInquiryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactInquiryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get contact inquiries count for admin dashboard
     * @return Success
     */
    count(): Observable<number> {
        let url_ = this.baseUrl + "/api/cms/contact-inquiries/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Hotelbeds_content_syncServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get all HotelBeds content sync items with their statuses
     * @return Success
     */
    items(): Observable<HotelBedsContentSyncStatusDto> {
        let url_ = this.baseUrl + "/api/cms/hotelbeds-content-sync/items";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsContentSyncStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsContentSyncStatusDto>;
        }));
    }

    protected processItems(response: HttpResponseBase): Observable<HotelBedsContentSyncStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsContentSyncStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Trigger full reference data sync
     * @return Success
     */
    triggerAll(): Observable<TriggerHotelBedsContentSyncResultDto> {
        let url_ = this.baseUrl + "/api/cms/hotelbeds-content-sync/trigger-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TriggerHotelBedsContentSyncResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TriggerHotelBedsContentSyncResultDto>;
        }));
    }

    protected processTriggerAll(response: HttpResponseBase): Observable<TriggerHotelBedsContentSyncResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TriggerHotelBedsContentSyncResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get HotelBeds content sync settings
     * @return Success
     */
    settingsGet(): Observable<HotelBedsContentSyncSettingsDto> {
        let url_ = this.baseUrl + "/api/cms/hotelbeds-content-sync/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSettingsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSettingsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsContentSyncSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsContentSyncSettingsDto>;
        }));
    }

    protected processSettingsGet(response: HttpResponseBase): Observable<HotelBedsContentSyncSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsContentSyncSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update HotelBeds content sync settings
     * @param body (optional) 
     * @return Success
     */
    settingsPost(body: UpdateHotelBedsContentSyncSettingsDto | undefined): Observable<HotelBedsContentSyncSettingsDto> {
        let url_ = this.baseUrl + "/api/cms/hotelbeds-content-sync/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSettingsPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSettingsPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsContentSyncSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsContentSyncSettingsDto>;
        }));
    }

    protected processSettingsPost(response: HttpResponseBase): Observable<HotelBedsContentSyncSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsContentSyncSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get HotelBeds content sync history
     * @param catalogKey (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    history(catalogKey: string | undefined, status: HotelBedsContentSyncStatus | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HotelBedsContentSyncRunDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/cms/hotelbeds-content-sync/history?";
        if (catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' cannot be null.");
        else if (catalogKey !== undefined)
            url_ += "CatalogKey=" + encodeURIComponent("" + catalogKey) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsContentSyncRunDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsContentSyncRunDtoPagedResultDto>;
        }));
    }

    protected processHistory(response: HttpResponseBase): Observable<HotelBedsContentSyncRunDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsContentSyncRunDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check HotelBeds API health
     * @return Success
     */
    health(): Observable<HotelBedsHealthCheckDto> {
        let url_ = this.baseUrl + "/api/cms/hotelbeds-content-sync/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsHealthCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsHealthCheckDto>;
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<HotelBedsHealthCheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsHealthCheckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ItemsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Trigger sync for a specific catalog item
     * @return Success
     */
    trigger(key: string): Observable<TriggerHotelBedsContentSyncResultDto> {
        let url_ = this.baseUrl + "/api/cms/hotelbeds-content-sync/items/{key}/trigger";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrigger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrigger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TriggerHotelBedsContentSyncResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TriggerHotelBedsContentSyncResultDto>;
        }));
    }

    protected processTrigger(response: HttpResponseBase): Observable<TriggerHotelBedsContentSyncResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TriggerHotelBedsContentSyncResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel sync for a specific catalog item
     * @return Success
     */
    cancel(key: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/cms/hotelbeds-content-sync/items/{key}/cancel";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CmsBackofficeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getPackagesHomepageContent(): Observable<PackagesHomepageContentDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsBackoffice/GetPackagesHomepageContent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackagesHomepageContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackagesHomepageContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackagesHomepageContentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackagesHomepageContentDto>;
        }));
    }

    protected processGetPackagesHomepageContent(response: HttpResponseBase): Observable<PackagesHomepageContentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackagesHomepageContentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param slug (optional) 
     * @return Success
     */
    getPageBySlug(slug: string | undefined): Observable<CmsPageDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsBackoffice/GetPageBySlug?";
        if (slug === null)
            throw new globalThis.Error("The parameter 'slug' cannot be null.");
        else if (slug !== undefined)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPageBySlug(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPageBySlug(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageDto>;
        }));
    }

    protected processGetPageBySlug(response: HttpResponseBase): Observable<CmsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CmsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageType (optional) 
     * @return Success
     */
    getPageByType(pageType: string | undefined): Observable<CmsPageDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsBackoffice/GetPageByType?";
        if (pageType === null)
            throw new globalThis.Error("The parameter 'pageType' cannot be null.");
        else if (pageType !== undefined)
            url_ += "pageType=" + encodeURIComponent("" + pageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPageByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPageByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageDto>;
        }));
    }

    protected processGetPageByType(response: HttpResponseBase): Observable<CmsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CmsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create or update packages homepage with file uploads (following package pattern)
     * @param body (optional) 
     * @return Success
     */
    createOrUpdatePackagesHomepageWithFiles(body: CreateOrUpdatePackagesHomepageDto | undefined): Observable<PackagesHomepageDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsBackoffice/CreateOrUpdatePackagesHomepageWithFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdatePackagesHomepageWithFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdatePackagesHomepageWithFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackagesHomepageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackagesHomepageDto>;
        }));
    }

    protected processCreateOrUpdatePackagesHomepageWithFiles(response: HttpResponseBase): Observable<PackagesHomepageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackagesHomepageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CmsFileUploadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadImage(body: CmsFileUploadDto | undefined): Observable<CmsFileUploadResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsFileUpload/UploadImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsFileUploadResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsFileUploadResultDto>;
        }));
    }

    protected processUploadImage(response: HttpResponseBase): Observable<CmsFileUploadResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CmsFileUploadResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documentId (optional) 
     * @return Success
     */
    deleteImage(documentId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CmsFileUpload/DeleteImage?";
        if (documentId === null)
            throw new globalThis.Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteImage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CmsPageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param pageName (optional) 
     * @return Success
     */
    getByPageName(pageName: string | undefined): Observable<CmsPageDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsPage/GetByPageName?";
        if (pageName === null)
            throw new globalThis.Error("The parameter 'pageName' cannot be null.");
        else if (pageName !== undefined)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPageName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPageName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageDto>;
        }));
    }

    protected processGetByPageName(response: HttpResponseBase): Observable<CmsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CmsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageType (optional) 
     * @return Success
     */
    getByPageType(pageType: string | undefined): Observable<CmsPageDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsPage/GetByPageType?";
        if (pageType === null)
            throw new globalThis.Error("The parameter 'pageType' cannot be null.");
        else if (pageType !== undefined)
            url_ += "pageType=" + encodeURIComponent("" + pageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPageType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPageType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageDto>;
        }));
    }

    protected processGetByPageType(response: HttpResponseBase): Observable<CmsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CmsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPackagesHomepage(): Observable<PackagesHomepageDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsPage/GetPackagesHomepage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackagesHomepage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackagesHomepage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackagesHomepageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackagesHomepageDto>;
        }));
    }

    protected processGetPackagesHomepage(response: HttpResponseBase): Observable<PackagesHomepageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackagesHomepageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdatePackagesHomepage(body: PackagesHomepageContentDto | undefined): Observable<PackagesHomepageDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsPage/CreateOrUpdatePackagesHomepage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdatePackagesHomepage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdatePackagesHomepage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackagesHomepageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackagesHomepageDto>;
        }));
    }

    protected processCreateOrUpdatePackagesHomepage(response: HttpResponseBase): Observable<PackagesHomepageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackagesHomepageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCmsPageDto | undefined): Observable<CmsPageDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsPage/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CmsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CmsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCmsPageDto | undefined): Observable<CmsPageDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsPage/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CmsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CmsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CmsPage/Activate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deactivate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CmsPage/Deactivate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CmsPageDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsPage/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CmsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CmsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param pageType (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, pageType: string | undefined, isActive: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CmsPageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsPage/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageType === null)
            throw new globalThis.Error("The parameter 'pageType' cannot be null.");
        else if (pageType !== undefined)
            url_ += "PageType=" + encodeURIComponent("" + pageType) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CmsPageDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CmsPageDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CmsPage/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CmsPublicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getGlobalSettingsForPublic(): Observable<GlobalSettingsContentDto> {
        let url_ = this.baseUrl + "/api/services/app/CmsPublic/GetGlobalSettingsForPublic";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlobalSettingsForPublic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlobalSettingsForPublic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSettingsContentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSettingsContentDto>;
        }));
    }

    protected processGetGlobalSettingsForPublic(response: HttpResponseBase): Observable<GlobalSettingsContentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSettingsContentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContactInquiryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param name (optional) 
     * @param email (optional) 
     * @param status (optional) 
     * @param creationTimeStart (optional) 
     * @param creationTimeEnd (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getContactInquiries(name: string | undefined, email: string | undefined, status: ContactInquiryStatus | undefined, creationTimeStart: moment.Moment | undefined, creationTimeEnd: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ContactInquiryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactInquiry/GetContactInquiries?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (creationTimeStart === null)
            throw new globalThis.Error("The parameter 'creationTimeStart' cannot be null.");
        else if (creationTimeStart !== undefined)
            url_ += "CreationTimeStart=" + encodeURIComponent(creationTimeStart ? "" + creationTimeStart.toISOString() : "") + "&";
        if (creationTimeEnd === null)
            throw new globalThis.Error("The parameter 'creationTimeEnd' cannot be null.");
        else if (creationTimeEnd !== undefined)
            url_ += "CreationTimeEnd=" + encodeURIComponent(creationTimeEnd ? "" + creationTimeEnd.toISOString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactInquiries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactInquiries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactInquiryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactInquiryDtoPagedResultDto>;
        }));
    }

    protected processGetContactInquiries(response: HttpResponseBase): Observable<ContactInquiryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactInquiryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getContactInquiry(id: string | undefined): Observable<ContactInquiryDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactInquiry/GetContactInquiry?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactInquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactInquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactInquiryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactInquiryDto>;
        }));
    }

    protected processGetContactInquiry(response: HttpResponseBase): Observable<ContactInquiryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactInquiryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createContactInquiry(body: CreateContactInquiryDto | undefined): Observable<ContactInquiryDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactInquiry/CreateContactInquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContactInquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContactInquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactInquiryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactInquiryDto>;
        }));
    }

    protected processCreateContactInquiry(response: HttpResponseBase): Observable<ContactInquiryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactInquiryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateContactInquiryStatus(body: UpdateContactInquiryStatusDto | undefined): Observable<ContactInquiryDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactInquiry/UpdateContactInquiryStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContactInquiryStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContactInquiryStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactInquiryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactInquiryDto>;
        }));
    }

    protected processUpdateContactInquiryStatus(response: HttpResponseBase): Observable<ContactInquiryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactInquiryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteContactInquiry(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ContactInquiry/DeleteContactInquiry?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContactInquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContactInquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteContactInquiry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getContactInquiriesCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ContactInquiry/GetContactInquiriesCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactInquiriesCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactInquiriesCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetContactInquiriesCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContactInquiryPublicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitContactInquiry(body: CreateContactInquiryDto | undefined): Observable<ContactInquiryDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactInquiryPublic/SubmitContactInquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitContactInquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitContactInquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactInquiryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactInquiryDto>;
        }));
    }

    protected processSubmitContactInquiry(response: HttpResponseBase): Observable<ContactInquiryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactInquiryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerBookingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCustomerBooking(body: CreateCustomerBookingDto | undefined): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/CreateCustomerBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomerBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomerBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processCreateCustomerBooking(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomerBooking(body: UpdateCustomerBookingDto | undefined): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/UpdateCustomerBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processUpdateCustomerBooking(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCustomerBooking(id: string | undefined): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/GetCustomerBooking?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processGetCustomerBooking(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    progressStep(body: ProgressStepDto | undefined): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/ProgressStep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProgressStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgressStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processProgressStep(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recoverSession(body: SessionRecoveryRequestDto | undefined): Observable<CustomerBookingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/RecoverSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecoverSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecoverSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto[]>;
        }));
    }

    protected processRecoverSession(response: HttpResponseBase): Observable<CustomerBookingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerBookingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    finalizeCustomerBooking(body: FinalizeCustomerBookingDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/FinalizeCustomerBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeCustomerBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeCustomerBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFinalizeCustomerBooking(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCustomerBooking(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/DeleteCustomerBooking?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomerBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCustomerBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyCustomerBookings(): Observable<CustomerBookingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/GetMyCustomerBookings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyCustomerBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCustomerBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto[]>;
        }));
    }

    protected processGetMyCustomerBookings(response: HttpResponseBase): Observable<CustomerBookingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerBookingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param hoursSinceLastAccess (optional) 
     * @return Success
     */
    getAbandonedCarts(hoursSinceLastAccess: number | undefined): Observable<AbandonedCartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/GetAbandonedCarts?";
        if (hoursSinceLastAccess === null)
            throw new globalThis.Error("The parameter 'hoursSinceLastAccess' cannot be null.");
        else if (hoursSinceLastAccess !== undefined)
            url_ += "hoursSinceLastAccess=" + encodeURIComponent("" + hoursSinceLastAccess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAbandonedCarts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAbandonedCarts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AbandonedCartDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AbandonedCartDto[]>;
        }));
    }

    protected processGetAbandonedCarts(response: HttpResponseBase): Observable<AbandonedCartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AbandonedCartDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    cleanupExpiredDrafts(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/CleanupExpiredDrafts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCleanupExpiredDrafts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCleanupExpiredDrafts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCleanupExpiredDrafts(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    touchCustomerBooking(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/TouchCustomerBooking?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTouchCustomerBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTouchCustomerBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTouchCustomerBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tourId (optional) 
     * @param sessionId (optional) 
     * @return Success
     */
    getExistingCustomerBookingForTour(tourId: number | undefined, sessionId: string | undefined): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/GetExistingCustomerBookingForTour?";
        if (tourId === null)
            throw new globalThis.Error("The parameter 'tourId' cannot be null.");
        else if (tourId !== undefined)
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingCustomerBookingForTour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingCustomerBookingForTour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processGetExistingCustomerBookingForTour(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param order (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAllCustomerBookings(page: number | undefined, size: number | undefined, sort: string | undefined, order: string | undefined, search: string | undefined): Observable<CustomerBookingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/GetAllCustomerBookings?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new globalThis.Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (order === null)
            throw new globalThis.Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCustomerBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustomerBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDtoPagedResultDto>;
        }));
    }

    protected processGetAllCustomerBookings(response: HttpResponseBase): Observable<CustomerBookingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCustomerBookingByIdForAdmin(id: string | undefined): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/GetCustomerBookingByIdForAdmin?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerBookingByIdForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerBookingByIdForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processGetCustomerBookingByIdForAdmin(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomerBookingStatus(body: UpdateCustomerBookingStatusDto | undefined): Observable<CustomerBookingDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/UpdateCustomerBookingStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerBookingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerBookingStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBookingDto>;
        }));
    }

    protected processUpdateCustomerBookingStatus(response: HttpResponseBase): Observable<CustomerBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param customerBookingId (optional) 
     * @return Success
     */
    getPaymentReceiptsByBooking(customerBookingId: string | undefined): Observable<CustomerPaymentReceiptDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/GetPaymentReceiptsByBooking?";
        if (customerBookingId === null)
            throw new globalThis.Error("The parameter 'customerBookingId' cannot be null.");
        else if (customerBookingId !== undefined)
            url_ += "customerBookingId=" + encodeURIComponent("" + customerBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentReceiptsByBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentReceiptsByBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerPaymentReceiptDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerPaymentReceiptDto[]>;
        }));
    }

    protected processGetPaymentReceiptsByBooking(response: HttpResponseBase): Observable<CustomerPaymentReceiptDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerPaymentReceiptDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPaymentReceiptById(id: string | undefined): Observable<CustomerPaymentReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/GetPaymentReceiptById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentReceiptById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentReceiptById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerPaymentReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerPaymentReceiptDto>;
        }));
    }

    protected processGetPaymentReceiptById(response: HttpResponseBase): Observable<CustomerPaymentReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerPaymentReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyPaymentReceipt(body: VerifyPaymentReceiptDto | undefined): Observable<CustomerPaymentReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/VerifyPaymentReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyPaymentReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyPaymentReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerPaymentReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerPaymentReceiptDto>;
        }));
    }

    protected processVerifyPaymentReceipt(response: HttpResponseBase): Observable<CustomerPaymentReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerPaymentReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param receiptId (optional) 
     * @return Success
     */
    getPaymentReceiptSignedUrl(receiptId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/GetPaymentReceiptSignedUrl?";
        if (receiptId === null)
            throw new globalThis.Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentReceiptSignedUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentReceiptSignedUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPaymentReceiptSignedUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBookingStatusCounts(): Observable<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/GetBookingStatusCounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingStatusCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingStatusCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: number; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: number; }>;
        }));
    }

    protected processGetBookingStatusCounts(response: HttpResponseBase): Observable<{ [key: string]: number; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)[key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPaymentReceiptStatusCounts(): Observable<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/services/app/CustomerBooking/GetPaymentReceiptStatusCounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentReceiptStatusCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentReceiptStatusCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: number; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: number; }>;
        }));
    }

    protected processGetPaymentReceiptStatusCounts(response: HttpResponseBase): Observable<{ [key: string]: number; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)[key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Payment_receiptsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    byBooking(customerBookingId: string): Observable<PublicCustomerPaymentReceiptDto[]> {
        let url_ = this.baseUrl + "/api/public/payment-receipts/by-booking/{customerBookingId}";
        if (customerBookingId === undefined || customerBookingId === null)
            throw new globalThis.Error("The parameter 'customerBookingId' must be defined.");
        url_ = url_.replace("{customerBookingId}", encodeURIComponent("" + customerBookingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicCustomerPaymentReceiptDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicCustomerPaymentReceiptDto[]>;
        }));
    }

    protected processByBooking(response: HttpResponseBase): Observable<PublicCustomerPaymentReceiptDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PublicCustomerPaymentReceiptDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    byReceiptNumber(receiptNumber: string): Observable<PublicCustomerPaymentReceiptDto> {
        let url_ = this.baseUrl + "/api/public/payment-receipts/by-receipt-number/{receiptNumber}";
        if (receiptNumber === undefined || receiptNumber === null)
            throw new globalThis.Error("The parameter 'receiptNumber' must be defined.");
        url_ = url_.replace("{receiptNumber}", encodeURIComponent("" + receiptNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByReceiptNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByReceiptNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicCustomerPaymentReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicCustomerPaymentReceiptDto>;
        }));
    }

    protected processByReceiptNumber(response: HttpResponseBase): Observable<PublicCustomerPaymentReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicCustomerPaymentReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param amount (optional) 
     * @return Success
     */
    validateAmount(id: string, amount: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/public/payment-receipts/{id}/validate-amount?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (amount === null)
            throw new globalThis.Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAmount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateAmount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    signedUrl(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/public/payment-receipts/{id}/signed-url";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignedUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignedUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSignedUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerPaymentReceiptServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCustomerPaymentReceiptDto | undefined): Observable<PublicCustomerPaymentReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPaymentReceipt/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicCustomerPaymentReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicCustomerPaymentReceiptDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PublicCustomerPaymentReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicCustomerPaymentReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PublicCustomerPaymentReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPaymentReceipt/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicCustomerPaymentReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicCustomerPaymentReceiptDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PublicCustomerPaymentReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicCustomerPaymentReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param customerBookingId (optional) 
     * @return Success
     */
    getByCustomerBooking(customerBookingId: string | undefined): Observable<PublicCustomerPaymentReceiptDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPaymentReceipt/GetByCustomerBooking?";
        if (customerBookingId === null)
            throw new globalThis.Error("The parameter 'customerBookingId' cannot be null.");
        else if (customerBookingId !== undefined)
            url_ += "customerBookingId=" + encodeURIComponent("" + customerBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCustomerBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCustomerBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicCustomerPaymentReceiptDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicCustomerPaymentReceiptDto[]>;
        }));
    }

    protected processGetByCustomerBooking(response: HttpResponseBase): Observable<PublicCustomerPaymentReceiptDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PublicCustomerPaymentReceiptDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param receiptNumber (optional) 
     * @return Success
     */
    getByReceiptNumber(receiptNumber: string | undefined): Observable<PublicCustomerPaymentReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPaymentReceipt/GetByReceiptNumber?";
        if (receiptNumber === null)
            throw new globalThis.Error("The parameter 'receiptNumber' cannot be null.");
        else if (receiptNumber !== undefined)
            url_ += "receiptNumber=" + encodeURIComponent("" + receiptNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByReceiptNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByReceiptNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicCustomerPaymentReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicCustomerPaymentReceiptDto>;
        }));
    }

    protected processGetByReceiptNumber(response: HttpResponseBase): Observable<PublicCustomerPaymentReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicCustomerPaymentReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param customerBookingId (optional) 
     * @param amount (optional) 
     * @return Success
     */
    validateAmount(customerBookingId: string | undefined, amount: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPaymentReceipt/ValidateAmount?";
        if (customerBookingId === null)
            throw new globalThis.Error("The parameter 'customerBookingId' cannot be null.");
        else if (customerBookingId !== undefined)
            url_ += "customerBookingId=" + encodeURIComponent("" + customerBookingId) + "&";
        if (amount === null)
            throw new globalThis.Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAmount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateAmount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSignedFileUrl(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPaymentReceipt/GetSignedFileUrl?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignedFileUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignedFileUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSignedFileUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocScannerApkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getLatestApkDownloadUrl(): Observable<DocScannerApkDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/DocScannerApk/GetLatestApkDownloadUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestApkDownloadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestApkDownloadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocScannerApkDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocScannerApkDownloadDto>;
        }));
    }

    protected processGetLatestApkDownloadUrl(response: HttpResponseBase): Observable<DocScannerApkDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocScannerApkDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSecuredUrl(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Documents/GetSecuredUrl?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecuredUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecuredUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSecuredUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getProfilePictureUrl(userId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Documents/GetProfilePictureUrl?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetProfilePictureUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(referenceId: string | undefined, body: DocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/Create?";
        if (referenceId === null)
            throw new globalThis.Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param referenceId (optional) 
     * @return Success
     */
    delete(id: string | undefined, referenceId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Documents/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (referenceId === null)
            throw new globalThis.Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentScannerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    scanPassport(body: ScannedDocumentDto | undefined): Observable<ScannedDocumentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentScanner/ScanPassport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScanPassport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScanPassport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannedDocumentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannedDocumentResponseDto>;
        }));
    }

    protected processScanPassport(response: HttpResponseBase): Observable<ScannedDocumentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannedDocumentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FlightAvailabilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param origin IATA airport code for the departure airport. Example: `SYD`
     * @param destination IATA airport code for the arrival airport. Example: `MEL`
     * @param departureDate Departure date to check availability for.
     * @param adults (optional) Number of adult passengers. Min: 1, Max: 9.
     * @param children (optional) Number of child passengers. Max: 9.
     * @param infants (optional) Number of infant passengers. Max: 4.
     * @param preferredCarrier (optional) IATA carrier code to filter results. Example: `QF`.
     * @param departureTime (optional) Preferred departure time in `HH:mm` format. Example: `08:00`.
     * @return Success
     */
    getAvailability(origin: string, destination: string, departureDate: moment.Moment, adults: number | undefined, children: number | undefined, infants: number | undefined, preferredCarrier: string | undefined, departureTime: string | undefined): Observable<FlightAvailabilityApiDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FlightAvailability/GetAvailability?";
        if (origin === undefined || origin === null)
            throw new globalThis.Error("The parameter 'origin' must be defined and cannot be null.");
        else
            url_ += "Origin=" + encodeURIComponent("" + origin) + "&";
        if (destination === undefined || destination === null)
            throw new globalThis.Error("The parameter 'destination' must be defined and cannot be null.");
        else
            url_ += "Destination=" + encodeURIComponent("" + destination) + "&";
        if (departureDate === undefined || departureDate === null)
            throw new globalThis.Error("The parameter 'departureDate' must be defined and cannot be null.");
        else
            url_ += "DepartureDate=" + encodeURIComponent(departureDate ? "" + departureDate.toISOString() : "") + "&";
        if (adults === null)
            throw new globalThis.Error("The parameter 'adults' cannot be null.");
        else if (adults !== undefined)
            url_ += "Adults=" + encodeURIComponent("" + adults) + "&";
        if (children === null)
            throw new globalThis.Error("The parameter 'children' cannot be null.");
        else if (children !== undefined)
            url_ += "Children=" + encodeURIComponent("" + children) + "&";
        if (infants === null)
            throw new globalThis.Error("The parameter 'infants' cannot be null.");
        else if (infants !== undefined)
            url_ += "Infants=" + encodeURIComponent("" + infants) + "&";
        if (preferredCarrier === null)
            throw new globalThis.Error("The parameter 'preferredCarrier' cannot be null.");
        else if (preferredCarrier !== undefined)
            url_ += "PreferredCarrier=" + encodeURIComponent("" + preferredCarrier) + "&";
        if (departureTime === null)
            throw new globalThis.Error("The parameter 'departureTime' cannot be null.");
        else if (departureTime !== undefined)
            url_ += "DepartureTime=" + encodeURIComponent("" + departureTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlightAvailabilityApiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlightAvailabilityApiDto[]>;
        }));
    }

    protected processGetAvailability(response: HttpResponseBase): Observable<FlightAvailabilityApiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FlightAvailabilityApiDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FlightBookingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    book(body: FlightBookingApiRequest | undefined): Observable<FlightBookingApiDto> {
        let url_ = this.baseUrl + "/api/services/app/FlightBooking/Book";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlightBookingApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlightBookingApiDto>;
        }));
    }

    protected processBook(response: HttpResponseBase): Observable<FlightBookingApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlightBookingApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingReference (optional) 
     * @return Success
     */
    get(bookingReference: string | undefined): Observable<FlightBookingApiDto> {
        let url_ = this.baseUrl + "/api/services/app/FlightBooking/Get?";
        if (bookingReference === null)
            throw new globalThis.Error("The parameter 'bookingReference' cannot be null.");
        else if (bookingReference !== undefined)
            url_ += "bookingReference=" + encodeURIComponent("" + bookingReference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlightBookingApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlightBookingApiDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FlightBookingApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlightBookingApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingReference (optional) 
     * @return Success
     */
    cancel(bookingReference: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FlightBooking/Cancel?";
        if (bookingReference === null)
            throw new globalThis.Error("The parameter 'bookingReference' cannot be null.");
        else if (bookingReference !== undefined)
            url_ += "bookingReference=" + encodeURIComponent("" + bookingReference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FlightsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Search for available flights (Step 1 of booking flow).
     * @param body (optional) 
     * @return Success
     */
    search(body: FlightSearchApiRequest | undefined): Observable<FlightOfferApiDto[]> {
        let url_ = this.baseUrl + "/api/flights/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlightOfferApiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlightOfferApiDto[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<FlightOfferApiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FlightOfferApiDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Re-price a selected flight offer (Step 2 of booking flow).
     * @param body (optional) 
     * @return Success
     */
    price(body: FlightPriceApiRequest | undefined): Observable<FlightOfferApiDto> {
        let url_ = this.baseUrl + "/api/flights/price";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlightOfferApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlightOfferApiDto>;
        }));
    }

    protected processPrice(response: HttpResponseBase): Observable<FlightOfferApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlightOfferApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Book a flight (Step 3 of booking flow).
     * @param body (optional) 
     * @return Success
     */
    book(body: FlightBookingApiRequest | undefined): Observable<FlightBookingApiDto> {
        let url_ = this.baseUrl + "/api/flights/book";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlightBookingApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlightBookingApiDto>;
        }));
    }

    protected processBook(response: HttpResponseBase): Observable<FlightBookingApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlightBookingApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a booking by reference (Step 4 of booking flow).
     * @param bookingReference The booking reference returned from `/book`.
     * @return Success
     */
    bookingGet(bookingReference: string): Observable<FlightBookingApiDto> {
        let url_ = this.baseUrl + "/api/flights/booking/{bookingReference}";
        if (bookingReference === undefined || bookingReference === null)
            throw new globalThis.Error("The parameter 'bookingReference' must be defined.");
        url_ = url_.replace("{bookingReference}", encodeURIComponent("" + bookingReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookingGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlightBookingApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlightBookingApiDto>;
        }));
    }

    protected processBookingGet(response: HttpResponseBase): Observable<FlightBookingApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlightBookingApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel a booking.
     * @param bookingReference The booking reference returned from `/book`.
     * @return Success
     */
    bookingDelete(bookingReference: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/flights/booking/{bookingReference}";
        if (bookingReference === undefined || bookingReference === null)
            throw new globalThis.Error("The parameter 'bookingReference' must be defined.");
        url_ = url_.replace("{bookingReference}", encodeURIComponent("" + bookingReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookingDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processBookingDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * [Internal] Check GDS seat inventory availability.
     * @param body (optional) 
     * @return Success
     */
    availability(body: FlightAvailabilityApiRequest | undefined): Observable<FlightAvailabilityApiDto[]> {
        let url_ = this.baseUrl + "/api/flights/availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlightAvailabilityApiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlightAvailabilityApiDto[]>;
        }));
    }

    protected processAvailability(response: HttpResponseBase): Observable<FlightAvailabilityApiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FlightAvailabilityApiDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FlightSearchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: FlightSearchApiRequest | undefined): Observable<FlightOfferApiDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FlightSearch/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlightOfferApiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlightOfferApiDto[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<FlightOfferApiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FlightOfferApiDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    price(body: FlightPriceApiRequest | undefined): Observable<FlightOfferApiDto> {
        let url_ = this.baseUrl + "/api/services/app/FlightSearch/Price";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlightOfferApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlightOfferApiDto>;
        }));
    }

    protected processPrice(response: HttpResponseBase): Observable<FlightOfferApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlightOfferApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GlobalSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getGlobalSettings(): Observable<GlobalSettingsPageDto> {
        let url_ = this.baseUrl + "/api/services/app/GlobalSettings/GetGlobalSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlobalSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlobalSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSettingsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSettingsPageDto>;
        }));
    }

    protected processGetGlobalSettings(response: HttpResponseBase): Observable<GlobalSettingsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSettingsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateGlobalSettings(body: CreateOrUpdateGlobalSettingsDto | undefined): Observable<GlobalSettingsPageDto> {
        let url_ = this.baseUrl + "/api/services/app/GlobalSettings/CreateOrUpdateGlobalSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateGlobalSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateGlobalSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSettingsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSettingsPageDto>;
        }));
    }

    protected processCreateOrUpdateGlobalSettings(response: HttpResponseBase): Observable<GlobalSettingsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSettingsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getGlobalSettingsContent(): Observable<GlobalSettingsContentDto> {
        let url_ = this.baseUrl + "/api/services/app/GlobalSettings/GetGlobalSettingsContent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlobalSettingsContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlobalSettingsContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSettingsContentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSettingsContentDto>;
        }));
    }

    protected processGetGlobalSettingsContent(response: HttpResponseBase): Observable<GlobalSettingsContentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSettingsContentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    health(): Observable<void> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HotelBedsContentSyncServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getSettings(): Observable<HotelBedsContentSyncSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSync/GetSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsContentSyncSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsContentSyncSettingsDto>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<HotelBedsContentSyncSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsContentSyncSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSettings(body: UpdateHotelBedsContentSyncSettingsDto | undefined): Observable<HotelBedsContentSyncSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSync/UpdateSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsContentSyncSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsContentSyncSettingsDto>;
        }));
    }

    protected processUpdateSettings(response: HttpResponseBase): Observable<HotelBedsContentSyncSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsContentSyncSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getStatus(): Observable<HotelBedsContentSyncStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSync/GetStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsContentSyncStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsContentSyncStatusDto>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<HotelBedsContentSyncStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsContentSyncStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param catalogKey (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSyncHistory(catalogKey: string | undefined, status: HotelBedsContentSyncStatus | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HotelBedsContentSyncRunDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSync/GetSyncHistory?";
        if (catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' cannot be null.");
        else if (catalogKey !== undefined)
            url_ += "CatalogKey=" + encodeURIComponent("" + catalogKey) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSyncHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSyncHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsContentSyncRunDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsContentSyncRunDtoPagedResultDto>;
        }));
    }

    protected processGetSyncHistory(response: HttpResponseBase): Observable<HotelBedsContentSyncRunDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsContentSyncRunDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    triggerReferenceDataSync(): Observable<TriggerHotelBedsContentSyncResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSync/TriggerReferenceDataSync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerReferenceDataSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerReferenceDataSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TriggerHotelBedsContentSyncResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TriggerHotelBedsContentSyncResultDto>;
        }));
    }

    protected processTriggerReferenceDataSync(response: HttpResponseBase): Observable<TriggerHotelBedsContentSyncResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TriggerHotelBedsContentSyncResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param catalogKey (optional) 
     * @param hotelCode (optional) 
     * @param countryCode (optional) 
     * @param destinationCode (optional) 
     * @return Success
     */
    triggerItemSync(catalogKey: string | undefined, hotelCode: string | undefined, countryCode: string | undefined, destinationCode: string | undefined): Observable<TriggerHotelBedsContentSyncResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSync/TriggerItemSync?";
        if (catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' cannot be null.");
        else if (catalogKey !== undefined)
            url_ += "catalogKey=" + encodeURIComponent("" + catalogKey) + "&";
        if (hotelCode === null)
            throw new globalThis.Error("The parameter 'hotelCode' cannot be null.");
        else if (hotelCode !== undefined)
            url_ += "hotelCode=" + encodeURIComponent("" + hotelCode) + "&";
        if (countryCode === null)
            throw new globalThis.Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (destinationCode === null)
            throw new globalThis.Error("The parameter 'destinationCode' cannot be null.");
        else if (destinationCode !== undefined)
            url_ += "destinationCode=" + encodeURIComponent("" + destinationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerItemSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerItemSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TriggerHotelBedsContentSyncResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TriggerHotelBedsContentSyncResultDto>;
        }));
    }

    protected processTriggerItemSync(response: HttpResponseBase): Observable<TriggerHotelBedsContentSyncResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TriggerHotelBedsContentSyncResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param hotelCode (optional) 
     * @return Success
     */
    inspectHotelContent(hotelCode: string | undefined): Observable<HotelBedsHotelContentInspectDto> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSync/InspectHotelContent?";
        if (hotelCode === null)
            throw new globalThis.Error("The parameter 'hotelCode' cannot be null.");
        else if (hotelCode !== undefined)
            url_ += "hotelCode=" + encodeURIComponent("" + hotelCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInspectHotelContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInspectHotelContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsHotelContentInspectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsHotelContentInspectDto>;
        }));
    }

    protected processInspectHotelContent(response: HttpResponseBase): Observable<HotelBedsHotelContentInspectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsHotelContentInspectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param catalogKey (optional) 
     * @return Success
     */
    cancelItemSync(catalogKey: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSync/CancelItemSync?";
        if (catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' cannot be null.");
        else if (catalogKey !== undefined)
            url_ += "catalogKey=" + encodeURIComponent("" + catalogKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelItemSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelItemSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancelItemSync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Forcibly resets a stuck "Running" item to Idle without requiring an
    in-memory cancellation token.  Use when CancelItemSyncAsync returns false
    (e.g. after a backend restart left the DB row stuck in Running state).
     * @param catalogKey (optional) 
     * @return Success
     */
    forceResetItem(catalogKey: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSync/ForceResetItem?";
        if (catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' cannot be null.");
        else if (catalogKey !== undefined)
            url_ += "catalogKey=" + encodeURIComponent("" + catalogKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceResetItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceResetItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processForceResetItem(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkHealth(): Observable<HotelBedsHealthCheckDto> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSync/CheckHealth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsHealthCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsHealthCheckDto>;
        }));
    }

    protected processCheckHealth(response: HttpResponseBase): Observable<HotelBedsHealthCheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsHealthCheckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Capture real API responses and save as fixtures for mock testing
    WARNING: This uses the REAL API and will consume 18 API calls from your daily quota
    Ensure UseMockData is set to false before calling this
     * @return Success
     */
    captureFixtures(): Observable<FixtureCaptureResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSync/CaptureFixtures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaptureFixtures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaptureFixtures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FixtureCaptureResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FixtureCaptureResultDto>;
        }));
    }

    protected processCaptureFixtures(response: HttpResponseBase): Observable<FixtureCaptureResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FixtureCaptureResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HotelBedsContentSyncOrchestratorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param catalogKey (optional) 
     * @return Success
     */
    execute(catalogKey: string | undefined): Observable<ContentSyncOutcome> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSyncOrchestrator/Execute?";
        if (catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' cannot be null.");
        else if (catalogKey !== undefined)
            url_ += "catalogKey=" + encodeURIComponent("" + catalogKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentSyncOutcome>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentSyncOutcome>;
        }));
    }

    protected processExecute(response: HttpResponseBase): Observable<ContentSyncOutcome> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param catalogKey (optional) 
     * @param runId (optional) 
     * @param initiatedByUserId (optional) 
     * @return Success
     */
    syncItem(catalogKey: string | undefined, runId: string | undefined, initiatedByUserId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSyncOrchestrator/SyncItem?";
        if (catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' cannot be null.");
        else if (catalogKey !== undefined)
            url_ += "catalogKey=" + encodeURIComponent("" + catalogKey) + "&";
        if (runId === null)
            throw new globalThis.Error("The parameter 'runId' cannot be null.");
        else if (runId !== undefined)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        if (initiatedByUserId === null)
            throw new globalThis.Error("The parameter 'initiatedByUserId' cannot be null.");
        else if (initiatedByUserId !== undefined)
            url_ += "initiatedByUserId=" + encodeURIComponent("" + initiatedByUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSyncItem(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param runId (optional) 
     * @param initiatedByUserId (optional) 
     * @return Success
     */
    syncAllReferenceData(runId: string | undefined, initiatedByUserId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsContentSyncOrchestrator/SyncAllReferenceData?";
        if (runId === null)
            throw new globalThis.Error("The parameter 'runId' cannot be null.");
        else if (runId !== undefined)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        if (initiatedByUserId === null)
            throw new globalThis.Error("The parameter 'initiatedByUserId' cannot be null.");
        else if (initiatedByUserId !== undefined)
            url_ += "initiatedByUserId=" + encodeURIComponent("" + initiatedByUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncAllReferenceData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncAllReferenceData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSyncAllReferenceData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HotelBedsStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    checkHealth(): Observable<HotelBedsHealthCheckDto> {
        let url_ = this.baseUrl + "/api/services/app/HotelBedsStatus/CheckHealth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HotelBedsHealthCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HotelBedsHealthCheckDto>;
        }));
    }

    protected processCheckHealth(response: HttpResponseBase): Observable<HotelBedsHealthCheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBedsHealthCheckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MarkupRuleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMarkupRuleDto | undefined): Observable<MarkupRuleDto> {
        let url_ = this.baseUrl + "/api/services/app/MarkupRule/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarkupRuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarkupRuleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MarkupRuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarkupRuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMarkupRuleDto | undefined): Observable<MarkupRuleDto> {
        let url_ = this.baseUrl + "/api/services/app/MarkupRule/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarkupRuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarkupRuleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MarkupRuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarkupRuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkupRule/Activate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deactivate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkupRule/Deactivate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    testMarkup(body: TestMarkupInputDto | undefined): Observable<TestMarkupResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MarkupRule/TestMarkup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestMarkup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestMarkup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestMarkupResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestMarkupResultDto>;
        }));
    }

    protected processTestMarkup(response: HttpResponseBase): Observable<TestMarkupResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestMarkupResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<MarkupRuleDto> {
        let url_ = this.baseUrl + "/api/services/app/MarkupRule/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarkupRuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarkupRuleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MarkupRuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarkupRuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param supplierName (optional) 
     * @param productType (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, supplierName: string | undefined, productType: MarkupProductType | undefined, isActive: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MarkupRuleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MarkupRule/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (supplierName === null)
            throw new globalThis.Error("The parameter 'supplierName' cannot be null.");
        else if (supplierName !== undefined)
            url_ += "SupplierName=" + encodeURIComponent("" + supplierName) + "&";
        if (productType === null)
            throw new globalThis.Error("The parameter 'productType' cannot be null.");
        else if (productType !== undefined)
            url_ += "ProductType=" + encodeURIComponent("" + productType) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarkupRuleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarkupRuleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MarkupRuleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarkupRuleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkupRule/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    get(): Observable<NetStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/Net/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NetStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NetStatusDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NetStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NetStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NewsletterSubscriberServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    subscribe(body: CreateNewsletterSubscriberDto | undefined): Observable<NewsletterSubscriptionResult> {
        let url_ = this.baseUrl + "/api/services/app/NewsletterSubscriber/Subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewsletterSubscriptionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewsletterSubscriptionResult>;
        }));
    }

    protected processSubscribe(response: HttpResponseBase): Observable<NewsletterSubscriptionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewsletterSubscriptionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param count (optional) 
     * @return Success
     */
    getLatestSubscribers(count: number | undefined): Observable<NewsletterSubscriberDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NewsletterSubscriber/GetLatestSubscribers?";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestSubscribers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestSubscribers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewsletterSubscriberDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewsletterSubscriberDto[]>;
        }));
    }

    protected processGetLatestSubscribers(response: HttpResponseBase): Observable<NewsletterSubscriberDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NewsletterSubscriberDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<NewsletterSubscriberDto> {
        let url_ = this.baseUrl + "/api/services/app/NewsletterSubscriber/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewsletterSubscriberDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewsletterSubscriberDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NewsletterSubscriberDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewsletterSubscriberDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNotification(body: CreateNotificationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/CreateNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUnreadNotificationsForUser(userId: number | undefined): Observable<NotificationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUnreadNotificationsForUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreadNotificationsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadNotificationsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDto[]>;
        }));
    }

    protected processGetUnreadNotificationsForUser(response: HttpResponseBase): Observable<NotificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NotificationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param notificationId (optional) 
     * @return Success
     */
    markNotificationAsRead(notificationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/MarkNotificationAsRead?";
        if (notificationId === null)
            throw new globalThis.Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PackageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userIdFilter: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PackageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Package/GetAll?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PackageDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PackageDto> {
        let url_ = this.baseUrl + "/api/services/app/Package/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PackageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePackageDto | undefined): Observable<PackageDto> {
        let url_ = this.baseUrl + "/api/services/app/Package/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PackageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePackageDto | undefined): Observable<PackageDto> {
        let url_ = this.baseUrl + "/api/services/app/Package/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PackageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Package/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deletionReason (optional) 
     * @return Success
     */
    deleteWithReason(id: string, deletionReason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Package/DeleteWithReason?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deletionReason === null)
            throw new globalThis.Error("The parameter 'deletionReason' cannot be null.");
        else if (deletionReason !== undefined)
            url_ += "DeletionReason=" + encodeURIComponent("" + deletionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWithReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWithReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWithReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * 🆕 RESTORE SOFT-DELETED PACKAGE WITH ALL RELATED ENTITIES
     * @param body (optional) Package ID to restore
     * @return Success
     */
    restore(body: GuidEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Package/Restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getLatestPackages(): Observable<PackageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Package/GetLatestPackages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestPackages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestPackages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto[]>;
        }));
    }

    protected processGetLatestPackages(response: HttpResponseBase): Observable<PackageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param count (optional) 
     * @return Success
     */
    getRecentPackages(count: number | undefined): Observable<PackageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Package/GetRecentPackages?";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentPackages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentPackages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto[]>;
        }));
    }

    protected processGetRecentPackages(response: HttpResponseBase): Observable<PackageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param packageId (optional) 
     * @return Success
     */
    getTravelsByPackageId(packageId: string | undefined): Observable<PackageTravelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Package/GetTravelsByPackageId?";
        if (packageId === null)
            throw new globalThis.Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelsByPackageId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelsByPackageId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageTravelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageTravelDto[]>;
        }));
    }

    protected processGetTravelsByPackageId(response: HttpResponseBase): Observable<PackageTravelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageTravelDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deActivate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Package/DeActivate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Package/Activate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    publish(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Package/Publish?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    unpublish(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Package/Unpublish?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnpublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnpublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnpublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search tours with filtering and pagination - Dynamic implementation with enhanced UX
    Provides comprehensive user experience with transparent status communication
     * @param body (optional) 
     * @return Success
     */
    searchTours1(body: TourSearchDto | undefined): Observable<TourSearchResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Package/SearchTours1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTours1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTours1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourSearchResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourSearchResponseDto>;
        }));
    }

    protected processSearchTours1(response: HttpResponseBase): Observable<TourSearchResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourSearchResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search packages by title for CMS selection
     * @param title (optional) Package title to search for
     * @return Success
     */
    searchPackagesByTitle(title: string | undefined): Observable<PackageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Package/SearchPackagesByTitle?";
        if (title === null)
            throw new globalThis.Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPackagesByTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPackagesByTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto[]>;
        }));
    }

    protected processSearchPackagesByTitle(response: HttpResponseBase): Observable<PackageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PassengerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userIdFilter: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PassengerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Passenger/GetAll?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassengerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassengerDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PassengerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassengerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PassengerDto> {
        let url_ = this.baseUrl + "/api/services/app/Passenger/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassengerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassengerDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PassengerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassengerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePassengerDto | undefined): Observable<PassengerDto> {
        let url_ = this.baseUrl + "/api/services/app/Passenger/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassengerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassengerDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PassengerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassengerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePassengerDto | undefined): Observable<PassengerDto> {
        let url_ = this.baseUrl + "/api/services/app/Passenger/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassengerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassengerDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PassengerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassengerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Passenger/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deletionReason (optional) Optional note recorded when soft-deleting the passenger.
     * @return Success
     */
    deleteWithReason(id: string, deletionReason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Passenger/DeleteWithReason?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deletionReason === null)
            throw new globalThis.Error("The parameter 'deletionReason' cannot be null.");
        else if (deletionReason !== undefined)
            url_ += "DeletionReason=" + encodeURIComponent("" + deletionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWithReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWithReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWithReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deActivate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Passenger/DeActivate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Passenger/Activate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    search(keyword: string | undefined): Observable<PassengerSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Passenger/Search?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassengerSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassengerSearchResultDto[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PassengerSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PassengerSearchResultDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    quickAdd(body: QuickAddPassengerDto | undefined): Observable<PassengerSearchResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Passenger/QuickAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuickAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuickAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassengerSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassengerSearchResultDto>;
        }));
    }

    protected processQuickAdd(response: HttpResponseBase): Observable<PassengerSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassengerSearchResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PassengerTagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param passengerId (optional) 
     * @return Success
     */
    getAll(passengerId: string | undefined): Observable<PassengerTag[]> {
        let url_ = this.baseUrl + "/api/services/app/PassengerTag/GetAll?";
        if (passengerId === null)
            throw new globalThis.Error("The parameter 'passengerId' cannot be null.");
        else if (passengerId !== undefined)
            url_ += "passengerId=" + encodeURIComponent("" + passengerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassengerTag[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassengerTag[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PassengerTag[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PassengerTag.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePassengerTagDto | undefined): Observable<PassengerTagDto> {
        let url_ = this.baseUrl + "/api/services/app/PassengerTag/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassengerTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassengerTagDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PassengerTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassengerTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePassengerTagDto | undefined): Observable<PassengerTagDto> {
        let url_ = this.baseUrl + "/api/services/app/PassengerTag/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassengerTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassengerTagDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PassengerTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassengerTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PassengerTag/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PassportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PassportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Passport/GetAll?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassportDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PassportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param issuingCountry (optional) 
     * @param documentType (optional) 
     * @param documentNo (optional) 
     * @param issuedDate (optional) 
     * @param expirationDate (optional) 
     * @param name (optional) 
     * @param surname (optional) 
     * @param middleName (optional) 
     * @param dateOfBirth (optional) 
     * @param gender (optional) 
     * @param birthPlace (optional) 
     * @param issuingAuthority (optional) 
     * @param nationality (optional) 
     * @param isActive (optional) 
     * @param isPrimary (optional) 
     * @param scannedPassportId (optional) 
     * @param documentFile_Base64 (optional) 
     * @param documentFile_Name (optional) 
     * @param documentFile_Type (optional) 
     * @return Success
     */
    create(issuingCountry: string | undefined, documentType: string | undefined, documentNo: string | undefined, issuedDate: moment.Moment | undefined, expirationDate: moment.Moment | undefined, name: string | undefined, surname: string | undefined, middleName: string | undefined, dateOfBirth: moment.Moment | undefined, gender: string | undefined, birthPlace: string | undefined, issuingAuthority: string | undefined, nationality: string | undefined, isActive: boolean | undefined, isPrimary: boolean | undefined, scannedPassportId: string | undefined, documentFile_Base64: string | undefined, documentFile_Name: string | undefined, documentFile_Type: string | undefined): Observable<PassportDto> {
        let url_ = this.baseUrl + "/api/services/app/Passport/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (issuingCountry === null || issuingCountry === undefined)
            throw new globalThis.Error("The parameter 'issuingCountry' cannot be null.");
        else
            content_.append("IssuingCountry", issuingCountry.toString());
        if (documentType === null || documentType === undefined)
            throw new globalThis.Error("The parameter 'documentType' cannot be null.");
        else
            content_.append("DocumentType", documentType.toString());
        if (documentNo === null || documentNo === undefined)
            throw new globalThis.Error("The parameter 'documentNo' cannot be null.");
        else
            content_.append("DocumentNo", documentNo.toString());
        if (issuedDate === null || issuedDate === undefined)
            throw new globalThis.Error("The parameter 'issuedDate' cannot be null.");
        else
            content_.append("IssuedDate", issuedDate.toJSON());
        if (expirationDate === null || expirationDate === undefined)
            throw new globalThis.Error("The parameter 'expirationDate' cannot be null.");
        else
            content_.append("ExpirationDate", expirationDate.toJSON());
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (surname === null || surname === undefined)
            throw new globalThis.Error("The parameter 'surname' cannot be null.");
        else
            content_.append("Surname", surname.toString());
        if (middleName === null || middleName === undefined)
            throw new globalThis.Error("The parameter 'middleName' cannot be null.");
        else
            content_.append("MiddleName", middleName.toString());
        if (dateOfBirth === null || dateOfBirth === undefined)
            throw new globalThis.Error("The parameter 'dateOfBirth' cannot be null.");
        else
            content_.append("DateOfBirth", dateOfBirth.toJSON());
        if (gender === null || gender === undefined)
            throw new globalThis.Error("The parameter 'gender' cannot be null.");
        else
            content_.append("Gender", gender.toString());
        if (birthPlace === null || birthPlace === undefined)
            throw new globalThis.Error("The parameter 'birthPlace' cannot be null.");
        else
            content_.append("BirthPlace", birthPlace.toString());
        if (issuingAuthority === null || issuingAuthority === undefined)
            throw new globalThis.Error("The parameter 'issuingAuthority' cannot be null.");
        else
            content_.append("IssuingAuthority", issuingAuthority.toString());
        if (nationality === null || nationality === undefined)
            throw new globalThis.Error("The parameter 'nationality' cannot be null.");
        else
            content_.append("Nationality", nationality.toString());
        if (isActive === null || isActive === undefined)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else
            content_.append("IsActive", isActive.toString());
        if (isPrimary === null || isPrimary === undefined)
            throw new globalThis.Error("The parameter 'isPrimary' cannot be null.");
        else
            content_.append("IsPrimary", isPrimary.toString());
        if (scannedPassportId === null || scannedPassportId === undefined)
            throw new globalThis.Error("The parameter 'scannedPassportId' cannot be null.");
        else
            content_.append("ScannedPassportId", scannedPassportId.toString());
        if (documentFile_Base64 === null || documentFile_Base64 === undefined)
            throw new globalThis.Error("The parameter 'documentFile_Base64' cannot be null.");
        else
            content_.append("DocumentFile.Base64", documentFile_Base64.toString());
        if (documentFile_Name === null || documentFile_Name === undefined)
            throw new globalThis.Error("The parameter 'documentFile_Name' cannot be null.");
        else
            content_.append("DocumentFile.Name", documentFile_Name.toString());
        if (documentFile_Type === null || documentFile_Type === undefined)
            throw new globalThis.Error("The parameter 'documentFile_Type' cannot be null.");
        else
            content_.append("DocumentFile.Type", documentFile_Type.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassportDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PassportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param issuingCountry (optional) 
     * @param documentType (optional) 
     * @param documentNo (optional) 
     * @param issuedDate (optional) 
     * @param expirationDate (optional) 
     * @param name (optional) 
     * @param surname (optional) 
     * @param middleName (optional) 
     * @param dateOfBirth (optional) 
     * @param gender (optional) 
     * @param birthPlace (optional) 
     * @param issuingAuthority (optional) 
     * @param nationality (optional) 
     * @param isActive (optional) 
     * @param isPrimary (optional) 
     * @param documentFile_Base64 (optional) 
     * @param documentFile_Name (optional) 
     * @param documentFile_Type (optional) 
     * @param id (optional) 
     * @return Success
     */
    update(issuingCountry: string | undefined, documentType: string | undefined, documentNo: string | undefined, issuedDate: moment.Moment | undefined, expirationDate: moment.Moment | undefined, name: string | undefined, surname: string | undefined, middleName: string | undefined, dateOfBirth: moment.Moment | undefined, gender: string | undefined, birthPlace: string | undefined, issuingAuthority: string | undefined, nationality: string | undefined, isActive: boolean | undefined, isPrimary: boolean | undefined, documentFile_Base64: string | undefined, documentFile_Name: string | undefined, documentFile_Type: string | undefined, id: string | undefined): Observable<PassportDto> {
        let url_ = this.baseUrl + "/api/services/app/Passport/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (issuingCountry === null || issuingCountry === undefined)
            throw new globalThis.Error("The parameter 'issuingCountry' cannot be null.");
        else
            content_.append("IssuingCountry", issuingCountry.toString());
        if (documentType === null || documentType === undefined)
            throw new globalThis.Error("The parameter 'documentType' cannot be null.");
        else
            content_.append("DocumentType", documentType.toString());
        if (documentNo === null || documentNo === undefined)
            throw new globalThis.Error("The parameter 'documentNo' cannot be null.");
        else
            content_.append("DocumentNo", documentNo.toString());
        if (issuedDate === null || issuedDate === undefined)
            throw new globalThis.Error("The parameter 'issuedDate' cannot be null.");
        else
            content_.append("IssuedDate", issuedDate.toJSON());
        if (expirationDate === null || expirationDate === undefined)
            throw new globalThis.Error("The parameter 'expirationDate' cannot be null.");
        else
            content_.append("ExpirationDate", expirationDate.toJSON());
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (surname === null || surname === undefined)
            throw new globalThis.Error("The parameter 'surname' cannot be null.");
        else
            content_.append("Surname", surname.toString());
        if (middleName === null || middleName === undefined)
            throw new globalThis.Error("The parameter 'middleName' cannot be null.");
        else
            content_.append("MiddleName", middleName.toString());
        if (dateOfBirth === null || dateOfBirth === undefined)
            throw new globalThis.Error("The parameter 'dateOfBirth' cannot be null.");
        else
            content_.append("DateOfBirth", dateOfBirth.toJSON());
        if (gender === null || gender === undefined)
            throw new globalThis.Error("The parameter 'gender' cannot be null.");
        else
            content_.append("Gender", gender.toString());
        if (birthPlace === null || birthPlace === undefined)
            throw new globalThis.Error("The parameter 'birthPlace' cannot be null.");
        else
            content_.append("BirthPlace", birthPlace.toString());
        if (issuingAuthority === null || issuingAuthority === undefined)
            throw new globalThis.Error("The parameter 'issuingAuthority' cannot be null.");
        else
            content_.append("IssuingAuthority", issuingAuthority.toString());
        if (nationality === null || nationality === undefined)
            throw new globalThis.Error("The parameter 'nationality' cannot be null.");
        else
            content_.append("Nationality", nationality.toString());
        if (isActive === null || isActive === undefined)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else
            content_.append("IsActive", isActive.toString());
        if (isPrimary === null || isPrimary === undefined)
            throw new globalThis.Error("The parameter 'isPrimary' cannot be null.");
        else
            content_.append("IsPrimary", isPrimary.toString());
        if (documentFile_Base64 === null || documentFile_Base64 === undefined)
            throw new globalThis.Error("The parameter 'documentFile_Base64' cannot be null.");
        else
            content_.append("DocumentFile.Base64", documentFile_Base64.toString());
        if (documentFile_Name === null || documentFile_Name === undefined)
            throw new globalThis.Error("The parameter 'documentFile_Name' cannot be null.");
        else
            content_.append("DocumentFile.Name", documentFile_Name.toString());
        if (documentFile_Type === null || documentFile_Type === undefined)
            throw new globalThis.Error("The parameter 'documentFile_Type' cannot be null.");
        else
            content_.append("DocumentFile.Type", documentFile_Type.toString());
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassportDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PassportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Passport/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PassportDto> {
        let url_ = this.baseUrl + "/api/services/app/Passport/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassportDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PassportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PayServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Authorize payment and issue the flight ticket (Step 4 of booking flow).
     * @param body (optional) 
     * @return Success
     */
    authorize(body: PaymentApiRequest | undefined): Observable<PaymentApiDto> {
        let url_ = this.baseUrl + "/api/pay/authorize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentApiDto>;
        }));
    }

    protected processAuthorize(response: HttpResponseBase): Observable<PaymentApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 402) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result402: any = null;
            let resultData402 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result402 = ProblemDetails.fromJS(resultData402);
            return throwException("Client Error", status, _responseText, _headers, result402);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authorizeAndTicket(body: PaymentApiRequest | undefined): Observable<PaymentApiDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/AuthorizeAndTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorizeAndTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorizeAndTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentApiDto>;
        }));
    }

    protected processAuthorizeAndTicket(response: HttpResponseBase): Observable<PaymentApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Register a new customer account using ABP framework
     * @param body (optional) 
     * @return Success
     */
    register(body: CustomerRegistrationDto | undefined): Observable<CustomerRegistrationResponseDto> {
        let url_ = this.baseUrl + "/api/public/auth/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerRegistrationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerRegistrationResponseDto>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<CustomerRegistrationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerRegistrationResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Login customer using ABP authentication
     * @param body (optional) 
     * @return Success
     */
    login(body: CustomerLoginDto | undefined): Observable<CustomerLoginResponseDto> {
        let url_ = this.baseUrl + "/api/public/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerLoginResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerLoginResponseDto>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<CustomerLoginResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerLoginResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if email is available for registration
     * @param email (optional) 
     * @return Success
     */
    checkEmail(email: string | undefined): Observable<EmailAvailabilityDto> {
        let url_ = this.baseUrl + "/api/public/auth/check-email?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAvailabilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAvailabilityDto>;
        }));
    }

    protected processCheckEmail(response: HttpResponseBase): Observable<EmailAvailabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailAvailabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class About_usServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get image gallery for About Us page (no authentication required)
     * @return Success
     */
    imageGallery(): Observable<GalleryItemDto[]> {
        let url_ = this.baseUrl + "/api/public/cms/about-us/image-gallery";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImageGallery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImageGallery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GalleryItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GalleryItemDto[]>;
        }));
    }

    protected processImageGallery(response: HttpResponseBase): Observable<GalleryItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GalleryItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StaysServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Search destinations for autocomplete.
    Returns destinations matching the query by name or code.
     * @param q (optional) Search query (minimum 2 characters)
     * @param limit (optional) Maximum results to return (default 10, max 20)
     * @return Success
     */
    destinations(q: string | undefined, limit: number | undefined): Observable<StayDestinationSuggestionDto[]> {
        let url_ = this.baseUrl + "/api/public/stays/destinations?";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDestinations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDestinations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayDestinationSuggestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayDestinationSuggestionDto[]>;
        }));
    }

    protected processDestinations(response: HttpResponseBase): Observable<StayDestinationSuggestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StayDestinationSuggestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    cancellationRequests(requestId: string): Observable<StayCancellationRequestDetailWithBookingDto> {
        let url_ = this.baseUrl + "/api/stays/cancellation-requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new globalThis.Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancellationRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancellationRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailWithBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailWithBookingDto>;
        }));
    }

    protected processCancellationRequests(response: HttpResponseBase): Observable<StayCancellationRequestDetailWithBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailWithBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update draft checkout (guest information)
     * @param body (optional) 
     * @return Success
     */
    checkoutPut(id: string, body: StayCheckoutDraftRequest | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckoutPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckoutPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processCheckoutPut(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get checkout status (for polling after payment)
     * @param email (optional) 
     * @return Success
     */
    checkoutGet(id: string, email: string | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckoutGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckoutGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processCheckoutGet(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: StaySearchApiRequest | undefined): Observable<StaySearchApiResultDto> {
        let url_ = this.baseUrl + "/api/stays/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaySearchApiResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaySearchApiResultDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<StaySearchApiResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaySearchApiResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param currency (optional) 
     * @return Success
     */
    rate(rateKey: string, currency: string | undefined): Observable<StayRateApiDto> {
        let url_ = this.baseUrl + "/api/stays/rate/{rateKey}?";
        if (rateKey === undefined || rateKey === null)
            throw new globalThis.Error("The parameter 'rateKey' must be defined.");
        url_ = url_.replace("{rateKey}", encodeURIComponent("" + rateKey));
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayRateApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayRateApiDto>;
        }));
    }

    protected processRate(response: HttpResponseBase): Observable<StayRateApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayRateApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    book(body: StayBookingApiRequest | undefined): Observable<StayBookingApiDto> {
        let url_ = this.baseUrl + "/api/stays/book";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayBookingApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayBookingApiDto>;
        }));
    }

    protected processBook(response: HttpResponseBase): Observable<StayBookingApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayBookingApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    bookingGet(bookingReference: string): Observable<StayBookingApiDto> {
        let url_ = this.baseUrl + "/api/stays/booking/{bookingReference}";
        if (bookingReference === undefined || bookingReference === null)
            throw new globalThis.Error("The parameter 'bookingReference' must be defined.");
        url_ = url_.replace("{bookingReference}", encodeURIComponent("" + bookingReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookingGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayBookingApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayBookingApiDto>;
        }));
    }

    protected processBookingGet(response: HttpResponseBase): Observable<StayBookingApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayBookingApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    bookingDelete(bookingReference: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/stays/booking/{bookingReference}";
        if (bookingReference === undefined || bookingReference === null)
            throw new globalThis.Error("The parameter 'bookingReference' must be defined.");
        url_ = url_.replace("{bookingReference}", encodeURIComponent("" + bookingReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookingDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processBookingDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PurchaseOrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @return Success
     */
    getAll(userIdFilter: number | undefined, keyword: string | undefined, sortColumn: string | undefined, sortOrder: string | undefined, page: number | undefined, size: number | undefined): Observable<PurchaseOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/GetAll?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sortColumn === null)
            throw new globalThis.Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PurchaseOrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseOrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @return Success
     */
    getPurchases(userIdFilter: number | undefined, keyword: string | undefined, sortColumn: string | undefined, sortOrder: string | undefined, page: number | undefined, size: number | undefined): Observable<PagedPurchaseOrderResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/GetPurchases?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sortColumn === null)
            throw new globalThis.Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedPurchaseOrderResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedPurchaseOrderResultDto>;
        }));
    }

    protected processGetPurchases(response: HttpResponseBase): Observable<PagedPurchaseOrderResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedPurchaseOrderResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingId (optional) 
     * @return Success
     */
    getByBookingId(bookingId: string | undefined): Observable<PurchaseOrderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/GetByBookingId?";
        if (bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByBookingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByBookingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderDto[]>;
        }));
    }

    protected processGetByBookingId(response: HttpResponseBase): Observable<PurchaseOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PurchaseOrderDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PurchaseOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PurchaseOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePurchaseOrderDto | undefined): Observable<PurchaseOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PurchaseOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePurchaseOrderDto | undefined): Observable<PurchaseOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PurchaseOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deletionReason (optional) 
     * @return Success
     */
    deleteWithReason(id: string, deletionReason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/DeleteWithReason?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deletionReason === null)
            throw new globalThis.Error("The parameter 'deletionReason' cannot be null.");
        else if (deletionReason !== undefined)
            url_ += "DeletionReason=" + encodeURIComponent("" + deletionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWithReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWithReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWithReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadReceipt(body: CreatePurchaseOrderReceiptDto | undefined): Observable<PurchaseOrderReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/UploadReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderReceiptDto>;
        }));
    }

    protected processUploadReceipt(response: HttpResponseBase): Observable<PurchaseOrderReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseOrderReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param receiptId (optional) 
     * @return Success
     */
    deleteReceipt(receiptId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/DeleteReceipt?";
        if (receiptId === null)
            throw new globalThis.Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteReceipt(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param receiptAttachmentId (optional) 
     * @return Success
     */
    deleteReceiptAttachment(receiptAttachmentId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/DeleteReceiptAttachment?";
        if (receiptAttachmentId === null)
            throw new globalThis.Error("The parameter 'receiptAttachmentId' cannot be null.");
        else if (receiptAttachmentId !== undefined)
            url_ += "receiptAttachmentId=" + encodeURIComponent("" + receiptAttachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReceiptAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReceiptAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteReceiptAttachment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param purchaseOrderId (optional) 
     * @param statusId (optional) 
     * @return Success
     */
    setStatus(purchaseOrderId: string | undefined, statusId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrder/SetStatus?";
        if (purchaseOrderId === null)
            throw new globalThis.Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new globalThis.Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getPermission(permission: string | undefined): Observable<PermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetPermission?";
        if (permission === null)
            throw new globalThis.Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDto[]>;
        }));
    }

    protected processGetPermission(response: HttpResponseBase): Observable<PermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PermissionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deletionReason (optional) 
     * @return Success
     */
    deleteWithReason(id: number, deletionReason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteWithReason?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deletionReason === null)
            throw new globalThis.Error("The parameter 'deletionReason' cannot be null.");
        else if (deletionReason !== undefined)
            url_ += "DeletionReason=" + encodeURIComponent("" + deletionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWithReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWithReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWithReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<GroupedPermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupedPermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupedPermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<GroupedPermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupedPermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScannedPassportsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getScannedPassportById(id: string | undefined): Observable<ScannedPassportDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannedPassports/GetScannedPassportById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannedPassportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannedPassportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannedPassportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannedPassportDto>;
        }));
    }

    protected processGetScannedPassportById(response: HttpResponseBase): Observable<ScannedPassportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannedPassportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceCode (optional) 
     * @return Success
     */
    search(referenceCode: string | undefined): Observable<ScannedPassportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScannedPassports/Search?";
        if (referenceCode === null)
            throw new globalThis.Error("The parameter 'referenceCode' cannot be null.");
        else if (referenceCode !== undefined)
            url_ += "referenceCode=" + encodeURIComponent("" + referenceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannedPassportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannedPassportDto[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ScannedPassportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ScannedPassportDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signInWithToken(body: SignInWithTokenInput | undefined): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/SignInWithToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignInWithToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignInWithToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processSignInWithToken(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StatementOfAccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param statementNumberFilter (optional) 
     * @param receiptNumberFilter (optional) 
     * @param guestNameFilter (optional) 
     * @param statusIdFilter (optional) 
     * @param bookingOrProductCodeFilter (optional) 
     * @param agentNameFilter (optional) 
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @return Success
     */
    getAll(userIdFilter: number | undefined, keyword: string | undefined, statementNumberFilter: string | undefined, receiptNumberFilter: string | undefined, guestNameFilter: string | undefined, statusIdFilter: string | undefined, bookingOrProductCodeFilter: string | undefined, agentNameFilter: string | undefined, sortColumn: string | undefined, sortOrder: string | undefined, page: number | undefined, size: number | undefined): Observable<StatementOfAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/GetAll?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (statementNumberFilter === null)
            throw new globalThis.Error("The parameter 'statementNumberFilter' cannot be null.");
        else if (statementNumberFilter !== undefined)
            url_ += "StatementNumberFilter=" + encodeURIComponent("" + statementNumberFilter) + "&";
        if (receiptNumberFilter === null)
            throw new globalThis.Error("The parameter 'receiptNumberFilter' cannot be null.");
        else if (receiptNumberFilter !== undefined)
            url_ += "ReceiptNumberFilter=" + encodeURIComponent("" + receiptNumberFilter) + "&";
        if (guestNameFilter === null)
            throw new globalThis.Error("The parameter 'guestNameFilter' cannot be null.");
        else if (guestNameFilter !== undefined)
            url_ += "GuestNameFilter=" + encodeURIComponent("" + guestNameFilter) + "&";
        if (statusIdFilter === null)
            throw new globalThis.Error("The parameter 'statusIdFilter' cannot be null.");
        else if (statusIdFilter !== undefined)
            url_ += "StatusIdFilter=" + encodeURIComponent("" + statusIdFilter) + "&";
        if (bookingOrProductCodeFilter === null)
            throw new globalThis.Error("The parameter 'bookingOrProductCodeFilter' cannot be null.");
        else if (bookingOrProductCodeFilter !== undefined)
            url_ += "BookingOrProductCodeFilter=" + encodeURIComponent("" + bookingOrProductCodeFilter) + "&";
        if (agentNameFilter === null)
            throw new globalThis.Error("The parameter 'agentNameFilter' cannot be null.");
        else if (agentNameFilter !== undefined)
            url_ += "AgentNameFilter=" + encodeURIComponent("" + agentNameFilter) + "&";
        if (sortColumn === null)
            throw new globalThis.Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatementOfAccountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatementOfAccountDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StatementOfAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatementOfAccountDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<StatementOfAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatementOfAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatementOfAccountDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StatementOfAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatementOfAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateStatementOfAccountDto | undefined): Observable<StatementOfAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatementOfAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatementOfAccountDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StatementOfAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatementOfAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param statementNumberFilter (optional) 
     * @param receiptNumberFilter (optional) 
     * @param guestNameFilter (optional) 
     * @param statusIdFilter (optional) 
     * @param bookingOrProductCodeFilter (optional) 
     * @param agentNameFilter (optional) 
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @return Success
     */
    getSales(userIdFilter: number | undefined, keyword: string | undefined, statementNumberFilter: string | undefined, receiptNumberFilter: string | undefined, guestNameFilter: string | undefined, statusIdFilter: string | undefined, bookingOrProductCodeFilter: string | undefined, agentNameFilter: string | undefined, sortColumn: string | undefined, sortOrder: string | undefined, page: number | undefined, size: number | undefined): Observable<PagedStatementOfAccountResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/GetSales?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (statementNumberFilter === null)
            throw new globalThis.Error("The parameter 'statementNumberFilter' cannot be null.");
        else if (statementNumberFilter !== undefined)
            url_ += "StatementNumberFilter=" + encodeURIComponent("" + statementNumberFilter) + "&";
        if (receiptNumberFilter === null)
            throw new globalThis.Error("The parameter 'receiptNumberFilter' cannot be null.");
        else if (receiptNumberFilter !== undefined)
            url_ += "ReceiptNumberFilter=" + encodeURIComponent("" + receiptNumberFilter) + "&";
        if (guestNameFilter === null)
            throw new globalThis.Error("The parameter 'guestNameFilter' cannot be null.");
        else if (guestNameFilter !== undefined)
            url_ += "GuestNameFilter=" + encodeURIComponent("" + guestNameFilter) + "&";
        if (statusIdFilter === null)
            throw new globalThis.Error("The parameter 'statusIdFilter' cannot be null.");
        else if (statusIdFilter !== undefined)
            url_ += "StatusIdFilter=" + encodeURIComponent("" + statusIdFilter) + "&";
        if (bookingOrProductCodeFilter === null)
            throw new globalThis.Error("The parameter 'bookingOrProductCodeFilter' cannot be null.");
        else if (bookingOrProductCodeFilter !== undefined)
            url_ += "BookingOrProductCodeFilter=" + encodeURIComponent("" + bookingOrProductCodeFilter) + "&";
        if (agentNameFilter === null)
            throw new globalThis.Error("The parameter 'agentNameFilter' cannot be null.");
        else if (agentNameFilter !== undefined)
            url_ += "AgentNameFilter=" + encodeURIComponent("" + agentNameFilter) + "&";
        if (sortColumn === null)
            throw new globalThis.Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedStatementOfAccountResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedStatementOfAccountResultDto>;
        }));
    }

    protected processGetSales(response: HttpResponseBase): Observable<PagedStatementOfAccountResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedStatementOfAccountResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param statementNumberFilter (optional) 
     * @param receiptNumberFilter (optional) 
     * @param guestNameFilter (optional) 
     * @param statusIdFilter (optional) 
     * @param bookingOrProductCodeFilter (optional) 
     * @param agentNameFilter (optional) 
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @return Success
     */
    getSalesForReport(userIdFilter: number | undefined, keyword: string | undefined, statementNumberFilter: string | undefined, receiptNumberFilter: string | undefined, guestNameFilter: string | undefined, statusIdFilter: string | undefined, bookingOrProductCodeFilter: string | undefined, agentNameFilter: string | undefined, sortColumn: string | undefined, sortOrder: string | undefined, page: number | undefined, size: number | undefined): Observable<PagedStatementOfAccountForReportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/GetSalesForReport?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (statementNumberFilter === null)
            throw new globalThis.Error("The parameter 'statementNumberFilter' cannot be null.");
        else if (statementNumberFilter !== undefined)
            url_ += "StatementNumberFilter=" + encodeURIComponent("" + statementNumberFilter) + "&";
        if (receiptNumberFilter === null)
            throw new globalThis.Error("The parameter 'receiptNumberFilter' cannot be null.");
        else if (receiptNumberFilter !== undefined)
            url_ += "ReceiptNumberFilter=" + encodeURIComponent("" + receiptNumberFilter) + "&";
        if (guestNameFilter === null)
            throw new globalThis.Error("The parameter 'guestNameFilter' cannot be null.");
        else if (guestNameFilter !== undefined)
            url_ += "GuestNameFilter=" + encodeURIComponent("" + guestNameFilter) + "&";
        if (statusIdFilter === null)
            throw new globalThis.Error("The parameter 'statusIdFilter' cannot be null.");
        else if (statusIdFilter !== undefined)
            url_ += "StatusIdFilter=" + encodeURIComponent("" + statusIdFilter) + "&";
        if (bookingOrProductCodeFilter === null)
            throw new globalThis.Error("The parameter 'bookingOrProductCodeFilter' cannot be null.");
        else if (bookingOrProductCodeFilter !== undefined)
            url_ += "BookingOrProductCodeFilter=" + encodeURIComponent("" + bookingOrProductCodeFilter) + "&";
        if (agentNameFilter === null)
            throw new globalThis.Error("The parameter 'agentNameFilter' cannot be null.");
        else if (agentNameFilter !== undefined)
            url_ += "AgentNameFilter=" + encodeURIComponent("" + agentNameFilter) + "&";
        if (sortColumn === null)
            throw new globalThis.Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesForReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesForReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedStatementOfAccountForReportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedStatementOfAccountForReportResultDto>;
        }));
    }

    protected processGetSalesForReport(response: HttpResponseBase): Observable<PagedStatementOfAccountForReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedStatementOfAccountForReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingId (optional) 
     * @return Success
     */
    getByBookingId(bookingId: string | undefined): Observable<StatementOfAccountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/GetByBookingId?";
        if (bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByBookingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByBookingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatementOfAccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatementOfAccountDto[]>;
        }));
    }

    protected processGetByBookingId(response: HttpResponseBase): Observable<StatementOfAccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StatementOfAccountDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadReceipt(body: CreateStatementOfAccountReceiptDto | undefined): Observable<StatementOfAccountReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/UploadReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatementOfAccountReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatementOfAccountReceiptDto>;
        }));
    }

    protected processUploadReceipt(response: HttpResponseBase): Observable<StatementOfAccountReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatementOfAccountReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param receiptId (optional) 
     * @return Success
     */
    deleteReceipt(receiptId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/DeleteReceipt?";
        if (receiptId === null)
            throw new globalThis.Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteReceipt(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param receiptAttachmentId (optional) 
     * @return Success
     */
    deleteReceiptAttachment(receiptAttachmentId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/DeleteReceiptAttachment?";
        if (receiptAttachmentId === null)
            throw new globalThis.Error("The parameter 'receiptAttachmentId' cannot be null.");
        else if (receiptAttachmentId !== undefined)
            url_ += "receiptAttachmentId=" + encodeURIComponent("" + receiptAttachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReceiptAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReceiptAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteReceiptAttachment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param purchaseOrderId (optional) 
     * @param statusId (optional) 
     * @return Success
     */
    setStatus(purchaseOrderId: string | undefined, statusId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/SetStatus?";
        if (purchaseOrderId === null)
            throw new globalThis.Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStatementNumber(body: UpdateStatementNumberInput | undefined): Observable<StatementOfAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/UpdateStatementNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatementNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatementNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatementOfAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatementOfAccountDto>;
        }));
    }

    protected processUpdateStatementNumber(response: HttpResponseBase): Observable<StatementOfAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatementOfAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateStatementOfAccountDto | undefined): Observable<StatementOfAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatementOfAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatementOfAccountDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StatementOfAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatementOfAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deletionReason (optional) 
     * @return Success
     */
    deleteWithReason(id: string, deletionReason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StatementOfAccount/DeleteWithReason?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deletionReason === null)
            throw new globalThis.Error("The parameter 'deletionReason' cannot be null.");
        else if (deletionReason !== undefined)
            url_ += "DeletionReason=" + encodeURIComponent("" + deletionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWithReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWithReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWithReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StayBookingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    book(body: StayBookingApiRequest | undefined): Observable<StayBookingApiDto> {
        let url_ = this.baseUrl + "/api/services/app/StayBooking/Book";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayBookingApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayBookingApiDto>;
        }));
    }

    protected processBook(response: HttpResponseBase): Observable<StayBookingApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayBookingApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingReference (optional) 
     * @return Success
     */
    get(bookingReference: string | undefined): Observable<StayBookingApiDto> {
        let url_ = this.baseUrl + "/api/services/app/StayBooking/Get?";
        if (bookingReference === null)
            throw new globalThis.Error("The parameter 'bookingReference' cannot be null.");
        else if (bookingReference !== undefined)
            url_ += "bookingReference=" + encodeURIComponent("" + bookingReference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayBookingApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayBookingApiDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StayBookingApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayBookingApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingReference (optional) 
     * @return Success
     */
    cancel(bookingReference: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/StayBooking/Cancel?";
        if (bookingReference === null)
            throw new globalThis.Error("The parameter 'bookingReference' cannot be null.");
        else if (bookingReference !== undefined)
            url_ += "bookingReference=" + encodeURIComponent("" + bookingReference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bookingReference (optional) 
     * @param simulation (optional) 
     * @return Success
     */
    cancelWithDetails(bookingReference: string | undefined, simulation: boolean | undefined): Observable<StayCancellationDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/StayBooking/CancelWithDetails?";
        if (bookingReference === null)
            throw new globalThis.Error("The parameter 'bookingReference' cannot be null.");
        else if (bookingReference !== undefined)
            url_ += "bookingReference=" + encodeURIComponent("" + bookingReference) + "&";
        if (simulation === null)
            throw new globalThis.Error("The parameter 'simulation' cannot be null.");
        else if (simulation !== undefined)
            url_ += "simulation=" + encodeURIComponent("" + simulation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelWithDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelWithDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationDetailsDto>;
        }));
    }

    protected processCancelWithDetails(response: HttpResponseBase): Observable<StayCancellationDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StayBookingEmailServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param draftId (optional) 
     * @return Success
     */
    buildModel(draftId: string | undefined): Observable<StayBookingEmailModel> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/BuildModel?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayBookingEmailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayBookingEmailModel>;
        }));
    }

    protected processBuildModel(response: HttpResponseBase): Observable<StayBookingEmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayBookingEmailModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @return Success
     */
    renderConfirmationHtml(draftId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/RenderConfirmationHtml?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenderConfirmationHtml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenderConfirmationHtml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRenderConfirmationHtml(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @param overrideToEmail (optional) 
     * @return Success
     */
    sendConfirmationTest(draftId: string | undefined, overrideToEmail: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/SendConfirmationTest?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        if (overrideToEmail === null)
            throw new globalThis.Error("The parameter 'overrideToEmail' cannot be null.");
        else if (overrideToEmail !== undefined)
            url_ += "overrideToEmail=" + encodeURIComponent("" + overrideToEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendConfirmationTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @param overrideToEmail (optional) 
     * @param sessionId (optional) 
     * @return Success
     */
    sendConfirmationTestForCheckout(draftId: string | undefined, overrideToEmail: string | undefined, sessionId: string | undefined): Observable<SendStayConfirmationEmailResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/SendConfirmationTestForCheckout?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        if (overrideToEmail === null)
            throw new globalThis.Error("The parameter 'overrideToEmail' cannot be null.");
        else if (overrideToEmail !== undefined)
            url_ += "overrideToEmail=" + encodeURIComponent("" + overrideToEmail) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationTestForCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationTestForCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendStayConfirmationEmailResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendStayConfirmationEmailResultDto>;
        }));
    }

    protected processSendConfirmationTestForCheckout(response: HttpResponseBase): Observable<SendStayConfirmationEmailResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendStayConfirmationEmailResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @return Success
     */
    sendConfirmation(draftId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/SendConfirmation?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @return Success
     */
    sendFailureRefund(draftId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/SendFailureRefund?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendFailureRefund(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendFailureRefund(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendFailureRefund(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @return Success
     */
    sendPaymentFailed(draftId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/SendPaymentFailed?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPaymentFailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPaymentFailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPaymentFailed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @return Success
     */
    sendConfirming(draftId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/SendConfirming?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirming(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirming(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendConfirming(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @param daysBeforeCheckIn (optional) 
     * @return Success
     */
    sendPreStayReminder(draftId: string | undefined, daysBeforeCheckIn: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/SendPreStayReminder?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        if (daysBeforeCheckIn === null)
            throw new globalThis.Error("The parameter 'daysBeforeCheckIn' cannot be null.");
        else if (daysBeforeCheckIn !== undefined)
            url_ += "daysBeforeCheckIn=" + encodeURIComponent("" + daysBeforeCheckIn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPreStayReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPreStayReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPreStayReminder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @return Success
     */
    sendCancellation(draftId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/SendCancellation?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCancellation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendCancellation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    trySendCancellationRequestReceived(requestId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/TrySendCancellationRequestReceived?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrySendCancellationRequestReceived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrySendCancellationRequestReceived(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrySendCancellationRequestReceived(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    trySendCancellationApproved(requestId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/TrySendCancellationApproved?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrySendCancellationApproved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrySendCancellationApproved(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrySendCancellationApproved(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    trySendCancellationDeclined(requestId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/TrySendCancellationDeclined?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrySendCancellationDeclined(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrySendCancellationDeclined(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrySendCancellationDeclined(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    trySendCancellationClosedNotCancellable(requestId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayBookingEmailService/TrySendCancellationClosedNotCancellable?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrySendCancellationClosedNotCancellable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrySendCancellationClosedNotCancellable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrySendCancellationClosedNotCancellable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Cancellation_requestsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Paged admin list. Route segment "list" keeps NSwag method names distinct from GET by id.
     * @param status (optional) 
     * @param clientReference (optional) 
     * @param requestedFrom (optional) 
     * @param requestedTo (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    list(status: StayCancellationRequestStatus | undefined, clientReference: string | undefined, requestedFrom: moment.Moment | undefined, requestedTo: moment.Moment | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StayCancellationRequestListItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/stays/cancellation-requests/list?";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (clientReference === null)
            throw new globalThis.Error("The parameter 'clientReference' cannot be null.");
        else if (clientReference !== undefined)
            url_ += "ClientReference=" + encodeURIComponent("" + clientReference) + "&";
        if (requestedFrom === null)
            throw new globalThis.Error("The parameter 'requestedFrom' cannot be null.");
        else if (requestedFrom !== undefined)
            url_ += "RequestedFrom=" + encodeURIComponent(requestedFrom ? "" + requestedFrom.toISOString() : "") + "&";
        if (requestedTo === null)
            throw new globalThis.Error("The parameter 'requestedTo' cannot be null.");
        else if (requestedTo !== undefined)
            url_ += "RequestedTo=" + encodeURIComponent(requestedTo ? "" + requestedTo.toISOString() : "") + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestListItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestListItemDtoPagedResultDto>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<StayCancellationRequestListItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestListItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(requestId: string, body: ApproveStayCancellationRequestInput | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/stays/cancellation-requests/{requestId}/approve";
        if (requestId === undefined || requestId === null)
            throw new globalThis.Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    decline(requestId: string, body: DeclineStayCancellationRequestInput | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/stays/cancellation-requests/{requestId}/decline";
        if (requestId === undefined || requestId === null)
            throw new globalThis.Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processDecline(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    closeNotCancellable(requestId: string, body: CloseStayCancellationRequestNotCancellableInput | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/stays/cancellation-requests/{requestId}/close-not-cancellable";
        if (requestId === undefined || requestId === null)
            throw new globalThis.Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseNotCancellable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseNotCancellable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processCloseNotCancellable(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markRefundCompleted(requestId: string, body: MarkStayCancellationRefundCompletedInput | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/stays/cancellation-requests/{requestId}/mark-refund-completed";
        if (requestId === undefined || requestId === null)
            throw new globalThis.Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkRefundCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkRefundCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processMarkRefundCompleted(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StayCancellationRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param draftId (optional) 
     * @param sessionId (optional) 
     * @param body (optional) 
     * @return Success
     */
    submit(draftId: string | undefined, sessionId: string | undefined, body: SubmitStayCancellationRequestInput | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCancellationRequest/Submit?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @param sessionId (optional) 
     * @param email (optional) 
     * @return Success
     */
    getForCheckout(draftId: string | undefined, sessionId: string | undefined, email: string | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCancellationRequest/GetForCheckout?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processGetForCheckout(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @param sessionId (optional) 
     * @param email (optional) 
     * @return Success
     */
    withdraw(draftId: string | undefined, sessionId: string | undefined, email: string | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCancellationRequest/Withdraw?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdraw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdraw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processWithdraw(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param status (optional) 
     * @param clientReference (optional) 
     * @param requestedFrom (optional) 
     * @param requestedTo (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getList(status: StayCancellationRequestStatus | undefined, clientReference: string | undefined, requestedFrom: moment.Moment | undefined, requestedTo: moment.Moment | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StayCancellationRequestListItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCancellationRequest/GetList?";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (clientReference === null)
            throw new globalThis.Error("The parameter 'clientReference' cannot be null.");
        else if (clientReference !== undefined)
            url_ += "ClientReference=" + encodeURIComponent("" + clientReference) + "&";
        if (requestedFrom === null)
            throw new globalThis.Error("The parameter 'requestedFrom' cannot be null.");
        else if (requestedFrom !== undefined)
            url_ += "RequestedFrom=" + encodeURIComponent(requestedFrom ? "" + requestedFrom.toISOString() : "") + "&";
        if (requestedTo === null)
            throw new globalThis.Error("The parameter 'requestedTo' cannot be null.");
        else if (requestedTo !== undefined)
            url_ += "RequestedTo=" + encodeURIComponent(requestedTo ? "" + requestedTo.toISOString() : "") + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestListItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestListItemDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<StayCancellationRequestListItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestListItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    get(requestId: string | undefined): Observable<StayCancellationRequestDetailWithBookingDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCancellationRequest/Get?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailWithBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailWithBookingDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StayCancellationRequestDetailWithBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailWithBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param body (optional) 
     * @return Success
     */
    approve(requestId: string | undefined, body: ApproveStayCancellationRequestInput | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCancellationRequest/Approve?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param body (optional) 
     * @return Success
     */
    decline(requestId: string | undefined, body: DeclineStayCancellationRequestInput | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCancellationRequest/Decline?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processDecline(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param body (optional) 
     * @return Success
     */
    closeNotCancellable(requestId: string | undefined, body: CloseStayCancellationRequestNotCancellableInput | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCancellationRequest/CloseNotCancellable?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseNotCancellable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseNotCancellable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processCloseNotCancellable(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param body (optional) 
     * @return Success
     */
    markRefundCompleted(requestId: string | undefined, body: MarkStayCancellationRefundCompletedInput | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCancellationRequest/MarkRefundCompleted?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkRefundCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkRefundCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processMarkRefundCompleted(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CheckoutServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Initialize checkout — CheckRate + create draft (D4b URL-owned checkout)
     * @param body (optional) 
     * @return Success
     */
    init(body: StayCheckoutInitRequest | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/init";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processInit(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new draft checkout
     * @param body (optional) 
     * @return Success
     */
    draft(body: StayCheckoutDraftRequest | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/draft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processDraft(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Stripe PaymentIntent for checkout
     * @return Success
     */
    paymentIntent(id: string): Observable<StayPaymentIntentDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/{id}/payment-intent";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentIntent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentIntent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayPaymentIntentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayPaymentIntentDto>;
        }));
    }

    protected processPaymentIntent(response: HttpResponseBase): Observable<StayPaymentIntentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayPaymentIntentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Admin lookup by client reference (requires Pages.Stays.CancelBooking)
     * @return Success
     */
    byReference(clientReference: string): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/by-reference/{clientReference}";
        if (clientReference === undefined || clientReference === null)
            throw new globalThis.Error("The parameter 'clientReference' must be defined.");
        url_ = url_.replace("{clientReference}", encodeURIComponent("" + clientReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByReference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByReference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processByReference(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retry HotelBeds confirmation after payment succeeded (non-blocking for GET polls)
     * @return Success
     */
    confirmSupplier(id: string): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/{id}/confirm-supplier";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processConfirmSupplier(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send booking confirmation email to a specified address (dev / manual resend)
     * @param body (optional) 
     * @return Success
     */
    sendConfirmationEmail(id: string, body: SendStayConfirmationEmailRequest | undefined): Observable<SendStayConfirmationEmailResultDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/{id}/send-confirmation-email";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendStayConfirmationEmailResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendStayConfirmationEmailResultDto>;
        }));
    }

    protected processSendConfirmationEmail(response: HttpResponseBase): Observable<SendStayConfirmationEmailResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendStayConfirmationEmailResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Preview cancellation refund/penalty via HotelBeds simulation (no DB changes)
     * @param body (optional) 
     * @return Success
     */
    cancellationPreview(id: string, body: StayCancellationRequestDto | undefined): Observable<StayCancellationPreviewDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/{id}/cancellation-preview";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancellationPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancellationPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationPreviewDto>;
        }));
    }

    protected processCancellationPreview(response: HttpResponseBase): Observable<StayCancellationPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationPreviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel a confirmed checkout booking (HotelBeds + Stripe partial refund + E6 email)
     * @param body (optional) 
     * @return Success
     */
    cancel(id: string, body: StayCancellationRequestDto | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/{id}/cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Submit a cancellation request (guest — requires session or lead-guest email)
     * @param body (optional) 
     * @return Success
     */
    cancellationRequestPost(id: string, body: SubmitStayCancellationRequestInput | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/{id}/cancellation-request";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancellationRequestPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancellationRequestPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processCancellationRequestPost(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get current cancellation request for a checkout (guest)
     * @param email (optional) 
     * @return Success
     */
    cancellationRequestGet(id: string, email: string | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/{id}/cancellation-request?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancellationRequestGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancellationRequestGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processCancellationRequestGet(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Cancellation_requestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Withdraw a pending cancellation request (guest)
     * @param body (optional) 
     * @return Success
     */
    withdraw(id: string, body: WithdrawStayCancellationRequestInput | undefined): Observable<StayCancellationRequestDetailDto> {
        let url_ = this.baseUrl + "/api/stays/checkout/{id}/cancellation-request/withdraw";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdraw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdraw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationRequestDetailDto>;
        }));
    }

    protected processWithdraw(response: HttpResponseBase): Observable<StayCancellationRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StayCheckoutServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDraft(body: StayCheckoutDraftRequest | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/CreateDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processCreateDraft(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    initCheckout(body: StayCheckoutInitRequest | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/InitCheckout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processInitCheckout(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateDraft(id: string | undefined, body: StayCheckoutDraftRequest | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/UpdateDraft?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processUpdateDraft(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    createPaymentIntent(id: string | undefined): Observable<StayPaymentIntentDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/CreatePaymentIntent?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentIntent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentIntent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayPaymentIntentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayPaymentIntentDto>;
        }));
    }

    protected processCreatePaymentIntent(response: HttpResponseBase): Observable<StayPaymentIntentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayPaymentIntentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sessionId (optional) 
     * @param email (optional) 
     * @return Success
     */
    getCheckout(id: string | undefined, sessionId: string | undefined, email: string | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/GetCheckout?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processGetCheckout(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientReference (optional) 
     * @return Success
     */
    getCheckoutByReference(clientReference: string | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/GetCheckoutByReference?";
        if (clientReference === null)
            throw new globalThis.Error("The parameter 'clientReference' cannot be null.");
        else if (clientReference !== undefined)
            url_ += "clientReference=" + encodeURIComponent("" + clientReference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckoutByReference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckoutByReference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processGetCheckoutByReference(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sessionId (optional) 
     * @return Success
     */
    retrySupplierConfirmation(id: string | undefined, sessionId: string | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/RetrySupplierConfirmation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrySupplierConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrySupplierConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processRetrySupplierConfirmation(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentIntentId (optional) 
     * @return Success
     */
    handlePaymentSucceeded(paymentIntentId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/HandlePaymentSucceeded?";
        if (paymentIntentId === null)
            throw new globalThis.Error("The parameter 'paymentIntentId' cannot be null.");
        else if (paymentIntentId !== undefined)
            url_ += "paymentIntentId=" + encodeURIComponent("" + paymentIntentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandlePaymentSucceeded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandlePaymentSucceeded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandlePaymentSucceeded(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @param sessionId (optional) 
     * @param email (optional) 
     * @return Success
     */
    getCancellationPreview(draftId: string | undefined, sessionId: string | undefined, email: string | undefined): Observable<StayCancellationPreviewDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/GetCancellationPreview?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancellationPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancellationPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationPreviewDto>;
        }));
    }

    protected processGetCancellationPreview(response: HttpResponseBase): Observable<StayCancellationPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationPreviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @return Success
     */
    getCancellationPreviewForBooking(draftId: string | undefined): Observable<StayCancellationPreviewDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/GetCancellationPreviewForBooking?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancellationPreviewForBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancellationPreviewForBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCancellationPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCancellationPreviewDto>;
        }));
    }

    protected processGetCancellationPreviewForBooking(response: HttpResponseBase): Observable<StayCancellationPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCancellationPreviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @param sessionId (optional) 
     * @param email (optional) 
     * @param deniedMessage (optional) 
     * @return Success
     */
    ensureGuestCanAccessCheckout(draftId: string | undefined, sessionId: string | undefined, email: string | undefined, deniedMessage: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/EnsureGuestCanAccessCheckout?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (deniedMessage === null)
            throw new globalThis.Error("The parameter 'deniedMessage' cannot be null.");
        else if (deniedMessage !== undefined)
            url_ += "deniedMessage=" + encodeURIComponent("" + deniedMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnsureGuestCanAccessCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnsureGuestCanAccessCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnsureGuestCanAccessCheckout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @param sessionId (optional) 
     * @param body (optional) 
     * @return Success
     */
    cancel(draftId: string | undefined, sessionId: string | undefined, body: StayCancellationRequestDto | undefined): Observable<StayCheckoutDto> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/Cancel?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCheckoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCheckoutDto>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<StayCheckoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCheckoutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * HotelBeds live cancel with optional Stripe refund and E6 email. No guest/session guard — callers must authorize first.
    C-REQ-1 approve: SkipStripeRefund = !AutoRefundOnCancellationApproval; SendCancellationEmail = false (E6b instead).
     * @param draftId (optional) 
     * @param body (optional) 
     * @return Success
     */
    executeSupplierCancel(draftId: string | undefined, body: StaySupplierCancelOptions | undefined): Observable<StayCustomerBooking> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/ExecuteSupplierCancel?";
        if (draftId === null)
            throw new globalThis.Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteSupplierCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteSupplierCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayCustomerBooking>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayCustomerBooking>;
        }));
    }

    protected processExecuteSupplierCancel(response: HttpResponseBase): Observable<StayCustomerBooking> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayCustomerBooking.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentIntentId (optional) 
     * @return Success
     */
    handlePaymentFailed(paymentIntentId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StayCheckout/HandlePaymentFailed?";
        if (paymentIntentId === null)
            throw new globalThis.Error("The parameter 'paymentIntentId' cannot be null.");
        else if (paymentIntentId !== undefined)
            url_ += "paymentIntentId=" + encodeURIComponent("" + paymentIntentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandlePaymentFailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandlePaymentFailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandlePaymentFailed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StayDestinationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param query (optional) 
     * @param limit (optional) 
     * @return Success
     */
    searchDestinations(query: string | undefined, limit: number | undefined): Observable<StayDestinationSuggestionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StayDestination/SearchDestinations?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDestinations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDestinations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayDestinationSuggestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayDestinationSuggestionDto[]>;
        }));
    }

    protected processSearchDestinations(response: HttpResponseBase): Observable<StayDestinationSuggestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StayDestinationSuggestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HotelsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * DB-only HotelBeds Content for public hotel detail. Returns null result when unsynced
    so the UI can fall back to placeholders without treating it as an error.
     * @return Success
     */
    content(hotelCode: string): Observable<StayHotelContentDto> {
        let url_ = this.baseUrl + "/api/stays/hotels/{hotelCode}/content";
        if (hotelCode === undefined || hotelCode === null)
            throw new globalThis.Error("The parameter 'hotelCode' must be defined.");
        url_ = url_.replace("{hotelCode}", encodeURIComponent("" + hotelCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayHotelContentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayHotelContentDto>;
        }));
    }

    protected processContent(response: HttpResponseBase): Observable<StayHotelContentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayHotelContentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StaySearchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: StaySearchApiRequest | undefined): Observable<StaySearchApiResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StaySearch/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaySearchApiResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaySearchApiResultDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<StaySearchApiResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaySearchApiResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param hotelCode (optional) 
     * @return Success
     */
    getHotelContent(hotelCode: string | undefined): Observable<StayHotelContentDto> {
        let url_ = this.baseUrl + "/api/services/app/StaySearch/GetHotelContent?";
        if (hotelCode === null)
            throw new globalThis.Error("The parameter 'hotelCode' cannot be null.");
        else if (hotelCode !== undefined)
            url_ += "hotelCode=" + encodeURIComponent("" + hotelCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotelContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotelContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayHotelContentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayHotelContentDto>;
        }));
    }

    protected processGetHotelContent(response: HttpResponseBase): Observable<StayHotelContentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayHotelContentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rateKey (optional) 
     * @param currency (optional) 
     * @return Success
     */
    getRate(rateKey: string | undefined, currency: string | undefined): Observable<StayRateApiDto> {
        let url_ = this.baseUrl + "/api/services/app/StaySearch/GetRate?";
        if (rateKey === null)
            throw new globalThis.Error("The parameter 'rateKey' cannot be null.");
        else if (rateKey !== undefined)
            url_ += "rateKey=" + encodeURIComponent("" + rateKey) + "&";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StayRateApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StayRateApiDto>;
        }));
    }

    protected processGetRate(response: HttpResponseBase): Observable<StayRateApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StayRateApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StripeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Stripe webhook endpoint
     * @return Success
     */
    webhook(): Observable<void> {
        let url_ = this.baseUrl + "/api/stripe/webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWebhook(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SupplierServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userIdFilter (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userIdFilter: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SupplierDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Supplier/GetAll?";
        if (userIdFilter === null)
            throw new globalThis.Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SupplierDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<SupplierDto> {
        let url_ = this.baseUrl + "/api/services/app/Supplier/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SupplierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSupplierDto | undefined): Observable<SupplierDto> {
        let url_ = this.baseUrl + "/api/services/app/Supplier/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SupplierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSupplierDto | undefined): Observable<SupplierDto> {
        let url_ = this.baseUrl + "/api/services/app/Supplier/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SupplierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Supplier/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deletionReason (optional) 
     * @return Success
     */
    deleteWithReason(id: string, deletionReason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Supplier/DeleteWithReason?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deletionReason === null)
            throw new globalThis.Error("The parameter 'deletionReason' cannot be null.");
        else if (deletionReason !== undefined)
            url_ += "DeletionReason=" + encodeURIComponent("" + deletionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWithReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWithReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWithReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTopSuppliers(): Observable<SupplierDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Supplier/GetTopSuppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopSuppliers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierDto[]>;
        }));
    }

    protected processGetTopSuppliers(response: HttpResponseBase): Observable<SupplierDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SupplierDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deActivate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Supplier/DeActivate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Supplier/Activate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TourInquiryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTourInquiryDto | undefined): Observable<TourInquiryDto> {
        let url_ = this.baseUrl + "/api/services/app/TourInquiry/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourInquiryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourInquiryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TourInquiryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourInquiryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param count (optional) 
     * @return Success
     */
    getLatestInquiries(count: number | undefined): Observable<TourInquiryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TourInquiry/GetLatestInquiries?";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestInquiries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestInquiries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourInquiryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourInquiryDto[]>;
        }));
    }

    protected processGetLatestInquiries(response: HttpResponseBase): Observable<TourInquiryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TourInquiryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param adminNote (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateStatus(id: string | undefined, adminNote: string | undefined, body: TourInquiryStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TourInquiry/UpdateStatus?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (adminNote === null)
            throw new globalThis.Error("The parameter 'adminNote' cannot be null.");
        else if (adminNote !== undefined)
            url_ += "adminNote=" + encodeURIComponent("" + adminNote) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<TourInquiryDto> {
        let url_ = this.baseUrl + "/api/services/app/TourInquiry/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourInquiryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourInquiryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TourInquiryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourInquiryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Tour_likesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Toggle like status for a tour package
    Supports both authenticated and anonymous users
     * @param body (optional) 
     * @return Success
     */
    toggle(body: ToggleTourLikeDto | undefined): Observable<TourLikeCountDto> {
        let url_ = this.baseUrl + "/api/public/tour-likes/toggle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourLikeCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourLikeCountDto>;
        }));
    }

    protected processToggle(response: HttpResponseBase): Observable<TourLikeCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourLikeCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get like status and count for a tour package
    Supports both authenticated and anonymous users
     * @param sessionId (optional) 
     * @return Success
     */
    status(packageId: string, sessionId: string | undefined): Observable<TourLikeCountDto> {
        let url_ = this.baseUrl + "/api/public/tour-likes/{packageId}/status?";
        if (packageId === undefined || packageId === null)
            throw new globalThis.Error("The parameter 'packageId' must be defined.");
        url_ = url_.replace("{packageId}", encodeURIComponent("" + packageId));
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourLikeCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourLikeCountDto>;
        }));
    }

    protected processStatus(response: HttpResponseBase): Observable<TourLikeCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourLikeCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get total like count for a tour package
    Public endpoint - no authentication required
     * @return Success
     */
    count(packageId: string): Observable<number> {
        let url_ = this.baseUrl + "/api/public/tour-likes/{packageId}/count";
        if (packageId === undefined || packageId === null)
            throw new globalThis.Error("The parameter 'packageId' must be defined.");
        url_ = url_.replace("{packageId}", encodeURIComponent("" + packageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TourLikeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleLike(body: ToggleTourLikeDto | undefined): Observable<TourLikeCountDto> {
        let url_ = this.baseUrl + "/api/services/app/TourLike/ToggleLike";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleLike(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleLike(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourLikeCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourLikeCountDto>;
        }));
    }

    protected processToggleLike(response: HttpResponseBase): Observable<TourLikeCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourLikeCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param packageId (optional) 
     * @param sessionId (optional) 
     * @return Success
     */
    getLikeStatus(packageId: string | undefined, sessionId: string | undefined): Observable<TourLikeCountDto> {
        let url_ = this.baseUrl + "/api/services/app/TourLike/GetLikeStatus?";
        if (packageId === null)
            throw new globalThis.Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLikeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLikeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourLikeCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourLikeCountDto>;
        }));
    }

    protected processGetLikeStatus(response: HttpResponseBase): Observable<TourLikeCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourLikeCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param packageId (optional) 
     * @return Success
     */
    getLikeCount(packageId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TourLike/GetLikeCount?";
        if (packageId === null)
            throw new globalThis.Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLikeCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLikeCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLikeCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ToursServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get featured tour packages for homepage - Now uses dynamic Package data with fallback
    Phase 3D: Dynamic tour data integration
     * @return Success
     */
    featured(): Observable<TourPackageDto[]> {
        let url_ = this.baseUrl + "/api/public/tours/featured";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFeatured(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeatured(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourPackageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourPackageDto[]>;
        }));
    }

    protected processFeatured(response: HttpResponseBase): Observable<TourPackageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TourPackageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get recently created tour packages for homepage
     * @param count (optional) 
     * @return Success
     */
    recent(count: number | undefined): Observable<TourPackageDto[]> {
        let url_ = this.baseUrl + "/api/public/tours/recent?";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourPackageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourPackageDto[]>;
        }));
    }

    protected processRecent(response: HttpResponseBase): Observable<TourPackageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TourPackageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get tour categories for homepage
     * @return Success
     */
    categories(): Observable<TourCategoryDto[]> {
        let url_ = this.baseUrl + "/api/public/tours/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourCategoryDto[]>;
        }));
    }

    protected processCategories(response: HttpResponseBase): Observable<TourCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TourCategoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search tours with filtering and pagination - Now uses dynamic PackageAppService with enhanced UX
    Phase 3D: Dynamic tour search implementation with comprehensive fallback strategy
     * @param location (optional) 
     * @param date (optional) 
     * @param tourType (optional) 
     * @param tourName (optional) 
     * @param priceMin (optional) 
     * @param priceMax (optional) 
     * @param durationMin (optional) 
     * @param durationMax (optional) 
     * @param withFlights (optional) 
     * @param continent (optional) 
     * @param holidayTypes (optional) 
     * @param sortBy (optional) 
     * @param sortOrder (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    search(location: string | undefined, date: string | undefined, tourType: string | undefined, tourName: string | undefined, priceMin: number | undefined, priceMax: number | undefined, durationMin: number | undefined, durationMax: number | undefined, withFlights: boolean | undefined, continent: string | undefined, holidayTypes: string[] | undefined, sortBy: string | undefined, sortOrder: string | undefined, page: number | undefined, pageSize: number | undefined): Observable<TourSearchResponseDto> {
        let url_ = this.baseUrl + "/api/public/tours/search?";
        if (location === null)
            throw new globalThis.Error("The parameter 'location' cannot be null.");
        else if (location !== undefined)
            url_ += "Location=" + encodeURIComponent("" + location) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (tourType === null)
            throw new globalThis.Error("The parameter 'tourType' cannot be null.");
        else if (tourType !== undefined)
            url_ += "TourType=" + encodeURIComponent("" + tourType) + "&";
        if (tourName === null)
            throw new globalThis.Error("The parameter 'tourName' cannot be null.");
        else if (tourName !== undefined)
            url_ += "TourName=" + encodeURIComponent("" + tourName) + "&";
        if (priceMin === null)
            throw new globalThis.Error("The parameter 'priceMin' cannot be null.");
        else if (priceMin !== undefined)
            url_ += "PriceMin=" + encodeURIComponent("" + priceMin) + "&";
        if (priceMax === null)
            throw new globalThis.Error("The parameter 'priceMax' cannot be null.");
        else if (priceMax !== undefined)
            url_ += "PriceMax=" + encodeURIComponent("" + priceMax) + "&";
        if (durationMin === null)
            throw new globalThis.Error("The parameter 'durationMin' cannot be null.");
        else if (durationMin !== undefined)
            url_ += "DurationMin=" + encodeURIComponent("" + durationMin) + "&";
        if (durationMax === null)
            throw new globalThis.Error("The parameter 'durationMax' cannot be null.");
        else if (durationMax !== undefined)
            url_ += "DurationMax=" + encodeURIComponent("" + durationMax) + "&";
        if (withFlights === null)
            throw new globalThis.Error("The parameter 'withFlights' cannot be null.");
        else if (withFlights !== undefined)
            url_ += "WithFlights=" + encodeURIComponent("" + withFlights) + "&";
        if (continent === null)
            throw new globalThis.Error("The parameter 'continent' cannot be null.");
        else if (continent !== undefined)
            url_ += "Continent=" + encodeURIComponent("" + continent) + "&";
        if (holidayTypes === null)
            throw new globalThis.Error("The parameter 'holidayTypes' cannot be null.");
        else if (holidayTypes !== undefined)
            holidayTypes && holidayTypes.forEach(item => { url_ += "HolidayTypes=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourSearchResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourSearchResponseDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<TourSearchResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TourSearchResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get tour pricing information - Now uses dynamic Package data with fallback
    Phase 4.1: Convert pricing endpoint from static to dynamic implementation
     * @return Success
     */
    pricing(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/public/tours/{id}/pricing";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPricing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get available locations for search
     * @return Success
     */
    locations(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/public/tours/locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processLocations(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get available tour types
     * @return Success
     */
    types(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/public/tours/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get available holiday types for search filters
    Lightweight query - projects only holiday type names (no full package load, no document URLs)
     * @return Success
     */
    holidayTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/public/tours/holidayTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHolidayTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHolidayTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processHolidayTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get available continents for search filters
    Lightweight projection - fetches only continent names (no full package load)
     * @return Success
     */
    continents(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/public/tours/continents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContinents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContinents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processContinents(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Submit tour inquiry - Allows customers to submit inquiries for tour packages
    Phase 4.2: Tour Inquiry System Implementation
     * @param body (optional) 
     * @return Success
     */
    inquiry(body: CreateTourInquiryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/public/tours/inquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInquiry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get tour inquiries for admin dashboard
    Phase 4.3: Tour Inquiry System - Admin API
     * @param count (optional) 
     * @return Success
     */
    inquiries(count: number | undefined): Observable<TourInquiryDto[]> {
        let url_ = this.baseUrl + "/api/public/tours/inquiries?";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInquiries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInquiries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourInquiryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourInquiryDto[]>;
        }));
    }

    protected processInquiries(response: HttpResponseBase): Observable<TourInquiryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TourInquiryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get tour cards for listing - Uses dynamic Package data with fallback
    Phase 3D: Dynamic tour data integration
     * @return Success
     */
    cards(): Observable<TourCardDto[]> {
        let url_ = this.baseUrl + "/api/public/tours/cards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TourCardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TourCardDto[]>;
        }));
    }

    protected processCards(response: HttpResponseBase): Observable<TourCardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TourCardDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Subscribe to newsletter - Public endpoint
     * @param body (optional) 
     * @return Success
     */
    subscribe(body: CreateNewsletterSubscriberDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/public/tours/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubscribe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InquiriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Update tour inquiry status and admin notes
    Phase 4.3: Tour Inquiry System - Admin API
     * @param body (optional) 
     * @return Success
     */
    status(id: string, body: UpdateTourInquiryStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/public/tours/inquiries/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TravelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param packageId (optional) 
     * @return Success
     */
    getTravelsByPackageId(packageId: string | undefined): Observable<PackageTravelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Travel/GetTravelsByPackageId?";
        if (packageId === null)
            throw new globalThis.Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelsByPackageId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelsByPackageId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageTravelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageTravelDto[]>;
        }));
    }

    protected processGetTravelsByPackageId(response: HttpResponseBase): Observable<PackageTravelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageTravelDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new travel/departure date for a package
    Immediately persists to database
     * @param packageId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createTravel(packageId: string | undefined, body: CreatePackageTravelDto | undefined): Observable<PackageTravelDto> {
        let url_ = this.baseUrl + "/api/services/app/Travel/CreateTravel?";
        if (packageId === null)
            throw new globalThis.Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTravel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageTravelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageTravelDto>;
        }));
    }

    protected processCreateTravel(response: HttpResponseBase): Observable<PackageTravelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageTravelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing travel/departure date
    Immediately persists changes to database
     * @param travelId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateTravel(travelId: string | undefined, body: CreatePackageTravelDto | undefined): Observable<PackageTravelDto> {
        let url_ = this.baseUrl + "/api/services/app/Travel/UpdateTravel?";
        if (travelId === null)
            throw new globalThis.Error("The parameter 'travelId' cannot be null.");
        else if (travelId !== undefined)
            url_ += "travelId=" + encodeURIComponent("" + travelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTravel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageTravelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageTravelDto>;
        }));
    }

    protected processUpdateTravel(response: HttpResponseBase): Observable<PackageTravelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageTravelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a travel/departure date
    Immediately removes from database
     * @param travelId (optional) 
     * @return Success
     */
    deleteTravel(travelId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Travel/DeleteTravel?";
        if (travelId === null)
            throw new globalThis.Error("The parameter 'travelId' cannot be null.");
        else if (travelId !== undefined)
            url_ += "travelId=" + encodeURIComponent("" + travelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTravel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTravel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deletionReason (optional) 
     * @return Success
     */
    deleteWithReason(id: number, deletionReason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteWithReason?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deletionReason === null)
            throw new globalThis.Error("The parameter 'deletionReason' cannot be null.");
        else if (deletionReason !== undefined)
            url_ += "DeletionReason=" + encodeURIComponent("" + deletionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWithReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWithReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWithReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    activate(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    deActivate(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param themeSettings (optional) 
     * @return Success
     */
    updateUserThemeSettings(themeSettings: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserThemeSettings?";
        if (themeSettings === null)
            throw new globalThis.Error("The parameter 'themeSettings' cannot be null.");
        else if (themeSettings !== undefined)
            url_ += "themeSettings=" + encodeURIComponent("" + themeSettings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserThemeSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserThemeSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateUserThemeSettings(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    resetUserPassword(userId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserPassword?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processResetUserPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param role (optional) 
     * @return Success
     */
    searchResaAgent(keyword: string | undefined, role: string | undefined): Observable<UserMinDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/SearchResaAgent?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (role === null)
            throw new globalThis.Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchResaAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchResaAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMinDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMinDto[]>;
        }));
    }

    protected processSearchResaAgent(response: HttpResponseBase): Observable<UserMinDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserMinDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param role (optional) 
     * @return Success
     */
    topAgentsByType(role: string | undefined): Observable<UserMinDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/TopAgentsByType?";
        if (role === null)
            throw new globalThis.Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTopAgentsByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTopAgentsByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMinDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMinDto[]>;
        }));
    }

    protected processTopAgentsByType(response: HttpResponseBase): Observable<UserMinDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserMinDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** DTO for abandoned cart analytics */
export class AbandonedCartDto implements IAbandonedCartDto {
    id: string;
    tourName: string | undefined;
    totalAmount: number;
    totalTravelers: number;
    creationTime: moment.Moment;
    lastAccessedAt: moment.Moment;
    currentStep: number;
    hoursAbandoned: number;
    contactEmail: string | undefined;
    isExpired: boolean;

    constructor(data?: IAbandonedCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tourName = _data["tourName"];
            this.totalAmount = _data["totalAmount"];
            this.totalTravelers = _data["totalTravelers"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.lastAccessedAt = _data["lastAccessedAt"] ? moment(_data["lastAccessedAt"].toString()) : undefined as any;
            this.currentStep = _data["currentStep"];
            this.hoursAbandoned = _data["hoursAbandoned"];
            this.contactEmail = _data["contactEmail"];
            this.isExpired = _data["isExpired"];
        }
    }

    static fromJS(data: any): AbandonedCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbandonedCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tourName"] = this.tourName;
        data["totalAmount"] = this.totalAmount;
        data["totalTravelers"] = this.totalTravelers;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["lastAccessedAt"] = this.lastAccessedAt ? this.lastAccessedAt.toISOString() : undefined as any;
        data["currentStep"] = this.currentStep;
        data["hoursAbandoned"] = this.hoursAbandoned;
        data["contactEmail"] = this.contactEmail;
        data["isExpired"] = this.isExpired;
        return data;
    }

    clone(): AbandonedCartDto {
        const json = this.toJSON();
        let result = new AbandonedCartDto();
        result.init(json);
        return result;
    }
}

/** DTO for abandoned cart analytics */
export interface IAbandonedCartDto {
    id: string;
    tourName: string | undefined;
    totalAmount: number;
    totalTravelers: number;
    creationTime: moment.Moment;
    lastAccessedAt: moment.Moment;
    currentStep: number;
    hoursAbandoned: number;
    contactEmail: string | undefined;
    isExpired: boolean;
}

export class AboutTheBusinessDto implements IAboutTheBusinessDto {
    callUsHeaderText: string | undefined;
    callUsContentText: string | undefined;
    mobileNumber: string | undefined;
    telephoneNumber: string | undefined;
    emailUsHeaderText: string | undefined;
    emailUsContentText: string | undefined;
    emailAddress: string | undefined;
    showFacebookLink: boolean;
    showInstagramLink: boolean;
    showTwitterLink: boolean;
    showLinkedinLink: boolean;
    showSendUsMessageForm: boolean;
    showLocationMap: boolean;
    officeLocations: OfficeLocationDto[] | undefined;
    selectedOfficeId: string | undefined;

    constructor(data?: IAboutTheBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callUsHeaderText = _data["callUsHeaderText"];
            this.callUsContentText = _data["callUsContentText"];
            this.mobileNumber = _data["mobileNumber"];
            this.telephoneNumber = _data["telephoneNumber"];
            this.emailUsHeaderText = _data["emailUsHeaderText"];
            this.emailUsContentText = _data["emailUsContentText"];
            this.emailAddress = _data["emailAddress"];
            this.showFacebookLink = _data["showFacebookLink"];
            this.showInstagramLink = _data["showInstagramLink"];
            this.showTwitterLink = _data["showTwitterLink"];
            this.showLinkedinLink = _data["showLinkedinLink"];
            this.showSendUsMessageForm = _data["showSendUsMessageForm"];
            this.showLocationMap = _data["showLocationMap"];
            if (Array.isArray(_data["officeLocations"])) {
                this.officeLocations = [] as any;
                for (let item of _data["officeLocations"])
                    this.officeLocations.push(OfficeLocationDto.fromJS(item));
            }
            this.selectedOfficeId = _data["selectedOfficeId"];
        }
    }

    static fromJS(data: any): AboutTheBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new AboutTheBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callUsHeaderText"] = this.callUsHeaderText;
        data["callUsContentText"] = this.callUsContentText;
        data["mobileNumber"] = this.mobileNumber;
        data["telephoneNumber"] = this.telephoneNumber;
        data["emailUsHeaderText"] = this.emailUsHeaderText;
        data["emailUsContentText"] = this.emailUsContentText;
        data["emailAddress"] = this.emailAddress;
        data["showFacebookLink"] = this.showFacebookLink;
        data["showInstagramLink"] = this.showInstagramLink;
        data["showTwitterLink"] = this.showTwitterLink;
        data["showLinkedinLink"] = this.showLinkedinLink;
        data["showSendUsMessageForm"] = this.showSendUsMessageForm;
        data["showLocationMap"] = this.showLocationMap;
        if (Array.isArray(this.officeLocations)) {
            data["officeLocations"] = [];
            for (let item of this.officeLocations)
                data["officeLocations"].push(item ? item.toJSON() : undefined as any);
        }
        data["selectedOfficeId"] = this.selectedOfficeId;
        return data;
    }

    clone(): AboutTheBusinessDto {
        const json = this.toJSON();
        let result = new AboutTheBusinessDto();
        result.init(json);
        return result;
    }
}

export interface IAboutTheBusinessDto {
    callUsHeaderText: string | undefined;
    callUsContentText: string | undefined;
    mobileNumber: string | undefined;
    telephoneNumber: string | undefined;
    emailUsHeaderText: string | undefined;
    emailUsContentText: string | undefined;
    emailAddress: string | undefined;
    showFacebookLink: boolean;
    showInstagramLink: boolean;
    showTwitterLink: boolean;
    showLinkedinLink: boolean;
    showSendUsMessageForm: boolean;
    showLocationMap: boolean;
    officeLocations: OfficeLocationDto[] | undefined;
    selectedOfficeId: string | undefined;
}

export class AboutUsDto implements IAboutUsDto {
    heading: string | undefined;
    subheading: string | undefined;
    content: string | undefined;
    highlightTags: HighlightTagDto[] | undefined;
    imageUrls: string[] | undefined;
    imageGallery: GalleryItemDto[] | undefined;

    constructor(data?: IAboutUsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.subheading = _data["subheading"];
            this.content = _data["content"];
            if (Array.isArray(_data["highlightTags"])) {
                this.highlightTags = [] as any;
                for (let item of _data["highlightTags"])
                    this.highlightTags.push(HighlightTagDto.fromJS(item));
            }
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls.push(item);
            }
            if (Array.isArray(_data["imageGallery"])) {
                this.imageGallery = [] as any;
                for (let item of _data["imageGallery"])
                    this.imageGallery.push(GalleryItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AboutUsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AboutUsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["subheading"] = this.subheading;
        data["content"] = this.content;
        if (Array.isArray(this.highlightTags)) {
            data["highlightTags"] = [];
            for (let item of this.highlightTags)
                data["highlightTags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        if (Array.isArray(this.imageGallery)) {
            data["imageGallery"] = [];
            for (let item of this.imageGallery)
                data["imageGallery"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): AboutUsDto {
        const json = this.toJSON();
        let result = new AboutUsDto();
        result.init(json);
        return result;
    }
}

export interface IAboutUsDto {
    heading: string | undefined;
    subheading: string | undefined;
    content: string | undefined;
    highlightTags: HighlightTagDto[] | undefined;
    imageUrls: string[] | undefined;
    imageGallery: GalleryItemDto[] | undefined;
}

export class AccountingTransactionDto implements IAccountingTransactionDto {
    id: string;
    isPurchaseOrder: boolean;
    creationTime: moment.Moment;
    totalAmount: number;
    dueDate: moment.Moment | undefined;
    statusId: string | undefined;
    status: AppSettingOption;
    referenceNumber: string | undefined;

    constructor(data?: IAccountingTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isPurchaseOrder = _data["isPurchaseOrder"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? AppSettingOption.fromJS(_data["status"]) : undefined as any;
            this.referenceNumber = _data["referenceNumber"];
        }
    }

    static fromJS(data: any): AccountingTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isPurchaseOrder"] = this.isPurchaseOrder;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["referenceNumber"] = this.referenceNumber;
        return data;
    }

    clone(): AccountingTransactionDto {
        const json = this.toJSON();
        let result = new AccountingTransactionDto();
        result.init(json);
        return result;
    }
}

export interface IAccountingTransactionDto {
    id: string;
    isPurchaseOrder: boolean;
    creationTime: moment.Moment;
    totalAmount: number;
    dueDate: moment.Moment | undefined;
    statusId: string | undefined;
    status: AppSettingOption;
    referenceNumber: string | undefined;
}

export class Agent implements IAgent {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    agentTypeId: string;
    agentType: AppSettingOption;
    name: string | undefined;
    deletionReason: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    isDotAccredited: boolean;
    dotAccreditationExpiryDate: moment.Moment | undefined;
    status: Status;
    isActive: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocument: Document;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocument: Document;
    users: User[] | undefined;
    files: AgentFile[] | undefined;
    phoneNumbers: AgentPhoneNumber[] | undefined;
    emails: AgentEmail[] | undefined;

    constructor(data?: IAgent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.agentTypeId = _data["agentTypeId"];
            this.agentType = _data["agentType"] ? AppSettingOption.fromJS(_data["agentType"]) : undefined as any;
            this.name = _data["name"];
            this.deletionReason = _data["deletionReason"];
            this.contactPerson = _data["contactPerson"];
            this.designation = _data["designation"];
            this.note = _data["note"];
            this.isDotAccredited = _data["isDotAccredited"];
            this.dotAccreditationExpiryDate = _data["dotAccreditationExpiryDate"] ? moment(_data["dotAccreditationExpiryDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureDocument = _data["profilePictureDocument"] ? Document.fromJS(_data["profilePictureDocument"]) : undefined as any;
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.coverPhotoDocument = _data["coverPhotoDocument"] ? Document.fromJS(_data["coverPhotoDocument"]) : undefined as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users.push(User.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(AgentFile.fromJS(item));
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(AgentPhoneNumber.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(AgentEmail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Agent {
        data = typeof data === 'object' ? data : {};
        let result = new Agent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["agentTypeId"] = this.agentTypeId;
        data["agentType"] = this.agentType ? this.agentType.toJSON() : undefined as any;
        data["name"] = this.name;
        data["deletionReason"] = this.deletionReason;
        data["contactPerson"] = this.contactPerson;
        data["designation"] = this.designation;
        data["note"] = this.note;
        data["isDotAccredited"] = this.isDotAccredited;
        data["dotAccreditationExpiryDate"] = this.dotAccreditationExpiryDate ? this.dotAccreditationExpiryDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureDocument"] = this.profilePictureDocument ? this.profilePictureDocument.toJSON() : undefined as any;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["coverPhotoDocument"] = this.coverPhotoDocument ? this.coverPhotoDocument.toJSON() : undefined as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Agent {
        const json = this.toJSON();
        let result = new Agent();
        result.init(json);
        return result;
    }
}

export interface IAgent {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    agentTypeId: string;
    agentType: AppSettingOption;
    name: string | undefined;
    deletionReason: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    isDotAccredited: boolean;
    dotAccreditationExpiryDate: moment.Moment | undefined;
    status: Status;
    isActive: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocument: Document;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocument: Document;
    users: User[] | undefined;
    files: AgentFile[] | undefined;
    phoneNumbers: AgentPhoneNumber[] | undefined;
    emails: AgentEmail[] | undefined;
}

export class AgentDto implements IAgentDto {
    id: string;
    agentType: AppSettingOptionDto;
    name: string | undefined;
    contactPerson: string | undefined;
    contactNumber: string | undefined;
    designation: string | undefined;
    email: string | undefined;
    note: string | undefined;
    isDotAccredited: boolean;
    dotAccreditationExpiryDate: moment.Moment | undefined;
    status: Status;
    isActive: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    phoneNumbers: AgentPhoneNumberDto[] | undefined;
    emails: AgentEmailDto[] | undefined;

    constructor(data?: IAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentType = _data["agentType"] ? AppSettingOptionDto.fromJS(_data["agentType"]) : undefined as any;
            this.name = _data["name"];
            this.contactPerson = _data["contactPerson"];
            this.contactNumber = _data["contactNumber"];
            this.designation = _data["designation"];
            this.email = _data["email"];
            this.note = _data["note"];
            this.isDotAccredited = _data["isDotAccredited"];
            this.dotAccreditationExpiryDate = _data["dotAccreditationExpiryDate"] ? moment(_data["dotAccreditationExpiryDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureDocumentUrl = _data["profilePictureDocumentUrl"];
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.coverPhotoDocumentUrl = _data["coverPhotoDocumentUrl"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(AgentPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(AgentEmailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentType"] = this.agentType ? this.agentType.toJSON() : undefined as any;
        data["name"] = this.name;
        data["contactPerson"] = this.contactPerson;
        data["contactNumber"] = this.contactNumber;
        data["designation"] = this.designation;
        data["email"] = this.email;
        data["note"] = this.note;
        data["isDotAccredited"] = this.isDotAccredited;
        data["dotAccreditationExpiryDate"] = this.dotAccreditationExpiryDate ? this.dotAccreditationExpiryDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureDocumentUrl"] = this.profilePictureDocumentUrl;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["coverPhotoDocumentUrl"] = this.coverPhotoDocumentUrl;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): AgentDto {
        const json = this.toJSON();
        let result = new AgentDto();
        result.init(json);
        return result;
    }
}

export interface IAgentDto {
    id: string;
    agentType: AppSettingOptionDto;
    name: string | undefined;
    contactPerson: string | undefined;
    contactNumber: string | undefined;
    designation: string | undefined;
    email: string | undefined;
    note: string | undefined;
    isDotAccredited: boolean;
    dotAccreditationExpiryDate: moment.Moment | undefined;
    status: Status;
    isActive: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    phoneNumbers: AgentPhoneNumberDto[] | undefined;
    emails: AgentEmailDto[] | undefined;
}

export class AgentDtoPagedResultDto implements IAgentDtoPagedResultDto {
    items: AgentDto[] | undefined;
    totalCount: number;

    constructor(data?: IAgentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AgentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AgentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AgentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgentDtoPagedResultDto {
    items: AgentDto[] | undefined;
    totalCount: number;
}

export class AgentEmail implements IAgentEmail {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    email: string | undefined;
    note: string | undefined;
    agentId: string;
    isActive: boolean;
    isPrimary: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    agent: Agent;

    constructor(data?: IAgentEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.email = _data["email"];
            this.note = _data["note"];
            this.agentId = _data["agentId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
        }
    }

    static fromJS(data: any): AgentEmail {
        data = typeof data === 'object' ? data : {};
        let result = new AgentEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["email"] = this.email;
        data["note"] = this.note;
        data["agentId"] = this.agentId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        return data;
    }

    clone(): AgentEmail {
        const json = this.toJSON();
        let result = new AgentEmail();
        result.init(json);
        return result;
    }
}

export interface IAgentEmail {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    email: string | undefined;
    note: string | undefined;
    agentId: string;
    isActive: boolean;
    isPrimary: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    agent: Agent;
}

export class AgentEmailDto implements IAgentEmailDto {
    id: string;
    email: string | undefined;
    note: string | undefined;
    agentId: string;
    isActive: boolean;
    isPrimary: boolean;
    agent: AgentDto;

    constructor(data?: IAgentEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.note = _data["note"];
            this.agentId = _data["agentId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.agent = _data["agent"] ? AgentDto.fromJS(_data["agent"]) : undefined as any;
        }
    }

    static fromJS(data: any): AgentEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["note"] = this.note;
        data["agentId"] = this.agentId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        return data;
    }

    clone(): AgentEmailDto {
        const json = this.toJSON();
        let result = new AgentEmailDto();
        result.init(json);
        return result;
    }
}

export interface IAgentEmailDto {
    id: string;
    email: string | undefined;
    note: string | undefined;
    agentId: string;
    isActive: boolean;
    isPrimary: boolean;
    agent: AgentDto;
}

export class AgentFile implements IAgentFile {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    agentId: string;
    agent: Agent;
    documentId: string | undefined;
    document: Document;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;

    constructor(data?: IAgentFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AgentFile {
        data = typeof data === 'object' ? data : {};
        let result = new AgentFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        return data;
    }

    clone(): AgentFile {
        const json = this.toJSON();
        let result = new AgentFile();
        result.init(json);
        return result;
    }
}

export interface IAgentFile {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    agentId: string;
    agent: Agent;
    documentId: string | undefined;
    document: Document;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
}

export class AgentPhoneNumber implements IAgentPhoneNumber {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    agentId: string;
    agent: Agent;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;

    constructor(data?: IAgentPhoneNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AgentPhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new AgentPhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        return data;
    }

    clone(): AgentPhoneNumber {
        const json = this.toJSON();
        let result = new AgentPhoneNumber();
        result.init(json);
        return result;
    }
}

export interface IAgentPhoneNumber {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    agentId: string;
    agent: Agent;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
}

export class AgentPhoneNumberDto implements IAgentPhoneNumberDto {
    id: string;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    agentId: string;
    agent: AgentDto;

    constructor(data?: IAgentPhoneNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? AgentDto.fromJS(_data["agent"]) : undefined as any;
        }
    }

    static fromJS(data: any): AgentPhoneNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentPhoneNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        return data;
    }

    clone(): AgentPhoneNumberDto {
        const json = this.toJSON();
        let result = new AgentPhoneNumberDto();
        result.init(json);
        return result;
    }
}

export interface IAgentPhoneNumberDto {
    id: string;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    agentId: string;
    agent: AgentDto;
}

export class AppSetting implements IAppSetting {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean;
    optionType: SettingsOptionType;
    icon: string | undefined;
    note: string | undefined;
    options: AppSettingOption[] | undefined;

    constructor(data?: IAppSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.optionType = _data["optionType"];
            this.icon = _data["icon"];
            this.note = _data["note"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options.push(AppSettingOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSetting {
        data = typeof data === 'object' ? data : {};
        let result = new AppSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["optionType"] = this.optionType;
        data["icon"] = this.icon;
        data["note"] = this.note;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): AppSetting {
        const json = this.toJSON();
        let result = new AppSetting();
        result.init(json);
        return result;
    }
}

export interface IAppSetting {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean;
    optionType: SettingsOptionType;
    icon: string | undefined;
    note: string | undefined;
    options: AppSettingOption[] | undefined;
}

export class AppSettingDto implements IAppSettingDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean;
    optionType: SettingsOptionType;
    icon: string | undefined;
    note: string | undefined;
    options: AppSettingOptionDto[] | undefined;

    constructor(data?: IAppSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.optionType = _data["optionType"];
            this.icon = _data["icon"];
            this.note = _data["note"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options.push(AppSettingOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["optionType"] = this.optionType;
        data["icon"] = this.icon;
        data["note"] = this.note;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): AppSettingDto {
        const json = this.toJSON();
        let result = new AppSettingDto();
        result.init(json);
        return result;
    }
}

export interface IAppSettingDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean;
    optionType: SettingsOptionType;
    icon: string | undefined;
    note: string | undefined;
    options: AppSettingOptionDto[] | undefined;
}

export class AppSettingDtoPagedResultDto implements IAppSettingDtoPagedResultDto {
    items: AppSettingDto[] | undefined;
    totalCount: number;

    constructor(data?: IAppSettingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AppSettingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AppSettingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AppSettingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AppSettingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAppSettingDtoPagedResultDto {
    items: AppSettingDto[] | undefined;
    totalCount: number;
}

export class AppSettingOption implements IAppSettingOption {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    description: string | undefined;
    value: string | undefined;
    isActive: boolean;
    order: number | undefined;
    appSettingId: string;
    appSetting: AppSetting;

    constructor(data?: IAppSettingOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.value = _data["value"];
            this.isActive = _data["isActive"];
            this.order = _data["order"];
            this.appSettingId = _data["appSettingId"];
            this.appSetting = _data["appSetting"] ? AppSetting.fromJS(_data["appSetting"]) : undefined as any;
        }
    }

    static fromJS(data: any): AppSettingOption {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["value"] = this.value;
        data["isActive"] = this.isActive;
        data["order"] = this.order;
        data["appSettingId"] = this.appSettingId;
        data["appSetting"] = this.appSetting ? this.appSetting.toJSON() : undefined as any;
        return data;
    }

    clone(): AppSettingOption {
        const json = this.toJSON();
        let result = new AppSettingOption();
        result.init(json);
        return result;
    }
}

export interface IAppSettingOption {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    description: string | undefined;
    value: string | undefined;
    isActive: boolean;
    order: number | undefined;
    appSettingId: string;
    appSetting: AppSetting;
}

export class AppSettingOptionDto implements IAppSettingOptionDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    value: string | undefined;
    isActive: boolean;
    order: number | undefined;
    appSettingId: string;
    appSetting: AppSettingDto;

    constructor(data?: IAppSettingOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.value = _data["value"];
            this.isActive = _data["isActive"];
            this.order = _data["order"];
            this.appSettingId = _data["appSettingId"];
            this.appSetting = _data["appSetting"] ? AppSettingDto.fromJS(_data["appSetting"]) : undefined as any;
        }
    }

    static fromJS(data: any): AppSettingOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["value"] = this.value;
        data["isActive"] = this.isActive;
        data["order"] = this.order;
        data["appSettingId"] = this.appSettingId;
        data["appSetting"] = this.appSetting ? this.appSetting.toJSON() : undefined as any;
        return data;
    }

    clone(): AppSettingOptionDto {
        const json = this.toJSON();
        let result = new AppSettingOptionDto();
        result.init(json);
        return result;
    }
}

export interface IAppSettingOptionDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    value: string | undefined;
    isActive: boolean;
    order: number | undefined;
    appSettingId: string;
    appSetting: AppSettingDto;
}

export class AppSettingOptionDtoPagedResultDto implements IAppSettingOptionDtoPagedResultDto {
    items: AppSettingOptionDto[] | undefined;
    totalCount: number;

    constructor(data?: IAppSettingOptionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AppSettingOptionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AppSettingOptionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingOptionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AppSettingOptionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AppSettingOptionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAppSettingOptionDtoPagedResultDto {
    items: AppSettingOptionDto[] | undefined;
    totalCount: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (this.features as any)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (data["features"] as any)[key] = (this.features as any)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class ApproveStayCancellationRequestInput implements IApproveStayCancellationRequestInput {
    adminNote: string | undefined;

    constructor(data?: IApproveStayCancellationRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminNote = _data["adminNote"];
        }
    }

    static fromJS(data: any): ApproveStayCancellationRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveStayCancellationRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminNote"] = this.adminNote;
        return data;
    }

    clone(): ApproveStayCancellationRequestInput {
        const json = this.toJSON();
        let result = new ApproveStayCancellationRequestInput();
        result.init(json);
        return result;
    }
}

export interface IApproveStayCancellationRequestInput {
    adminNote: string | undefined;
}

export class AuditLogDto implements IAuditLogDto {
    id: number;
    executionTime: moment.Moment;
    methodName: string | undefined;
    serviceName: string | undefined;
    userId: number | undefined;
    impersonatorTenantId: number | undefined;
    parameters: string | undefined;
    auditLogsType: AuditLogsType;
    servicesName: ServicesNameType;
    executionDuration: number;
    returnValue: string | undefined;
    userName: string | undefined;
    browserInfo: string | undefined;
    clientIpAddress: string | undefined;
    customData: string | undefined;

    constructor(data?: IAuditLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : undefined as any;
            this.methodName = _data["methodName"];
            this.serviceName = _data["serviceName"];
            this.userId = _data["userId"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.parameters = _data["parameters"];
            this.auditLogsType = _data["auditLogsType"];
            this.servicesName = _data["servicesName"];
            this.executionDuration = _data["executionDuration"];
            this.returnValue = _data["returnValue"];
            this.userName = _data["userName"];
            this.browserInfo = _data["browserInfo"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.customData = _data["customData"];
        }
    }

    static fromJS(data: any): AuditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : undefined as any;
        data["methodName"] = this.methodName;
        data["serviceName"] = this.serviceName;
        data["userId"] = this.userId;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["parameters"] = this.parameters;
        data["auditLogsType"] = this.auditLogsType;
        data["servicesName"] = this.servicesName;
        data["executionDuration"] = this.executionDuration;
        data["returnValue"] = this.returnValue;
        data["userName"] = this.userName;
        data["browserInfo"] = this.browserInfo;
        data["clientIpAddress"] = this.clientIpAddress;
        data["customData"] = this.customData;
        return data;
    }

    clone(): AuditLogDto {
        const json = this.toJSON();
        let result = new AuditLogDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogDto {
    id: number;
    executionTime: moment.Moment;
    methodName: string | undefined;
    serviceName: string | undefined;
    userId: number | undefined;
    impersonatorTenantId: number | undefined;
    parameters: string | undefined;
    auditLogsType: AuditLogsType;
    servicesName: ServicesNameType;
    executionDuration: number;
    returnValue: string | undefined;
    userName: string | undefined;
    browserInfo: string | undefined;
    clientIpAddress: string | undefined;
    customData: string | undefined;
}

export enum AuditLogsType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

/** DTO for available travel dates within search range Used to show alternative dates to users */
export class AvailableDateDto implements IAvailableDateDto {
    travelDate: moment.Moment;
    formattedDate: string | undefined;
    price: number;
    currency: string | undefined;
    availableSpots: number;
    totalCapacity: number;
    daysFromSearch: number;
    proximityText: string | undefined;

    constructor(data?: IAvailableDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.travelDate = _data["travelDate"] ? moment(_data["travelDate"].toString()) : undefined as any;
            this.formattedDate = _data["formattedDate"];
            this.price = _data["price"];
            this.currency = _data["currency"];
            this.availableSpots = _data["availableSpots"];
            this.totalCapacity = _data["totalCapacity"];
            this.daysFromSearch = _data["daysFromSearch"];
            this.proximityText = _data["proximityText"];
        }
    }

    static fromJS(data: any): AvailableDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["travelDate"] = this.travelDate ? this.travelDate.toISOString() : undefined as any;
        data["formattedDate"] = this.formattedDate;
        data["price"] = this.price;
        data["currency"] = this.currency;
        data["availableSpots"] = this.availableSpots;
        data["totalCapacity"] = this.totalCapacity;
        data["daysFromSearch"] = this.daysFromSearch;
        data["proximityText"] = this.proximityText;
        return data;
    }

    clone(): AvailableDateDto {
        const json = this.toJSON();
        let result = new AvailableDateDto();
        result.init(json);
        return result;
    }
}

/** DTO for available travel dates within search range Used to show alternative dates to users */
export interface IAvailableDateDto {
    travelDate: moment.Moment;
    formattedDate: string | undefined;
    price: number;
    currency: string | undefined;
    availableSpots: number;
    totalCapacity: number;
    daysFromSearch: number;
    proximityText: string | undefined;
}

/** Baggage allowance for a specific passenger type. */
export class BaggageApiDto implements IBaggageApiDto {
    /** Passenger type this allowance applies to: `Adult`, `Child`, or `Infant`. */
    passengerType: string | undefined;
    /** Number of checked bags included. */
    pieces: number;
    /** Maximum weight per bag in kilograms, if applicable. */
    weightKg: number | undefined;
    /** Human-readable description of the baggage allowance. */
    description: string | undefined;

    constructor(data?: IBaggageApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passengerType = _data["passengerType"];
            this.pieces = _data["pieces"];
            this.weightKg = _data["weightKg"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BaggageApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaggageApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passengerType"] = this.passengerType;
        data["pieces"] = this.pieces;
        data["weightKg"] = this.weightKg;
        data["description"] = this.description;
        return data;
    }

    clone(): BaggageApiDto {
        const json = this.toJSON();
        let result = new BaggageApiDto();
        result.init(json);
        return result;
    }
}

/** Baggage allowance for a specific passenger type. */
export interface IBaggageApiDto {
    /** Passenger type this allowance applies to: `Adult`, `Child`, or `Infant`. */
    passengerType: string | undefined;
    /** Number of checked bags included. */
    pieces: number;
    /** Maximum weight per bag in kilograms, if applicable. */
    weightKg: number | undefined;
    /** Human-readable description of the baggage allowance. */
    description: string | undefined;
}

export class BestPackagesDto implements IBestPackagesDto {
    heading: string | undefined;
    imageCards: ImageCardDto[] | undefined;
    selectedPackages: SelectedPackageDto[] | undefined;

    constructor(data?: IBestPackagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            if (Array.isArray(_data["imageCards"])) {
                this.imageCards = [] as any;
                for (let item of _data["imageCards"])
                    this.imageCards.push(ImageCardDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedPackages"])) {
                this.selectedPackages = [] as any;
                for (let item of _data["selectedPackages"])
                    this.selectedPackages.push(SelectedPackageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BestPackagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new BestPackagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        if (Array.isArray(this.imageCards)) {
            data["imageCards"] = [];
            for (let item of this.imageCards)
                data["imageCards"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.selectedPackages)) {
            data["selectedPackages"] = [];
            for (let item of this.selectedPackages)
                data["selectedPackages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BestPackagesDto {
        const json = this.toJSON();
        let result = new BestPackagesDto();
        result.init(json);
        return result;
    }
}

export interface IBestPackagesDto {
    heading: string | undefined;
    imageCards: ImageCardDto[] | undefined;
    selectedPackages: SelectedPackageDto[] | undefined;
}

/** Summary of a booked passenger as confirmed by the supplier. */
export class BookedPassengerApiDto implements IBookedPassengerApiDto {
    /** Supplier-assigned passenger identifier. */
    passengerId: string | undefined;
    /** Passenger type: `Adult`, `Child`, or `Infant`. */
    type: string | undefined;
    /** Name title (e.g. `MR`, `MRS`). */
    title: string | undefined;
    /** Given (first) name. */
    firstName: string | undefined;
    /** Family (last) name. */
    lastName: string | undefined;

    constructor(data?: IBookedPassengerApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passengerId = _data["passengerId"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): BookedPassengerApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookedPassengerApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passengerId"] = this.passengerId;
        data["type"] = this.type;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }

    clone(): BookedPassengerApiDto {
        const json = this.toJSON();
        let result = new BookedPassengerApiDto();
        result.init(json);
        return result;
    }
}

/** Summary of a booked passenger as confirmed by the supplier. */
export interface IBookedPassengerApiDto {
    /** Supplier-assigned passenger identifier. */
    passengerId: string | undefined;
    /** Passenger type: `Adult`, `Child`, or `Infant`. */
    type: string | undefined;
    /** Name title (e.g. `MR`, `MRS`). */
    title: string | undefined;
    /** Given (first) name. */
    firstName: string | undefined;
    /** Family (last) name. */
    lastName: string | undefined;
}

export class BookedRoomApiDto implements IBookedRoomApiDto {
    roomName: string | undefined;
    boardType: string | undefined;
    cost: number;

    constructor(data?: IBookedRoomApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomName = _data["roomName"];
            this.boardType = _data["boardType"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): BookedRoomApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookedRoomApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomName"] = this.roomName;
        data["boardType"] = this.boardType;
        data["cost"] = this.cost;
        return data;
    }

    clone(): BookedRoomApiDto {
        const json = this.toJSON();
        let result = new BookedRoomApiDto();
        result.init(json);
        return result;
    }
}

export interface IBookedRoomApiDto {
    roomName: string | undefined;
    boardType: string | undefined;
    cost: number;
}

export class Booking implements IBooking {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingNo: string | undefined;
    deletionReason: string | undefined;
    overview: string | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    statusId: string | undefined;
    status: AppSettingOption;
    attachments: BookingAttachment[] | undefined;
    clients: BookingClient[] | undefined;
    agentInCharges: BookingInCharge[] | undefined;
    processedDocument: ProcessedDocument;
    processedPackage: ProcessedPackage;
    processedTicket: ProcessedTicket;
    processedVisa: ProcessedVisa;
    creatorUser: User;
    lastModifierUser: User;
    statementOfAccounts: StatementOfAccount[] | undefined;

    constructor(data?: IBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.bookingNo = _data["bookingNo"];
            this.deletionReason = _data["deletionReason"];
            this.overview = _data["overview"];
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? AppSettingOption.fromJS(_data["status"]) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(BookingAttachment.fromJS(item));
            }
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients.push(BookingClient.fromJS(item));
            }
            if (Array.isArray(_data["agentInCharges"])) {
                this.agentInCharges = [] as any;
                for (let item of _data["agentInCharges"])
                    this.agentInCharges.push(BookingInCharge.fromJS(item));
            }
            this.processedDocument = _data["processedDocument"] ? ProcessedDocument.fromJS(_data["processedDocument"]) : undefined as any;
            this.processedPackage = _data["processedPackage"] ? ProcessedPackage.fromJS(_data["processedPackage"]) : undefined as any;
            this.processedTicket = _data["processedTicket"] ? ProcessedTicket.fromJS(_data["processedTicket"]) : undefined as any;
            this.processedVisa = _data["processedVisa"] ? ProcessedVisa.fromJS(_data["processedVisa"]) : undefined as any;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : undefined as any;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : undefined as any;
            if (Array.isArray(_data["statementOfAccounts"])) {
                this.statementOfAccounts = [] as any;
                for (let item of _data["statementOfAccounts"])
                    this.statementOfAccounts.push(StatementOfAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Booking {
        data = typeof data === 'object' ? data : {};
        let result = new Booking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["bookingNo"] = this.bookingNo;
        data["deletionReason"] = this.deletionReason;
        data["overview"] = this.overview;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.agentInCharges)) {
            data["agentInCharges"] = [];
            for (let item of this.agentInCharges)
                data["agentInCharges"].push(item ? item.toJSON() : undefined as any);
        }
        data["processedDocument"] = this.processedDocument ? this.processedDocument.toJSON() : undefined as any;
        data["processedPackage"] = this.processedPackage ? this.processedPackage.toJSON() : undefined as any;
        data["processedTicket"] = this.processedTicket ? this.processedTicket.toJSON() : undefined as any;
        data["processedVisa"] = this.processedVisa ? this.processedVisa.toJSON() : undefined as any;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined as any;
        if (Array.isArray(this.statementOfAccounts)) {
            data["statementOfAccounts"] = [];
            for (let item of this.statementOfAccounts)
                data["statementOfAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Booking {
        const json = this.toJSON();
        let result = new Booking();
        result.init(json);
        return result;
    }
}

export interface IBooking {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingNo: string | undefined;
    deletionReason: string | undefined;
    overview: string | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    statusId: string | undefined;
    status: AppSettingOption;
    attachments: BookingAttachment[] | undefined;
    clients: BookingClient[] | undefined;
    agentInCharges: BookingInCharge[] | undefined;
    processedDocument: ProcessedDocument;
    processedPackage: ProcessedPackage;
    processedTicket: ProcessedTicket;
    processedVisa: ProcessedVisa;
    creatorUser: User;
    lastModifierUser: User;
    statementOfAccounts: StatementOfAccount[] | undefined;
}

export class BookingActivitiesDto implements IBookingActivitiesDto {
    overview: OverviewDto;
    labels: string[] | undefined;
    series: SeriesDto;

    constructor(data?: IBookingActivitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overview = _data["overview"] ? OverviewDto.fromJS(_data["overview"]) : undefined as any;
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels.push(item);
            }
            this.series = _data["series"] ? SeriesDto.fromJS(_data["series"]) : undefined as any;
        }
    }

    static fromJS(data: any): BookingActivitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingActivitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overview"] = this.overview ? this.overview.toJSON() : undefined as any;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["series"] = this.series ? this.series.toJSON() : undefined as any;
        return data;
    }

    clone(): BookingActivitiesDto {
        const json = this.toJSON();
        let result = new BookingActivitiesDto();
        result.init(json);
        return result;
    }
}

export interface IBookingActivitiesDto {
    overview: OverviewDto;
    labels: string[] | undefined;
    series: SeriesDto;
}

export class BookingAttachment implements IBookingAttachment {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    description: string | undefined;
    bookingId: string;
    booking: Booking;
    attachDocumentId: string | undefined;
    attachDocument: Document;
    typeId: string | undefined;
    type: AppSettingOption;

    constructor(data?: IBookingAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.description = _data["description"];
            this.bookingId = _data["bookingId"];
            this.booking = _data["booking"] ? Booking.fromJS(_data["booking"]) : undefined as any;
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocument = _data["attachDocument"] ? Document.fromJS(_data["attachDocument"]) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
        }
    }

    static fromJS(data: any): BookingAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["description"] = this.description;
        data["bookingId"] = this.bookingId;
        data["booking"] = this.booking ? this.booking.toJSON() : undefined as any;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocument"] = this.attachDocument ? this.attachDocument.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        return data;
    }

    clone(): BookingAttachment {
        const json = this.toJSON();
        let result = new BookingAttachment();
        result.init(json);
        return result;
    }
}

export interface IBookingAttachment {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    description: string | undefined;
    bookingId: string;
    booking: Booking;
    attachDocumentId: string | undefined;
    attachDocument: Document;
    typeId: string | undefined;
    type: AppSettingOption;
}

export class BookingClient implements IBookingClient {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    passengerId: string;
    passenger: Passenger;
    typeId: string | undefined;
    type: AppSettingOption;
    attachedPassportId: string | undefined;
    attachedPassport: Passport;
    note: string | undefined;
    isPrimary: boolean;
    willAvailTravelInsurance: boolean;
    addOns: BookingClientAddOn[] | undefined;

    constructor(data?: IBookingClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.bookingId = _data["bookingId"];
            this.booking = _data["booking"] ? Booking.fromJS(_data["booking"]) : undefined as any;
            this.passengerId = _data["passengerId"];
            this.passenger = _data["passenger"] ? Passenger.fromJS(_data["passenger"]) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.attachedPassportId = _data["attachedPassportId"];
            this.attachedPassport = _data["attachedPassport"] ? Passport.fromJS(_data["attachedPassport"]) : undefined as any;
            this.note = _data["note"];
            this.isPrimary = _data["isPrimary"];
            this.willAvailTravelInsurance = _data["willAvailTravelInsurance"];
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns.push(BookingClientAddOn.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingClient {
        data = typeof data === 'object' ? data : {};
        let result = new BookingClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["bookingId"] = this.bookingId;
        data["booking"] = this.booking ? this.booking.toJSON() : undefined as any;
        data["passengerId"] = this.passengerId;
        data["passenger"] = this.passenger ? this.passenger.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["attachedPassportId"] = this.attachedPassportId;
        data["attachedPassport"] = this.attachedPassport ? this.attachedPassport.toJSON() : undefined as any;
        data["note"] = this.note;
        data["isPrimary"] = this.isPrimary;
        data["willAvailTravelInsurance"] = this.willAvailTravelInsurance;
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BookingClient {
        const json = this.toJSON();
        let result = new BookingClient();
        result.init(json);
        return result;
    }
}

export interface IBookingClient {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    passengerId: string;
    passenger: Passenger;
    typeId: string | undefined;
    type: AppSettingOption;
    attachedPassportId: string | undefined;
    attachedPassport: Passport;
    note: string | undefined;
    isPrimary: boolean;
    willAvailTravelInsurance: boolean;
    addOns: BookingClientAddOn[] | undefined;
}

export class BookingClientAddOn implements IBookingClientAddOn {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    bookingClientId: string | undefined;
    bookingClient: BookingClient;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;

    constructor(data?: IBookingClientAddOn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.bookingClientId = _data["bookingClientId"];
            this.bookingClient = _data["bookingClient"] ? BookingClient.fromJS(_data["bookingClient"]) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.note = _data["note"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): BookingClientAddOn {
        data = typeof data === 'object' ? data : {};
        let result = new BookingClientAddOn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["bookingClientId"] = this.bookingClientId;
        data["bookingClient"] = this.bookingClient ? this.bookingClient.toJSON() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["note"] = this.note;
        data["price"] = this.price;
        return data;
    }

    clone(): BookingClientAddOn {
        const json = this.toJSON();
        let result = new BookingClientAddOn();
        result.init(json);
        return result;
    }
}

export interface IBookingClientAddOn {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    bookingClientId: string | undefined;
    bookingClient: BookingClient;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;
}

export class BookingDto implements IBookingDto {
    id: string;
    bookingNo: string | undefined;
    typeId: string | undefined;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    clientCount: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment;
    creatorUser: PublicUserDetails;
    lastModifierUser: PublicUserDetails;
    processedPackage: MinProcessedPackageDto;
    processedVisa: MinProcessedVisaDto;
    processedDocument: MinProcessedDocumentDto;
    processedTicket: MinProcessedTicketDto;
    clients: MinBookingClientDto[] | undefined;
    attachments: MinBookingAttachmentDto[] | undefined;

    constructor(data?: IBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bookingNo = _data["bookingNo"];
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.status = _data["status"] ? AppSettingOptionDto.fromJS(_data["status"]) : undefined as any;
            this.clientCount = _data["clientCount"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.creatorUser = _data["creatorUser"] ? PublicUserDetails.fromJS(_data["creatorUser"]) : undefined as any;
            this.lastModifierUser = _data["lastModifierUser"] ? PublicUserDetails.fromJS(_data["lastModifierUser"]) : undefined as any;
            this.processedPackage = _data["processedPackage"] ? MinProcessedPackageDto.fromJS(_data["processedPackage"]) : undefined as any;
            this.processedVisa = _data["processedVisa"] ? MinProcessedVisaDto.fromJS(_data["processedVisa"]) : undefined as any;
            this.processedDocument = _data["processedDocument"] ? MinProcessedDocumentDto.fromJS(_data["processedDocument"]) : undefined as any;
            this.processedTicket = _data["processedTicket"] ? MinProcessedTicketDto.fromJS(_data["processedTicket"]) : undefined as any;
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients.push(MinBookingClientDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(MinBookingAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookingNo"] = this.bookingNo;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["clientCount"] = this.clientCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined as any;
        data["processedPackage"] = this.processedPackage ? this.processedPackage.toJSON() : undefined as any;
        data["processedVisa"] = this.processedVisa ? this.processedVisa.toJSON() : undefined as any;
        data["processedDocument"] = this.processedDocument ? this.processedDocument.toJSON() : undefined as any;
        data["processedTicket"] = this.processedTicket ? this.processedTicket.toJSON() : undefined as any;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BookingDto {
        const json = this.toJSON();
        let result = new BookingDto();
        result.init(json);
        return result;
    }
}

export interface IBookingDto {
    id: string;
    bookingNo: string | undefined;
    typeId: string | undefined;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    clientCount: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment;
    creatorUser: PublicUserDetails;
    lastModifierUser: PublicUserDetails;
    processedPackage: MinProcessedPackageDto;
    processedVisa: MinProcessedVisaDto;
    processedDocument: MinProcessedDocumentDto;
    processedTicket: MinProcessedTicketDto;
    clients: MinBookingClientDto[] | undefined;
    attachments: MinBookingAttachmentDto[] | undefined;
}

export class BookingDtoPagedResultDto implements IBookingDtoPagedResultDto {
    items: BookingDto[] | undefined;
    totalCount: number;

    constructor(data?: IBookingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BookingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BookingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BookingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BookingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBookingDtoPagedResultDto {
    items: BookingDto[] | undefined;
    totalCount: number;
}

export class BookingInCharge implements IBookingInCharge {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    agentId: number;
    agent: User;
    typeId: string | undefined;
    type: AppSettingOption;

    constructor(data?: IBookingInCharge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.bookingId = _data["bookingId"];
            this.booking = _data["booking"] ? Booking.fromJS(_data["booking"]) : undefined as any;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? User.fromJS(_data["agent"]) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
        }
    }

    static fromJS(data: any): BookingInCharge {
        data = typeof data === 'object' ? data : {};
        let result = new BookingInCharge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["bookingId"] = this.bookingId;
        data["booking"] = this.booking ? this.booking.toJSON() : undefined as any;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        return data;
    }

    clone(): BookingInCharge {
        const json = this.toJSON();
        let result = new BookingInCharge();
        result.init(json);
        return result;
    }
}

export interface IBookingInCharge {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    agentId: number;
    agent: User;
    typeId: string | undefined;
    type: AppSettingOption;
}

export class BookingModuleSettingsContentDto implements IBookingModuleSettingsContentDto {
    enableCustomerFlightsBooking: boolean;
    enableCustomerHotelBooking: boolean;
    enableCustomerTourBooking: boolean;
    enableCustomerCabBooking: boolean;

    constructor(data?: IBookingModuleSettingsContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableCustomerFlightsBooking = _data["enableCustomerFlightsBooking"];
            this.enableCustomerHotelBooking = _data["enableCustomerHotelBooking"];
            this.enableCustomerTourBooking = _data["enableCustomerTourBooking"];
            this.enableCustomerCabBooking = _data["enableCustomerCabBooking"];
        }
    }

    static fromJS(data: any): BookingModuleSettingsContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingModuleSettingsContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableCustomerFlightsBooking"] = this.enableCustomerFlightsBooking;
        data["enableCustomerHotelBooking"] = this.enableCustomerHotelBooking;
        data["enableCustomerTourBooking"] = this.enableCustomerTourBooking;
        data["enableCustomerCabBooking"] = this.enableCustomerCabBooking;
        return data;
    }

    clone(): BookingModuleSettingsContentDto {
        const json = this.toJSON();
        let result = new BookingModuleSettingsContentDto();
        result.init(json);
        return result;
    }
}

export interface IBookingModuleSettingsContentDto {
    enableCustomerFlightsBooking: boolean;
    enableCustomerHotelBooking: boolean;
    enableCustomerTourBooking: boolean;
    enableCustomerCabBooking: boolean;
}

export class BookingModuleSettingsDto implements IBookingModuleSettingsDto {
    id: string;
    enableCustomerFlightsBooking: boolean;
    enableCustomerHotelBooking: boolean;
    enableCustomerTourBooking: boolean;
    enableCustomerCabBooking: boolean;
    isActive: boolean;

    constructor(data?: IBookingModuleSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enableCustomerFlightsBooking = _data["enableCustomerFlightsBooking"];
            this.enableCustomerHotelBooking = _data["enableCustomerHotelBooking"];
            this.enableCustomerTourBooking = _data["enableCustomerTourBooking"];
            this.enableCustomerCabBooking = _data["enableCustomerCabBooking"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BookingModuleSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingModuleSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enableCustomerFlightsBooking"] = this.enableCustomerFlightsBooking;
        data["enableCustomerHotelBooking"] = this.enableCustomerHotelBooking;
        data["enableCustomerTourBooking"] = this.enableCustomerTourBooking;
        data["enableCustomerCabBooking"] = this.enableCustomerCabBooking;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): BookingModuleSettingsDto {
        const json = this.toJSON();
        let result = new BookingModuleSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IBookingModuleSettingsDto {
    id: string;
    enableCustomerFlightsBooking: boolean;
    enableCustomerHotelBooking: boolean;
    enableCustomerTourBooking: boolean;
    enableCustomerCabBooking: boolean;
    isActive: boolean;
}

export class BookingSummaryDto implements IBookingSummaryDto {
    draftId: string;
    clientReference: string | undefined;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    leadGuestEmail: string | undefined;
    paidAmount: number | undefined;
    currency: string | undefined;
    status: string | undefined;

    constructor(data?: IBookingSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftId = _data["draftId"];
            this.clientReference = _data["clientReference"];
            this.hotelName = _data["hotelName"];
            this.checkIn = _data["checkIn"] ? moment(_data["checkIn"].toString()) : undefined as any;
            this.checkOut = _data["checkOut"] ? moment(_data["checkOut"].toString()) : undefined as any;
            this.leadGuestEmail = _data["leadGuestEmail"];
            this.paidAmount = _data["paidAmount"];
            this.currency = _data["currency"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BookingSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftId"] = this.draftId;
        data["clientReference"] = this.clientReference;
        data["hotelName"] = this.hotelName;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : undefined as any;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : undefined as any;
        data["leadGuestEmail"] = this.leadGuestEmail;
        data["paidAmount"] = this.paidAmount;
        data["currency"] = this.currency;
        data["status"] = this.status;
        return data;
    }

    clone(): BookingSummaryDto {
        const json = this.toJSON();
        let result = new BookingSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IBookingSummaryDto {
    draftId: string;
    clientReference: string | undefined;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    leadGuestEmail: string | undefined;
    paidAmount: number | undefined;
    currency: string | undefined;
    status: string | undefined;
}

export class BookingTransactionDto implements IBookingTransactionDto {
    id: string;
    bookingNo: string | undefined;
    typeId: string | undefined;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    overview: string | undefined;
    clientCount: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment;
    creatorUser: PublicUserDetails;
    lastModifierUser: PublicUserDetails;
    processedPackage: MinProcessedPackageDto;
    processedVisa: MinProcessedVisaDto;
    processedDocument: MinProcessedDocumentDto;
    processedTicket: MinProcessedTicketDto;

    constructor(data?: IBookingTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bookingNo = _data["bookingNo"];
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.status = _data["status"] ? AppSettingOptionDto.fromJS(_data["status"]) : undefined as any;
            this.overview = _data["overview"];
            this.clientCount = _data["clientCount"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.creatorUser = _data["creatorUser"] ? PublicUserDetails.fromJS(_data["creatorUser"]) : undefined as any;
            this.lastModifierUser = _data["lastModifierUser"] ? PublicUserDetails.fromJS(_data["lastModifierUser"]) : undefined as any;
            this.processedPackage = _data["processedPackage"] ? MinProcessedPackageDto.fromJS(_data["processedPackage"]) : undefined as any;
            this.processedVisa = _data["processedVisa"] ? MinProcessedVisaDto.fromJS(_data["processedVisa"]) : undefined as any;
            this.processedDocument = _data["processedDocument"] ? MinProcessedDocumentDto.fromJS(_data["processedDocument"]) : undefined as any;
            this.processedTicket = _data["processedTicket"] ? MinProcessedTicketDto.fromJS(_data["processedTicket"]) : undefined as any;
        }
    }

    static fromJS(data: any): BookingTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookingNo"] = this.bookingNo;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["overview"] = this.overview;
        data["clientCount"] = this.clientCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined as any;
        data["processedPackage"] = this.processedPackage ? this.processedPackage.toJSON() : undefined as any;
        data["processedVisa"] = this.processedVisa ? this.processedVisa.toJSON() : undefined as any;
        data["processedDocument"] = this.processedDocument ? this.processedDocument.toJSON() : undefined as any;
        data["processedTicket"] = this.processedTicket ? this.processedTicket.toJSON() : undefined as any;
        return data;
    }

    clone(): BookingTransactionDto {
        const json = this.toJSON();
        let result = new BookingTransactionDto();
        result.init(json);
        return result;
    }
}

export interface IBookingTransactionDto {
    id: string;
    bookingNo: string | undefined;
    typeId: string | undefined;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    overview: string | undefined;
    clientCount: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment;
    creatorUser: PublicUserDetails;
    lastModifierUser: PublicUserDetails;
    processedPackage: MinProcessedPackageDto;
    processedVisa: MinProcessedVisaDto;
    processedDocument: MinProcessedDocumentDto;
    processedTicket: MinProcessedTicketDto;
}

export class BookingTransactionOverviewDto implements IBookingTransactionOverviewDto {
    id: string;
    bookingNo: string | undefined;
    typeId: string | undefined;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    clientCount: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment;
    creatorUser: PublicUserDetails;
    lastModifierUser: PublicUserDetails;
    processedPackage: MinProcessedPackageDto;
    processedVisa: MinProcessedVisaDto;
    processedDocument: MinProcessedDocumentDto;
    clients: MinBookingClientDto[] | undefined;
    attachments: MinBookingAttachmentDto[] | undefined;

    constructor(data?: IBookingTransactionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bookingNo = _data["bookingNo"];
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.status = _data["status"] ? AppSettingOptionDto.fromJS(_data["status"]) : undefined as any;
            this.clientCount = _data["clientCount"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.creatorUser = _data["creatorUser"] ? PublicUserDetails.fromJS(_data["creatorUser"]) : undefined as any;
            this.lastModifierUser = _data["lastModifierUser"] ? PublicUserDetails.fromJS(_data["lastModifierUser"]) : undefined as any;
            this.processedPackage = _data["processedPackage"] ? MinProcessedPackageDto.fromJS(_data["processedPackage"]) : undefined as any;
            this.processedVisa = _data["processedVisa"] ? MinProcessedVisaDto.fromJS(_data["processedVisa"]) : undefined as any;
            this.processedDocument = _data["processedDocument"] ? MinProcessedDocumentDto.fromJS(_data["processedDocument"]) : undefined as any;
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients.push(MinBookingClientDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(MinBookingAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingTransactionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingTransactionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookingNo"] = this.bookingNo;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["clientCount"] = this.clientCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined as any;
        data["processedPackage"] = this.processedPackage ? this.processedPackage.toJSON() : undefined as any;
        data["processedVisa"] = this.processedVisa ? this.processedVisa.toJSON() : undefined as any;
        data["processedDocument"] = this.processedDocument ? this.processedDocument.toJSON() : undefined as any;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BookingTransactionOverviewDto {
        const json = this.toJSON();
        let result = new BookingTransactionOverviewDto();
        result.init(json);
        return result;
    }
}

export interface IBookingTransactionOverviewDto {
    id: string;
    bookingNo: string | undefined;
    typeId: string | undefined;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    clientCount: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment;
    creatorUser: PublicUserDetails;
    lastModifierUser: PublicUserDetails;
    processedPackage: MinProcessedPackageDto;
    processedVisa: MinProcessedVisaDto;
    processedDocument: MinProcessedDocumentDto;
    clients: MinBookingClientDto[] | undefined;
    attachments: MinBookingAttachmentDto[] | undefined;
}

export class CallToActionDto implements ICallToActionDto {
    heading: string | undefined;
    subheading: string | undefined;
    buttonText: string | undefined;
    buttonLink: string | undefined;
    postHeadingIcon: string | undefined;

    constructor(data?: ICallToActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.subheading = _data["subheading"];
            this.buttonText = _data["buttonText"];
            this.buttonLink = _data["buttonLink"];
            this.postHeadingIcon = _data["postHeadingIcon"];
        }
    }

    static fromJS(data: any): CallToActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallToActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["subheading"] = this.subheading;
        data["buttonText"] = this.buttonText;
        data["buttonLink"] = this.buttonLink;
        data["postHeadingIcon"] = this.postHeadingIcon;
        return data;
    }

    clone(): CallToActionDto {
        const json = this.toJSON();
        let result = new CallToActionDto();
        result.init(json);
        return result;
    }
}

export interface ICallToActionDto {
    heading: string | undefined;
    subheading: string | undefined;
    buttonText: string | undefined;
    buttonLink: string | undefined;
    postHeadingIcon: string | undefined;
}

export class CancellationPolicyDto implements ICancellationPolicyDto {
    type: string | undefined;
    refund: string | undefined;

    constructor(data?: ICancellationPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.refund = _data["refund"];
        }
    }

    static fromJS(data: any): CancellationPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["refund"] = this.refund;
        return data;
    }

    clone(): CancellationPolicyDto {
        const json = this.toJSON();
        let result = new CancellationPolicyDto();
        result.init(json);
        return result;
    }
}

export interface ICancellationPolicyDto {
    type: string | undefined;
    refund: string | undefined;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CheckoutOccupancyRequest implements ICheckoutOccupancyRequest {
    adults: number;
    childrenAges: number[] | undefined;

    constructor(data?: ICheckoutOccupancyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adults = _data["adults"];
            if (Array.isArray(_data["childrenAges"])) {
                this.childrenAges = [] as any;
                for (let item of _data["childrenAges"])
                    this.childrenAges.push(item);
            }
        }
    }

    static fromJS(data: any): CheckoutOccupancyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutOccupancyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adults"] = this.adults;
        if (Array.isArray(this.childrenAges)) {
            data["childrenAges"] = [];
            for (let item of this.childrenAges)
                data["childrenAges"].push(item);
        }
        return data;
    }

    clone(): CheckoutOccupancyRequest {
        const json = this.toJSON();
        let result = new CheckoutOccupancyRequest();
        result.init(json);
        return result;
    }
}

export interface ICheckoutOccupancyRequest {
    adults: number;
    childrenAges: number[] | undefined;
}

export class CheckoutRoomRequest implements ICheckoutRoomRequest {
    rateKey: string | undefined;
    guests: GuestApiDto[] | undefined;

    constructor(data?: ICheckoutRoomRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rateKey = _data["rateKey"];
            if (Array.isArray(_data["guests"])) {
                this.guests = [] as any;
                for (let item of _data["guests"])
                    this.guests.push(GuestApiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckoutRoomRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutRoomRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rateKey"] = this.rateKey;
        if (Array.isArray(this.guests)) {
            data["guests"] = [];
            for (let item of this.guests)
                data["guests"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CheckoutRoomRequest {
        const json = this.toJSON();
        let result = new CheckoutRoomRequest();
        result.init(json);
        return result;
    }
}

export interface ICheckoutRoomRequest {
    rateKey: string | undefined;
    guests: GuestApiDto[] | undefined;
}

export class CheckoutSelectionRequest implements ICheckoutSelectionRequest {
    roomName: string | undefined;
    roomCode: string | undefined;
    boardType: string | undefined;
    destinationCode: string | undefined;
    destinationLabel: string | undefined;

    constructor(data?: ICheckoutSelectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomName = _data["roomName"];
            this.roomCode = _data["roomCode"];
            this.boardType = _data["boardType"];
            this.destinationCode = _data["destinationCode"];
            this.destinationLabel = _data["destinationLabel"];
        }
    }

    static fromJS(data: any): CheckoutSelectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutSelectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomName"] = this.roomName;
        data["roomCode"] = this.roomCode;
        data["boardType"] = this.boardType;
        data["destinationCode"] = this.destinationCode;
        data["destinationLabel"] = this.destinationLabel;
        return data;
    }

    clone(): CheckoutSelectionRequest {
        const json = this.toJSON();
        let result = new CheckoutSelectionRequest();
        result.init(json);
        return result;
    }
}

export interface ICheckoutSelectionRequest {
    roomName: string | undefined;
    roomCode: string | undefined;
    boardType: string | undefined;
    destinationCode: string | undefined;
    destinationLabel: string | undefined;
}

/** Seat inventory for a single GDS booking class. */
export class ClassAvailabilityApiDto implements IClassAvailabilityApiDto {
    /** GDS booking class code. Example: `Y`, `J`, `F`. */
    bookingClass: string | undefined;
    /** Cabin associated with this booking class. Example: `Economy`, `Business`. */
    cabinClass: string | undefined;
    /** Number of seats available in this class. `null` if not disclosed. */
    seatsAvailable: number | undefined;
    /** Availability status: `Available`, `WaitList`, `OnRequest`, `Closed`. */
    status: string | undefined;

    constructor(data?: IClassAvailabilityApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingClass = _data["bookingClass"];
            this.cabinClass = _data["cabinClass"];
            this.seatsAvailable = _data["seatsAvailable"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ClassAvailabilityApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassAvailabilityApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingClass"] = this.bookingClass;
        data["cabinClass"] = this.cabinClass;
        data["seatsAvailable"] = this.seatsAvailable;
        data["status"] = this.status;
        return data;
    }

    clone(): ClassAvailabilityApiDto {
        const json = this.toJSON();
        let result = new ClassAvailabilityApiDto();
        result.init(json);
        return result;
    }
}

/** Seat inventory for a single GDS booking class. */
export interface IClassAvailabilityApiDto {
    /** GDS booking class code. Example: `Y`, `J`, `F`. */
    bookingClass: string | undefined;
    /** Cabin associated with this booking class. Example: `Economy`, `Business`. */
    cabinClass: string | undefined;
    /** Number of seats available in this class. `null` if not disclosed. */
    seatsAvailable: number | undefined;
    /** Availability status: `Available`, `WaitList`, `OnRequest`, `Closed`. */
    status: string | undefined;
}

export class CloseStayCancellationRequestNotCancellableInput implements ICloseStayCancellationRequestNotCancellableInput {
    reason: string;

    constructor(data?: ICloseStayCancellationRequestNotCancellableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CloseStayCancellationRequestNotCancellableInput {
        data = typeof data === 'object' ? data : {};
        let result = new CloseStayCancellationRequestNotCancellableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }

    clone(): CloseStayCancellationRequestNotCancellableInput {
        const json = this.toJSON();
        let result = new CloseStayCancellationRequestNotCancellableInput();
        result.init(json);
        return result;
    }
}

export interface ICloseStayCancellationRequestNotCancellableInput {
    reason: string;
}

export class CmsFileUploadDto implements ICmsFileUploadDto {
    base64: string;
    contentType: string;
    fileName: string;
    section: string;

    constructor(data?: ICmsFileUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
            this.contentType = _data["contentType"];
            this.fileName = _data["fileName"];
            this.section = _data["section"];
        }
    }

    static fromJS(data: any): CmsFileUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new CmsFileUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["section"] = this.section;
        return data;
    }

    clone(): CmsFileUploadDto {
        const json = this.toJSON();
        let result = new CmsFileUploadDto();
        result.init(json);
        return result;
    }
}

export interface ICmsFileUploadDto {
    base64: string;
    contentType: string;
    fileName: string;
    section: string;
}

export class CmsFileUploadResultDto implements ICmsFileUploadResultDto {
    success: boolean;
    message: string | undefined;
    fileUrl: string | undefined;
    documentId: string;
    fileName: string | undefined;

    constructor(data?: ICmsFileUploadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.fileUrl = _data["fileUrl"];
            this.documentId = _data["documentId"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): CmsFileUploadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CmsFileUploadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["fileUrl"] = this.fileUrl;
        data["documentId"] = this.documentId;
        data["fileName"] = this.fileName;
        return data;
    }

    clone(): CmsFileUploadResultDto {
        const json = this.toJSON();
        let result = new CmsFileUploadResultDto();
        result.init(json);
        return result;
    }
}

export interface ICmsFileUploadResultDto {
    success: boolean;
    message: string | undefined;
    fileUrl: string | undefined;
    documentId: string;
    fileName: string | undefined;
}

export class CmsPageDto implements ICmsPageDto {
    id: string;
    pageName: string | undefined;
    pageTitle: string | undefined;
    pageDescription: string | undefined;
    pageType: string | undefined;
    contentJson: string | undefined;
    slug: string | undefined;
    isActive: boolean;
    sortOrder: number;
    metaTitle: string | undefined;
    metaDescription: string | undefined;
    metaKeywords: string | undefined;

    constructor(data?: ICmsPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageName = _data["pageName"];
            this.pageTitle = _data["pageTitle"];
            this.pageDescription = _data["pageDescription"];
            this.pageType = _data["pageType"];
            this.contentJson = _data["contentJson"];
            this.slug = _data["slug"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
        }
    }

    static fromJS(data: any): CmsPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CmsPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageName"] = this.pageName;
        data["pageTitle"] = this.pageTitle;
        data["pageDescription"] = this.pageDescription;
        data["pageType"] = this.pageType;
        data["contentJson"] = this.contentJson;
        data["slug"] = this.slug;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        return data;
    }

    clone(): CmsPageDto {
        const json = this.toJSON();
        let result = new CmsPageDto();
        result.init(json);
        return result;
    }
}

export interface ICmsPageDto {
    id: string;
    pageName: string | undefined;
    pageTitle: string | undefined;
    pageDescription: string | undefined;
    pageType: string | undefined;
    contentJson: string | undefined;
    slug: string | undefined;
    isActive: boolean;
    sortOrder: number;
    metaTitle: string | undefined;
    metaDescription: string | undefined;
    metaKeywords: string | undefined;
}

export class CmsPageDtoPagedResultDto implements ICmsPageDtoPagedResultDto {
    items: CmsPageDto[] | undefined;
    totalCount: number;

    constructor(data?: ICmsPageDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CmsPageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CmsPageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CmsPageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CmsPageDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CmsPageDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICmsPageDtoPagedResultDto {
    items: CmsPageDto[] | undefined;
    totalCount: number;
}

export class ContactInfoDto implements IContactInfoDto {
    email: string | undefined;
    phone: string | undefined;

    constructor(data?: IContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): ContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }

    clone(): ContactInfoDto {
        const json = this.toJSON();
        let result = new ContactInfoDto();
        result.init(json);
        return result;
    }
}

export interface IContactInfoDto {
    email: string | undefined;
    phone: string | undefined;
}

export class ContactInquiryDto implements IContactInquiryDto {
    id: string;
    name: string;
    email: string;
    mobileNumber: string;
    message: string;
    status: ContactInquiryStatus;
    adminNotes: string | undefined;
    ipAddress: string | undefined;
    userAgent: string | undefined;
    responseDate: moment.Moment | undefined;
    responseMessage: string | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IContactInquiryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.message = _data["message"];
            this.status = _data["status"];
            this.adminNotes = _data["adminNotes"];
            this.ipAddress = _data["ipAddress"];
            this.userAgent = _data["userAgent"];
            this.responseDate = _data["responseDate"] ? moment(_data["responseDate"].toString()) : undefined as any;
            this.responseMessage = _data["responseMessage"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ContactInquiryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInquiryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["message"] = this.message;
        data["status"] = this.status;
        data["adminNotes"] = this.adminNotes;
        data["ipAddress"] = this.ipAddress;
        data["userAgent"] = this.userAgent;
        data["responseDate"] = this.responseDate ? this.responseDate.toISOString() : undefined as any;
        data["responseMessage"] = this.responseMessage;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): ContactInquiryDto {
        const json = this.toJSON();
        let result = new ContactInquiryDto();
        result.init(json);
        return result;
    }
}

export interface IContactInquiryDto {
    id: string;
    name: string;
    email: string;
    mobileNumber: string;
    message: string;
    status: ContactInquiryStatus;
    adminNotes: string | undefined;
    ipAddress: string | undefined;
    userAgent: string | undefined;
    responseDate: moment.Moment | undefined;
    responseMessage: string | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class ContactInquiryDtoPagedResultDto implements IContactInquiryDtoPagedResultDto {
    items: ContactInquiryDto[] | undefined;
    totalCount: number;

    constructor(data?: IContactInquiryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ContactInquiryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ContactInquiryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInquiryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ContactInquiryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ContactInquiryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IContactInquiryDtoPagedResultDto {
    items: ContactInquiryDto[] | undefined;
    totalCount: number;
}

export enum ContactInquiryStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

/** Outcome of a single catalog-item sync (used for Partial destinations progress). */
export enum ContentSyncOutcome {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CreateAgentDto implements ICreateAgentDto {
    agentTypeId: string;
    name: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    isDotAccredited: boolean;
    dotAccreditationExpiryDate: moment.Moment | undefined;
    status: Status;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    phoneNumbers: CreateAgentPhoneNumberDto[] | undefined;
    emails: CreateAgentEmailDto[] | undefined;

    constructor(data?: ICreateAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentTypeId = _data["agentTypeId"];
            this.name = _data["name"];
            this.contactPerson = _data["contactPerson"];
            this.designation = _data["designation"];
            this.note = _data["note"];
            this.isDotAccredited = _data["isDotAccredited"];
            this.dotAccreditationExpiryDate = _data["dotAccreditationExpiryDate"] ? moment(_data["dotAccreditationExpiryDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.coverPhoto = _data["coverPhoto"] ? FileDto.fromJS(_data["coverPhoto"]) : undefined as any;
            this.profilePhoto = _data["profilePhoto"] ? FileDto.fromJS(_data["profilePhoto"]) : undefined as any;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(CreateAgentPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(CreateAgentEmailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentTypeId"] = this.agentTypeId;
        data["name"] = this.name;
        data["contactPerson"] = this.contactPerson;
        data["designation"] = this.designation;
        data["note"] = this.note;
        data["isDotAccredited"] = this.isDotAccredited;
        data["dotAccreditationExpiryDate"] = this.dotAccreditationExpiryDate ? this.dotAccreditationExpiryDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["coverPhoto"] = this.coverPhoto ? this.coverPhoto.toJSON() : undefined as any;
        data["profilePhoto"] = this.profilePhoto ? this.profilePhoto.toJSON() : undefined as any;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateAgentDto {
        const json = this.toJSON();
        let result = new CreateAgentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAgentDto {
    agentTypeId: string;
    name: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    isDotAccredited: boolean;
    dotAccreditationExpiryDate: moment.Moment | undefined;
    status: Status;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    phoneNumbers: CreateAgentPhoneNumberDto[] | undefined;
    emails: CreateAgentEmailDto[] | undefined;
}

export class CreateAgentEmailDto implements ICreateAgentEmailDto {
    email: string | undefined;
    note: string | undefined;
    agentId: string;
    isActive: boolean;
    isPrimary: boolean;

    constructor(data?: ICreateAgentEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.note = _data["note"];
            this.agentId = _data["agentId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): CreateAgentEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgentEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["note"] = this.note;
        data["agentId"] = this.agentId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        return data;
    }

    clone(): CreateAgentEmailDto {
        const json = this.toJSON();
        let result = new CreateAgentEmailDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAgentEmailDto {
    email: string | undefined;
    note: string | undefined;
    agentId: string;
    isActive: boolean;
    isPrimary: boolean;
}

export class CreateAgentPhoneNumberDto implements ICreateAgentPhoneNumberDto {
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    agentId: string;
    isActive: boolean;
    isPrimary: boolean;

    constructor(data?: ICreateAgentPhoneNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.note = _data["note"];
            this.agentId = _data["agentId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): CreateAgentPhoneNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgentPhoneNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["note"] = this.note;
        data["agentId"] = this.agentId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        return data;
    }

    clone(): CreateAgentPhoneNumberDto {
        const json = this.toJSON();
        let result = new CreateAgentPhoneNumberDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAgentPhoneNumberDto {
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    agentId: string;
    isActive: boolean;
    isPrimary: boolean;
}

export class CreateAppSettingDto implements ICreateAppSettingDto {
    name: string | undefined;
    description: string | undefined;
    isActive: boolean;
    optionType: SettingsOptionType;
    icon: string | undefined;
    note: string | undefined;
    options: CreateAppSettingOptionDto[] | undefined;

    constructor(data?: ICreateAppSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.optionType = _data["optionType"];
            this.icon = _data["icon"];
            this.note = _data["note"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options.push(CreateAppSettingOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAppSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["optionType"] = this.optionType;
        data["icon"] = this.icon;
        data["note"] = this.note;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateAppSettingDto {
        const json = this.toJSON();
        let result = new CreateAppSettingDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAppSettingDto {
    name: string | undefined;
    description: string | undefined;
    isActive: boolean;
    optionType: SettingsOptionType;
    icon: string | undefined;
    note: string | undefined;
    options: CreateAppSettingOptionDto[] | undefined;
}

export class CreateAppSettingOptionDto implements ICreateAppSettingOptionDto {
    name: string | undefined;
    description: string | undefined;
    value: string | undefined;
    order: number;
    appSettingId: string;

    constructor(data?: ICreateAppSettingOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.value = _data["value"];
            this.order = _data["order"];
            this.appSettingId = _data["appSettingId"];
        }
    }

    static fromJS(data: any): CreateAppSettingOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppSettingOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["value"] = this.value;
        data["order"] = this.order;
        data["appSettingId"] = this.appSettingId;
        return data;
    }

    clone(): CreateAppSettingOptionDto {
        const json = this.toJSON();
        let result = new CreateAppSettingOptionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAppSettingOptionDto {
    name: string | undefined;
    description: string | undefined;
    value: string | undefined;
    order: number;
    appSettingId: string;
}

export class CreateBookingAttachmentDto implements ICreateBookingAttachmentDto {
    description: string | undefined;
    attachDocumentFile: FileDto;
    typeId: string | undefined;

    constructor(data?: ICreateBookingAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.attachDocumentFile = _data["attachDocumentFile"] ? FileDto.fromJS(_data["attachDocumentFile"]) : undefined as any;
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): CreateBookingAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["attachDocumentFile"] = this.attachDocumentFile ? this.attachDocumentFile.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        return data;
    }

    clone(): CreateBookingAttachmentDto {
        const json = this.toJSON();
        let result = new CreateBookingAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBookingAttachmentDto {
    description: string | undefined;
    attachDocumentFile: FileDto;
    typeId: string | undefined;
}

export class CreateBookingClientAddOnDto implements ICreateBookingClientAddOnDto {
    typeId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;
    bookingClientId: string | undefined;

    constructor(data?: ICreateBookingClientAddOnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.note = _data["note"];
            this.price = _data["price"];
            this.bookingClientId = _data["bookingClientId"];
        }
    }

    static fromJS(data: any): CreateBookingClientAddOnDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingClientAddOnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["note"] = this.note;
        data["price"] = this.price;
        data["bookingClientId"] = this.bookingClientId;
        return data;
    }

    clone(): CreateBookingClientAddOnDto {
        const json = this.toJSON();
        let result = new CreateBookingClientAddOnDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBookingClientAddOnDto {
    typeId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;
    bookingClientId: string | undefined;
}

export class CreateBookingClientDto implements ICreateBookingClientDto {
    passengerId: string;
    typeId: string | undefined;
    isPrimary: boolean;
    willAvailTravelInsurance: boolean;
    addOns: CreateBookingClientAddOnDto[] | undefined;

    constructor(data?: ICreateBookingClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passengerId = _data["passengerId"];
            this.typeId = _data["typeId"];
            this.isPrimary = _data["isPrimary"];
            this.willAvailTravelInsurance = _data["willAvailTravelInsurance"];
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns.push(CreateBookingClientAddOnDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateBookingClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passengerId"] = this.passengerId;
        data["typeId"] = this.typeId;
        data["isPrimary"] = this.isPrimary;
        data["willAvailTravelInsurance"] = this.willAvailTravelInsurance;
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateBookingClientDto {
        const json = this.toJSON();
        let result = new CreateBookingClientDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBookingClientDto {
    passengerId: string;
    typeId: string | undefined;
    isPrimary: boolean;
    willAvailTravelInsurance: boolean;
    addOns: CreateBookingClientAddOnDto[] | undefined;
}

export class CreateBookingDto implements ICreateBookingDto {
    typeId: string | undefined;
    package: string | undefined;
    attachments: CreateBookingAttachmentDto[] | undefined;
    processedPackage: CreateProcessedPackageDto;
    processedVisa: CreateProcessedVisaDto;
    processedDocument: CreateProcessedDocumentDto;
    processedTicket: CreateProcessedTicketDto;
    clients: CreateBookingClientDto[] | undefined;
    note: string | undefined;

    constructor(data?: ICreateBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.package = _data["package"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(CreateBookingAttachmentDto.fromJS(item));
            }
            this.processedPackage = _data["processedPackage"] ? CreateProcessedPackageDto.fromJS(_data["processedPackage"]) : undefined as any;
            this.processedVisa = _data["processedVisa"] ? CreateProcessedVisaDto.fromJS(_data["processedVisa"]) : undefined as any;
            this.processedDocument = _data["processedDocument"] ? CreateProcessedDocumentDto.fromJS(_data["processedDocument"]) : undefined as any;
            this.processedTicket = _data["processedTicket"] ? CreateProcessedTicketDto.fromJS(_data["processedTicket"]) : undefined as any;
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients.push(CreateBookingClientDto.fromJS(item));
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["package"] = this.package;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["processedPackage"] = this.processedPackage ? this.processedPackage.toJSON() : undefined as any;
        data["processedVisa"] = this.processedVisa ? this.processedVisa.toJSON() : undefined as any;
        data["processedDocument"] = this.processedDocument ? this.processedDocument.toJSON() : undefined as any;
        data["processedTicket"] = this.processedTicket ? this.processedTicket.toJSON() : undefined as any;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item ? item.toJSON() : undefined as any);
        }
        data["note"] = this.note;
        return data;
    }

    clone(): CreateBookingDto {
        const json = this.toJSON();
        let result = new CreateBookingDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBookingDto {
    typeId: string | undefined;
    package: string | undefined;
    attachments: CreateBookingAttachmentDto[] | undefined;
    processedPackage: CreateProcessedPackageDto;
    processedVisa: CreateProcessedVisaDto;
    processedDocument: CreateProcessedDocumentDto;
    processedTicket: CreateProcessedTicketDto;
    clients: CreateBookingClientDto[] | undefined;
    note: string | undefined;
}

export class CreateCmsPageDto implements ICreateCmsPageDto {
    pageName: string | undefined;
    pageTitle: string | undefined;
    pageDescription: string | undefined;
    pageType: string | undefined;
    contentJson: string | undefined;
    slug: string | undefined;
    isActive: boolean;
    sortOrder: number;
    metaTitle: string | undefined;
    metaDescription: string | undefined;
    metaKeywords: string | undefined;

    constructor(data?: ICreateCmsPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageName = _data["pageName"];
            this.pageTitle = _data["pageTitle"];
            this.pageDescription = _data["pageDescription"];
            this.pageType = _data["pageType"];
            this.contentJson = _data["contentJson"];
            this.slug = _data["slug"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
        }
    }

    static fromJS(data: any): CreateCmsPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCmsPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageName"] = this.pageName;
        data["pageTitle"] = this.pageTitle;
        data["pageDescription"] = this.pageDescription;
        data["pageType"] = this.pageType;
        data["contentJson"] = this.contentJson;
        data["slug"] = this.slug;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        return data;
    }

    clone(): CreateCmsPageDto {
        const json = this.toJSON();
        let result = new CreateCmsPageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCmsPageDto {
    pageName: string | undefined;
    pageTitle: string | undefined;
    pageDescription: string | undefined;
    pageType: string | undefined;
    contentJson: string | undefined;
    slug: string | undefined;
    isActive: boolean;
    sortOrder: number;
    metaTitle: string | undefined;
    metaDescription: string | undefined;
    metaKeywords: string | undefined;
}

export class CreateContactInquiryDto implements ICreateContactInquiryDto {
    name: string;
    email: string;
    mobileNumber: string;
    message: string;
    ipAddress: string | undefined;
    userAgent: string | undefined;

    constructor(data?: ICreateContactInquiryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.message = _data["message"];
            this.ipAddress = _data["ipAddress"];
            this.userAgent = _data["userAgent"];
        }
    }

    static fromJS(data: any): CreateContactInquiryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactInquiryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["message"] = this.message;
        data["ipAddress"] = this.ipAddress;
        data["userAgent"] = this.userAgent;
        return data;
    }

    clone(): CreateContactInquiryDto {
        const json = this.toJSON();
        let result = new CreateContactInquiryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateContactInquiryDto {
    name: string;
    email: string;
    mobileNumber: string;
    message: string;
    ipAddress: string | undefined;
    userAgent: string | undefined;
}

/** DTO for creating a new customer booking */
export class CreateCustomerBookingDto implements ICreateCustomerBookingDto {
    tourId: number;
    tourName: string | undefined;
    contactEmail: string;
    contactPhone: string;
    totalAmount: number | undefined;
    currency: string | undefined;
    travelDate: moment.Moment | undefined;
    days: number | undefined;
    nights: number | undefined;
    notes: string | undefined;
    sessionId: string | undefined;
    travelers: CreateCustomerTravelerDto[] | undefined;

    constructor(data?: ICreateCustomerBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourId = _data["tourId"];
            this.tourName = _data["tourName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.totalAmount = _data["totalAmount"];
            this.currency = _data["currency"];
            this.travelDate = _data["travelDate"] ? moment(_data["travelDate"].toString()) : undefined as any;
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.notes = _data["notes"];
            this.sessionId = _data["sessionId"];
            if (Array.isArray(_data["travelers"])) {
                this.travelers = [] as any;
                for (let item of _data["travelers"])
                    this.travelers.push(CreateCustomerTravelerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCustomerBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourId"] = this.tourId;
        data["tourName"] = this.tourName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["totalAmount"] = this.totalAmount;
        data["currency"] = this.currency;
        data["travelDate"] = this.travelDate ? this.travelDate.toISOString() : undefined as any;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["notes"] = this.notes;
        data["sessionId"] = this.sessionId;
        if (Array.isArray(this.travelers)) {
            data["travelers"] = [];
            for (let item of this.travelers)
                data["travelers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateCustomerBookingDto {
        const json = this.toJSON();
        let result = new CreateCustomerBookingDto();
        result.init(json);
        return result;
    }
}

/** DTO for creating a new customer booking */
export interface ICreateCustomerBookingDto {
    tourId: number;
    tourName: string | undefined;
    contactEmail: string;
    contactPhone: string;
    totalAmount: number | undefined;
    currency: string | undefined;
    travelDate: moment.Moment | undefined;
    days: number | undefined;
    nights: number | undefined;
    notes: string | undefined;
    sessionId: string | undefined;
    travelers: CreateCustomerTravelerDto[] | undefined;
}

export class CreateCustomerPaymentReceiptDto implements ICreateCustomerPaymentReceiptDto {
    receiptNumber: string;
    amount: number;
    currency: string;
    paymentDate: moment.Moment;
    receiptType: CustomerPaymentReceiptType;
    notes: string | undefined;
    customerBookingId: string;
    fileBase64: string;
    fileName: string;
    fileType: string;
    fileSize: number;
    fileExtension: string;

    constructor(data?: ICreateCustomerPaymentReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptNumber = _data["receiptNumber"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : undefined as any;
            this.receiptType = _data["receiptType"];
            this.notes = _data["notes"];
            this.customerBookingId = _data["customerBookingId"];
            this.fileBase64 = _data["fileBase64"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileSize = _data["fileSize"];
            this.fileExtension = _data["fileExtension"];
        }
    }

    static fromJS(data: any): CreateCustomerPaymentReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerPaymentReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptNumber"] = this.receiptNumber;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined as any;
        data["receiptType"] = this.receiptType;
        data["notes"] = this.notes;
        data["customerBookingId"] = this.customerBookingId;
        data["fileBase64"] = this.fileBase64;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileSize"] = this.fileSize;
        data["fileExtension"] = this.fileExtension;
        return data;
    }

    clone(): CreateCustomerPaymentReceiptDto {
        const json = this.toJSON();
        let result = new CreateCustomerPaymentReceiptDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerPaymentReceiptDto {
    receiptNumber: string;
    amount: number;
    currency: string;
    paymentDate: moment.Moment;
    receiptType: CustomerPaymentReceiptType;
    notes: string | undefined;
    customerBookingId: string;
    fileBase64: string;
    fileName: string;
    fileType: string;
    fileSize: number;
    fileExtension: string;
}

/** DTO for creating or updating customer traveler information */
export class CreateCustomerTravelerDto implements ICreateCustomerTravelerDto {
    title: string | undefined;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    nationality: string | undefined;
    passportNumber: string | undefined;
    passportExpiryDate: moment.Moment | undefined;
    specialRequests: string | undefined;
    travelerOrder: number;

    constructor(data?: ICreateCustomerTravelerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.nationality = _data["nationality"];
            this.passportNumber = _data["passportNumber"];
            this.passportExpiryDate = _data["passportExpiryDate"] ? moment(_data["passportExpiryDate"].toString()) : undefined as any;
            this.specialRequests = _data["specialRequests"];
            this.travelerOrder = _data["travelerOrder"];
        }
    }

    static fromJS(data: any): CreateCustomerTravelerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerTravelerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["nationality"] = this.nationality;
        data["passportNumber"] = this.passportNumber;
        data["passportExpiryDate"] = this.passportExpiryDate ? this.passportExpiryDate.toISOString() : undefined as any;
        data["specialRequests"] = this.specialRequests;
        data["travelerOrder"] = this.travelerOrder;
        return data;
    }

    clone(): CreateCustomerTravelerDto {
        const json = this.toJSON();
        let result = new CreateCustomerTravelerDto();
        result.init(json);
        return result;
    }
}

/** DTO for creating or updating customer traveler information */
export interface ICreateCustomerTravelerDto {
    title: string | undefined;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    nationality: string | undefined;
    passportNumber: string | undefined;
    passportExpiryDate: moment.Moment | undefined;
    specialRequests: string | undefined;
    travelerOrder: number;
}

export class CreateInstallmentSchedule implements ICreateInstallmentSchedule {
    title: string | undefined;
    date: moment.Moment;
    amount: number;

    constructor(data?: ICreateInstallmentSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CreateInstallmentSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInstallmentSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["amount"] = this.amount;
        return data;
    }

    clone(): CreateInstallmentSchedule {
        const json = this.toJSON();
        let result = new CreateInstallmentSchedule();
        result.init(json);
        return result;
    }
}

export interface ICreateInstallmentSchedule {
    title: string | undefined;
    date: moment.Moment;
    amount: number;
}

export class CreateMarkupRuleDto implements ICreateMarkupRuleDto {
    name: string;
    description: string | undefined;
    supplierName: string | undefined;
    productType: MarkupProductType;
    cabinClass: string | undefined;
    destinationRegion: string | undefined;
    markupType: MarkupType;
    markupValue: number;
    priority: number;
    validFrom: moment.Moment | undefined;
    validTo: moment.Moment | undefined;
    isActive: boolean;

    constructor(data?: ICreateMarkupRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.supplierName = _data["supplierName"];
            this.productType = _data["productType"];
            this.cabinClass = _data["cabinClass"];
            this.destinationRegion = _data["destinationRegion"];
            this.markupType = _data["markupType"];
            this.markupValue = _data["markupValue"];
            this.priority = _data["priority"];
            this.validFrom = _data["validFrom"] ? moment(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? moment(_data["validTo"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateMarkupRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMarkupRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["supplierName"] = this.supplierName;
        data["productType"] = this.productType;
        data["cabinClass"] = this.cabinClass;
        data["destinationRegion"] = this.destinationRegion;
        data["markupType"] = this.markupType;
        data["markupValue"] = this.markupValue;
        data["priority"] = this.priority;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateMarkupRuleDto {
        const json = this.toJSON();
        let result = new CreateMarkupRuleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMarkupRuleDto {
    name: string;
    description: string | undefined;
    supplierName: string | undefined;
    productType: MarkupProductType;
    cabinClass: string | undefined;
    destinationRegion: string | undefined;
    markupType: MarkupType;
    markupValue: number;
    priority: number;
    validFrom: moment.Moment | undefined;
    validTo: moment.Moment | undefined;
    isActive: boolean;
}

export class CreateNewsletterSubscriberDto implements ICreateNewsletterSubscriberDto {
    email: string;

    constructor(data?: ICreateNewsletterSubscriberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateNewsletterSubscriberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewsletterSubscriberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }

    clone(): CreateNewsletterSubscriberDto {
        const json = this.toJSON();
        let result = new CreateNewsletterSubscriberDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNewsletterSubscriberDto {
    email: string;
}

export class CreateNotificationInput implements ICreateNotificationInput {
    userId: number | undefined;
    entityType: string | undefined;
    entityId: string;
    type: NotificationType;
    message: string | undefined;
    data: any | undefined;

    constructor(data?: ICreateNotificationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.type = _data["type"];
            this.message = _data["message"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CreateNotificationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNotificationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["type"] = this.type;
        data["message"] = this.message;
        data["data"] = this.data;
        return data;
    }

    clone(): CreateNotificationInput {
        const json = this.toJSON();
        let result = new CreateNotificationInput();
        result.init(json);
        return result;
    }
}

export interface ICreateNotificationInput {
    userId: number | undefined;
    entityType: string | undefined;
    entityId: string;
    type: NotificationType;
    message: string | undefined;
    data: any | undefined;
}

export class CreateOrUpdateBookingModuleSettingsDto implements ICreateOrUpdateBookingModuleSettingsDto {
    content: BookingModuleSettingsContentDto;

    constructor(data?: ICreateOrUpdateBookingModuleSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] ? BookingModuleSettingsContentDto.fromJS(_data["content"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateOrUpdateBookingModuleSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBookingModuleSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : undefined as any;
        return data;
    }

    clone(): CreateOrUpdateBookingModuleSettingsDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateBookingModuleSettingsDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateBookingModuleSettingsDto {
    content: BookingModuleSettingsContentDto;
}

export class CreateOrUpdateGlobalSettingsDto implements ICreateOrUpdateGlobalSettingsDto {
    content: GlobalSettingsContentDto;
    metaTitle: string | undefined;
    metaDescription: string | undefined;
    metaKeywords: string | undefined;

    constructor(data?: ICreateOrUpdateGlobalSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.content = new GlobalSettingsContentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] ? GlobalSettingsContentDto.fromJS(_data["content"]) : new GlobalSettingsContentDto();
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
        }
    }

    static fromJS(data: any): CreateOrUpdateGlobalSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateGlobalSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : undefined as any;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        return data;
    }

    clone(): CreateOrUpdateGlobalSettingsDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateGlobalSettingsDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateGlobalSettingsDto {
    content: GlobalSettingsContentDto;
    metaTitle: string | undefined;
    metaDescription: string | undefined;
    metaKeywords: string | undefined;
}

/** DTO for creating or updating packages homepage with file uploads (following package pattern) */
export class CreateOrUpdatePackagesHomepageDto implements ICreateOrUpdatePackagesHomepageDto {
    content: PackagesHomepageContentDto;
    bannerImageFile: FileDto;
    reviewMainImageFile: FileDto;
    reviewSupportingImage1File: FileDto;
    reviewSupportingImage2File: FileDto;
    mainImageFile: FileDto;
    supportingImage1File: FileDto;
    supportingImage2File: FileDto;
    aboutUsMainImage1File: FileDto;
    aboutUsMainImage2File: FileDto;
    aboutUsSupportingImageFile: FileDto;
    postHeadingIconFile: FileDto;
    /** Team member images (can have multiple) */
    teamMemberImages: TeamMemberImageDto[] | undefined;
    /** Review author images (can have multiple) */
    reviewAuthorImages: ReviewAuthorImageDto[] | undefined;
    /** Story module images (can have multiple) */
    storyModuleImages: StoryModuleImageDto[] | undefined;
    /** Image card images (can have multiple) */
    imageCardImages: ImageCardImageDto[] | undefined;
    /** Gallery images for About Us page (can have multiple) */
    galleryImages: GalleryImageDto[] | undefined;

    constructor(data?: ICreateOrUpdatePackagesHomepageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] ? PackagesHomepageContentDto.fromJS(_data["content"]) : undefined as any;
            this.bannerImageFile = _data["bannerImageFile"] ? FileDto.fromJS(_data["bannerImageFile"]) : undefined as any;
            this.reviewMainImageFile = _data["reviewMainImageFile"] ? FileDto.fromJS(_data["reviewMainImageFile"]) : undefined as any;
            this.reviewSupportingImage1File = _data["reviewSupportingImage1File"] ? FileDto.fromJS(_data["reviewSupportingImage1File"]) : undefined as any;
            this.reviewSupportingImage2File = _data["reviewSupportingImage2File"] ? FileDto.fromJS(_data["reviewSupportingImage2File"]) : undefined as any;
            this.mainImageFile = _data["mainImageFile"] ? FileDto.fromJS(_data["mainImageFile"]) : undefined as any;
            this.supportingImage1File = _data["supportingImage1File"] ? FileDto.fromJS(_data["supportingImage1File"]) : undefined as any;
            this.supportingImage2File = _data["supportingImage2File"] ? FileDto.fromJS(_data["supportingImage2File"]) : undefined as any;
            this.aboutUsMainImage1File = _data["aboutUsMainImage1File"] ? FileDto.fromJS(_data["aboutUsMainImage1File"]) : undefined as any;
            this.aboutUsMainImage2File = _data["aboutUsMainImage2File"] ? FileDto.fromJS(_data["aboutUsMainImage2File"]) : undefined as any;
            this.aboutUsSupportingImageFile = _data["aboutUsSupportingImageFile"] ? FileDto.fromJS(_data["aboutUsSupportingImageFile"]) : undefined as any;
            this.postHeadingIconFile = _data["postHeadingIconFile"] ? FileDto.fromJS(_data["postHeadingIconFile"]) : undefined as any;
            if (Array.isArray(_data["teamMemberImages"])) {
                this.teamMemberImages = [] as any;
                for (let item of _data["teamMemberImages"])
                    this.teamMemberImages.push(TeamMemberImageDto.fromJS(item));
            }
            if (Array.isArray(_data["reviewAuthorImages"])) {
                this.reviewAuthorImages = [] as any;
                for (let item of _data["reviewAuthorImages"])
                    this.reviewAuthorImages.push(ReviewAuthorImageDto.fromJS(item));
            }
            if (Array.isArray(_data["storyModuleImages"])) {
                this.storyModuleImages = [] as any;
                for (let item of _data["storyModuleImages"])
                    this.storyModuleImages.push(StoryModuleImageDto.fromJS(item));
            }
            if (Array.isArray(_data["imageCardImages"])) {
                this.imageCardImages = [] as any;
                for (let item of _data["imageCardImages"])
                    this.imageCardImages.push(ImageCardImageDto.fromJS(item));
            }
            if (Array.isArray(_data["galleryImages"])) {
                this.galleryImages = [] as any;
                for (let item of _data["galleryImages"])
                    this.galleryImages.push(GalleryImageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdatePackagesHomepageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePackagesHomepageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : undefined as any;
        data["bannerImageFile"] = this.bannerImageFile ? this.bannerImageFile.toJSON() : undefined as any;
        data["reviewMainImageFile"] = this.reviewMainImageFile ? this.reviewMainImageFile.toJSON() : undefined as any;
        data["reviewSupportingImage1File"] = this.reviewSupportingImage1File ? this.reviewSupportingImage1File.toJSON() : undefined as any;
        data["reviewSupportingImage2File"] = this.reviewSupportingImage2File ? this.reviewSupportingImage2File.toJSON() : undefined as any;
        data["mainImageFile"] = this.mainImageFile ? this.mainImageFile.toJSON() : undefined as any;
        data["supportingImage1File"] = this.supportingImage1File ? this.supportingImage1File.toJSON() : undefined as any;
        data["supportingImage2File"] = this.supportingImage2File ? this.supportingImage2File.toJSON() : undefined as any;
        data["aboutUsMainImage1File"] = this.aboutUsMainImage1File ? this.aboutUsMainImage1File.toJSON() : undefined as any;
        data["aboutUsMainImage2File"] = this.aboutUsMainImage2File ? this.aboutUsMainImage2File.toJSON() : undefined as any;
        data["aboutUsSupportingImageFile"] = this.aboutUsSupportingImageFile ? this.aboutUsSupportingImageFile.toJSON() : undefined as any;
        data["postHeadingIconFile"] = this.postHeadingIconFile ? this.postHeadingIconFile.toJSON() : undefined as any;
        if (Array.isArray(this.teamMemberImages)) {
            data["teamMemberImages"] = [];
            for (let item of this.teamMemberImages)
                data["teamMemberImages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reviewAuthorImages)) {
            data["reviewAuthorImages"] = [];
            for (let item of this.reviewAuthorImages)
                data["reviewAuthorImages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.storyModuleImages)) {
            data["storyModuleImages"] = [];
            for (let item of this.storyModuleImages)
                data["storyModuleImages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageCardImages)) {
            data["imageCardImages"] = [];
            for (let item of this.imageCardImages)
                data["imageCardImages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.galleryImages)) {
            data["galleryImages"] = [];
            for (let item of this.galleryImages)
                data["galleryImages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateOrUpdatePackagesHomepageDto {
        const json = this.toJSON();
        let result = new CreateOrUpdatePackagesHomepageDto();
        result.init(json);
        return result;
    }
}

/** DTO for creating or updating packages homepage with file uploads (following package pattern) */
export interface ICreateOrUpdatePackagesHomepageDto {
    content: PackagesHomepageContentDto;
    bannerImageFile: FileDto;
    reviewMainImageFile: FileDto;
    reviewSupportingImage1File: FileDto;
    reviewSupportingImage2File: FileDto;
    mainImageFile: FileDto;
    supportingImage1File: FileDto;
    supportingImage2File: FileDto;
    aboutUsMainImage1File: FileDto;
    aboutUsMainImage2File: FileDto;
    aboutUsSupportingImageFile: FileDto;
    postHeadingIconFile: FileDto;
    /** Team member images (can have multiple) */
    teamMemberImages: TeamMemberImageDto[] | undefined;
    /** Review author images (can have multiple) */
    reviewAuthorImages: ReviewAuthorImageDto[] | undefined;
    /** Story module images (can have multiple) */
    storyModuleImages: StoryModuleImageDto[] | undefined;
    /** Image card images (can have multiple) */
    imageCardImages: ImageCardImageDto[] | undefined;
    /** Gallery images for About Us page (can have multiple) */
    galleryImages: GalleryImageDto[] | undefined;
}

export class CreatePackageCancellationPolicyDto implements ICreatePackageCancellationPolicyDto {
    type: string | undefined;
    refund: string | undefined;
    displayOrder: number;

    constructor(data?: ICreatePackageCancellationPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.refund = _data["refund"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreatePackageCancellationPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageCancellationPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["refund"] = this.refund;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreatePackageCancellationPolicyDto {
        const json = this.toJSON();
        let result = new CreatePackageCancellationPolicyDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageCancellationPolicyDto {
    type: string | undefined;
    refund: string | undefined;
    displayOrder: number;
}

export class CreatePackageDto implements ICreatePackageDto {
    type: PackageType;
    packageTypeNote: string | undefined;
    title: string | undefined;
    details: string | undefined;
    shortOverview: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    isPublished: boolean;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    images: CreatePackageImageDto[] | undefined;
    travels: CreatePackageTravelDto[] | undefined;
    price: number;
    tourPackageTypeId: string | undefined;
    continentId: string | undefined;
    days: number;
    nights: number;
    endPoint: string | undefined;
    rating: number;
    withFlights: boolean;
    sale: string | undefined;
    description: string | undefined;
    reviewCount: number;
    currency: string | undefined;
    basePrice: number;
    startPoint: string | undefined;
    placeCovered: string | undefined;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    minTravelers: number;
    maxTravelers: number;
    tourInfo: CreatePackageTourInfoDto[] | undefined;
    highlights: CreatePackageHighlightDto[] | undefined;
    inclusions: CreatePackageInclusionDto[] | undefined;
    exclusions: CreatePackageExclusionDto[] | undefined;
    cancellationPolicies: CreatePackageCancellationPolicyDto[] | undefined;
    itinerary: CreatePackageItineraryDto[] | undefined;
    holidayTypes: CreatePackageHolidayTypeDto[] | undefined;

    constructor(data?: ICreatePackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.packageTypeNote = _data["packageTypeNote"];
            this.title = _data["title"];
            this.details = _data["details"];
            this.shortOverview = _data["shortOverview"];
            this.note = _data["note"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.isPublished = _data["isPublished"];
            this.coverPhoto = _data["coverPhoto"] ? FileDto.fromJS(_data["coverPhoto"]) : undefined as any;
            this.profilePhoto = _data["profilePhoto"] ? FileDto.fromJS(_data["profilePhoto"]) : undefined as any;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(CreatePackageImageDto.fromJS(item));
            }
            if (Array.isArray(_data["travels"])) {
                this.travels = [] as any;
                for (let item of _data["travels"])
                    this.travels.push(CreatePackageTravelDto.fromJS(item));
            }
            this.price = _data["price"];
            this.tourPackageTypeId = _data["tourPackageTypeId"];
            this.continentId = _data["continentId"];
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.endPoint = _data["endPoint"];
            this.rating = _data["rating"];
            this.withFlights = _data["withFlights"];
            this.sale = _data["sale"];
            this.description = _data["description"];
            this.reviewCount = _data["reviewCount"];
            this.currency = _data["currency"];
            this.basePrice = _data["basePrice"];
            this.startPoint = _data["startPoint"];
            this.placeCovered = _data["placeCovered"];
            this.availableFrom = _data["availableFrom"] ? moment(_data["availableFrom"].toString()) : undefined as any;
            this.availableTo = _data["availableTo"] ? moment(_data["availableTo"].toString()) : undefined as any;
            this.minTravelers = _data["minTravelers"];
            this.maxTravelers = _data["maxTravelers"];
            if (Array.isArray(_data["tourInfo"])) {
                this.tourInfo = [] as any;
                for (let item of _data["tourInfo"])
                    this.tourInfo.push(CreatePackageTourInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["highlights"])) {
                this.highlights = [] as any;
                for (let item of _data["highlights"])
                    this.highlights.push(CreatePackageHighlightDto.fromJS(item));
            }
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions.push(CreatePackageInclusionDto.fromJS(item));
            }
            if (Array.isArray(_data["exclusions"])) {
                this.exclusions = [] as any;
                for (let item of _data["exclusions"])
                    this.exclusions.push(CreatePackageExclusionDto.fromJS(item));
            }
            if (Array.isArray(_data["cancellationPolicies"])) {
                this.cancellationPolicies = [] as any;
                for (let item of _data["cancellationPolicies"])
                    this.cancellationPolicies.push(CreatePackageCancellationPolicyDto.fromJS(item));
            }
            if (Array.isArray(_data["itinerary"])) {
                this.itinerary = [] as any;
                for (let item of _data["itinerary"])
                    this.itinerary.push(CreatePackageItineraryDto.fromJS(item));
            }
            if (Array.isArray(_data["holidayTypes"])) {
                this.holidayTypes = [] as any;
                for (let item of _data["holidayTypes"])
                    this.holidayTypes.push(CreatePackageHolidayTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["packageTypeNote"] = this.packageTypeNote;
        data["title"] = this.title;
        data["details"] = this.details;
        data["shortOverview"] = this.shortOverview;
        data["note"] = this.note;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["isPublished"] = this.isPublished;
        data["coverPhoto"] = this.coverPhoto ? this.coverPhoto.toJSON() : undefined as any;
        data["profilePhoto"] = this.profilePhoto ? this.profilePhoto.toJSON() : undefined as any;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.travels)) {
            data["travels"] = [];
            for (let item of this.travels)
                data["travels"].push(item ? item.toJSON() : undefined as any);
        }
        data["price"] = this.price;
        data["tourPackageTypeId"] = this.tourPackageTypeId;
        data["continentId"] = this.continentId;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["endPoint"] = this.endPoint;
        data["rating"] = this.rating;
        data["withFlights"] = this.withFlights;
        data["sale"] = this.sale;
        data["description"] = this.description;
        data["reviewCount"] = this.reviewCount;
        data["currency"] = this.currency;
        data["basePrice"] = this.basePrice;
        data["startPoint"] = this.startPoint;
        data["placeCovered"] = this.placeCovered;
        data["availableFrom"] = this.availableFrom ? this.availableFrom.toISOString() : undefined as any;
        data["availableTo"] = this.availableTo ? this.availableTo.toISOString() : undefined as any;
        data["minTravelers"] = this.minTravelers;
        data["maxTravelers"] = this.maxTravelers;
        if (Array.isArray(this.tourInfo)) {
            data["tourInfo"] = [];
            for (let item of this.tourInfo)
                data["tourInfo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.highlights)) {
            data["highlights"] = [];
            for (let item of this.highlights)
                data["highlights"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exclusions)) {
            data["exclusions"] = [];
            for (let item of this.exclusions)
                data["exclusions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cancellationPolicies)) {
            data["cancellationPolicies"] = [];
            for (let item of this.cancellationPolicies)
                data["cancellationPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.itinerary)) {
            data["itinerary"] = [];
            for (let item of this.itinerary)
                data["itinerary"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.holidayTypes)) {
            data["holidayTypes"] = [];
            for (let item of this.holidayTypes)
                data["holidayTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreatePackageDto {
        const json = this.toJSON();
        let result = new CreatePackageDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageDto {
    type: PackageType;
    packageTypeNote: string | undefined;
    title: string | undefined;
    details: string | undefined;
    shortOverview: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    isPublished: boolean;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    images: CreatePackageImageDto[] | undefined;
    travels: CreatePackageTravelDto[] | undefined;
    price: number;
    tourPackageTypeId: string | undefined;
    continentId: string | undefined;
    days: number;
    nights: number;
    endPoint: string | undefined;
    rating: number;
    withFlights: boolean;
    sale: string | undefined;
    description: string | undefined;
    reviewCount: number;
    currency: string | undefined;
    basePrice: number;
    startPoint: string | undefined;
    placeCovered: string | undefined;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    minTravelers: number;
    maxTravelers: number;
    tourInfo: CreatePackageTourInfoDto[] | undefined;
    highlights: CreatePackageHighlightDto[] | undefined;
    inclusions: CreatePackageInclusionDto[] | undefined;
    exclusions: CreatePackageExclusionDto[] | undefined;
    cancellationPolicies: CreatePackageCancellationPolicyDto[] | undefined;
    itinerary: CreatePackageItineraryDto[] | undefined;
    holidayTypes: CreatePackageHolidayTypeDto[] | undefined;
}

export class CreatePackageExclusionDto implements ICreatePackageExclusionDto {
    exclusion: string | undefined;
    displayOrder: number;

    constructor(data?: ICreatePackageExclusionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exclusion = _data["exclusion"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreatePackageExclusionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageExclusionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exclusion"] = this.exclusion;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreatePackageExclusionDto {
        const json = this.toJSON();
        let result = new CreatePackageExclusionDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageExclusionDto {
    exclusion: string | undefined;
    displayOrder: number;
}

export class CreatePackageHighlightDto implements ICreatePackageHighlightDto {
    highlight: string | undefined;
    displayOrder: number;

    constructor(data?: ICreatePackageHighlightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.highlight = _data["highlight"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreatePackageHighlightDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageHighlightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["highlight"] = this.highlight;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreatePackageHighlightDto {
        const json = this.toJSON();
        let result = new CreatePackageHighlightDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageHighlightDto {
    highlight: string | undefined;
    displayOrder: number;
}

export class CreatePackageHolidayTypeDto implements ICreatePackageHolidayTypeDto {
    holidayTypeId: string;
    displayOrder: number;

    constructor(data?: ICreatePackageHolidayTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayTypeId = _data["holidayTypeId"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreatePackageHolidayTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageHolidayTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayTypeId"] = this.holidayTypeId;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreatePackageHolidayTypeDto {
        const json = this.toJSON();
        let result = new CreatePackageHolidayTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageHolidayTypeDto {
    holidayTypeId: string;
    displayOrder: number;
}

export class CreatePackageImageDto implements ICreatePackageImageDto {
    title: string | undefined;
    sortOrder: number;
    photo: FileDto;

    constructor(data?: ICreatePackageImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.sortOrder = _data["sortOrder"];
            this.photo = _data["photo"] ? FileDto.fromJS(_data["photo"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreatePackageImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["sortOrder"] = this.sortOrder;
        data["photo"] = this.photo ? this.photo.toJSON() : undefined as any;
        return data;
    }

    clone(): CreatePackageImageDto {
        const json = this.toJSON();
        let result = new CreatePackageImageDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageImageDto {
    title: string | undefined;
    sortOrder: number;
    photo: FileDto;
}

export class CreatePackageInclusionDto implements ICreatePackageInclusionDto {
    inclusion: string | undefined;
    displayOrder: number;

    constructor(data?: ICreatePackageInclusionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inclusion = _data["inclusion"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreatePackageInclusionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageInclusionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inclusion"] = this.inclusion;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreatePackageInclusionDto {
        const json = this.toJSON();
        let result = new CreatePackageInclusionDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageInclusionDto {
    inclusion: string | undefined;
    displayOrder: number;
}

export class CreatePackageItineraryActivityDto implements ICreatePackageItineraryActivityDto {
    activity: string | undefined;
    displayOrder: number;

    constructor(data?: ICreatePackageItineraryActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreatePackageItineraryActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageItineraryActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreatePackageItineraryActivityDto {
        const json = this.toJSON();
        let result = new CreatePackageItineraryActivityDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageItineraryActivityDto {
    activity: string | undefined;
    displayOrder: number;
}

export class CreatePackageItineraryDto implements ICreatePackageItineraryDto {
    day: number;
    title: string | undefined;
    description: string | undefined;
    displayOrder: number;
    activities: CreatePackageItineraryActivityDto[] | undefined;

    constructor(data?: ICreatePackageItineraryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities.push(CreatePackageItineraryActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePackageItineraryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageItineraryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["title"] = this.title;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreatePackageItineraryDto {
        const json = this.toJSON();
        let result = new CreatePackageItineraryDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageItineraryDto {
    day: number;
    title: string | undefined;
    description: string | undefined;
    displayOrder: number;
    activities: CreatePackageItineraryActivityDto[] | undefined;
}

export class CreatePackageTourInfoDto implements ICreatePackageTourInfoDto {
    title: string | undefined;
    info: string | undefined;
    displayOrder: number;

    constructor(data?: ICreatePackageTourInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.info = _data["info"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreatePackageTourInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageTourInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["info"] = this.info;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreatePackageTourInfoDto {
        const json = this.toJSON();
        let result = new CreatePackageTourInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageTourInfoDto {
    title: string | undefined;
    info: string | undefined;
    displayOrder: number;
}

export class CreatePackageTravelCommisionDto implements ICreatePackageTravelCommisionDto {
    title: string | undefined;
    amount: number;
    note: string | undefined;

    constructor(data?: ICreatePackageTravelCommisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreatePackageTravelCommisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageTravelCommisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }

    clone(): CreatePackageTravelCommisionDto {
        const json = this.toJSON();
        let result = new CreatePackageTravelCommisionDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageTravelCommisionDto {
    title: string | undefined;
    amount: number;
    note: string | undefined;
}

export class CreatePackageTravelDto implements ICreatePackageTravelDto {
    title: string | undefined;
    details: string | undefined;
    travelDate: moment.Moment;
    passengerLimitCount: number;
    price: number;
    currency: string | undefined;
    note: string | undefined;
    status: PackageTravelStatus;
    itineraries: CreatePackageTravelItineraryDto[] | undefined;
    commisions: CreatePackageTravelCommisionDto[] | undefined;

    constructor(data?: ICreatePackageTravelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.details = _data["details"];
            this.travelDate = _data["travelDate"] ? moment(_data["travelDate"].toString()) : undefined as any;
            this.passengerLimitCount = _data["passengerLimitCount"];
            this.price = _data["price"];
            this.currency = _data["currency"];
            this.note = _data["note"];
            this.status = _data["status"];
            if (Array.isArray(_data["itineraries"])) {
                this.itineraries = [] as any;
                for (let item of _data["itineraries"])
                    this.itineraries.push(CreatePackageTravelItineraryDto.fromJS(item));
            }
            if (Array.isArray(_data["commisions"])) {
                this.commisions = [] as any;
                for (let item of _data["commisions"])
                    this.commisions.push(CreatePackageTravelCommisionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePackageTravelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageTravelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["details"] = this.details;
        data["travelDate"] = this.travelDate ? this.travelDate.toISOString() : undefined as any;
        data["passengerLimitCount"] = this.passengerLimitCount;
        data["price"] = this.price;
        data["currency"] = this.currency;
        data["note"] = this.note;
        data["status"] = this.status;
        if (Array.isArray(this.itineraries)) {
            data["itineraries"] = [];
            for (let item of this.itineraries)
                data["itineraries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.commisions)) {
            data["commisions"] = [];
            for (let item of this.commisions)
                data["commisions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreatePackageTravelDto {
        const json = this.toJSON();
        let result = new CreatePackageTravelDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageTravelDto {
    title: string | undefined;
    details: string | undefined;
    travelDate: moment.Moment;
    passengerLimitCount: number;
    price: number;
    currency: string | undefined;
    note: string | undefined;
    status: PackageTravelStatus;
    itineraries: CreatePackageTravelItineraryDto[] | undefined;
    commisions: CreatePackageTravelCommisionDto[] | undefined;
}

export class CreatePackageTravelItineraryDto implements ICreatePackageTravelItineraryDto {
    title: string | undefined;
    details: string | undefined;
    items: CreatePackageTravelItineraryItemDto[] | undefined;
    meals: CreatePackageTravelItineraryMealDto[] | undefined;

    constructor(data?: ICreatePackageTravelItineraryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.details = _data["details"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CreatePackageTravelItineraryItemDto.fromJS(item));
            }
            if (Array.isArray(_data["meals"])) {
                this.meals = [] as any;
                for (let item of _data["meals"])
                    this.meals.push(CreatePackageTravelItineraryMealDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePackageTravelItineraryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageTravelItineraryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["details"] = this.details;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.meals)) {
            data["meals"] = [];
            for (let item of this.meals)
                data["meals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreatePackageTravelItineraryDto {
        const json = this.toJSON();
        let result = new CreatePackageTravelItineraryDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageTravelItineraryDto {
    title: string | undefined;
    details: string | undefined;
    items: CreatePackageTravelItineraryItemDto[] | undefined;
    meals: CreatePackageTravelItineraryMealDto[] | undefined;
}

export class CreatePackageTravelItineraryItemDto implements ICreatePackageTravelItineraryItemDto {
    title: string | undefined;
    time: string | undefined;

    constructor(data?: ICreatePackageTravelItineraryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.time = _data["time"];
        }
    }

    static fromJS(data: any): CreatePackageTravelItineraryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageTravelItineraryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["time"] = this.time;
        return data;
    }

    clone(): CreatePackageTravelItineraryItemDto {
        const json = this.toJSON();
        let result = new CreatePackageTravelItineraryItemDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageTravelItineraryItemDto {
    title: string | undefined;
    time: string | undefined;
}

export class CreatePackageTravelItineraryMealDto implements ICreatePackageTravelItineraryMealDto {
    hasBreakFast: boolean;
    hasMorningSnack: boolean;
    hasLunch: boolean;
    hasAfternoonSnack: boolean;
    hasDinner: boolean;

    constructor(data?: ICreatePackageTravelItineraryMealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasBreakFast = _data["hasBreakFast"];
            this.hasMorningSnack = _data["hasMorningSnack"];
            this.hasLunch = _data["hasLunch"];
            this.hasAfternoonSnack = _data["hasAfternoonSnack"];
            this.hasDinner = _data["hasDinner"];
        }
    }

    static fromJS(data: any): CreatePackageTravelItineraryMealDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageTravelItineraryMealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasBreakFast"] = this.hasBreakFast;
        data["hasMorningSnack"] = this.hasMorningSnack;
        data["hasLunch"] = this.hasLunch;
        data["hasAfternoonSnack"] = this.hasAfternoonSnack;
        data["hasDinner"] = this.hasDinner;
        return data;
    }

    clone(): CreatePackageTravelItineraryMealDto {
        const json = this.toJSON();
        let result = new CreatePackageTravelItineraryMealDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageTravelItineraryMealDto {
    hasBreakFast: boolean;
    hasMorningSnack: boolean;
    hasLunch: boolean;
    hasAfternoonSnack: boolean;
    hasDinner: boolean;
}

export class CreatePassengerDto implements ICreatePassengerDto {
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    birthPlace: string | undefined;
    isActive: boolean;
    note: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    passports: CreatePassportDto[] | undefined;
    phoneNumbers: CreatePassengerPhoneNumberDto[] | undefined;
    emails: CreatePassengerEmailDto[] | undefined;

    constructor(data?: ICreatePassengerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.middleName = _data["middleName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.birthPlace = _data["birthPlace"];
            this.isActive = _data["isActive"];
            this.note = _data["note"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.zipOrPostCode = _data["zipOrPostCode"];
            this.stateOrProvince = _data["stateOrProvince"];
            this.country = _data["country"];
            this.coverPhoto = _data["coverPhoto"] ? FileDto.fromJS(_data["coverPhoto"]) : undefined as any;
            this.profilePhoto = _data["profilePhoto"] ? FileDto.fromJS(_data["profilePhoto"]) : undefined as any;
            if (Array.isArray(_data["passports"])) {
                this.passports = [] as any;
                for (let item of _data["passports"])
                    this.passports.push(CreatePassportDto.fromJS(item));
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(CreatePassengerPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(CreatePassengerEmailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePassengerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePassengerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["middleName"] = this.middleName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["birthPlace"] = this.birthPlace;
        data["isActive"] = this.isActive;
        data["note"] = this.note;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["zipOrPostCode"] = this.zipOrPostCode;
        data["stateOrProvince"] = this.stateOrProvince;
        data["country"] = this.country;
        data["coverPhoto"] = this.coverPhoto ? this.coverPhoto.toJSON() : undefined as any;
        data["profilePhoto"] = this.profilePhoto ? this.profilePhoto.toJSON() : undefined as any;
        if (Array.isArray(this.passports)) {
            data["passports"] = [];
            for (let item of this.passports)
                data["passports"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreatePassengerDto {
        const json = this.toJSON();
        let result = new CreatePassengerDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePassengerDto {
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    birthPlace: string | undefined;
    isActive: boolean;
    note: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    passports: CreatePassportDto[] | undefined;
    phoneNumbers: CreatePassengerPhoneNumberDto[] | undefined;
    emails: CreatePassengerEmailDto[] | undefined;
}

export class CreatePassengerEmailDto implements ICreatePassengerEmailDto {
    email: string | undefined;
    note: string | undefined;
    isPrimary: boolean;
    isActive: boolean;
    passengerId: string;

    constructor(data?: ICreatePassengerEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.note = _data["note"];
            this.isPrimary = _data["isPrimary"];
            this.isActive = _data["isActive"];
            this.passengerId = _data["passengerId"];
        }
    }

    static fromJS(data: any): CreatePassengerEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePassengerEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["note"] = this.note;
        data["isPrimary"] = this.isPrimary;
        data["isActive"] = this.isActive;
        data["passengerId"] = this.passengerId;
        return data;
    }

    clone(): CreatePassengerEmailDto {
        const json = this.toJSON();
        let result = new CreatePassengerEmailDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePassengerEmailDto {
    email: string | undefined;
    note: string | undefined;
    isPrimary: boolean;
    isActive: boolean;
    passengerId: string;
}

export class CreatePassengerPhoneNumberDto implements ICreatePassengerPhoneNumberDto {
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    passengerId: string;
    isPrimary: boolean;
    isActive: boolean;

    constructor(data?: ICreatePassengerPhoneNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.note = _data["note"];
            this.passengerId = _data["passengerId"];
            this.isPrimary = _data["isPrimary"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreatePassengerPhoneNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePassengerPhoneNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["note"] = this.note;
        data["passengerId"] = this.passengerId;
        data["isPrimary"] = this.isPrimary;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreatePassengerPhoneNumberDto {
        const json = this.toJSON();
        let result = new CreatePassengerPhoneNumberDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePassengerPhoneNumberDto {
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    passengerId: string;
    isPrimary: boolean;
    isActive: boolean;
}

export class CreatePassengerTagDto implements ICreatePassengerTagDto {
    passengerId: string;
    tagId: string | undefined;
    tag: TagDto;

    constructor(data?: ICreatePassengerTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passengerId = _data["passengerId"];
            this.tagId = _data["tagId"];
            this.tag = _data["tag"] ? TagDto.fromJS(_data["tag"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreatePassengerTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePassengerTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passengerId"] = this.passengerId;
        data["tagId"] = this.tagId;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined as any;
        return data;
    }

    clone(): CreatePassengerTagDto {
        const json = this.toJSON();
        let result = new CreatePassengerTagDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePassengerTagDto {
    passengerId: string;
    tagId: string | undefined;
    tag: TagDto;
}

export class CreatePassportDto implements ICreatePassportDto {
    issuingCountry: string | undefined;
    documentType: string | undefined;
    documentNo: string | undefined;
    issuedDate: moment.Moment;
    expirationDate: moment.Moment | undefined;
    name: string | undefined;
    surname: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    birthPlace: string | undefined;
    issuingAuthority: string | undefined;
    nationality: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    scannedPassportId: string | undefined;
    documentFile: FileDto;

    constructor(data?: ICreatePassportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuingCountry = _data["issuingCountry"];
            this.documentType = _data["documentType"];
            this.documentNo = _data["documentNo"];
            this.issuedDate = _data["issuedDate"] ? moment(_data["issuedDate"].toString()) : undefined as any;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : undefined as any;
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.middleName = _data["middleName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.birthPlace = _data["birthPlace"];
            this.issuingAuthority = _data["issuingAuthority"];
            this.nationality = _data["nationality"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.scannedPassportId = _data["scannedPassportId"];
            this.documentFile = _data["documentFile"] ? FileDto.fromJS(_data["documentFile"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreatePassportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePassportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuingCountry"] = this.issuingCountry;
        data["documentType"] = this.documentType;
        data["documentNo"] = this.documentNo;
        data["issuedDate"] = this.issuedDate ? this.issuedDate.toISOString() : undefined as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["middleName"] = this.middleName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["birthPlace"] = this.birthPlace;
        data["issuingAuthority"] = this.issuingAuthority;
        data["nationality"] = this.nationality;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["scannedPassportId"] = this.scannedPassportId;
        data["documentFile"] = this.documentFile ? this.documentFile.toJSON() : undefined as any;
        return data;
    }

    clone(): CreatePassportDto {
        const json = this.toJSON();
        let result = new CreatePassportDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePassportDto {
    issuingCountry: string | undefined;
    documentType: string | undefined;
    documentNo: string | undefined;
    issuedDate: moment.Moment;
    expirationDate: moment.Moment | undefined;
    name: string | undefined;
    surname: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    birthPlace: string | undefined;
    issuingAuthority: string | undefined;
    nationality: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    scannedPassportId: string | undefined;
    documentFile: FileDto;
}

export class CreateProcessedDocumentDto implements ICreateProcessedDocumentDto {
    typeId: string | undefined;
    note: string | undefined;

    constructor(data?: ICreateProcessedDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateProcessedDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateProcessedDocumentDto {
        const json = this.toJSON();
        let result = new CreateProcessedDocumentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedDocumentDto {
    typeId: string | undefined;
    note: string | undefined;
}

export class CreateProcessedPackageAddOnDto implements ICreateProcessedPackageAddOnDto {
    typeId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;

    constructor(data?: ICreateProcessedPackageAddOnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.note = _data["note"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CreateProcessedPackageAddOnDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedPackageAddOnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["note"] = this.note;
        data["price"] = this.price;
        return data;
    }

    clone(): CreateProcessedPackageAddOnDto {
        const json = this.toJSON();
        let result = new CreateProcessedPackageAddOnDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedPackageAddOnDto {
    typeId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;
}

export class CreateProcessedPackageDto implements ICreateProcessedPackageDto {
    typeId: string | undefined;
    isVisaRequired: boolean;
    note: string | undefined;
    packageId: string | undefined;
    agentId: string | undefined;
    resaAgentId: number | undefined;
    salesAgentId: number | undefined;
    packageTravelId: string | undefined;
    willAvailTravelInsurance: boolean;
    manualTravelDate: moment.Moment | undefined;
    manualPackageTitle: string | undefined;
    addOns: CreateProcessedPackageAddOnDto[] | undefined;
    assignedRooms: CreateProcessedPackageRoomDto[] | undefined;

    constructor(data?: ICreateProcessedPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.isVisaRequired = _data["isVisaRequired"];
            this.note = _data["note"];
            this.packageId = _data["packageId"];
            this.agentId = _data["agentId"];
            this.resaAgentId = _data["resaAgentId"];
            this.salesAgentId = _data["salesAgentId"];
            this.packageTravelId = _data["packageTravelId"];
            this.willAvailTravelInsurance = _data["willAvailTravelInsurance"];
            this.manualTravelDate = _data["manualTravelDate"] ? moment(_data["manualTravelDate"].toString()) : undefined as any;
            this.manualPackageTitle = _data["manualPackageTitle"];
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns.push(CreateProcessedPackageAddOnDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedRooms"])) {
                this.assignedRooms = [] as any;
                for (let item of _data["assignedRooms"])
                    this.assignedRooms.push(CreateProcessedPackageRoomDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProcessedPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["isVisaRequired"] = this.isVisaRequired;
        data["note"] = this.note;
        data["packageId"] = this.packageId;
        data["agentId"] = this.agentId;
        data["resaAgentId"] = this.resaAgentId;
        data["salesAgentId"] = this.salesAgentId;
        data["packageTravelId"] = this.packageTravelId;
        data["willAvailTravelInsurance"] = this.willAvailTravelInsurance;
        data["manualTravelDate"] = this.manualTravelDate ? this.manualTravelDate.toISOString() : undefined as any;
        data["manualPackageTitle"] = this.manualPackageTitle;
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignedRooms)) {
            data["assignedRooms"] = [];
            for (let item of this.assignedRooms)
                data["assignedRooms"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateProcessedPackageDto {
        const json = this.toJSON();
        let result = new CreateProcessedPackageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedPackageDto {
    typeId: string | undefined;
    isVisaRequired: boolean;
    note: string | undefined;
    packageId: string | undefined;
    agentId: string | undefined;
    resaAgentId: number | undefined;
    salesAgentId: number | undefined;
    packageTravelId: string | undefined;
    willAvailTravelInsurance: boolean;
    manualTravelDate: moment.Moment | undefined;
    manualPackageTitle: string | undefined;
    addOns: CreateProcessedPackageAddOnDto[] | undefined;
    assignedRooms: CreateProcessedPackageRoomDto[] | undefined;
}

export class CreateProcessedPackageRoomDto implements ICreateProcessedPackageRoomDto {
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    attachDocumentFile: FileDto;

    constructor(data?: ICreateProcessedPackageRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.note = _data["note"];
            this.attachDocumentFile = _data["attachDocumentFile"] ? FileDto.fromJS(_data["attachDocumentFile"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateProcessedPackageRoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedPackageRoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["note"] = this.note;
        data["attachDocumentFile"] = this.attachDocumentFile ? this.attachDocumentFile.toJSON() : undefined as any;
        return data;
    }

    clone(): CreateProcessedPackageRoomDto {
        const json = this.toJSON();
        let result = new CreateProcessedPackageRoomDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedPackageRoomDto {
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    attachDocumentFile: FileDto;
}

export class CreateProcessedTicketDto implements ICreateProcessedTicketDto {
    typeId: string | undefined;
    adultCount: number;
    childCount: number;
    infantCount: number;
    note: string | undefined;
    flights: CreateProcessedTicketFlightDto[] | undefined;
    rates: CreateProcessedTicketRateDto[] | undefined;

    constructor(data?: ICreateProcessedTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.adultCount = _data["adultCount"];
            this.childCount = _data["childCount"];
            this.infantCount = _data["infantCount"];
            this.note = _data["note"];
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights.push(CreateProcessedTicketFlightDto.fromJS(item));
            }
            if (Array.isArray(_data["rates"])) {
                this.rates = [] as any;
                for (let item of _data["rates"])
                    this.rates.push(CreateProcessedTicketRateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProcessedTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["adultCount"] = this.adultCount;
        data["childCount"] = this.childCount;
        data["infantCount"] = this.infantCount;
        data["note"] = this.note;
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rates)) {
            data["rates"] = [];
            for (let item of this.rates)
                data["rates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateProcessedTicketDto {
        const json = this.toJSON();
        let result = new CreateProcessedTicketDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedTicketDto {
    typeId: string | undefined;
    adultCount: number;
    childCount: number;
    infantCount: number;
    note: string | undefined;
    flights: CreateProcessedTicketFlightDto[] | undefined;
    rates: CreateProcessedTicketRateDto[] | undefined;
}

export class CreateProcessedTicketFlightDetailDto implements ICreateProcessedTicketFlightDetailDto {
    typeId: string | undefined;
    order: number;
    airline: string | undefined;
    flightNo: string | undefined;
    from: string | undefined;
    to: string | undefined;
    estimatedTimeDeparture: moment.Moment;
    estimatedTimeArrival: moment.Moment;

    constructor(data?: ICreateProcessedTicketFlightDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.order = _data["order"];
            this.airline = _data["airline"];
            this.flightNo = _data["flightNo"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.estimatedTimeDeparture = _data["estimatedTimeDeparture"] ? moment(_data["estimatedTimeDeparture"].toString()) : undefined as any;
            this.estimatedTimeArrival = _data["estimatedTimeArrival"] ? moment(_data["estimatedTimeArrival"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateProcessedTicketFlightDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedTicketFlightDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["order"] = this.order;
        data["airline"] = this.airline;
        data["flightNo"] = this.flightNo;
        data["from"] = this.from;
        data["to"] = this.to;
        data["estimatedTimeDeparture"] = this.estimatedTimeDeparture ? this.estimatedTimeDeparture.toISOString() : undefined as any;
        data["estimatedTimeArrival"] = this.estimatedTimeArrival ? this.estimatedTimeArrival.toISOString() : undefined as any;
        return data;
    }

    clone(): CreateProcessedTicketFlightDetailDto {
        const json = this.toJSON();
        let result = new CreateProcessedTicketFlightDetailDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedTicketFlightDetailDto {
    typeId: string | undefined;
    order: number;
    airline: string | undefined;
    flightNo: string | undefined;
    from: string | undefined;
    to: string | undefined;
    estimatedTimeDeparture: moment.Moment;
    estimatedTimeArrival: moment.Moment;
}

export class CreateProcessedTicketFlightDto implements ICreateProcessedTicketFlightDto {
    typeId: string | undefined;
    name: string | undefined;
    flightDetails: CreateProcessedTicketFlightDetailDto[] | undefined;

    constructor(data?: ICreateProcessedTicketFlightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            if (Array.isArray(_data["flightDetails"])) {
                this.flightDetails = [] as any;
                for (let item of _data["flightDetails"])
                    this.flightDetails.push(CreateProcessedTicketFlightDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProcessedTicketFlightDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedTicketFlightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        if (Array.isArray(this.flightDetails)) {
            data["flightDetails"] = [];
            for (let item of this.flightDetails)
                data["flightDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateProcessedTicketFlightDto {
        const json = this.toJSON();
        let result = new CreateProcessedTicketFlightDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedTicketFlightDto {
    typeId: string | undefined;
    name: string | undefined;
    flightDetails: CreateProcessedTicketFlightDetailDto[] | undefined;
}

export class CreateProcessedTicketRateAddOnDto implements ICreateProcessedTicketRateAddOnDto {
    typeId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    price: number | undefined;

    constructor(data?: ICreateProcessedTicketRateAddOnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CreateProcessedTicketRateAddOnDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedTicketRateAddOnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        return data;
    }

    clone(): CreateProcessedTicketRateAddOnDto {
        const json = this.toJSON();
        let result = new CreateProcessedTicketRateAddOnDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedTicketRateAddOnDto {
    typeId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    price: number | undefined;
}

export class CreateProcessedTicketRateDto implements ICreateProcessedTicketRateDto {
    typeId: string | undefined;
    note: string | undefined;
    pricePerPax: number;
    totalPrice: number;
    addOns: CreateProcessedTicketRateAddOnDto[] | undefined;

    constructor(data?: ICreateProcessedTicketRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.note = _data["note"];
            this.pricePerPax = _data["pricePerPax"];
            this.totalPrice = _data["totalPrice"];
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns.push(CreateProcessedTicketRateAddOnDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProcessedTicketRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedTicketRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["note"] = this.note;
        data["pricePerPax"] = this.pricePerPax;
        data["totalPrice"] = this.totalPrice;
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateProcessedTicketRateDto {
        const json = this.toJSON();
        let result = new CreateProcessedTicketRateDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedTicketRateDto {
    typeId: string | undefined;
    note: string | undefined;
    pricePerPax: number;
    totalPrice: number;
    addOns: CreateProcessedTicketRateAddOnDto[] | undefined;
}

export class CreateProcessedVisaDto implements ICreateProcessedVisaDto {
    typeId: string | undefined;
    statusId: string | undefined;
    embassyId: string | undefined;
    requirements: CreateProcessedVisaRequirementDto[] | undefined;
    statusAttachments: CreateProcessedVisaStatusDto[] | undefined;
    note: string | undefined;

    constructor(data?: ICreateProcessedVisaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.embassyId = _data["embassyId"];
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements.push(CreateProcessedVisaRequirementDto.fromJS(item));
            }
            if (Array.isArray(_data["statusAttachments"])) {
                this.statusAttachments = [] as any;
                for (let item of _data["statusAttachments"])
                    this.statusAttachments.push(CreateProcessedVisaStatusDto.fromJS(item));
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateProcessedVisaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedVisaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["embassyId"] = this.embassyId;
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.statusAttachments)) {
            data["statusAttachments"] = [];
            for (let item of this.statusAttachments)
                data["statusAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["note"] = this.note;
        return data;
    }

    clone(): CreateProcessedVisaDto {
        const json = this.toJSON();
        let result = new CreateProcessedVisaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedVisaDto {
    typeId: string | undefined;
    statusId: string | undefined;
    embassyId: string | undefined;
    requirements: CreateProcessedVisaRequirementDto[] | undefined;
    statusAttachments: CreateProcessedVisaStatusDto[] | undefined;
    note: string | undefined;
}

export class CreateProcessedVisaRequirementAttachmentDto implements ICreateProcessedVisaRequirementAttachmentDto {
    attachDocumentFile: FileDto;

    constructor(data?: ICreateProcessedVisaRequirementAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachDocumentFile = _data["attachDocumentFile"] ? FileDto.fromJS(_data["attachDocumentFile"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateProcessedVisaRequirementAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedVisaRequirementAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachDocumentFile"] = this.attachDocumentFile ? this.attachDocumentFile.toJSON() : undefined as any;
        return data;
    }

    clone(): CreateProcessedVisaRequirementAttachmentDto {
        const json = this.toJSON();
        let result = new CreateProcessedVisaRequirementAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedVisaRequirementAttachmentDto {
    attachDocumentFile: FileDto;
}

export class CreateProcessedVisaRequirementDto implements ICreateProcessedVisaRequirementDto {
    typeId: string | undefined;
    isFulfilled: boolean;
    passengerId: string | undefined;
    attachments: CreateProcessedVisaRequirementAttachmentDto[] | undefined;

    constructor(data?: ICreateProcessedVisaRequirementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.isFulfilled = _data["isFulfilled"];
            this.passengerId = _data["passengerId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(CreateProcessedVisaRequirementAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProcessedVisaRequirementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedVisaRequirementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["isFulfilled"] = this.isFulfilled;
        data["passengerId"] = this.passengerId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateProcessedVisaRequirementDto {
        const json = this.toJSON();
        let result = new CreateProcessedVisaRequirementDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedVisaRequirementDto {
    typeId: string | undefined;
    isFulfilled: boolean;
    passengerId: string | undefined;
    attachments: CreateProcessedVisaRequirementAttachmentDto[] | undefined;
}

export class CreateProcessedVisaStatusAttachmentDto implements ICreateProcessedVisaStatusAttachmentDto {
    attachDocumentFile: FileDto;

    constructor(data?: ICreateProcessedVisaStatusAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachDocumentFile = _data["attachDocumentFile"] ? FileDto.fromJS(_data["attachDocumentFile"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateProcessedVisaStatusAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedVisaStatusAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachDocumentFile"] = this.attachDocumentFile ? this.attachDocumentFile.toJSON() : undefined as any;
        return data;
    }

    clone(): CreateProcessedVisaStatusAttachmentDto {
        const json = this.toJSON();
        let result = new CreateProcessedVisaStatusAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedVisaStatusAttachmentDto {
    attachDocumentFile: FileDto;
}

export class CreateProcessedVisaStatusDto implements ICreateProcessedVisaStatusDto {
    typeId: string | undefined;
    attachments: CreateProcessedVisaStatusAttachmentDto[] | undefined;

    constructor(data?: ICreateProcessedVisaStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(CreateProcessedVisaStatusAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProcessedVisaStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcessedVisaStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateProcessedVisaStatusDto {
        const json = this.toJSON();
        let result = new CreateProcessedVisaStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcessedVisaStatusDto {
    typeId: string | undefined;
    attachments: CreateProcessedVisaStatusAttachmentDto[] | undefined;
}

export class CreatePurchaseOrderDto implements ICreatePurchaseOrderDto {
    bookingId: string;
    bookingRef: string | undefined;
    statusId: string;
    paymentStatusId: string;
    supplierId: string;
    embassyFeeId: string | undefined;
    paymentDue: moment.Moment | undefined;
    totalAmount: number;
    phpToUsdRate: number;
    purchaseOrderNumber: string | undefined;
    note: string | undefined;
    handlerName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    particulars: CreatePurchaseOrderParticularDto[] | undefined;
    receipts: CreatePurchaseOrderReceiptDto[] | undefined;

    constructor(data?: ICreatePurchaseOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.bookingRef = _data["bookingRef"];
            this.statusId = _data["statusId"];
            this.paymentStatusId = _data["paymentStatusId"];
            this.supplierId = _data["supplierId"];
            this.embassyFeeId = _data["embassyFeeId"];
            this.paymentDue = _data["paymentDue"] ? moment(_data["paymentDue"].toString()) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.phpToUsdRate = _data["phpToUsdRate"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.note = _data["note"];
            this.handlerName = _data["handlerName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["particulars"])) {
                this.particulars = [] as any;
                for (let item of _data["particulars"])
                    this.particulars.push(CreatePurchaseOrderParticularDto.fromJS(item));
            }
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts.push(CreatePurchaseOrderReceiptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePurchaseOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["bookingRef"] = this.bookingRef;
        data["statusId"] = this.statusId;
        data["paymentStatusId"] = this.paymentStatusId;
        data["supplierId"] = this.supplierId;
        data["embassyFeeId"] = this.embassyFeeId;
        data["paymentDue"] = this.paymentDue ? this.paymentDue.toISOString() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["phpToUsdRate"] = this.phpToUsdRate;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["note"] = this.note;
        data["handlerName"] = this.handlerName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.particulars)) {
            data["particulars"] = [];
            for (let item of this.particulars)
                data["particulars"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreatePurchaseOrderDto {
        const json = this.toJSON();
        let result = new CreatePurchaseOrderDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePurchaseOrderDto {
    bookingId: string;
    bookingRef: string | undefined;
    statusId: string;
    paymentStatusId: string;
    supplierId: string;
    embassyFeeId: string | undefined;
    paymentDue: moment.Moment | undefined;
    totalAmount: number;
    phpToUsdRate: number;
    purchaseOrderNumber: string | undefined;
    note: string | undefined;
    handlerName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    particulars: CreatePurchaseOrderParticularDto[] | undefined;
    receipts: CreatePurchaseOrderReceiptDto[] | undefined;
}

export class CreatePurchaseOrderParticularDto implements ICreatePurchaseOrderParticularDto {
    name: string | undefined;
    price: number;
    quantity: number;
    total: number;
    isDeduction: boolean;
    sortOrder: number;

    constructor(data?: ICreatePurchaseOrderParticularDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.total = _data["total"];
            this.isDeduction = _data["isDeduction"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreatePurchaseOrderParticularDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrderParticularDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        data["isDeduction"] = this.isDeduction;
        data["sortOrder"] = this.sortOrder;
        return data;
    }

    clone(): CreatePurchaseOrderParticularDto {
        const json = this.toJSON();
        let result = new CreatePurchaseOrderParticularDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePurchaseOrderParticularDto {
    name: string | undefined;
    price: number;
    quantity: number;
    total: number;
    isDeduction: boolean;
    sortOrder: number;
}

export class CreatePurchaseOrderReceiptDto implements ICreatePurchaseOrderReceiptDto {
    purchaseOrderId: string;
    statusId: string;
    amount: number;
    note: string | undefined;
    receiptNo: string | undefined;
    attachDocumentFiles: FileDto[] | undefined;

    constructor(data?: ICreatePurchaseOrderReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.statusId = _data["statusId"];
            this.amount = _data["amount"];
            this.note = _data["note"];
            this.receiptNo = _data["receiptNo"];
            if (Array.isArray(_data["attachDocumentFiles"])) {
                this.attachDocumentFiles = [] as any;
                for (let item of _data["attachDocumentFiles"])
                    this.attachDocumentFiles.push(FileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePurchaseOrderReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrderReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["statusId"] = this.statusId;
        data["amount"] = this.amount;
        data["note"] = this.note;
        data["receiptNo"] = this.receiptNo;
        if (Array.isArray(this.attachDocumentFiles)) {
            data["attachDocumentFiles"] = [];
            for (let item of this.attachDocumentFiles)
                data["attachDocumentFiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreatePurchaseOrderReceiptDto {
        const json = this.toJSON();
        let result = new CreatePurchaseOrderReceiptDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePurchaseOrderReceiptDto {
    purchaseOrderId: string;
    statusId: string;
    amount: number;
    note: string | undefined;
    receiptNo: string | undefined;
    attachDocumentFiles: FileDto[] | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateStatementOfAccountDto implements ICreateStatementOfAccountDto {
    bookingId: string;
    statusId: string;
    agentId: string;
    bookingRef: string | undefined;
    paymentDue: moment.Moment | undefined;
    totalAmount: number;
    downPayment: number;
    phpToUsdRate: number;
    statementNumber: string | undefined;
    note: string | undefined;
    isInstallment: boolean;
    isBiPaymentTerm: boolean;
    particulars: CreateStatementOfAccountParticularDto[] | undefined;
    installmentSchedules: CreateInstallmentSchedule[] | undefined;

    constructor(data?: ICreateStatementOfAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.statusId = _data["statusId"];
            this.agentId = _data["agentId"];
            this.bookingRef = _data["bookingRef"];
            this.paymentDue = _data["paymentDue"] ? moment(_data["paymentDue"].toString()) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.downPayment = _data["downPayment"];
            this.phpToUsdRate = _data["phpToUsdRate"];
            this.statementNumber = _data["statementNumber"];
            this.note = _data["note"];
            this.isInstallment = _data["isInstallment"];
            this.isBiPaymentTerm = _data["isBiPaymentTerm"];
            if (Array.isArray(_data["particulars"])) {
                this.particulars = [] as any;
                for (let item of _data["particulars"])
                    this.particulars.push(CreateStatementOfAccountParticularDto.fromJS(item));
            }
            if (Array.isArray(_data["installmentSchedules"])) {
                this.installmentSchedules = [] as any;
                for (let item of _data["installmentSchedules"])
                    this.installmentSchedules.push(CreateInstallmentSchedule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStatementOfAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStatementOfAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["statusId"] = this.statusId;
        data["agentId"] = this.agentId;
        data["bookingRef"] = this.bookingRef;
        data["paymentDue"] = this.paymentDue ? this.paymentDue.toISOString() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["downPayment"] = this.downPayment;
        data["phpToUsdRate"] = this.phpToUsdRate;
        data["statementNumber"] = this.statementNumber;
        data["note"] = this.note;
        data["isInstallment"] = this.isInstallment;
        data["isBiPaymentTerm"] = this.isBiPaymentTerm;
        if (Array.isArray(this.particulars)) {
            data["particulars"] = [];
            for (let item of this.particulars)
                data["particulars"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.installmentSchedules)) {
            data["installmentSchedules"] = [];
            for (let item of this.installmentSchedules)
                data["installmentSchedules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateStatementOfAccountDto {
        const json = this.toJSON();
        let result = new CreateStatementOfAccountDto();
        result.init(json);
        return result;
    }
}

export interface ICreateStatementOfAccountDto {
    bookingId: string;
    statusId: string;
    agentId: string;
    bookingRef: string | undefined;
    paymentDue: moment.Moment | undefined;
    totalAmount: number;
    downPayment: number;
    phpToUsdRate: number;
    statementNumber: string | undefined;
    note: string | undefined;
    isInstallment: boolean;
    isBiPaymentTerm: boolean;
    particulars: CreateStatementOfAccountParticularDto[] | undefined;
    installmentSchedules: CreateInstallmentSchedule[] | undefined;
}

export class CreateStatementOfAccountParticularDto implements ICreateStatementOfAccountParticularDto {
    name: string | undefined;
    price: number;
    quantity: number;
    total: number;
    isDeduction: boolean;
    sortOrder: number;

    constructor(data?: ICreateStatementOfAccountParticularDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.total = _data["total"];
            this.isDeduction = _data["isDeduction"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreateStatementOfAccountParticularDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStatementOfAccountParticularDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        data["isDeduction"] = this.isDeduction;
        data["sortOrder"] = this.sortOrder;
        return data;
    }

    clone(): CreateStatementOfAccountParticularDto {
        const json = this.toJSON();
        let result = new CreateStatementOfAccountParticularDto();
        result.init(json);
        return result;
    }
}

export interface ICreateStatementOfAccountParticularDto {
    name: string | undefined;
    price: number;
    quantity: number;
    total: number;
    isDeduction: boolean;
    sortOrder: number;
}

export class CreateStatementOfAccountReceiptDto implements ICreateStatementOfAccountReceiptDto {
    statementOfAccountId: string;
    statusId: string;
    amount: number;
    note: string | undefined;
    receiptNo: string | undefined;
    attachDocumentFiles: FileDto[] | undefined;

    constructor(data?: ICreateStatementOfAccountReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statementOfAccountId = _data["statementOfAccountId"];
            this.statusId = _data["statusId"];
            this.amount = _data["amount"];
            this.note = _data["note"];
            this.receiptNo = _data["receiptNo"];
            if (Array.isArray(_data["attachDocumentFiles"])) {
                this.attachDocumentFiles = [] as any;
                for (let item of _data["attachDocumentFiles"])
                    this.attachDocumentFiles.push(FileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStatementOfAccountReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStatementOfAccountReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statementOfAccountId"] = this.statementOfAccountId;
        data["statusId"] = this.statusId;
        data["amount"] = this.amount;
        data["note"] = this.note;
        data["receiptNo"] = this.receiptNo;
        if (Array.isArray(this.attachDocumentFiles)) {
            data["attachDocumentFiles"] = [];
            for (let item of this.attachDocumentFiles)
                data["attachDocumentFiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateStatementOfAccountReceiptDto {
        const json = this.toJSON();
        let result = new CreateStatementOfAccountReceiptDto();
        result.init(json);
        return result;
    }
}

export interface ICreateStatementOfAccountReceiptDto {
    statementOfAccountId: string;
    statusId: string;
    amount: number;
    note: string | undefined;
    receiptNo: string | undefined;
    attachDocumentFiles: FileDto[] | undefined;
}

export class CreateSupplierDto implements ICreateSupplierDto {
    supplierTypeId: string | undefined;
    name: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    status: Status;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    phoneNumbers: CreateSupplierPhoneNumberDto[] | undefined;
    emails: CreateSupplierEmailDto[] | undefined;
    rateAttachments: CreateSupplierRateAttachmentDto[] | undefined;

    constructor(data?: ICreateSupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierTypeId = _data["supplierTypeId"];
            this.name = _data["name"];
            this.contactPerson = _data["contactPerson"];
            this.designation = _data["designation"];
            this.note = _data["note"];
            this.status = _data["status"];
            this.coverPhoto = _data["coverPhoto"] ? FileDto.fromJS(_data["coverPhoto"]) : undefined as any;
            this.profilePhoto = _data["profilePhoto"] ? FileDto.fromJS(_data["profilePhoto"]) : undefined as any;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(CreateSupplierPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(CreateSupplierEmailDto.fromJS(item));
            }
            if (Array.isArray(_data["rateAttachments"])) {
                this.rateAttachments = [] as any;
                for (let item of _data["rateAttachments"])
                    this.rateAttachments.push(CreateSupplierRateAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateSupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierTypeId"] = this.supplierTypeId;
        data["name"] = this.name;
        data["contactPerson"] = this.contactPerson;
        data["designation"] = this.designation;
        data["note"] = this.note;
        data["status"] = this.status;
        data["coverPhoto"] = this.coverPhoto ? this.coverPhoto.toJSON() : undefined as any;
        data["profilePhoto"] = this.profilePhoto ? this.profilePhoto.toJSON() : undefined as any;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rateAttachments)) {
            data["rateAttachments"] = [];
            for (let item of this.rateAttachments)
                data["rateAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateSupplierDto {
        const json = this.toJSON();
        let result = new CreateSupplierDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSupplierDto {
    supplierTypeId: string | undefined;
    name: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    status: Status;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    phoneNumbers: CreateSupplierPhoneNumberDto[] | undefined;
    emails: CreateSupplierEmailDto[] | undefined;
    rateAttachments: CreateSupplierRateAttachmentDto[] | undefined;
}

export class CreateSupplierEmailDto implements ICreateSupplierEmailDto {
    email: string | undefined;
    note: string | undefined;
    isPrimary: boolean | undefined;
    supplierId: string;

    constructor(data?: ICreateSupplierEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.note = _data["note"];
            this.isPrimary = _data["isPrimary"];
            this.supplierId = _data["supplierId"];
        }
    }

    static fromJS(data: any): CreateSupplierEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupplierEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["note"] = this.note;
        data["isPrimary"] = this.isPrimary;
        data["supplierId"] = this.supplierId;
        return data;
    }

    clone(): CreateSupplierEmailDto {
        const json = this.toJSON();
        let result = new CreateSupplierEmailDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSupplierEmailDto {
    email: string | undefined;
    note: string | undefined;
    isPrimary: boolean | undefined;
    supplierId: string;
}

export class CreateSupplierPhoneNumberDto implements ICreateSupplierPhoneNumberDto {
    countryCode: string | undefined;
    number: string | undefined;
    isPrimary: boolean | undefined;
    note: string | undefined;
    supplierId: string;

    constructor(data?: ICreateSupplierPhoneNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.isPrimary = _data["isPrimary"];
            this.note = _data["note"];
            this.supplierId = _data["supplierId"];
        }
    }

    static fromJS(data: any): CreateSupplierPhoneNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupplierPhoneNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["isPrimary"] = this.isPrimary;
        data["note"] = this.note;
        data["supplierId"] = this.supplierId;
        return data;
    }

    clone(): CreateSupplierPhoneNumberDto {
        const json = this.toJSON();
        let result = new CreateSupplierPhoneNumberDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSupplierPhoneNumberDto {
    countryCode: string | undefined;
    number: string | undefined;
    isPrimary: boolean | undefined;
    note: string | undefined;
    supplierId: string;
}

export class CreateSupplierRateAttachmentDto implements ICreateSupplierRateAttachmentDto {
    description: string | undefined;
    attachDocumentFile: FileDto;
    typeId: string | undefined;

    constructor(data?: ICreateSupplierRateAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.attachDocumentFile = _data["attachDocumentFile"] ? FileDto.fromJS(_data["attachDocumentFile"]) : undefined as any;
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): CreateSupplierRateAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupplierRateAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["attachDocumentFile"] = this.attachDocumentFile ? this.attachDocumentFile.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        return data;
    }

    clone(): CreateSupplierRateAttachmentDto {
        const json = this.toJSON();
        let result = new CreateSupplierRateAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSupplierRateAttachmentDto {
    description: string | undefined;
    attachDocumentFile: FileDto;
    typeId: string | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

/** DTO for creating a new tour booking */
export class CreateTourBookingDto implements ICreateTourBookingDto {
    tourId: number;
    userId: number | undefined;
    travelers: TravelerDto[];
    contactEmail: string;
    contactPhone: string;
    guestInfo: GuestInfoDto;

    constructor(data?: ICreateTourBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.travelers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourId = _data["tourId"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["travelers"])) {
                this.travelers = [] as any;
                for (let item of _data["travelers"])
                    this.travelers.push(TravelerDto.fromJS(item));
            }
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.guestInfo = _data["guestInfo"] ? GuestInfoDto.fromJS(_data["guestInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateTourBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTourBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourId"] = this.tourId;
        data["userId"] = this.userId;
        if (Array.isArray(this.travelers)) {
            data["travelers"] = [];
            for (let item of this.travelers)
                data["travelers"].push(item ? item.toJSON() : undefined as any);
        }
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["guestInfo"] = this.guestInfo ? this.guestInfo.toJSON() : undefined as any;
        return data;
    }

    clone(): CreateTourBookingDto {
        const json = this.toJSON();
        let result = new CreateTourBookingDto();
        result.init(json);
        return result;
    }
}

/** DTO for creating a new tour booking */
export interface ICreateTourBookingDto {
    tourId: number;
    userId: number | undefined;
    travelers: TravelerDto[];
    contactEmail: string;
    contactPhone: string;
    guestInfo: GuestInfoDto;
}

export class CreateTourInquiryDto implements ICreateTourInquiryDto {
    email: string;
    contactNumber: string;
    destination: string;
    adultCount: number;
    childCount: number;
    travelDateFrom: moment.Moment;
    travelDateTo: moment.Moment;
    notes: string | undefined;
    packageId: string;
    packageTitle: string;

    constructor(data?: ICreateTourInquiryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.contactNumber = _data["contactNumber"];
            this.destination = _data["destination"];
            this.adultCount = _data["adultCount"];
            this.childCount = _data["childCount"];
            this.travelDateFrom = _data["travelDateFrom"] ? moment(_data["travelDateFrom"].toString()) : undefined as any;
            this.travelDateTo = _data["travelDateTo"] ? moment(_data["travelDateTo"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.packageId = _data["packageId"];
            this.packageTitle = _data["packageTitle"];
        }
    }

    static fromJS(data: any): CreateTourInquiryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTourInquiryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["contactNumber"] = this.contactNumber;
        data["destination"] = this.destination;
        data["adultCount"] = this.adultCount;
        data["childCount"] = this.childCount;
        data["travelDateFrom"] = this.travelDateFrom ? this.travelDateFrom.toISOString() : undefined as any;
        data["travelDateTo"] = this.travelDateTo ? this.travelDateTo.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["packageId"] = this.packageId;
        data["packageTitle"] = this.packageTitle;
        return data;
    }

    clone(): CreateTourInquiryDto {
        const json = this.toJSON();
        let result = new CreateTourInquiryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTourInquiryDto {
    email: string;
    contactNumber: string;
    destination: string;
    adultCount: number;
    childCount: number;
    travelDateFrom: moment.Moment;
    travelDateTo: moment.Moment;
    notes: string | undefined;
    packageId: string;
    packageTitle: string;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    notes: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    gender: string | undefined;
    phoneNumber: string | undefined;
    roleNames: string[] | undefined;
    updateCoverPhoto: FileDto;
    updateProfilePhoto: FileDto;
    dateOfBirth: moment.Moment | undefined;
    title: string | undefined;
    company: string | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    emails: UserEmailDto[] | undefined;
    profilePictureDocument: DocumentDto;
    coverPhotoDocument: DocumentDto;
    password: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.notes = _data["notes"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.zipOrPostCode = _data["zipOrPostCode"];
            this.stateOrProvince = _data["stateOrProvince"];
            this.country = _data["country"];
            this.gender = _data["gender"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.updateCoverPhoto = _data["updateCoverPhoto"] ? FileDto.fromJS(_data["updateCoverPhoto"]) : undefined as any;
            this.updateProfilePhoto = _data["updateProfilePhoto"] ? FileDto.fromJS(_data["updateProfilePhoto"]) : undefined as any;
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.title = _data["title"];
            this.company = _data["company"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(PhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(UserEmailDto.fromJS(item));
            }
            this.profilePictureDocument = _data["profilePictureDocument"] ? DocumentDto.fromJS(_data["profilePictureDocument"]) : undefined as any;
            this.coverPhotoDocument = _data["coverPhotoDocument"] ? DocumentDto.fromJS(_data["coverPhotoDocument"]) : undefined as any;
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["notes"] = this.notes;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["zipOrPostCode"] = this.zipOrPostCode;
        data["stateOrProvince"] = this.stateOrProvince;
        data["country"] = this.country;
        data["gender"] = this.gender;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["updateCoverPhoto"] = this.updateCoverPhoto ? this.updateCoverPhoto.toJSON() : undefined as any;
        data["updateProfilePhoto"] = this.updateProfilePhoto ? this.updateProfilePhoto.toJSON() : undefined as any;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["title"] = this.title;
        data["company"] = this.company;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        data["profilePictureDocument"] = this.profilePictureDocument ? this.profilePictureDocument.toJSON() : undefined as any;
        data["coverPhotoDocument"] = this.coverPhotoDocument ? this.coverPhotoDocument.toJSON() : undefined as any;
        data["password"] = this.password;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    notes: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    gender: string | undefined;
    phoneNumber: string | undefined;
    roleNames: string[] | undefined;
    updateCoverPhoto: FileDto;
    updateProfilePhoto: FileDto;
    dateOfBirth: moment.Moment | undefined;
    title: string | undefined;
    company: string | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    emails: UserEmailDto[] | undefined;
    profilePictureDocument: DocumentDto;
    coverPhotoDocument: DocumentDto;
    password: string;
}

/** DTO for returning customer booking information */
export class CustomerBookingDto implements ICustomerBookingDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number | undefined;
    sessionId: string | undefined;
    tourId: number;
    tourName: string | undefined;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    totalAmount: number;
    currency: string | undefined;
    travelDate: moment.Moment | undefined;
    days: number | undefined;
    nights: number | undefined;
    status: CustomerBookingStatus;
    currentStep: number;
    lastAccessedAt: moment.Moment;
    expiresAt: moment.Moment;
    formDataJson: string | undefined;
    notes: string | undefined;
    isExpired: boolean;
    isAbandoned: boolean;
    totalTravelers: number;
    travelers: CustomerTravelerDto[] | undefined;
    paymentReceipts: CustomerPaymentReceiptDto[] | undefined;

    constructor(data?: ICustomerBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.sessionId = _data["sessionId"];
            this.tourId = _data["tourId"];
            this.tourName = _data["tourName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.totalAmount = _data["totalAmount"];
            this.currency = _data["currency"];
            this.travelDate = _data["travelDate"] ? moment(_data["travelDate"].toString()) : undefined as any;
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.status = _data["status"];
            this.currentStep = _data["currentStep"];
            this.lastAccessedAt = _data["lastAccessedAt"] ? moment(_data["lastAccessedAt"].toString()) : undefined as any;
            this.expiresAt = _data["expiresAt"] ? moment(_data["expiresAt"].toString()) : undefined as any;
            this.formDataJson = _data["formDataJson"];
            this.notes = _data["notes"];
            this.isExpired = _data["isExpired"];
            this.isAbandoned = _data["isAbandoned"];
            this.totalTravelers = _data["totalTravelers"];
            if (Array.isArray(_data["travelers"])) {
                this.travelers = [] as any;
                for (let item of _data["travelers"])
                    this.travelers.push(CustomerTravelerDto.fromJS(item));
            }
            if (Array.isArray(_data["paymentReceipts"])) {
                this.paymentReceipts = [] as any;
                for (let item of _data["paymentReceipts"])
                    this.paymentReceipts.push(CustomerPaymentReceiptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["sessionId"] = this.sessionId;
        data["tourId"] = this.tourId;
        data["tourName"] = this.tourName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["totalAmount"] = this.totalAmount;
        data["currency"] = this.currency;
        data["travelDate"] = this.travelDate ? this.travelDate.toISOString() : undefined as any;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["status"] = this.status;
        data["currentStep"] = this.currentStep;
        data["lastAccessedAt"] = this.lastAccessedAt ? this.lastAccessedAt.toISOString() : undefined as any;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["formDataJson"] = this.formDataJson;
        data["notes"] = this.notes;
        data["isExpired"] = this.isExpired;
        data["isAbandoned"] = this.isAbandoned;
        data["totalTravelers"] = this.totalTravelers;
        if (Array.isArray(this.travelers)) {
            data["travelers"] = [];
            for (let item of this.travelers)
                data["travelers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.paymentReceipts)) {
            data["paymentReceipts"] = [];
            for (let item of this.paymentReceipts)
                data["paymentReceipts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CustomerBookingDto {
        const json = this.toJSON();
        let result = new CustomerBookingDto();
        result.init(json);
        return result;
    }
}

/** DTO for returning customer booking information */
export interface ICustomerBookingDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number | undefined;
    sessionId: string | undefined;
    tourId: number;
    tourName: string | undefined;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    totalAmount: number;
    currency: string | undefined;
    travelDate: moment.Moment | undefined;
    days: number | undefined;
    nights: number | undefined;
    status: CustomerBookingStatus;
    currentStep: number;
    lastAccessedAt: moment.Moment;
    expiresAt: moment.Moment;
    formDataJson: string | undefined;
    notes: string | undefined;
    isExpired: boolean;
    isAbandoned: boolean;
    totalTravelers: number;
    travelers: CustomerTravelerDto[] | undefined;
    paymentReceipts: CustomerPaymentReceiptDto[] | undefined;
}

export class CustomerBookingDtoPagedResultDto implements ICustomerBookingDtoPagedResultDto {
    items: CustomerBookingDto[] | undefined;
    totalCount: number;

    constructor(data?: ICustomerBookingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerBookingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomerBookingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBookingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CustomerBookingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomerBookingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerBookingDtoPagedResultDto {
    items: CustomerBookingDto[] | undefined;
    totalCount: number;
}

export enum CustomerBookingStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export class CustomerLoginDto implements ICustomerLoginDto {
    emailOrUsername: string;
    password: string;
    rememberMe: boolean;

    constructor(data?: ICustomerLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailOrUsername = _data["emailOrUsername"];
            this.password = _data["password"];
            this.rememberMe = _data["rememberMe"];
        }
    }

    static fromJS(data: any): CustomerLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailOrUsername"] = this.emailOrUsername;
        data["password"] = this.password;
        data["rememberMe"] = this.rememberMe;
        return data;
    }

    clone(): CustomerLoginDto {
        const json = this.toJSON();
        let result = new CustomerLoginDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerLoginDto {
    emailOrUsername: string;
    password: string;
    rememberMe: boolean;
}

export class CustomerLoginResponseDto implements ICustomerLoginResponseDto {
    success: boolean;
    message: string | undefined;
    user: UserInfoDto;
    errors: string[] | undefined;

    constructor(data?: ICustomerLoginResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.user = _data["user"] ? UserInfoDto.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): CustomerLoginResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLoginResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }

    clone(): CustomerLoginResponseDto {
        const json = this.toJSON();
        let result = new CustomerLoginResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerLoginResponseDto {
    success: boolean;
    message: string | undefined;
    user: UserInfoDto;
    errors: string[] | undefined;
}

export class CustomerPaymentReceiptDto implements ICustomerPaymentReceiptDto {
    id: string;
    receiptNumber: string | undefined;
    amount: number;
    currency: string | undefined;
    paymentDate: moment.Moment;
    uploadDate: moment.Moment;
    receiptType: CustomerPaymentReceiptType;
    status: CustomerPaymentReceiptStatus;
    notes: string | undefined;
    rejectionReason: string | undefined;
    customerBookingId: string;
    verifiedByUserId: number | undefined;
    verificationDate: moment.Moment | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    fileSize: number;
    fileUrl: string | undefined;
    ipAddress: string | undefined;
    userAgent: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    signedFileUrl: string | undefined;
    readonly statusDisplayName: string | undefined;
    readonly receiptTypeDisplayName: string | undefined;
    readonly fileSizeFormatted: string | undefined;

    constructor(data?: ICustomerPaymentReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receiptNumber = _data["receiptNumber"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : undefined as any;
            this.uploadDate = _data["uploadDate"] ? moment(_data["uploadDate"].toString()) : undefined as any;
            this.receiptType = _data["receiptType"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.rejectionReason = _data["rejectionReason"];
            this.customerBookingId = _data["customerBookingId"];
            this.verifiedByUserId = _data["verifiedByUserId"];
            this.verificationDate = _data["verificationDate"] ? moment(_data["verificationDate"].toString()) : undefined as any;
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileSize = _data["fileSize"];
            this.fileUrl = _data["fileUrl"];
            this.ipAddress = _data["ipAddress"];
            this.userAgent = _data["userAgent"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.signedFileUrl = _data["signedFileUrl"];
            (this as any).statusDisplayName = _data["statusDisplayName"];
            (this as any).receiptTypeDisplayName = _data["receiptTypeDisplayName"];
            (this as any).fileSizeFormatted = _data["fileSizeFormatted"];
        }
    }

    static fromJS(data: any): CustomerPaymentReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPaymentReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receiptNumber"] = this.receiptNumber;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined as any;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : undefined as any;
        data["receiptType"] = this.receiptType;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["rejectionReason"] = this.rejectionReason;
        data["customerBookingId"] = this.customerBookingId;
        data["verifiedByUserId"] = this.verifiedByUserId;
        data["verificationDate"] = this.verificationDate ? this.verificationDate.toISOString() : undefined as any;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["ipAddress"] = this.ipAddress;
        data["userAgent"] = this.userAgent;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["signedFileUrl"] = this.signedFileUrl;
        data["statusDisplayName"] = this.statusDisplayName;
        data["receiptTypeDisplayName"] = this.receiptTypeDisplayName;
        data["fileSizeFormatted"] = this.fileSizeFormatted;
        return data;
    }

    clone(): CustomerPaymentReceiptDto {
        const json = this.toJSON();
        let result = new CustomerPaymentReceiptDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerPaymentReceiptDto {
    id: string;
    receiptNumber: string | undefined;
    amount: number;
    currency: string | undefined;
    paymentDate: moment.Moment;
    uploadDate: moment.Moment;
    receiptType: CustomerPaymentReceiptType;
    status: CustomerPaymentReceiptStatus;
    notes: string | undefined;
    rejectionReason: string | undefined;
    customerBookingId: string;
    verifiedByUserId: number | undefined;
    verificationDate: moment.Moment | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    fileSize: number;
    fileUrl: string | undefined;
    ipAddress: string | undefined;
    userAgent: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    signedFileUrl: string | undefined;
    statusDisplayName: string | undefined;
    receiptTypeDisplayName: string | undefined;
    fileSizeFormatted: string | undefined;
}

export enum CustomerPaymentReceiptStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum CustomerPaymentReceiptType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _99 = 99,
}

export class CustomerRegistrationDto implements ICustomerRegistrationDto {
    name: string;
    surname: string;
    email: string;
    password: string;
    phoneNumber: string | undefined;

    constructor(data?: ICustomerRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CustomerRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["password"] = this.password;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): CustomerRegistrationDto {
        const json = this.toJSON();
        let result = new CustomerRegistrationDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerRegistrationDto {
    name: string;
    surname: string;
    email: string;
    password: string;
    phoneNumber: string | undefined;
}

export class CustomerRegistrationResponseDto implements ICustomerRegistrationResponseDto {
    success: boolean;
    message: string | undefined;
    user: UserInfoDto;
    errors: string[] | undefined;

    constructor(data?: ICustomerRegistrationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.user = _data["user"] ? UserInfoDto.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): CustomerRegistrationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRegistrationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }

    clone(): CustomerRegistrationResponseDto {
        const json = this.toJSON();
        let result = new CustomerRegistrationResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerRegistrationResponseDto {
    success: boolean;
    message: string | undefined;
    user: UserInfoDto;
    errors: string[] | undefined;
}

/** DTO for returning customer traveler information */
export class CustomerTravelerDto implements ICustomerTravelerDto {
    id: string;
    customerBookingId: string;
    title: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    nationality: string | undefined;
    passportNumber: string | undefined;
    passportExpiryDate: moment.Moment | undefined;
    specialRequests: string | undefined;
    travelerOrder: number;
    fullName: string | undefined;
    age: number | undefined;
    isPassportExpiringSoon: boolean;

    constructor(data?: ICustomerTravelerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerBookingId = _data["customerBookingId"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.nationality = _data["nationality"];
            this.passportNumber = _data["passportNumber"];
            this.passportExpiryDate = _data["passportExpiryDate"] ? moment(_data["passportExpiryDate"].toString()) : undefined as any;
            this.specialRequests = _data["specialRequests"];
            this.travelerOrder = _data["travelerOrder"];
            this.fullName = _data["fullName"];
            this.age = _data["age"];
            this.isPassportExpiringSoon = _data["isPassportExpiringSoon"];
        }
    }

    static fromJS(data: any): CustomerTravelerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTravelerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerBookingId"] = this.customerBookingId;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["nationality"] = this.nationality;
        data["passportNumber"] = this.passportNumber;
        data["passportExpiryDate"] = this.passportExpiryDate ? this.passportExpiryDate.toISOString() : undefined as any;
        data["specialRequests"] = this.specialRequests;
        data["travelerOrder"] = this.travelerOrder;
        data["fullName"] = this.fullName;
        data["age"] = this.age;
        data["isPassportExpiringSoon"] = this.isPassportExpiringSoon;
        return data;
    }

    clone(): CustomerTravelerDto {
        const json = this.toJSON();
        let result = new CustomerTravelerDto();
        result.init(json);
        return result;
    }
}

/** DTO for returning customer traveler information */
export interface ICustomerTravelerDto {
    id: string;
    customerBookingId: string;
    title: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    nationality: string | undefined;
    passportNumber: string | undefined;
    passportExpiryDate: moment.Moment | undefined;
    specialRequests: string | undefined;
    travelerOrder: number;
    fullName: string | undefined;
    age: number | undefined;
    isPassportExpiringSoon: boolean;
}

/** Enum representing the type of date match for search results Used for prioritization and UI display */
export enum DateMatchType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class DeclineStayCancellationRequestInput implements IDeclineStayCancellationRequestInput {
    reason: string;

    constructor(data?: IDeclineStayCancellationRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): DeclineStayCancellationRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineStayCancellationRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }

    clone(): DeclineStayCancellationRequestInput {
        const json = this.toJSON();
        let result = new DeclineStayCancellationRequestInput();
        result.init(json);
        return result;
    }
}

export interface IDeclineStayCancellationRequestInput {
    reason: string;
}

export class DocScannerApkDownloadDto implements IDocScannerApkDownloadDto {
    downloadUrl: string | undefined;
    fileName: string | undefined;
    lastModified: moment.Moment;

    constructor(data?: IDocScannerApkDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadUrl = _data["downloadUrl"];
            this.fileName = _data["fileName"];
            this.lastModified = _data["lastModified"] ? moment(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DocScannerApkDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocScannerApkDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadUrl"] = this.downloadUrl;
        data["fileName"] = this.fileName;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }

    clone(): DocScannerApkDownloadDto {
        const json = this.toJSON();
        let result = new DocScannerApkDownloadDto();
        result.init(json);
        return result;
    }
}

export interface IDocScannerApkDownloadDto {
    downloadUrl: string | undefined;
    fileName: string | undefined;
    lastModified: moment.Moment;
}

export class Document implements IDocument {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    originalFileName: string | undefined;
    fileType: string | undefined;
    documentType: DocumentType;
    size: number;
    path: string | undefined;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.name = _data["name"];
            this.originalFileName = _data["originalFileName"];
            this.fileType = _data["fileType"];
            this.documentType = _data["documentType"];
            this.size = _data["size"];
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["name"] = this.name;
        data["originalFileName"] = this.originalFileName;
        data["fileType"] = this.fileType;
        data["documentType"] = this.documentType;
        data["size"] = this.size;
        data["path"] = this.path;
        return data;
    }

    clone(): Document {
        const json = this.toJSON();
        let result = new Document();
        result.init(json);
        return result;
    }
}

export interface IDocument {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    originalFileName: string | undefined;
    fileType: string | undefined;
    documentType: DocumentType;
    size: number;
    path: string | undefined;
}

export class DocumentDto implements IDocumentDto {
    id: string | undefined;
    name: string | undefined;
    originalFileName: string | undefined;
    fileType: string | undefined;
    documentType: DocumentType;
    size: number;
    creatorUserId: number;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.originalFileName = _data["originalFileName"];
            this.fileType = _data["fileType"];
            this.documentType = _data["documentType"];
            this.size = _data["size"];
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["originalFileName"] = this.originalFileName;
        data["fileType"] = this.fileType;
        data["documentType"] = this.documentType;
        data["size"] = this.size;
        data["creatorUserId"] = this.creatorUserId;
        return data;
    }

    clone(): DocumentDto {
        const json = this.toJSON();
        let result = new DocumentDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDto {
    id: string | undefined;
    name: string | undefined;
    originalFileName: string | undefined;
    fileType: string | undefined;
    documentType: DocumentType;
    size: number;
    creatorUserId: number;
}

export enum DocumentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _20 = 20,
    _21 = 21,
    _22 = 22,
    _30 = 30,
    _31 = 31,
    _32 = 32,
    _33 = 33,
    _34 = 34,
    _35 = 35,
    _91 = 91,
}

export class EmailAvailabilityDto implements IEmailAvailabilityDto {
    email: string | undefined;
    isAvailable: boolean;

    constructor(data?: IEmailAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): EmailAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["isAvailable"] = this.isAvailable;
        return data;
    }

    clone(): EmailAvailabilityDto {
        const json = this.toJSON();
        let result = new EmailAvailabilityDto();
        result.init(json);
        return result;
    }
}

export interface IEmailAvailabilityDto {
    email: string | undefined;
    isAvailable: boolean;
}

export class EmailSubscribeDto implements IEmailSubscribeDto {
    heading: string | undefined;
    subheading: string | undefined;
    placeholder: string | undefined;
    buttonText: string | undefined;

    constructor(data?: IEmailSubscribeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.subheading = _data["subheading"];
            this.placeholder = _data["placeholder"];
            this.buttonText = _data["buttonText"];
        }
    }

    static fromJS(data: any): EmailSubscribeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSubscribeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["subheading"] = this.subheading;
        data["placeholder"] = this.placeholder;
        data["buttonText"] = this.buttonText;
        return data;
    }

    clone(): EmailSubscribeDto {
        const json = this.toJSON();
        let result = new EmailSubscribeDto();
        result.init(json);
        return result;
    }
}

export interface IEmailSubscribeDto {
    heading: string | undefined;
    subheading: string | undefined;
    placeholder: string | undefined;
    buttonText: string | undefined;
}

export class EndpointCaptureResultDto implements IEndpointCaptureResultDto {
    endpoint: string | undefined;
    success: boolean;
    capturedAt: moment.Moment;
    filePath: string | undefined;
    fileSizeBytes: number;
    itemCount: number;
    captureLimit: number;
    errorMessage: string | undefined;

    constructor(data?: IEndpointCaptureResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.success = _data["success"];
            this.capturedAt = _data["capturedAt"] ? moment(_data["capturedAt"].toString()) : undefined as any;
            this.filePath = _data["filePath"];
            this.fileSizeBytes = _data["fileSizeBytes"];
            this.itemCount = _data["itemCount"];
            this.captureLimit = _data["captureLimit"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): EndpointCaptureResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndpointCaptureResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["success"] = this.success;
        data["capturedAt"] = this.capturedAt ? this.capturedAt.toISOString() : undefined as any;
        data["filePath"] = this.filePath;
        data["fileSizeBytes"] = this.fileSizeBytes;
        data["itemCount"] = this.itemCount;
        data["captureLimit"] = this.captureLimit;
        data["errorMessage"] = this.errorMessage;
        return data;
    }

    clone(): EndpointCaptureResultDto {
        const json = this.toJSON();
        let result = new EndpointCaptureResultDto();
        result.init(json);
        return result;
    }
}

export interface IEndpointCaptureResultDto {
    endpoint: string | undefined;
    success: boolean;
    capturedAt: moment.Moment;
    filePath: string | undefined;
    fileSizeBytes: number;
    itemCount: number;
    captureLimit: number;
    errorMessage: string | undefined;
}

export class ExternalLinksDto implements IExternalLinksDto {
    facebookUrl: string | undefined;
    instagramUrl: string | undefined;
    linkedinUrl: string | undefined;
    twitterUrl: string | undefined;
    youtubeUrl: string | undefined;

    constructor(data?: IExternalLinksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facebookUrl = _data["facebookUrl"];
            this.instagramUrl = _data["instagramUrl"];
            this.linkedinUrl = _data["linkedinUrl"];
            this.twitterUrl = _data["twitterUrl"];
            this.youtubeUrl = _data["youtubeUrl"];
        }
    }

    static fromJS(data: any): ExternalLinksDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLinksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facebookUrl"] = this.facebookUrl;
        data["instagramUrl"] = this.instagramUrl;
        data["linkedinUrl"] = this.linkedinUrl;
        data["twitterUrl"] = this.twitterUrl;
        data["youtubeUrl"] = this.youtubeUrl;
        return data;
    }

    clone(): ExternalLinksDto {
        const json = this.toJSON();
        let result = new ExternalLinksDto();
        result.init(json);
        return result;
    }
}

export interface IExternalLinksDto {
    facebookUrl: string | undefined;
    instagramUrl: string | undefined;
    linkedinUrl: string | undefined;
    twitterUrl: string | undefined;
    youtubeUrl: string | undefined;
}

/** Fare breakdown for a flight offer. */
export class FareDetailsApiDto implements IFareDetailsApiDto {
    /** Cabin class (e.g. `Economy`, `Business`, `First`). */
    cabinClass: string | undefined;
    /** Base fare before taxes, per passenger. */
    baseFare: number;
    /** Total taxes and surcharges, per passenger. */
    taxes: number;
    /** `true` if the fare allows a refund. */
    isRefundable: boolean;
    /** `true` if the fare allows date/flight changes. */
    isChangeable: boolean;
    /** Baggage allowance per passenger type. */
    baggageAllowance: BaggageApiDto[] | undefined;

    constructor(data?: IFareDetailsApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabinClass = _data["cabinClass"];
            this.baseFare = _data["baseFare"];
            this.taxes = _data["taxes"];
            this.isRefundable = _data["isRefundable"];
            this.isChangeable = _data["isChangeable"];
            if (Array.isArray(_data["baggageAllowance"])) {
                this.baggageAllowance = [] as any;
                for (let item of _data["baggageAllowance"])
                    this.baggageAllowance.push(BaggageApiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FareDetailsApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new FareDetailsApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinClass"] = this.cabinClass;
        data["baseFare"] = this.baseFare;
        data["taxes"] = this.taxes;
        data["isRefundable"] = this.isRefundable;
        data["isChangeable"] = this.isChangeable;
        if (Array.isArray(this.baggageAllowance)) {
            data["baggageAllowance"] = [];
            for (let item of this.baggageAllowance)
                data["baggageAllowance"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): FareDetailsApiDto {
        const json = this.toJSON();
        let result = new FareDetailsApiDto();
        result.init(json);
        return result;
    }
}

/** Fare breakdown for a flight offer. */
export interface IFareDetailsApiDto {
    /** Cabin class (e.g. `Economy`, `Business`, `First`). */
    cabinClass: string | undefined;
    /** Base fare before taxes, per passenger. */
    baseFare: number;
    /** Total taxes and surcharges, per passenger. */
    taxes: number;
    /** `true` if the fare allows a refund. */
    isRefundable: boolean;
    /** `true` if the fare allows date/flight changes. */
    isChangeable: boolean;
    /** Baggage allowance per passenger type. */
    baggageAllowance: BaggageApiDto[] | undefined;
}

export class FeaturedProductDto implements IFeaturedProductDto {
    id: string | undefined;
    title: string | undefined;
    price: number;
    basePrice: number;
    days: number;
    nights: number;
    rating: number;
    currency: string | undefined;
    tourPackageType: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    images: PackageImageDto[] | undefined;

    constructor(data?: IFeaturedProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.price = _data["price"];
            this.basePrice = _data["basePrice"];
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.rating = _data["rating"];
            this.currency = _data["currency"];
            this.tourPackageType = _data["tourPackageType"];
            this.coverPhotoDocumentUrl = _data["coverPhotoDocumentUrl"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(PackageImageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeaturedProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeaturedProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["price"] = this.price;
        data["basePrice"] = this.basePrice;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["rating"] = this.rating;
        data["currency"] = this.currency;
        data["tourPackageType"] = this.tourPackageType;
        data["coverPhotoDocumentUrl"] = this.coverPhotoDocumentUrl;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): FeaturedProductDto {
        const json = this.toJSON();
        let result = new FeaturedProductDto();
        result.init(json);
        return result;
    }
}

export interface IFeaturedProductDto {
    id: string | undefined;
    title: string | undefined;
    price: number;
    basePrice: number;
    days: number;
    nights: number;
    rating: number;
    currency: string | undefined;
    tourPackageType: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    images: PackageImageDto[] | undefined;
}

export class FileDto implements IFileDto {
    base64: string | undefined;
    name: string | undefined;
    type: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    base64: string | undefined;
    name: string | undefined;
    type: string | undefined;
}

/** DTO for converting draft to final booking */
export class FinalizeCustomerBookingDto implements IFinalizeCustomerBookingDto {
    customerBookingId: string;
    /** Final confirmation of traveler details */
    finalTravelers: CreateCustomerTravelerDto[] | undefined;
    /** Any final notes or special requests */
    finalNotes: string | undefined;

    constructor(data?: IFinalizeCustomerBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerBookingId = _data["customerBookingId"];
            if (Array.isArray(_data["finalTravelers"])) {
                this.finalTravelers = [] as any;
                for (let item of _data["finalTravelers"])
                    this.finalTravelers.push(CreateCustomerTravelerDto.fromJS(item));
            }
            this.finalNotes = _data["finalNotes"];
        }
    }

    static fromJS(data: any): FinalizeCustomerBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinalizeCustomerBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerBookingId"] = this.customerBookingId;
        if (Array.isArray(this.finalTravelers)) {
            data["finalTravelers"] = [];
            for (let item of this.finalTravelers)
                data["finalTravelers"].push(item ? item.toJSON() : undefined as any);
        }
        data["finalNotes"] = this.finalNotes;
        return data;
    }

    clone(): FinalizeCustomerBookingDto {
        const json = this.toJSON();
        let result = new FinalizeCustomerBookingDto();
        result.init(json);
        return result;
    }
}

/** DTO for converting draft to final booking */
export interface IFinalizeCustomerBookingDto {
    customerBookingId: string;
    /** Final confirmation of traveler details */
    finalTravelers: CreateCustomerTravelerDto[] | undefined;
    /** Any final notes or special requests */
    finalNotes: string | undefined;
}

export class FixtureCaptureResultDto implements IFixtureCaptureResultDto {
    startedAt: moment.Moment;
    completedAt: moment.Moment | undefined;
    durationSeconds: number;
    successCount: number;
    failureCount: number;
    endpointResults: EndpointCaptureResultDto[] | undefined;

    constructor(data?: IFixtureCaptureResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startedAt = _data["startedAt"] ? moment(_data["startedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? moment(_data["completedAt"].toString()) : undefined as any;
            this.durationSeconds = _data["durationSeconds"];
            this.successCount = _data["successCount"];
            this.failureCount = _data["failureCount"];
            if (Array.isArray(_data["endpointResults"])) {
                this.endpointResults = [] as any;
                for (let item of _data["endpointResults"])
                    this.endpointResults.push(EndpointCaptureResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FixtureCaptureResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FixtureCaptureResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["durationSeconds"] = this.durationSeconds;
        data["successCount"] = this.successCount;
        data["failureCount"] = this.failureCount;
        if (Array.isArray(this.endpointResults)) {
            data["endpointResults"] = [];
            for (let item of this.endpointResults)
                data["endpointResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): FixtureCaptureResultDto {
        const json = this.toJSON();
        let result = new FixtureCaptureResultDto();
        result.init(json);
        return result;
    }
}

export interface IFixtureCaptureResultDto {
    startedAt: moment.Moment;
    completedAt: moment.Moment | undefined;
    durationSeconds: number;
    successCount: number;
    failureCount: number;
    endpointResults: EndpointCaptureResultDto[] | undefined;
}

/** GDS seat inventory availability for a specific flight. */
export class FlightAvailabilityApiDto implements IFlightAvailabilityApiDto {
    /** Airline flight number. Example: `QF400`. */
    flightNumber: string | undefined;
    /** IATA code of the operating carrier. */
    carrierCode: string | undefined;
    /** Full name of the carrier. */
    carrierName: string | undefined;
    /** IATA code of the departure airport. */
    departureAirport: string | undefined;
    /** IATA code of the arrival airport. */
    arrivalAirport: string | undefined;
    /** Departure terminal, if available. */
    departureTerminal: string | undefined;
    /** Arrival terminal, if available. */
    arrivalTerminal: string | undefined;
    /** Scheduled departure date and time (local to departure airport). */
    departureDateTime: moment.Moment;
    /** Scheduled arrival date and time (local to arrival airport). */
    arrivalDateTime: moment.Moment;
    /** Total flight duration in minutes. */
    durationMinutes: number;
    /** ICAO aircraft type code. Example: `B738`. */
    aircraftType: string | undefined;
    /** Number of technical stops. */
    stopsCount: number;
    /** Seat availability broken down by booking class. */
    classAvailability: ClassAvailabilityApiDto[] | undefined;

    constructor(data?: IFlightAvailabilityApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flightNumber = _data["flightNumber"];
            this.carrierCode = _data["carrierCode"];
            this.carrierName = _data["carrierName"];
            this.departureAirport = _data["departureAirport"];
            this.arrivalAirport = _data["arrivalAirport"];
            this.departureTerminal = _data["departureTerminal"];
            this.arrivalTerminal = _data["arrivalTerminal"];
            this.departureDateTime = _data["departureDateTime"] ? moment(_data["departureDateTime"].toString()) : undefined as any;
            this.arrivalDateTime = _data["arrivalDateTime"] ? moment(_data["arrivalDateTime"].toString()) : undefined as any;
            this.durationMinutes = _data["durationMinutes"];
            this.aircraftType = _data["aircraftType"];
            this.stopsCount = _data["stopsCount"];
            if (Array.isArray(_data["classAvailability"])) {
                this.classAvailability = [] as any;
                for (let item of _data["classAvailability"])
                    this.classAvailability.push(ClassAvailabilityApiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlightAvailabilityApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAvailabilityApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flightNumber"] = this.flightNumber;
        data["carrierCode"] = this.carrierCode;
        data["carrierName"] = this.carrierName;
        data["departureAirport"] = this.departureAirport;
        data["arrivalAirport"] = this.arrivalAirport;
        data["departureTerminal"] = this.departureTerminal;
        data["arrivalTerminal"] = this.arrivalTerminal;
        data["departureDateTime"] = this.departureDateTime ? this.departureDateTime.toISOString() : undefined as any;
        data["arrivalDateTime"] = this.arrivalDateTime ? this.arrivalDateTime.toISOString() : undefined as any;
        data["durationMinutes"] = this.durationMinutes;
        data["aircraftType"] = this.aircraftType;
        data["stopsCount"] = this.stopsCount;
        if (Array.isArray(this.classAvailability)) {
            data["classAvailability"] = [];
            for (let item of this.classAvailability)
                data["classAvailability"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): FlightAvailabilityApiDto {
        const json = this.toJSON();
        let result = new FlightAvailabilityApiDto();
        result.init(json);
        return result;
    }
}

/** GDS seat inventory availability for a specific flight. */
export interface IFlightAvailabilityApiDto {
    /** Airline flight number. Example: `QF400`. */
    flightNumber: string | undefined;
    /** IATA code of the operating carrier. */
    carrierCode: string | undefined;
    /** Full name of the carrier. */
    carrierName: string | undefined;
    /** IATA code of the departure airport. */
    departureAirport: string | undefined;
    /** IATA code of the arrival airport. */
    arrivalAirport: string | undefined;
    /** Departure terminal, if available. */
    departureTerminal: string | undefined;
    /** Arrival terminal, if available. */
    arrivalTerminal: string | undefined;
    /** Scheduled departure date and time (local to departure airport). */
    departureDateTime: moment.Moment;
    /** Scheduled arrival date and time (local to arrival airport). */
    arrivalDateTime: moment.Moment;
    /** Total flight duration in minutes. */
    durationMinutes: number;
    /** ICAO aircraft type code. Example: `B738`. */
    aircraftType: string | undefined;
    /** Number of technical stops. */
    stopsCount: number;
    /** Seat availability broken down by booking class. */
    classAvailability: ClassAvailabilityApiDto[] | undefined;
}

/** Request body for `POST /api/flights/availability`. Internal/admin use only — for consumer flight search use `POST /api/flights/search`. */
export class FlightAvailabilityApiRequest implements IFlightAvailabilityApiRequest {
    /** IATA airport code for the departure airport. Example: `SYD` */
    origin: string;
    /** IATA airport code for the arrival airport. Example: `MEL` */
    destination: string;
    /** Departure date to check availability for. */
    departureDate: moment.Moment;
    /** Number of adult passengers. Min: 1, Max: 9. */
    adults: number;
    /** Number of child passengers. Max: 9. */
    children: number;
    /** Number of infant passengers. Max: 4. */
    infants: number;
    /** IATA carrier code to filter results. Example: `QF`. */
    preferredCarrier: string | undefined;
    /** Preferred departure time in `HH:mm` format. Example: `08:00`. */
    departureTime: string | undefined;

    constructor(data?: IFlightAvailabilityApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.departureDate = _data["departureDate"] ? moment(_data["departureDate"].toString()) : undefined as any;
            this.adults = _data["adults"];
            this.children = _data["children"];
            this.infants = _data["infants"];
            this.preferredCarrier = _data["preferredCarrier"];
            this.departureTime = _data["departureTime"];
        }
    }

    static fromJS(data: any): FlightAvailabilityApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAvailabilityApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : undefined as any;
        data["adults"] = this.adults;
        data["children"] = this.children;
        data["infants"] = this.infants;
        data["preferredCarrier"] = this.preferredCarrier;
        data["departureTime"] = this.departureTime;
        return data;
    }

    clone(): FlightAvailabilityApiRequest {
        const json = this.toJSON();
        let result = new FlightAvailabilityApiRequest();
        result.init(json);
        return result;
    }
}

/** Request body for `POST /api/flights/availability`. Internal/admin use only — for consumer flight search use `POST /api/flights/search`. */
export interface IFlightAvailabilityApiRequest {
    /** IATA airport code for the departure airport. Example: `SYD` */
    origin: string;
    /** IATA airport code for the arrival airport. Example: `MEL` */
    destination: string;
    /** Departure date to check availability for. */
    departureDate: moment.Moment;
    /** Number of adult passengers. Min: 1, Max: 9. */
    adults: number;
    /** Number of child passengers. Max: 9. */
    children: number;
    /** Number of infant passengers. Max: 4. */
    infants: number;
    /** IATA carrier code to filter results. Example: `QF`. */
    preferredCarrier: string | undefined;
    /** Preferred departure time in `HH:mm` format. Example: `08:00`. */
    departureTime: string | undefined;
}

/** Booking confirmation returned from `POST /api/flights/book` and `GET /api/flights/booking/{bookingReference}`. */
export class FlightBookingApiDto implements IFlightBookingApiDto {
    /** Internal booking reference generated by TravelM8Express. */
    bookingReference: string | undefined;
    /** Airline PNR (Passenger Name Record) from the supplier/GDS. */
    pnr: string | undefined;
    /** Current booking status. Values: `Pending`, `Confirmed`, `Cancelled`. */
    status: string | undefined;
    /** UTC datetime when the booking was created. */
    bookedAt: moment.Moment;
    /** Total price charged to the customer. */
    totalPrice: number;
    /** ISO 4217 currency code of the total price. */
    currency: string | undefined;
    /** Deadline to issue the ticket before the reservation is automatically cancelled by the airline. */
    ticketTimeLimit: string | undefined;
    /** Ordered list of outbound flight segments. */
    outboundSegments: FlightSegmentApiDto[] | undefined;
    /** Ordered list of inbound (return) flight segments. Empty for one-way bookings. */
    inboundSegments: FlightSegmentApiDto[] | undefined;
    /** List of booked passengers. */
    passengers: BookedPassengerApiDto[] | undefined;

    constructor(data?: IFlightBookingApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingReference = _data["bookingReference"];
            this.pnr = _data["pnr"];
            this.status = _data["status"];
            this.bookedAt = _data["bookedAt"] ? moment(_data["bookedAt"].toString()) : undefined as any;
            this.totalPrice = _data["totalPrice"];
            this.currency = _data["currency"];
            this.ticketTimeLimit = _data["ticketTimeLimit"];
            if (Array.isArray(_data["outboundSegments"])) {
                this.outboundSegments = [] as any;
                for (let item of _data["outboundSegments"])
                    this.outboundSegments.push(FlightSegmentApiDto.fromJS(item));
            }
            if (Array.isArray(_data["inboundSegments"])) {
                this.inboundSegments = [] as any;
                for (let item of _data["inboundSegments"])
                    this.inboundSegments.push(FlightSegmentApiDto.fromJS(item));
            }
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers.push(BookedPassengerApiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlightBookingApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightBookingApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingReference"] = this.bookingReference;
        data["pnr"] = this.pnr;
        data["status"] = this.status;
        data["bookedAt"] = this.bookedAt ? this.bookedAt.toISOString() : undefined as any;
        data["totalPrice"] = this.totalPrice;
        data["currency"] = this.currency;
        data["ticketTimeLimit"] = this.ticketTimeLimit;
        if (Array.isArray(this.outboundSegments)) {
            data["outboundSegments"] = [];
            for (let item of this.outboundSegments)
                data["outboundSegments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inboundSegments)) {
            data["inboundSegments"] = [];
            for (let item of this.inboundSegments)
                data["inboundSegments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): FlightBookingApiDto {
        const json = this.toJSON();
        let result = new FlightBookingApiDto();
        result.init(json);
        return result;
    }
}

/** Booking confirmation returned from `POST /api/flights/book` and `GET /api/flights/booking/{bookingReference}`. */
export interface IFlightBookingApiDto {
    /** Internal booking reference generated by TravelM8Express. */
    bookingReference: string | undefined;
    /** Airline PNR (Passenger Name Record) from the supplier/GDS. */
    pnr: string | undefined;
    /** Current booking status. Values: `Pending`, `Confirmed`, `Cancelled`. */
    status: string | undefined;
    /** UTC datetime when the booking was created. */
    bookedAt: moment.Moment;
    /** Total price charged to the customer. */
    totalPrice: number;
    /** ISO 4217 currency code of the total price. */
    currency: string | undefined;
    /** Deadline to issue the ticket before the reservation is automatically cancelled by the airline. */
    ticketTimeLimit: string | undefined;
    /** Ordered list of outbound flight segments. */
    outboundSegments: FlightSegmentApiDto[] | undefined;
    /** Ordered list of inbound (return) flight segments. Empty for one-way bookings. */
    inboundSegments: FlightSegmentApiDto[] | undefined;
    /** List of booked passengers. */
    passengers: BookedPassengerApiDto[] | undefined;
}

/** Request body for `POST /api/flights/book`. */
export class FlightBookingApiRequest implements IFlightBookingApiRequest {
    /** The `offerId` from the `POST /api/flights/price` response. */
    offerId: string;
    /** Details for each passenger. Must include at least one adult. */
    passengers: FlightPassengerApiDto[];
    contactDetails: FlightContactApiDto;
    /** Optional special service requests (e.g. meal preferences, wheelchair assistance). */
    specialRequests: string | undefined;

    constructor(data?: IFlightBookingApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.passengers = [];
            this.contactDetails = new FlightContactApiDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerId = _data["offerId"];
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers.push(FlightPassengerApiDto.fromJS(item));
            }
            this.contactDetails = _data["contactDetails"] ? FlightContactApiDto.fromJS(_data["contactDetails"]) : new FlightContactApiDto();
            this.specialRequests = _data["specialRequests"];
        }
    }

    static fromJS(data: any): FlightBookingApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FlightBookingApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item ? item.toJSON() : undefined as any);
        }
        data["contactDetails"] = this.contactDetails ? this.contactDetails.toJSON() : undefined as any;
        data["specialRequests"] = this.specialRequests;
        return data;
    }

    clone(): FlightBookingApiRequest {
        const json = this.toJSON();
        let result = new FlightBookingApiRequest();
        result.init(json);
        return result;
    }
}

/** Request body for `POST /api/flights/book`. */
export interface IFlightBookingApiRequest {
    /** The `offerId` from the `POST /api/flights/price` response. */
    offerId: string;
    /** Details for each passenger. Must include at least one adult. */
    passengers: FlightPassengerApiDto[];
    contactDetails: FlightContactApiDto;
    /** Optional special service requests (e.g. meal preferences, wheelchair assistance). */
    specialRequests: string | undefined;
}

/** Primary contact details for the booking. */
export class FlightContactApiDto implements IFlightContactApiDto {
    /** Contact email address for booking confirmation. */
    email: string;
    /** Contact phone number in E.164 format. Example: `+61400000000`. */
    phone: string;

    constructor(data?: IFlightContactApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): FlightContactApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightContactApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }

    clone(): FlightContactApiDto {
        const json = this.toJSON();
        let result = new FlightContactApiDto();
        result.init(json);
        return result;
    }
}

/** Primary contact details for the booking. */
export interface IFlightContactApiDto {
    /** Contact email address for booking confirmation. */
    email: string;
    /** Contact phone number in E.164 format. Example: `+61400000000`. */
    phone: string;
}

/** A priced, bookable flight offer returned from `POST /api/flights/search` or `POST /api/flights/price`. */
export class FlightOfferApiDto implements IFlightOfferApiDto {
    /** Unique offer identifier. Pass this to `/price` then `/book`. */
    offerId: string | undefined;
    /** IATA code of the departure airport. */
    origin: string | undefined;
    /** IATA code of the arrival airport. */
    destination: string | undefined;
    /** Outbound departure date. */
    departureDate: moment.Moment;
    /** Return departure date. `null` for one-way offers. */
    returnDate: moment.Moment | undefined;
    /** `true` if the offer includes a return leg. */
    isRoundTrip: boolean;
    /** Marked-up selling price shown to the customer. */
    sellingPrice: number;
    /** ISO 4217 currency code of the selling price. */
    currency: string | undefined;
    /** IATA code of the validating (ticketing) carrier. */
    validatingCarrierCode: string | undefined;
    /** Cabin class of the offer (e.g. `Economy`, `Business`). */
    cabinClass: string | undefined;
    /** Fare brand name from the airline (e.g. "Basic Economy", "Main Cabin"). `null` if not provided. */
    brandName: string | undefined;
    /** Ordered list of outbound flight segments. */
    outboundSegments: FlightSegmentApiDto[] | undefined;
    /** Ordered list of inbound (return) flight segments. Empty for one-way. */
    inboundSegments: FlightSegmentApiDto[] | undefined;
    fareDetails: FareDetailsApiDto;
    /** UTC datetime after which this offer is no longer guaranteed. Re-price before booking if close to expiry. */
    offerExpiry: moment.Moment;
    /** Deadline by which payment must be made to secure the booking. `null` for search results (available after pricing). */
    paymentTimeLimit: moment.Moment | undefined;

    constructor(data?: IFlightOfferApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerId = _data["offerId"];
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.departureDate = _data["departureDate"] ? moment(_data["departureDate"].toString()) : undefined as any;
            this.returnDate = _data["returnDate"] ? moment(_data["returnDate"].toString()) : undefined as any;
            this.isRoundTrip = _data["isRoundTrip"];
            this.sellingPrice = _data["sellingPrice"];
            this.currency = _data["currency"];
            this.validatingCarrierCode = _data["validatingCarrierCode"];
            this.cabinClass = _data["cabinClass"];
            this.brandName = _data["brandName"];
            if (Array.isArray(_data["outboundSegments"])) {
                this.outboundSegments = [] as any;
                for (let item of _data["outboundSegments"])
                    this.outboundSegments.push(FlightSegmentApiDto.fromJS(item));
            }
            if (Array.isArray(_data["inboundSegments"])) {
                this.inboundSegments = [] as any;
                for (let item of _data["inboundSegments"])
                    this.inboundSegments.push(FlightSegmentApiDto.fromJS(item));
            }
            this.fareDetails = _data["fareDetails"] ? FareDetailsApiDto.fromJS(_data["fareDetails"]) : undefined as any;
            this.offerExpiry = _data["offerExpiry"] ? moment(_data["offerExpiry"].toString()) : undefined as any;
            this.paymentTimeLimit = _data["paymentTimeLimit"] ? moment(_data["paymentTimeLimit"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FlightOfferApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightOfferApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId;
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : undefined as any;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : undefined as any;
        data["isRoundTrip"] = this.isRoundTrip;
        data["sellingPrice"] = this.sellingPrice;
        data["currency"] = this.currency;
        data["validatingCarrierCode"] = this.validatingCarrierCode;
        data["cabinClass"] = this.cabinClass;
        data["brandName"] = this.brandName;
        if (Array.isArray(this.outboundSegments)) {
            data["outboundSegments"] = [];
            for (let item of this.outboundSegments)
                data["outboundSegments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inboundSegments)) {
            data["inboundSegments"] = [];
            for (let item of this.inboundSegments)
                data["inboundSegments"].push(item ? item.toJSON() : undefined as any);
        }
        data["fareDetails"] = this.fareDetails ? this.fareDetails.toJSON() : undefined as any;
        data["offerExpiry"] = this.offerExpiry ? this.offerExpiry.toISOString() : undefined as any;
        data["paymentTimeLimit"] = this.paymentTimeLimit ? this.paymentTimeLimit.toISOString() : undefined as any;
        return data;
    }

    clone(): FlightOfferApiDto {
        const json = this.toJSON();
        let result = new FlightOfferApiDto();
        result.init(json);
        return result;
    }
}

/** A priced, bookable flight offer returned from `POST /api/flights/search` or `POST /api/flights/price`. */
export interface IFlightOfferApiDto {
    /** Unique offer identifier. Pass this to `/price` then `/book`. */
    offerId: string | undefined;
    /** IATA code of the departure airport. */
    origin: string | undefined;
    /** IATA code of the arrival airport. */
    destination: string | undefined;
    /** Outbound departure date. */
    departureDate: moment.Moment;
    /** Return departure date. `null` for one-way offers. */
    returnDate: moment.Moment | undefined;
    /** `true` if the offer includes a return leg. */
    isRoundTrip: boolean;
    /** Marked-up selling price shown to the customer. */
    sellingPrice: number;
    /** ISO 4217 currency code of the selling price. */
    currency: string | undefined;
    /** IATA code of the validating (ticketing) carrier. */
    validatingCarrierCode: string | undefined;
    /** Cabin class of the offer (e.g. `Economy`, `Business`). */
    cabinClass: string | undefined;
    /** Fare brand name from the airline (e.g. "Basic Economy", "Main Cabin"). `null` if not provided. */
    brandName: string | undefined;
    /** Ordered list of outbound flight segments. */
    outboundSegments: FlightSegmentApiDto[] | undefined;
    /** Ordered list of inbound (return) flight segments. Empty for one-way. */
    inboundSegments: FlightSegmentApiDto[] | undefined;
    fareDetails: FareDetailsApiDto;
    /** UTC datetime after which this offer is no longer guaranteed. Re-price before booking if close to expiry. */
    offerExpiry: moment.Moment;
    /** Deadline by which payment must be made to secure the booking. `null` for search results (available after pricing). */
    paymentTimeLimit: moment.Moment | undefined;
}

/** Passenger details required for booking. */
export class FlightPassengerApiDto implements IFlightPassengerApiDto {
    /** Optional client-side passenger identifier. */
    passengerId: string | undefined;
    /** Passenger type. Accepted values: `Adult`, `Child`, `Infant`. */
    type: string | undefined;
    /** Name title. Example: `MR`, `MRS`, `MS`, `DR`. */
    title: string | undefined;
    /** Given (first) name as it appears on the travel document. */
    firstName: string;
    /** Family (last) name as it appears on the travel document. */
    lastName: string;
    /** Date of birth. Required for child and infant passengers. */
    dateOfBirth: moment.Moment;
    /** Passport or travel document number. Required for international flights. */
    passportNumber: string | undefined;
    /** ISO 3166-1 alpha-2 country code of the issuing country. Example: `AU`. */
    passportCountry: string | undefined;
    /** Passport expiry date. */
    passportExpiry: moment.Moment | undefined;
    /** ISO 3166-1 alpha-2 nationality code. Example: `AU`. */
    nationality: string | undefined;

    constructor(data?: IFlightPassengerApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passengerId = _data["passengerId"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.passportNumber = _data["passportNumber"];
            this.passportCountry = _data["passportCountry"];
            this.passportExpiry = _data["passportExpiry"] ? moment(_data["passportExpiry"].toString()) : undefined as any;
            this.nationality = _data["nationality"];
        }
    }

    static fromJS(data: any): FlightPassengerApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPassengerApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passengerId"] = this.passengerId;
        data["type"] = this.type;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["passportNumber"] = this.passportNumber;
        data["passportCountry"] = this.passportCountry;
        data["passportExpiry"] = this.passportExpiry ? this.passportExpiry.toISOString() : undefined as any;
        data["nationality"] = this.nationality;
        return data;
    }

    clone(): FlightPassengerApiDto {
        const json = this.toJSON();
        let result = new FlightPassengerApiDto();
        result.init(json);
        return result;
    }
}

/** Passenger details required for booking. */
export interface IFlightPassengerApiDto {
    /** Optional client-side passenger identifier. */
    passengerId: string | undefined;
    /** Passenger type. Accepted values: `Adult`, `Child`, `Infant`. */
    type: string | undefined;
    /** Name title. Example: `MR`, `MRS`, `MS`, `DR`. */
    title: string | undefined;
    /** Given (first) name as it appears on the travel document. */
    firstName: string;
    /** Family (last) name as it appears on the travel document. */
    lastName: string;
    /** Date of birth. Required for child and infant passengers. */
    dateOfBirth: moment.Moment;
    /** Passport or travel document number. Required for international flights. */
    passportNumber: string | undefined;
    /** ISO 3166-1 alpha-2 country code of the issuing country. Example: `AU`. */
    passportCountry: string | undefined;
    /** Passport expiry date. */
    passportExpiry: moment.Moment | undefined;
    /** ISO 3166-1 alpha-2 nationality code. Example: `AU`. */
    nationality: string | undefined;
}

/** Passenger type and count for pricing. */
export class FlightPassengerCountDto implements IFlightPassengerCountDto {
    /** Passenger type. Accepted values: `Adult`, `Child`, `Infant`. */
    type: string | undefined;
    /** Number of passengers of this type. */
    count: number;

    constructor(data?: IFlightPassengerCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): FlightPassengerCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPassengerCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["count"] = this.count;
        return data;
    }

    clone(): FlightPassengerCountDto {
        const json = this.toJSON();
        let result = new FlightPassengerCountDto();
        result.init(json);
        return result;
    }
}

/** Passenger type and count for pricing. */
export interface IFlightPassengerCountDto {
    /** Passenger type. Accepted values: `Adult`, `Child`, `Infant`. */
    type: string | undefined;
    /** Number of passengers of this type. */
    count: number;
}

/** Request body for `POST /api/flights/price`. */
export class FlightPriceApiRequest implements IFlightPriceApiRequest {
    /** The `offerId` returned from `POST /api/flights/search`. */
    offerId: string;
    /** ISO 4217 currency code. Defaults to `AUD`. */
    currency: string | undefined;
    /** Passenger counts — must match what was used in the search. */
    passengers: FlightPassengerCountDto[] | undefined;

    constructor(data?: IFlightPriceApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerId = _data["offerId"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers.push(FlightPassengerCountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlightPriceApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPriceApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId;
        data["currency"] = this.currency;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): FlightPriceApiRequest {
        const json = this.toJSON();
        let result = new FlightPriceApiRequest();
        result.init(json);
        return result;
    }
}

/** Request body for `POST /api/flights/price`. */
export interface IFlightPriceApiRequest {
    /** The `offerId` returned from `POST /api/flights/search`. */
    offerId: string;
    /** ISO 4217 currency code. Defaults to `AUD`. */
    currency: string | undefined;
    /** Passenger counts — must match what was used in the search. */
    passengers: FlightPassengerCountDto[] | undefined;
}

/** Request body for `POST /api/flights/search`. */
export class FlightSearchApiRequest implements IFlightSearchApiRequest {
    /** IATA airport or city code for the departure. Example: `SYD`, `NYC` */
    origin: string;
    /** Controls whether `Origin` is treated as a city or airport.
Accepted values: `City Only`, `Airport Only`. Omit to search both. */
    originType: string | undefined;
    /** IATA airport or city code for the destination. Example: `MEL`, `ORD` */
    destination: string;
    /** Controls whether `Destination` is treated as a city or airport.
Accepted values: `City Only`, `Airport Only`. Omit to search both. */
    destinationType: string | undefined;
    /** Outbound departure date. */
    departureDate: moment.Moment;
    /** Return departure date. Omit for one-way searches. */
    returnDate: moment.Moment | undefined;
    /** Number of adult passengers (12+). Min: 1, Max: 9. */
    adults: number;
    /** Number of child passengers (2–11). Max: 9. */
    children: number;
    /** Number of infant passengers (under 2, lap). Max: 4. */
    infants: number;
    /** Preferred cabin class. Accepted values: `Economy`, `PremiumEconomy`,
`Business`, `First`, `PremiumFirst`. Defaults to `Economy`.
Omit to return all cabins. */
    cabinClass: string | undefined;
    /** When `true`, only non-stop flights are returned. */
    nonStopOnly: boolean;
    /** IATA carrier code to filter results. Example: `QF`, `AA`, `UA`. */
    preferredCarrier: string | undefined;
    /** ISO 4217 currency code for pricing. Defaults to `AUD`. */
    currency: string | undefined;

    constructor(data?: IFlightSearchApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"];
            this.originType = _data["originType"];
            this.destination = _data["destination"];
            this.destinationType = _data["destinationType"];
            this.departureDate = _data["departureDate"] ? moment(_data["departureDate"].toString()) : undefined as any;
            this.returnDate = _data["returnDate"] ? moment(_data["returnDate"].toString()) : undefined as any;
            this.adults = _data["adults"];
            this.children = _data["children"];
            this.infants = _data["infants"];
            this.cabinClass = _data["cabinClass"];
            this.nonStopOnly = _data["nonStopOnly"];
            this.preferredCarrier = _data["preferredCarrier"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): FlightSearchApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSearchApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin;
        data["originType"] = this.originType;
        data["destination"] = this.destination;
        data["destinationType"] = this.destinationType;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : undefined as any;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : undefined as any;
        data["adults"] = this.adults;
        data["children"] = this.children;
        data["infants"] = this.infants;
        data["cabinClass"] = this.cabinClass;
        data["nonStopOnly"] = this.nonStopOnly;
        data["preferredCarrier"] = this.preferredCarrier;
        data["currency"] = this.currency;
        return data;
    }

    clone(): FlightSearchApiRequest {
        const json = this.toJSON();
        let result = new FlightSearchApiRequest();
        result.init(json);
        return result;
    }
}

/** Request body for `POST /api/flights/search`. */
export interface IFlightSearchApiRequest {
    /** IATA airport or city code for the departure. Example: `SYD`, `NYC` */
    origin: string;
    /** Controls whether `Origin` is treated as a city or airport.
Accepted values: `City Only`, `Airport Only`. Omit to search both. */
    originType: string | undefined;
    /** IATA airport or city code for the destination. Example: `MEL`, `ORD` */
    destination: string;
    /** Controls whether `Destination` is treated as a city or airport.
Accepted values: `City Only`, `Airport Only`. Omit to search both. */
    destinationType: string | undefined;
    /** Outbound departure date. */
    departureDate: moment.Moment;
    /** Return departure date. Omit for one-way searches. */
    returnDate: moment.Moment | undefined;
    /** Number of adult passengers (12+). Min: 1, Max: 9. */
    adults: number;
    /** Number of child passengers (2–11). Max: 9. */
    children: number;
    /** Number of infant passengers (under 2, lap). Max: 4. */
    infants: number;
    /** Preferred cabin class. Accepted values: `Economy`, `PremiumEconomy`,
`Business`, `First`, `PremiumFirst`. Defaults to `Economy`.
Omit to return all cabins. */
    cabinClass: string | undefined;
    /** When `true`, only non-stop flights are returned. */
    nonStopOnly: boolean;
    /** IATA carrier code to filter results. Example: `QF`, `AA`, `UA`. */
    preferredCarrier: string | undefined;
    /** ISO 4217 currency code for pricing. Defaults to `AUD`. */
    currency: string | undefined;
}

/** A single flight segment (one take-off and landing) within an offer. */
export class FlightSegmentApiDto implements IFlightSegmentApiDto {
    /** Airline flight number. Example: `QF401`. */
    flightNumber: string | undefined;
    /** IATA code of the marketing carrier. */
    carrierCode: string | undefined;
    /** Full name of the marketing carrier. */
    carrierName: string | undefined;
    /** IATA code of the departure airport. */
    departureAirport: string | undefined;
    /** IATA code of the arrival airport. */
    arrivalAirport: string | undefined;
    /** Departure terminal identifier, if available. */
    departureTerminal: string | undefined;
    /** Arrival terminal identifier, if available. */
    arrivalTerminal: string | undefined;
    /** Scheduled departure date and time (local to departure airport). */
    departureDateTime: moment.Moment;
    /** Scheduled arrival date and time (local to arrival airport). */
    arrivalDateTime: moment.Moment;
    /** Total flight duration in minutes. */
    durationMinutes: number;
    /** ICAO aircraft type code. Example: `B738`, `A320`. */
    aircraftType: string | undefined;
    /** Number of technical stops (not counting layovers between segments). */
    stopsCount: number;
    /** IATA codes of stop airports, if any. */
    stopAirports: string[] | undefined;

    constructor(data?: IFlightSegmentApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flightNumber = _data["flightNumber"];
            this.carrierCode = _data["carrierCode"];
            this.carrierName = _data["carrierName"];
            this.departureAirport = _data["departureAirport"];
            this.arrivalAirport = _data["arrivalAirport"];
            this.departureTerminal = _data["departureTerminal"];
            this.arrivalTerminal = _data["arrivalTerminal"];
            this.departureDateTime = _data["departureDateTime"] ? moment(_data["departureDateTime"].toString()) : undefined as any;
            this.arrivalDateTime = _data["arrivalDateTime"] ? moment(_data["arrivalDateTime"].toString()) : undefined as any;
            this.durationMinutes = _data["durationMinutes"];
            this.aircraftType = _data["aircraftType"];
            this.stopsCount = _data["stopsCount"];
            if (Array.isArray(_data["stopAirports"])) {
                this.stopAirports = [] as any;
                for (let item of _data["stopAirports"])
                    this.stopAirports.push(item);
            }
        }
    }

    static fromJS(data: any): FlightSegmentApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSegmentApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flightNumber"] = this.flightNumber;
        data["carrierCode"] = this.carrierCode;
        data["carrierName"] = this.carrierName;
        data["departureAirport"] = this.departureAirport;
        data["arrivalAirport"] = this.arrivalAirport;
        data["departureTerminal"] = this.departureTerminal;
        data["arrivalTerminal"] = this.arrivalTerminal;
        data["departureDateTime"] = this.departureDateTime ? this.departureDateTime.toISOString() : undefined as any;
        data["arrivalDateTime"] = this.arrivalDateTime ? this.arrivalDateTime.toISOString() : undefined as any;
        data["durationMinutes"] = this.durationMinutes;
        data["aircraftType"] = this.aircraftType;
        data["stopsCount"] = this.stopsCount;
        if (Array.isArray(this.stopAirports)) {
            data["stopAirports"] = [];
            for (let item of this.stopAirports)
                data["stopAirports"].push(item);
        }
        return data;
    }

    clone(): FlightSegmentApiDto {
        const json = this.toJSON();
        let result = new FlightSegmentApiDto();
        result.init(json);
        return result;
    }
}

/** A single flight segment (one take-off and landing) within an offer. */
export interface IFlightSegmentApiDto {
    /** Airline flight number. Example: `QF401`. */
    flightNumber: string | undefined;
    /** IATA code of the marketing carrier. */
    carrierCode: string | undefined;
    /** Full name of the marketing carrier. */
    carrierName: string | undefined;
    /** IATA code of the departure airport. */
    departureAirport: string | undefined;
    /** IATA code of the arrival airport. */
    arrivalAirport: string | undefined;
    /** Departure terminal identifier, if available. */
    departureTerminal: string | undefined;
    /** Arrival terminal identifier, if available. */
    arrivalTerminal: string | undefined;
    /** Scheduled departure date and time (local to departure airport). */
    departureDateTime: moment.Moment;
    /** Scheduled arrival date and time (local to arrival airport). */
    arrivalDateTime: moment.Moment;
    /** Total flight duration in minutes. */
    durationMinutes: number;
    /** ICAO aircraft type code. Example: `B738`, `A320`. */
    aircraftType: string | undefined;
    /** Number of technical stops (not counting layovers between segments). */
    stopsCount: number;
    /** IATA codes of stop airports, if any. */
    stopAirports: string[] | undefined;
}

export class FooterDto implements IFooterDto {
    companyName: string | undefined;
    description: string | undefined;
    address: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    message: string | undefined;
    subscribeText: string | undefined;
    emailPlaceholder: string | undefined;
    copyrightText: string | undefined;
    socialMediaLinks: SocialMediaLinkDto[] | undefined;
    footerLinks: FooterLinkDto[] | undefined;

    constructor(data?: IFooterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.description = _data["description"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.message = _data["message"];
            this.subscribeText = _data["subscribeText"];
            this.emailPlaceholder = _data["emailPlaceholder"];
            this.copyrightText = _data["copyrightText"];
            if (Array.isArray(_data["socialMediaLinks"])) {
                this.socialMediaLinks = [] as any;
                for (let item of _data["socialMediaLinks"])
                    this.socialMediaLinks.push(SocialMediaLinkDto.fromJS(item));
            }
            if (Array.isArray(_data["footerLinks"])) {
                this.footerLinks = [] as any;
                for (let item of _data["footerLinks"])
                    this.footerLinks.push(FooterLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FooterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FooterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["description"] = this.description;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["message"] = this.message;
        data["subscribeText"] = this.subscribeText;
        data["emailPlaceholder"] = this.emailPlaceholder;
        data["copyrightText"] = this.copyrightText;
        if (Array.isArray(this.socialMediaLinks)) {
            data["socialMediaLinks"] = [];
            for (let item of this.socialMediaLinks)
                data["socialMediaLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.footerLinks)) {
            data["footerLinks"] = [];
            for (let item of this.footerLinks)
                data["footerLinks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): FooterDto {
        const json = this.toJSON();
        let result = new FooterDto();
        result.init(json);
        return result;
    }
}

export interface IFooterDto {
    companyName: string | undefined;
    description: string | undefined;
    address: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    message: string | undefined;
    subscribeText: string | undefined;
    emailPlaceholder: string | undefined;
    copyrightText: string | undefined;
    socialMediaLinks: SocialMediaLinkDto[] | undefined;
    footerLinks: FooterLinkDto[] | undefined;
}

export class FooterLinkDto implements IFooterLinkDto {
    id: string | undefined;
    title: string | undefined;
    url: string | undefined;
    order: number;

    constructor(data?: IFooterLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.url = _data["url"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): FooterLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new FooterLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["url"] = this.url;
        data["order"] = this.order;
        return data;
    }

    clone(): FooterLinkDto {
        const json = this.toJSON();
        let result = new FooterLinkDto();
        result.init(json);
        return result;
    }
}

export interface IFooterLinkDto {
    id: string | undefined;
    title: string | undefined;
    url: string | undefined;
    order: number;
}

export class GalleryImageDto implements IGalleryImageDto {
    imageFile: FileDto;
    description: string | undefined;
    altText: string | undefined;
    order: number;

    constructor(data?: IGalleryImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageFile = _data["imageFile"] ? FileDto.fromJS(_data["imageFile"]) : undefined as any;
            this.description = _data["description"];
            this.altText = _data["altText"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): GalleryImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageFile"] = this.imageFile ? this.imageFile.toJSON() : undefined as any;
        data["description"] = this.description;
        data["altText"] = this.altText;
        data["order"] = this.order;
        return data;
    }

    clone(): GalleryImageDto {
        const json = this.toJSON();
        let result = new GalleryImageDto();
        result.init(json);
        return result;
    }
}

export interface IGalleryImageDto {
    imageFile: FileDto;
    description: string | undefined;
    altText: string | undefined;
    order: number;
}

export class GalleryItemDto implements IGalleryItemDto {
    imageUrl: string | undefined;
    description: string | undefined;
    altText: string | undefined;
    order: number;

    constructor(data?: IGalleryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"];
            this.description = _data["description"];
            this.altText = _data["altText"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): GalleryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        data["description"] = this.description;
        data["altText"] = this.altText;
        data["order"] = this.order;
        return data;
    }

    clone(): GalleryItemDto {
        const json = this.toJSON();
        let result = new GalleryItemDto();
        result.init(json);
        return result;
    }
}

export interface IGalleryItemDto {
    imageUrl: string | undefined;
    description: string | undefined;
    altText: string | undefined;
    order: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    accessToken: string | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : undefined as any;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : undefined as any;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : undefined as any;
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        data["accessToken"] = this.accessToken;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    accessToken: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: GroupedPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : undefined as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(GroupedPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: GroupedPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GlobalSettingsContentDto implements IGlobalSettingsContentDto {
    termsOfService: TermsOfServiceDto;
    legalTerms: LegalTermsDto;
    externalLinks: ExternalLinksDto;
    aboutTheBusiness: AboutTheBusinessDto;

    constructor(data?: IGlobalSettingsContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termsOfService = _data["termsOfService"] ? TermsOfServiceDto.fromJS(_data["termsOfService"]) : undefined as any;
            this.legalTerms = _data["legalTerms"] ? LegalTermsDto.fromJS(_data["legalTerms"]) : undefined as any;
            this.externalLinks = _data["externalLinks"] ? ExternalLinksDto.fromJS(_data["externalLinks"]) : undefined as any;
            this.aboutTheBusiness = _data["aboutTheBusiness"] ? AboutTheBusinessDto.fromJS(_data["aboutTheBusiness"]) : undefined as any;
        }
    }

    static fromJS(data: any): GlobalSettingsContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSettingsContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termsOfService"] = this.termsOfService ? this.termsOfService.toJSON() : undefined as any;
        data["legalTerms"] = this.legalTerms ? this.legalTerms.toJSON() : undefined as any;
        data["externalLinks"] = this.externalLinks ? this.externalLinks.toJSON() : undefined as any;
        data["aboutTheBusiness"] = this.aboutTheBusiness ? this.aboutTheBusiness.toJSON() : undefined as any;
        return data;
    }

    clone(): GlobalSettingsContentDto {
        const json = this.toJSON();
        let result = new GlobalSettingsContentDto();
        result.init(json);
        return result;
    }
}

export interface IGlobalSettingsContentDto {
    termsOfService: TermsOfServiceDto;
    legalTerms: LegalTermsDto;
    externalLinks: ExternalLinksDto;
    aboutTheBusiness: AboutTheBusinessDto;
}

export class GlobalSettingsPageDto implements IGlobalSettingsPageDto {
    id: string;
    pageName: string | undefined;
    pageTitle: string | undefined;
    pageDescription: string | undefined;
    pageType: string | undefined;
    contentJson: string | undefined;
    slug: string | undefined;
    isActive: boolean;
    sortOrder: number;
    metaTitle: string | undefined;
    metaDescription: string | undefined;
    metaKeywords: string | undefined;

    constructor(data?: IGlobalSettingsPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageName = _data["pageName"];
            this.pageTitle = _data["pageTitle"];
            this.pageDescription = _data["pageDescription"];
            this.pageType = _data["pageType"];
            this.contentJson = _data["contentJson"];
            this.slug = _data["slug"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
        }
    }

    static fromJS(data: any): GlobalSettingsPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSettingsPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageName"] = this.pageName;
        data["pageTitle"] = this.pageTitle;
        data["pageDescription"] = this.pageDescription;
        data["pageType"] = this.pageType;
        data["contentJson"] = this.contentJson;
        data["slug"] = this.slug;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        return data;
    }

    clone(): GlobalSettingsPageDto {
        const json = this.toJSON();
        let result = new GlobalSettingsPageDto();
        result.init(json);
        return result;
    }
}

export interface IGlobalSettingsPageDto {
    id: string;
    pageName: string | undefined;
    pageTitle: string | undefined;
    pageDescription: string | undefined;
    pageType: string | undefined;
    contentJson: string | undefined;
    slug: string | undefined;
    isActive: boolean;
    sortOrder: number;
    metaTitle: string | undefined;
    metaDescription: string | undefined;
    metaKeywords: string | undefined;
}

export class GroupedPermissionDto implements IGroupedPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    parent: GroupedPermissionDto;
    children: GroupedPermissionDto[] | undefined;

    constructor(data?: IGroupedPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.parent = _data["parent"] ? GroupedPermissionDto.fromJS(_data["parent"]) : undefined as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(GroupedPermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupedPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): GroupedPermissionDto {
        const json = this.toJSON();
        let result = new GroupedPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IGroupedPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    parent: GroupedPermissionDto;
    children: GroupedPermissionDto[] | undefined;
}

export class GroupedPermissionDtoListResultDto implements IGroupedPermissionDtoListResultDto {
    items: GroupedPermissionDto[] | undefined;

    constructor(data?: IGroupedPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GroupedPermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupedPermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedPermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): GroupedPermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new GroupedPermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IGroupedPermissionDtoListResultDto {
    items: GroupedPermissionDto[] | undefined;
}

export class GuestApiDto implements IGuestApiDto {
    title: string | undefined;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;

    constructor(data?: IGuestApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): GuestApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }

    clone(): GuestApiDto {
        const json = this.toJSON();
        let result = new GuestApiDto();
        result.init(json);
        return result;
    }
}

export interface IGuestApiDto {
    title: string | undefined;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}

/** DTO for guest checkout information */
export class GuestInfoDto implements IGuestInfoDto {
    name: string;
    surname: string;
    email: string;
    password: string;
    phoneNumber: string | undefined;

    constructor(data?: IGuestInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): GuestInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["password"] = this.password;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): GuestInfoDto {
        const json = this.toJSON();
        let result = new GuestInfoDto();
        result.init(json);
        return result;
    }
}

/** DTO for guest checkout information */
export interface IGuestInfoDto {
    name: string;
    surname: string;
    email: string;
    password: string;
    phoneNumber: string | undefined;
}

export class GuidEntityDto implements IGuidEntityDto {
    id: string;

    constructor(data?: IGuidEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GuidEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): GuidEntityDto {
        const json = this.toJSON();
        let result = new GuidEntityDto();
        result.init(json);
        return result;
    }
}

export interface IGuidEntityDto {
    id: string;
}

export class HeroBannerDto implements IHeroBannerDto {
    heading: string | undefined;
    subheading: string | undefined;
    backgroundImageUrl: string | undefined;
    searchPlaceholder: string | undefined;
    searchByLocation: string | undefined;
    featuredProduct: FeaturedProductDto;

    constructor(data?: IHeroBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.subheading = _data["subheading"];
            this.backgroundImageUrl = _data["backgroundImageUrl"];
            this.searchPlaceholder = _data["searchPlaceholder"];
            this.searchByLocation = _data["searchByLocation"];
            this.featuredProduct = _data["featuredProduct"] ? FeaturedProductDto.fromJS(_data["featuredProduct"]) : undefined as any;
        }
    }

    static fromJS(data: any): HeroBannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new HeroBannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["subheading"] = this.subheading;
        data["backgroundImageUrl"] = this.backgroundImageUrl;
        data["searchPlaceholder"] = this.searchPlaceholder;
        data["searchByLocation"] = this.searchByLocation;
        data["featuredProduct"] = this.featuredProduct ? this.featuredProduct.toJSON() : undefined as any;
        return data;
    }

    clone(): HeroBannerDto {
        const json = this.toJSON();
        let result = new HeroBannerDto();
        result.init(json);
        return result;
    }
}

export interface IHeroBannerDto {
    heading: string | undefined;
    subheading: string | undefined;
    backgroundImageUrl: string | undefined;
    searchPlaceholder: string | undefined;
    searchByLocation: string | undefined;
    featuredProduct: FeaturedProductDto;
}

export class HighlightTagDto implements IHighlightTagDto {
    id: string | undefined;
    text: string | undefined;
    iconUrl: string | undefined;
    order: number;

    constructor(data?: IHighlightTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.iconUrl = _data["iconUrl"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): HighlightTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new HighlightTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["iconUrl"] = this.iconUrl;
        data["order"] = this.order;
        return data;
    }

    clone(): HighlightTagDto {
        const json = this.toJSON();
        let result = new HighlightTagDto();
        result.init(json);
        return result;
    }
}

export interface IHighlightTagDto {
    id: string | undefined;
    text: string | undefined;
    iconUrl: string | undefined;
    order: number;
}

export class HotelBedsContentSyncItemDto implements IHotelBedsContentSyncItemDto {
    key: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    estimatedDuration: string | undefined;
    status: string | undefined;
    lastSyncCompletedAt: moment.Moment | undefined;
    lastSyncDurationMs: number | undefined;
    rowCount: number;
    lastError: string | undefined;
    isRunning: boolean;
    /** Human-readable progress for last sync (success, partial, or failed).
Example: "6978/7288 in DB · +5000 this run · 5 pages · 6 API requests · resumed @2001" */
    syncSummary: string | undefined;
    expectedTotal: number | undefined;
    rowsUpsertedThisRun: number | undefined;
    apiRequestsThisRun: number | undefined;
    pagesCompletedThisRun: number | undefined;
    resumedFromOffset: number | undefined;
    syncStrategyUsed: string | undefined;
    stoppedReason: string | undefined;
    /** locations | types | hotels — mirrors HotelBeds Content API docs. */
    groupKey: string | undefined;
    groupDisplayName: string | undefined;
    groupSortOrder: number;
    /** True for Hotels / Hotel Details placeholders (D3.1/D5) — sync disabled. */
    isDeferred: boolean;

    constructor(data?: IHotelBedsContentSyncItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.estimatedDuration = _data["estimatedDuration"];
            this.status = _data["status"];
            this.lastSyncCompletedAt = _data["lastSyncCompletedAt"] ? moment(_data["lastSyncCompletedAt"].toString()) : undefined as any;
            this.lastSyncDurationMs = _data["lastSyncDurationMs"];
            this.rowCount = _data["rowCount"];
            this.lastError = _data["lastError"];
            this.isRunning = _data["isRunning"];
            this.syncSummary = _data["syncSummary"];
            this.expectedTotal = _data["expectedTotal"];
            this.rowsUpsertedThisRun = _data["rowsUpsertedThisRun"];
            this.apiRequestsThisRun = _data["apiRequestsThisRun"];
            this.pagesCompletedThisRun = _data["pagesCompletedThisRun"];
            this.resumedFromOffset = _data["resumedFromOffset"];
            this.syncStrategyUsed = _data["syncStrategyUsed"];
            this.stoppedReason = _data["stoppedReason"];
            this.groupKey = _data["groupKey"];
            this.groupDisplayName = _data["groupDisplayName"];
            this.groupSortOrder = _data["groupSortOrder"];
            this.isDeferred = _data["isDeferred"];
        }
    }

    static fromJS(data: any): HotelBedsContentSyncItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotelBedsContentSyncItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["estimatedDuration"] = this.estimatedDuration;
        data["status"] = this.status;
        data["lastSyncCompletedAt"] = this.lastSyncCompletedAt ? this.lastSyncCompletedAt.toISOString() : undefined as any;
        data["lastSyncDurationMs"] = this.lastSyncDurationMs;
        data["rowCount"] = this.rowCount;
        data["lastError"] = this.lastError;
        data["isRunning"] = this.isRunning;
        data["syncSummary"] = this.syncSummary;
        data["expectedTotal"] = this.expectedTotal;
        data["rowsUpsertedThisRun"] = this.rowsUpsertedThisRun;
        data["apiRequestsThisRun"] = this.apiRequestsThisRun;
        data["pagesCompletedThisRun"] = this.pagesCompletedThisRun;
        data["resumedFromOffset"] = this.resumedFromOffset;
        data["syncStrategyUsed"] = this.syncStrategyUsed;
        data["stoppedReason"] = this.stoppedReason;
        data["groupKey"] = this.groupKey;
        data["groupDisplayName"] = this.groupDisplayName;
        data["groupSortOrder"] = this.groupSortOrder;
        data["isDeferred"] = this.isDeferred;
        return data;
    }

    clone(): HotelBedsContentSyncItemDto {
        const json = this.toJSON();
        let result = new HotelBedsContentSyncItemDto();
        result.init(json);
        return result;
    }
}

export interface IHotelBedsContentSyncItemDto {
    key: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    estimatedDuration: string | undefined;
    status: string | undefined;
    lastSyncCompletedAt: moment.Moment | undefined;
    lastSyncDurationMs: number | undefined;
    rowCount: number;
    lastError: string | undefined;
    isRunning: boolean;
    /** Human-readable progress for last sync (success, partial, or failed).
Example: "6978/7288 in DB · +5000 this run · 5 pages · 6 API requests · resumed @2001" */
    syncSummary: string | undefined;
    expectedTotal: number | undefined;
    rowsUpsertedThisRun: number | undefined;
    apiRequestsThisRun: number | undefined;
    pagesCompletedThisRun: number | undefined;
    resumedFromOffset: number | undefined;
    syncStrategyUsed: string | undefined;
    stoppedReason: string | undefined;
    /** locations | types | hotels — mirrors HotelBeds Content API docs. */
    groupKey: string | undefined;
    groupDisplayName: string | undefined;
    groupSortOrder: number;
    /** True for Hotels / Hotel Details placeholders (D3.1/D5) — sync disabled. */
    isDeferred: boolean;
}

export class HotelBedsContentSyncRunDto implements IHotelBedsContentSyncRunDto {
    id: string;
    catalogKey: string | undefined;
    status: HotelBedsContentSyncStatus;
    triggerType: HotelBedsContentSyncTriggerType;
    startedAt: moment.Moment;
    completedAt: moment.Moment | undefined;
    initiatedByUserId: number | undefined;
    stepsCompleted: number;
    stepsFailed: number;
    errorSummary: string | undefined;
    durationMs: number | undefined;
    stepResultsJson: string | undefined;

    constructor(data?: IHotelBedsContentSyncRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.catalogKey = _data["catalogKey"];
            this.status = _data["status"];
            this.triggerType = _data["triggerType"];
            this.startedAt = _data["startedAt"] ? moment(_data["startedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? moment(_data["completedAt"].toString()) : undefined as any;
            this.initiatedByUserId = _data["initiatedByUserId"];
            this.stepsCompleted = _data["stepsCompleted"];
            this.stepsFailed = _data["stepsFailed"];
            this.errorSummary = _data["errorSummary"];
            this.durationMs = _data["durationMs"];
            this.stepResultsJson = _data["stepResultsJson"];
        }
    }

    static fromJS(data: any): HotelBedsContentSyncRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotelBedsContentSyncRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["catalogKey"] = this.catalogKey;
        data["status"] = this.status;
        data["triggerType"] = this.triggerType;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["initiatedByUserId"] = this.initiatedByUserId;
        data["stepsCompleted"] = this.stepsCompleted;
        data["stepsFailed"] = this.stepsFailed;
        data["errorSummary"] = this.errorSummary;
        data["durationMs"] = this.durationMs;
        data["stepResultsJson"] = this.stepResultsJson;
        return data;
    }

    clone(): HotelBedsContentSyncRunDto {
        const json = this.toJSON();
        let result = new HotelBedsContentSyncRunDto();
        result.init(json);
        return result;
    }
}

export interface IHotelBedsContentSyncRunDto {
    id: string;
    catalogKey: string | undefined;
    status: HotelBedsContentSyncStatus;
    triggerType: HotelBedsContentSyncTriggerType;
    startedAt: moment.Moment;
    completedAt: moment.Moment | undefined;
    initiatedByUserId: number | undefined;
    stepsCompleted: number;
    stepsFailed: number;
    errorSummary: string | undefined;
    durationMs: number | undefined;
    stepResultsJson: string | undefined;
}

export class HotelBedsContentSyncRunDtoPagedResultDto implements IHotelBedsContentSyncRunDtoPagedResultDto {
    items: HotelBedsContentSyncRunDto[] | undefined;
    totalCount: number;

    constructor(data?: IHotelBedsContentSyncRunDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HotelBedsContentSyncRunDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HotelBedsContentSyncRunDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotelBedsContentSyncRunDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HotelBedsContentSyncRunDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HotelBedsContentSyncRunDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHotelBedsContentSyncRunDtoPagedResultDto {
    items: HotelBedsContentSyncRunDto[] | undefined;
    totalCount: number;
}

export class HotelBedsContentSyncSettingsDto implements IHotelBedsContentSyncSettingsDto {
    id: string;
    isAutoSyncEnabled: boolean;
    referenceDataSyncIntervalHours: number;
    lastSuccessfulFullSyncAt: moment.Moment | undefined;

    constructor(data?: IHotelBedsContentSyncSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isAutoSyncEnabled = _data["isAutoSyncEnabled"];
            this.referenceDataSyncIntervalHours = _data["referenceDataSyncIntervalHours"];
            this.lastSuccessfulFullSyncAt = _data["lastSuccessfulFullSyncAt"] ? moment(_data["lastSuccessfulFullSyncAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): HotelBedsContentSyncSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotelBedsContentSyncSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isAutoSyncEnabled"] = this.isAutoSyncEnabled;
        data["referenceDataSyncIntervalHours"] = this.referenceDataSyncIntervalHours;
        data["lastSuccessfulFullSyncAt"] = this.lastSuccessfulFullSyncAt ? this.lastSuccessfulFullSyncAt.toISOString() : undefined as any;
        return data;
    }

    clone(): HotelBedsContentSyncSettingsDto {
        const json = this.toJSON();
        let result = new HotelBedsContentSyncSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IHotelBedsContentSyncSettingsDto {
    id: string;
    isAutoSyncEnabled: boolean;
    referenceDataSyncIntervalHours: number;
    lastSuccessfulFullSyncAt: moment.Moment | undefined;
}

export enum HotelBedsContentSyncStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class HotelBedsContentSyncStatusDto implements IHotelBedsContentSyncStatusDto {
    isHealthy: boolean;
    isSyncRunning: boolean;
    items: HotelBedsContentSyncItemDto[] | undefined;
    healthCheck: HotelBedsHealthCheckDto;
    rateLimitInfo: RateLimitInfoDto;

    constructor(data?: IHotelBedsContentSyncStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isHealthy = _data["isHealthy"];
            this.isSyncRunning = _data["isSyncRunning"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HotelBedsContentSyncItemDto.fromJS(item));
            }
            this.healthCheck = _data["healthCheck"] ? HotelBedsHealthCheckDto.fromJS(_data["healthCheck"]) : undefined as any;
            this.rateLimitInfo = _data["rateLimitInfo"] ? RateLimitInfoDto.fromJS(_data["rateLimitInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): HotelBedsContentSyncStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotelBedsContentSyncStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHealthy"] = this.isHealthy;
        data["isSyncRunning"] = this.isSyncRunning;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["healthCheck"] = this.healthCheck ? this.healthCheck.toJSON() : undefined as any;
        data["rateLimitInfo"] = this.rateLimitInfo ? this.rateLimitInfo.toJSON() : undefined as any;
        return data;
    }

    clone(): HotelBedsContentSyncStatusDto {
        const json = this.toJSON();
        let result = new HotelBedsContentSyncStatusDto();
        result.init(json);
        return result;
    }
}

export interface IHotelBedsContentSyncStatusDto {
    isHealthy: boolean;
    isSyncRunning: boolean;
    items: HotelBedsContentSyncItemDto[] | undefined;
    healthCheck: HotelBedsHealthCheckDto;
    rateLimitInfo: RateLimitInfoDto;
}

export enum HotelBedsContentSyncTriggerType {
    _0 = 0,
    _1 = 1,
}

export class HotelBedsHealthCheckDto implements IHotelBedsHealthCheckDto {
    isHealthy: boolean;
    errorMessage: string | undefined;
    testedAt: moment.Moment;

    constructor(data?: IHotelBedsHealthCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isHealthy = _data["isHealthy"];
            this.errorMessage = _data["errorMessage"];
            this.testedAt = _data["testedAt"] ? moment(_data["testedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): HotelBedsHealthCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotelBedsHealthCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHealthy"] = this.isHealthy;
        data["errorMessage"] = this.errorMessage;
        data["testedAt"] = this.testedAt ? this.testedAt.toISOString() : undefined as any;
        return data;
    }

    clone(): HotelBedsHealthCheckDto {
        const json = this.toJSON();
        let result = new HotelBedsHealthCheckDto();
        result.init(json);
        return result;
    }
}

export interface IHotelBedsHealthCheckDto {
    isHealthy: boolean;
    errorMessage: string | undefined;
    testedAt: moment.Moment;
}

export class HotelBedsHotelContentInspectDto implements IHotelBedsHotelContentInspectDto {
    hotelCode: string | undefined;
    exists: boolean;
    detailsSyncedAt: moment.Moment | undefined;
    catalogSyncedAt: moment.Moment | undefined;
    imageCount: number;
    imagesWithRoomCode: number;
    resyncNeeded: boolean;
    resyncReasons: string[] | undefined;
    content: StayHotelContentDto;

    constructor(data?: IHotelBedsHotelContentInspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hotelCode = _data["hotelCode"];
            this.exists = _data["exists"];
            this.detailsSyncedAt = _data["detailsSyncedAt"] ? moment(_data["detailsSyncedAt"].toString()) : undefined as any;
            this.catalogSyncedAt = _data["catalogSyncedAt"] ? moment(_data["catalogSyncedAt"].toString()) : undefined as any;
            this.imageCount = _data["imageCount"];
            this.imagesWithRoomCode = _data["imagesWithRoomCode"];
            this.resyncNeeded = _data["resyncNeeded"];
            if (Array.isArray(_data["resyncReasons"])) {
                this.resyncReasons = [] as any;
                for (let item of _data["resyncReasons"])
                    this.resyncReasons.push(item);
            }
            this.content = _data["content"] ? StayHotelContentDto.fromJS(_data["content"]) : undefined as any;
        }
    }

    static fromJS(data: any): HotelBedsHotelContentInspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotelBedsHotelContentInspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hotelCode"] = this.hotelCode;
        data["exists"] = this.exists;
        data["detailsSyncedAt"] = this.detailsSyncedAt ? this.detailsSyncedAt.toISOString() : undefined as any;
        data["catalogSyncedAt"] = this.catalogSyncedAt ? this.catalogSyncedAt.toISOString() : undefined as any;
        data["imageCount"] = this.imageCount;
        data["imagesWithRoomCode"] = this.imagesWithRoomCode;
        data["resyncNeeded"] = this.resyncNeeded;
        if (Array.isArray(this.resyncReasons)) {
            data["resyncReasons"] = [];
            for (let item of this.resyncReasons)
                data["resyncReasons"].push(item);
        }
        data["content"] = this.content ? this.content.toJSON() : undefined as any;
        return data;
    }

    clone(): HotelBedsHotelContentInspectDto {
        const json = this.toJSON();
        let result = new HotelBedsHotelContentInspectDto();
        result.init(json);
        return result;
    }
}

export interface IHotelBedsHotelContentInspectDto {
    hotelCode: string | undefined;
    exists: boolean;
    detailsSyncedAt: moment.Moment | undefined;
    catalogSyncedAt: moment.Moment | undefined;
    imageCount: number;
    imagesWithRoomCode: number;
    resyncNeeded: boolean;
    resyncReasons: string[] | undefined;
    content: StayHotelContentDto;
}

export class ImageCardDto implements IImageCardDto {
    id: string | undefined;
    title: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    linkUrl: string | undefined;
    order: number;

    constructor(data?: IImageCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.linkUrl = _data["linkUrl"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): ImageCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["linkUrl"] = this.linkUrl;
        data["order"] = this.order;
        return data;
    }

    clone(): ImageCardDto {
        const json = this.toJSON();
        let result = new ImageCardDto();
        result.init(json);
        return result;
    }
}

export interface IImageCardDto {
    id: string | undefined;
    title: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    linkUrl: string | undefined;
    order: number;
}

export class ImageCardImageDto implements IImageCardImageDto {
    cardId: string | undefined;
    imageFile: FileDto;

    constructor(data?: IImageCardImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.imageFile = _data["imageFile"] ? FileDto.fromJS(_data["imageFile"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImageCardImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageCardImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["imageFile"] = this.imageFile ? this.imageFile.toJSON() : undefined as any;
        return data;
    }

    clone(): ImageCardImageDto {
        const json = this.toJSON();
        let result = new ImageCardImageDto();
        result.init(json);
        return result;
    }
}

export interface IImageCardImageDto {
    cardId: string | undefined;
    imageFile: FileDto;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class ItineraryDayDto implements IItineraryDayDto {
    day: number;
    title: string | undefined;
    description: string | undefined;
    activities: string[] | undefined;
    images: string[] | undefined;

    constructor(data?: IItineraryDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities.push(item);
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(item);
            }
        }
    }

    static fromJS(data: any): ItineraryDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItineraryDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        return data;
    }

    clone(): ItineraryDayDto {
        const json = this.toJSON();
        let result = new ItineraryDayDto();
        result.init(json);
        return result;
    }
}

export interface IItineraryDayDto {
    day: number;
    title: string | undefined;
    description: string | undefined;
    activities: string[] | undefined;
    images: string[] | undefined;
}

export class LegalTermsDto implements ILegalTermsDto {
    siteTermsAndConditions: string;
    refundPolicy: string;
    permitsAndCertifications: string;

    constructor(data?: ILegalTermsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteTermsAndConditions = _data["siteTermsAndConditions"];
            this.refundPolicy = _data["refundPolicy"];
            this.permitsAndCertifications = _data["permitsAndCertifications"];
        }
    }

    static fromJS(data: any): LegalTermsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegalTermsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteTermsAndConditions"] = this.siteTermsAndConditions;
        data["refundPolicy"] = this.refundPolicy;
        data["permitsAndCertifications"] = this.permitsAndCertifications;
        return data;
    }

    clone(): LegalTermsDto {
        const json = this.toJSON();
        let result = new LegalTermsDto();
        result.init(json);
        return result;
    }
}

export interface ILegalTermsDto {
    siteTermsAndConditions: string;
    refundPolicy: string;
    permitsAndCertifications: string;
}

export class MarkStayCancellationRefundCompletedInput implements IMarkStayCancellationRefundCompletedInput {
    notes: string | undefined;

    constructor(data?: IMarkStayCancellationRefundCompletedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): MarkStayCancellationRefundCompletedInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkStayCancellationRefundCompletedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notes"] = this.notes;
        return data;
    }

    clone(): MarkStayCancellationRefundCompletedInput {
        const json = this.toJSON();
        let result = new MarkStayCancellationRefundCompletedInput();
        result.init(json);
        return result;
    }
}

export interface IMarkStayCancellationRefundCompletedInput {
    notes: string | undefined;
}

export enum MarkupProductType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class MarkupRuleDto implements IMarkupRuleDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    supplierName: string | undefined;
    productType: MarkupProductType;
    cabinClass: string | undefined;
    destinationRegion: string | undefined;
    markupType: MarkupType;
    markupValue: number;
    priority: number;
    validFrom: moment.Moment | undefined;
    validTo: moment.Moment | undefined;
    isActive: boolean;
    creationTime: moment.Moment;

    constructor(data?: IMarkupRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.supplierName = _data["supplierName"];
            this.productType = _data["productType"];
            this.cabinClass = _data["cabinClass"];
            this.destinationRegion = _data["destinationRegion"];
            this.markupType = _data["markupType"];
            this.markupValue = _data["markupValue"];
            this.priority = _data["priority"];
            this.validFrom = _data["validFrom"] ? moment(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? moment(_data["validTo"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MarkupRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarkupRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["supplierName"] = this.supplierName;
        data["productType"] = this.productType;
        data["cabinClass"] = this.cabinClass;
        data["destinationRegion"] = this.destinationRegion;
        data["markupType"] = this.markupType;
        data["markupValue"] = this.markupValue;
        data["priority"] = this.priority;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): MarkupRuleDto {
        const json = this.toJSON();
        let result = new MarkupRuleDto();
        result.init(json);
        return result;
    }
}

export interface IMarkupRuleDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    supplierName: string | undefined;
    productType: MarkupProductType;
    cabinClass: string | undefined;
    destinationRegion: string | undefined;
    markupType: MarkupType;
    markupValue: number;
    priority: number;
    validFrom: moment.Moment | undefined;
    validTo: moment.Moment | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
}

export class MarkupRuleDtoPagedResultDto implements IMarkupRuleDtoPagedResultDto {
    items: MarkupRuleDto[] | undefined;
    totalCount: number;

    constructor(data?: IMarkupRuleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MarkupRuleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MarkupRuleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarkupRuleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MarkupRuleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MarkupRuleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMarkupRuleDtoPagedResultDto {
    items: MarkupRuleDto[] | undefined;
    totalCount: number;
}

export enum MarkupType {
    _1 = 1,
    _2 = 2,
}

export class MeetTeamBannerDto implements IMeetTeamBannerDto {
    heading: string | undefined;
    highlight: string | undefined;
    subheading: string | undefined;

    constructor(data?: IMeetTeamBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.highlight = _data["highlight"];
            this.subheading = _data["subheading"];
        }
    }

    static fromJS(data: any): MeetTeamBannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetTeamBannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["highlight"] = this.highlight;
        data["subheading"] = this.subheading;
        return data;
    }

    clone(): MeetTeamBannerDto {
        const json = this.toJSON();
        let result = new MeetTeamBannerDto();
        result.init(json);
        return result;
    }
}

export interface IMeetTeamBannerDto {
    heading: string | undefined;
    highlight: string | undefined;
    subheading: string | undefined;
}

export class MinBookingAttachmentDto implements IMinBookingAttachmentDto {
    id: string;
    description: string | undefined;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    typeId: string | undefined;
    creationTime: moment.Moment;
    type: AppSettingOptionDto;

    constructor(data?: IMinBookingAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocumentUrl = _data["attachDocumentUrl"];
            this.attachDocumentName = _data["attachDocumentName"];
            this.attachDocumentFileType = _data["attachDocumentFileType"];
            this.typeId = _data["typeId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
        }
    }

    static fromJS(data: any): MinBookingAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinBookingAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocumentUrl"] = this.attachDocumentUrl;
        data["attachDocumentName"] = this.attachDocumentName;
        data["attachDocumentFileType"] = this.attachDocumentFileType;
        data["typeId"] = this.typeId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        return data;
    }

    clone(): MinBookingAttachmentDto {
        const json = this.toJSON();
        let result = new MinBookingAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface IMinBookingAttachmentDto {
    id: string;
    description: string | undefined;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    typeId: string | undefined;
    creationTime: moment.Moment;
    type: AppSettingOptionDto;
}

export class MinBookingClientAddOnDto implements IMinBookingClientAddOnDto {
    id: string;
    type: AppSettingOptionDto;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;

    constructor(data?: IMinBookingClientAddOnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.note = _data["note"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): MinBookingClientAddOnDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinBookingClientAddOnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["note"] = this.note;
        data["price"] = this.price;
        return data;
    }

    clone(): MinBookingClientAddOnDto {
        const json = this.toJSON();
        let result = new MinBookingClientAddOnDto();
        result.init(json);
        return result;
    }
}

export interface IMinBookingClientAddOnDto {
    id: string;
    type: AppSettingOptionDto;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;
}

export class MinBookingClientDto implements IMinBookingClientDto {
    id: string;
    passenger: MinPassengerDto;
    type: AppSettingOptionDto;
    isPrimary: boolean;
    willAvailTravelInsurance: boolean;
    addOns: MinBookingClientAddOnDto[] | undefined;

    constructor(data?: IMinBookingClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.passenger = _data["passenger"] ? MinPassengerDto.fromJS(_data["passenger"]) : undefined as any;
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.isPrimary = _data["isPrimary"];
            this.willAvailTravelInsurance = _data["willAvailTravelInsurance"];
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns.push(MinBookingClientAddOnDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MinBookingClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinBookingClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["passenger"] = this.passenger ? this.passenger.toJSON() : undefined as any;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["isPrimary"] = this.isPrimary;
        data["willAvailTravelInsurance"] = this.willAvailTravelInsurance;
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MinBookingClientDto {
        const json = this.toJSON();
        let result = new MinBookingClientDto();
        result.init(json);
        return result;
    }
}

export interface IMinBookingClientDto {
    id: string;
    passenger: MinPassengerDto;
    type: AppSettingOptionDto;
    isPrimary: boolean;
    willAvailTravelInsurance: boolean;
    addOns: MinBookingClientAddOnDto[] | undefined;
}

export class MinPassengerDto implements IMinPassengerDto {
    id: string;
    name: string | undefined;
    surname: string | undefined;
    profilePictureDocumentId: string | undefined;
    profilePictureUrl: string | undefined;

    constructor(data?: IMinPassengerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureUrl = _data["profilePictureUrl"];
        }
    }

    static fromJS(data: any): MinPassengerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinPassengerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureUrl"] = this.profilePictureUrl;
        return data;
    }

    clone(): MinPassengerDto {
        const json = this.toJSON();
        let result = new MinPassengerDto();
        result.init(json);
        return result;
    }
}

export interface IMinPassengerDto {
    id: string;
    name: string | undefined;
    surname: string | undefined;
    profilePictureDocumentId: string | undefined;
    profilePictureUrl: string | undefined;
}

export class MinProcessedDocumentDto implements IMinProcessedDocumentDto {
    id: string;
    type: AppSettingOptionDto;
    note: string | undefined;

    constructor(data?: IMinProcessedDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): MinProcessedDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["note"] = this.note;
        return data;
    }

    clone(): MinProcessedDocumentDto {
        const json = this.toJSON();
        let result = new MinProcessedDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedDocumentDto {
    id: string;
    type: AppSettingOptionDto;
    note: string | undefined;
}

export class MinProcessedPackageAddOnDto implements IMinProcessedPackageAddOnDto {
    id: string;
    type: AppSettingOptionDto;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;

    constructor(data?: IMinProcessedPackageAddOnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.note = _data["note"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): MinProcessedPackageAddOnDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedPackageAddOnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["note"] = this.note;
        data["price"] = this.price;
        return data;
    }

    clone(): MinProcessedPackageAddOnDto {
        const json = this.toJSON();
        let result = new MinProcessedPackageAddOnDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedPackageAddOnDto {
    id: string;
    type: AppSettingOptionDto;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;
}

export class MinProcessedPackageDto implements IMinProcessedPackageDto {
    id: string;
    type: AppSettingOptionDto;
    isVisaRequired: boolean;
    packageId: string | undefined;
    package: PackageDto;
    agentId: string | undefined;
    resaAgentId: number | undefined;
    salesAgentId: number | undefined;
    resaAgent: UserMinDto;
    salesAgent: UserMinDto;
    agent: AgentDto;
    packageTravelId: string | undefined;
    packageTravel: PackageTravelDto;
    manualTravelDate: moment.Moment | undefined;
    manualPackageTitle: string | undefined;
    note: string | undefined;
    willAvailTravelInsurance: boolean;
    addOns: MinProcessedPackageAddOnDto[] | undefined;
    assignedRooms: MinProcessedPackageRoomDto[] | undefined;

    constructor(data?: IMinProcessedPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.isVisaRequired = _data["isVisaRequired"];
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? PackageDto.fromJS(_data["package"]) : undefined as any;
            this.agentId = _data["agentId"];
            this.resaAgentId = _data["resaAgentId"];
            this.salesAgentId = _data["salesAgentId"];
            this.resaAgent = _data["resaAgent"] ? UserMinDto.fromJS(_data["resaAgent"]) : undefined as any;
            this.salesAgent = _data["salesAgent"] ? UserMinDto.fromJS(_data["salesAgent"]) : undefined as any;
            this.agent = _data["agent"] ? AgentDto.fromJS(_data["agent"]) : undefined as any;
            this.packageTravelId = _data["packageTravelId"];
            this.packageTravel = _data["packageTravel"] ? PackageTravelDto.fromJS(_data["packageTravel"]) : undefined as any;
            this.manualTravelDate = _data["manualTravelDate"] ? moment(_data["manualTravelDate"].toString()) : undefined as any;
            this.manualPackageTitle = _data["manualPackageTitle"];
            this.note = _data["note"];
            this.willAvailTravelInsurance = _data["willAvailTravelInsurance"];
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns.push(MinProcessedPackageAddOnDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedRooms"])) {
                this.assignedRooms = [] as any;
                for (let item of _data["assignedRooms"])
                    this.assignedRooms.push(MinProcessedPackageRoomDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MinProcessedPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["isVisaRequired"] = this.isVisaRequired;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["agentId"] = this.agentId;
        data["resaAgentId"] = this.resaAgentId;
        data["salesAgentId"] = this.salesAgentId;
        data["resaAgent"] = this.resaAgent ? this.resaAgent.toJSON() : undefined as any;
        data["salesAgent"] = this.salesAgent ? this.salesAgent.toJSON() : undefined as any;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["packageTravelId"] = this.packageTravelId;
        data["packageTravel"] = this.packageTravel ? this.packageTravel.toJSON() : undefined as any;
        data["manualTravelDate"] = this.manualTravelDate ? this.manualTravelDate.toISOString() : undefined as any;
        data["manualPackageTitle"] = this.manualPackageTitle;
        data["note"] = this.note;
        data["willAvailTravelInsurance"] = this.willAvailTravelInsurance;
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignedRooms)) {
            data["assignedRooms"] = [];
            for (let item of this.assignedRooms)
                data["assignedRooms"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MinProcessedPackageDto {
        const json = this.toJSON();
        let result = new MinProcessedPackageDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedPackageDto {
    id: string;
    type: AppSettingOptionDto;
    isVisaRequired: boolean;
    packageId: string | undefined;
    package: PackageDto;
    agentId: string | undefined;
    resaAgentId: number | undefined;
    salesAgentId: number | undefined;
    resaAgent: UserMinDto;
    salesAgent: UserMinDto;
    agent: AgentDto;
    packageTravelId: string | undefined;
    packageTravel: PackageTravelDto;
    manualTravelDate: moment.Moment | undefined;
    manualPackageTitle: string | undefined;
    note: string | undefined;
    willAvailTravelInsurance: boolean;
    addOns: MinProcessedPackageAddOnDto[] | undefined;
    assignedRooms: MinProcessedPackageRoomDto[] | undefined;
}

export class MinProcessedPackageRoomDto implements IMinProcessedPackageRoomDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: IMinProcessedPackageRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.note = _data["note"];
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocumentUrl = _data["attachDocumentUrl"];
            this.attachDocumentName = _data["attachDocumentName"];
            this.attachDocumentFileType = _data["attachDocumentFileType"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MinProcessedPackageRoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedPackageRoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["note"] = this.note;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocumentUrl"] = this.attachDocumentUrl;
        data["attachDocumentName"] = this.attachDocumentName;
        data["attachDocumentFileType"] = this.attachDocumentFileType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): MinProcessedPackageRoomDto {
        const json = this.toJSON();
        let result = new MinProcessedPackageRoomDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedPackageRoomDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    creationTime: moment.Moment;
}

export class MinProcessedTicketDto implements IMinProcessedTicketDto {
    id: string;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    adultCount: number;
    childCount: number;
    infantCount: number;
    note: string | undefined;
    flights: MinProcessedTicketFlightDto[] | undefined;
    rates: MinProcessedTicketRateDto[] | undefined;

    constructor(data?: IMinProcessedTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.status = _data["status"] ? AppSettingOptionDto.fromJS(_data["status"]) : undefined as any;
            this.adultCount = _data["adultCount"];
            this.childCount = _data["childCount"];
            this.infantCount = _data["infantCount"];
            this.note = _data["note"];
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights.push(MinProcessedTicketFlightDto.fromJS(item));
            }
            if (Array.isArray(_data["rates"])) {
                this.rates = [] as any;
                for (let item of _data["rates"])
                    this.rates.push(MinProcessedTicketRateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MinProcessedTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["adultCount"] = this.adultCount;
        data["childCount"] = this.childCount;
        data["infantCount"] = this.infantCount;
        data["note"] = this.note;
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rates)) {
            data["rates"] = [];
            for (let item of this.rates)
                data["rates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MinProcessedTicketDto {
        const json = this.toJSON();
        let result = new MinProcessedTicketDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedTicketDto {
    id: string;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    adultCount: number;
    childCount: number;
    infantCount: number;
    note: string | undefined;
    flights: MinProcessedTicketFlightDto[] | undefined;
    rates: MinProcessedTicketRateDto[] | undefined;
}

export class MinProcessedTicketFlightDetailsDto implements IMinProcessedTicketFlightDetailsDto {
    id: string;
    type: AppSettingOptionDto;
    name: string | undefined;
    requirements: MinProcessedVisaRequirementDto[] | undefined;

    constructor(data?: IMinProcessedTicketFlightDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.name = _data["name"];
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements.push(MinProcessedVisaRequirementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MinProcessedTicketFlightDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedTicketFlightDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["name"] = this.name;
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MinProcessedTicketFlightDetailsDto {
        const json = this.toJSON();
        let result = new MinProcessedTicketFlightDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedTicketFlightDetailsDto {
    id: string;
    type: AppSettingOptionDto;
    name: string | undefined;
    requirements: MinProcessedVisaRequirementDto[] | undefined;
}

export class MinProcessedTicketFlightDto implements IMinProcessedTicketFlightDto {
    id: string;
    type: AppSettingOptionDto;
    name: string | undefined;
    flightDetails: MinProcessedTicketFlightDetailsDto[] | undefined;

    constructor(data?: IMinProcessedTicketFlightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.name = _data["name"];
            if (Array.isArray(_data["flightDetails"])) {
                this.flightDetails = [] as any;
                for (let item of _data["flightDetails"])
                    this.flightDetails.push(MinProcessedTicketFlightDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MinProcessedTicketFlightDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedTicketFlightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["name"] = this.name;
        if (Array.isArray(this.flightDetails)) {
            data["flightDetails"] = [];
            for (let item of this.flightDetails)
                data["flightDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MinProcessedTicketFlightDto {
        const json = this.toJSON();
        let result = new MinProcessedTicketFlightDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedTicketFlightDto {
    id: string;
    type: AppSettingOptionDto;
    name: string | undefined;
    flightDetails: MinProcessedTicketFlightDetailsDto[] | undefined;
}

export class MinProcessedTicketRateAddOnDto implements IMinProcessedTicketRateAddOnDto {
    id: string;
    type: AppSettingOptionDto;
    name: string | undefined;
    description: string | undefined;
    price: number | undefined;

    constructor(data?: IMinProcessedTicketRateAddOnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): MinProcessedTicketRateAddOnDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedTicketRateAddOnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        return data;
    }

    clone(): MinProcessedTicketRateAddOnDto {
        const json = this.toJSON();
        let result = new MinProcessedTicketRateAddOnDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedTicketRateAddOnDto {
    id: string;
    type: AppSettingOptionDto;
    name: string | undefined;
    description: string | undefined;
    price: number | undefined;
}

export class MinProcessedTicketRateDto implements IMinProcessedTicketRateDto {
    id: string;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    note: string | undefined;
    pricePerPax: number;
    totalPrice: number;
    addOns: MinProcessedTicketRateAddOnDto[] | undefined;

    constructor(data?: IMinProcessedTicketRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.status = _data["status"] ? AppSettingOptionDto.fromJS(_data["status"]) : undefined as any;
            this.note = _data["note"];
            this.pricePerPax = _data["pricePerPax"];
            this.totalPrice = _data["totalPrice"];
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns.push(MinProcessedTicketRateAddOnDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MinProcessedTicketRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedTicketRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["note"] = this.note;
        data["pricePerPax"] = this.pricePerPax;
        data["totalPrice"] = this.totalPrice;
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MinProcessedTicketRateDto {
        const json = this.toJSON();
        let result = new MinProcessedTicketRateDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedTicketRateDto {
    id: string;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    note: string | undefined;
    pricePerPax: number;
    totalPrice: number;
    addOns: MinProcessedTicketRateAddOnDto[] | undefined;
}

export class MinProcessedVisaDto implements IMinProcessedVisaDto {
    id: string;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    embassy: AppSettingOptionDto;
    requirements: MinProcessedVisaRequirementDto[] | undefined;
    statusAttachments: MinProcessedVisaStatusDto[] | undefined;
    note: string | undefined;

    constructor(data?: IMinProcessedVisaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.status = _data["status"] ? AppSettingOptionDto.fromJS(_data["status"]) : undefined as any;
            this.embassy = _data["embassy"] ? AppSettingOptionDto.fromJS(_data["embassy"]) : undefined as any;
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements.push(MinProcessedVisaRequirementDto.fromJS(item));
            }
            if (Array.isArray(_data["statusAttachments"])) {
                this.statusAttachments = [] as any;
                for (let item of _data["statusAttachments"])
                    this.statusAttachments.push(MinProcessedVisaStatusDto.fromJS(item));
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): MinProcessedVisaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedVisaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["embassy"] = this.embassy ? this.embassy.toJSON() : undefined as any;
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.statusAttachments)) {
            data["statusAttachments"] = [];
            for (let item of this.statusAttachments)
                data["statusAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["note"] = this.note;
        return data;
    }

    clone(): MinProcessedVisaDto {
        const json = this.toJSON();
        let result = new MinProcessedVisaDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedVisaDto {
    id: string;
    type: AppSettingOptionDto;
    status: AppSettingOptionDto;
    embassy: AppSettingOptionDto;
    requirements: MinProcessedVisaRequirementDto[] | undefined;
    statusAttachments: MinProcessedVisaStatusDto[] | undefined;
    note: string | undefined;
}

export class MinProcessedVisaRequirementAttachmentDto implements IMinProcessedVisaRequirementAttachmentDto {
    id: string;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    creationTime: moment.Moment;
    size: number;

    constructor(data?: IMinProcessedVisaRequirementAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocumentUrl = _data["attachDocumentUrl"];
            this.attachDocumentName = _data["attachDocumentName"];
            this.attachDocumentFileType = _data["attachDocumentFileType"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): MinProcessedVisaRequirementAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedVisaRequirementAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocumentUrl"] = this.attachDocumentUrl;
        data["attachDocumentName"] = this.attachDocumentName;
        data["attachDocumentFileType"] = this.attachDocumentFileType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["size"] = this.size;
        return data;
    }

    clone(): MinProcessedVisaRequirementAttachmentDto {
        const json = this.toJSON();
        let result = new MinProcessedVisaRequirementAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedVisaRequirementAttachmentDto {
    id: string;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    creationTime: moment.Moment;
    size: number;
}

export class MinProcessedVisaRequirementDto implements IMinProcessedVisaRequirementDto {
    id: string;
    type: AppSettingOptionDto;
    isFulfilled: boolean;
    passengerId: string | undefined;
    attachments: MinProcessedVisaRequirementAttachmentDto[] | undefined;

    constructor(data?: IMinProcessedVisaRequirementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            this.isFulfilled = _data["isFulfilled"];
            this.passengerId = _data["passengerId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(MinProcessedVisaRequirementAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MinProcessedVisaRequirementDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedVisaRequirementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["isFulfilled"] = this.isFulfilled;
        data["passengerId"] = this.passengerId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MinProcessedVisaRequirementDto {
        const json = this.toJSON();
        let result = new MinProcessedVisaRequirementDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedVisaRequirementDto {
    id: string;
    type: AppSettingOptionDto;
    isFulfilled: boolean;
    passengerId: string | undefined;
    attachments: MinProcessedVisaRequirementAttachmentDto[] | undefined;
}

export class MinProcessedVisaStatusAttachmentDto implements IMinProcessedVisaStatusAttachmentDto {
    id: string;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    creationTime: moment.Moment;
    size: number;

    constructor(data?: IMinProcessedVisaStatusAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocumentUrl = _data["attachDocumentUrl"];
            this.attachDocumentName = _data["attachDocumentName"];
            this.attachDocumentFileType = _data["attachDocumentFileType"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): MinProcessedVisaStatusAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedVisaStatusAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocumentUrl"] = this.attachDocumentUrl;
        data["attachDocumentName"] = this.attachDocumentName;
        data["attachDocumentFileType"] = this.attachDocumentFileType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["size"] = this.size;
        return data;
    }

    clone(): MinProcessedVisaStatusAttachmentDto {
        const json = this.toJSON();
        let result = new MinProcessedVisaStatusAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedVisaStatusAttachmentDto {
    id: string;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    creationTime: moment.Moment;
    size: number;
}

export class MinProcessedVisaStatusDto implements IMinProcessedVisaStatusDto {
    id: string;
    type: AppSettingOptionDto;
    attachments: MinProcessedVisaStatusAttachmentDto[] | undefined;

    constructor(data?: IMinProcessedVisaStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? AppSettingOptionDto.fromJS(_data["type"]) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(MinProcessedVisaStatusAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MinProcessedVisaStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinProcessedVisaStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MinProcessedVisaStatusDto {
        const json = this.toJSON();
        let result = new MinProcessedVisaStatusDto();
        result.init(json);
        return result;
    }
}

export interface IMinProcessedVisaStatusDto {
    id: string;
    type: AppSettingOptionDto;
    attachments: MinProcessedVisaStatusAttachmentDto[] | undefined;
}

export class NetStatusDto implements INetStatusDto {
    connected: boolean;

    constructor(data?: INetStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connected = _data["connected"];
        }
    }

    static fromJS(data: any): NetStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new NetStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connected"] = this.connected;
        return data;
    }

    clone(): NetStatusDto {
        const json = this.toJSON();
        let result = new NetStatusDto();
        result.init(json);
        return result;
    }
}

export interface INetStatusDto {
    connected: boolean;
}

export class NewsletterSubscriberDto implements INewsletterSubscriberDto {
    id: string;
    email: string | undefined;
    isSubscribed: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: INewsletterSubscriberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.isSubscribed = _data["isSubscribed"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): NewsletterSubscriberDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsletterSubscriberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["isSubscribed"] = this.isSubscribed;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): NewsletterSubscriberDto {
        const json = this.toJSON();
        let result = new NewsletterSubscriberDto();
        result.init(json);
        return result;
    }
}

export interface INewsletterSubscriberDto {
    id: string;
    email: string | undefined;
    isSubscribed: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class NewsletterSubscriptionResult implements INewsletterSubscriptionResult {
    success: boolean;
    message: string | undefined;
    isNewSubscriber: boolean;

    constructor(data?: INewsletterSubscriptionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.isNewSubscriber = _data["isNewSubscriber"];
        }
    }

    static fromJS(data: any): NewsletterSubscriptionResult {
        data = typeof data === 'object' ? data : {};
        let result = new NewsletterSubscriptionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["isNewSubscriber"] = this.isNewSubscriber;
        return data;
    }

    clone(): NewsletterSubscriptionResult {
        const json = this.toJSON();
        let result = new NewsletterSubscriptionResult();
        result.init(json);
        return result;
    }
}

export interface INewsletterSubscriptionResult {
    success: boolean;
    message: string | undefined;
    isNewSubscriber: boolean;
}

export class NotificationDto implements INotificationDto {
    id: string;
    userId: string;
    entityType: string | undefined;
    entityId: string;
    type: NotificationType;
    notificationDate: moment.Moment;
    message: string | undefined;
    isRead: boolean;
    jsonData: string | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.type = _data["type"];
            this.notificationDate = _data["notificationDate"] ? moment(_data["notificationDate"].toString()) : undefined as any;
            this.message = _data["message"];
            this.isRead = _data["isRead"];
            this.jsonData = _data["jsonData"];
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["type"] = this.type;
        data["notificationDate"] = this.notificationDate ? this.notificationDate.toISOString() : undefined as any;
        data["message"] = this.message;
        data["isRead"] = this.isRead;
        data["jsonData"] = this.jsonData;
        return data;
    }

    clone(): NotificationDto {
        const json = this.toJSON();
        let result = new NotificationDto();
        result.init(json);
        return result;
    }
}

export interface INotificationDto {
    id: string;
    userId: string;
    entityType: string | undefined;
    entityId: string;
    type: NotificationType;
    notificationDate: moment.Moment;
    message: string | undefined;
    isRead: boolean;
    jsonData: string | undefined;
}

export enum NotificationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OfficeLocationDto implements IOfficeLocationDto {
    id: string | undefined;
    name: string | undefined;
    address: string | undefined;
    latitude: number;
    longitude: number;
    isActive: boolean;
    sortOrder: number;

    constructor(data?: IOfficeLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): OfficeLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        return data;
    }

    clone(): OfficeLocationDto {
        const json = this.toJSON();
        let result = new OfficeLocationDto();
        result.init(json);
        return result;
    }
}

export interface IOfficeLocationDto {
    id: string | undefined;
    name: string | undefined;
    address: string | undefined;
    latitude: number;
    longitude: number;
    isActive: boolean;
    sortOrder: number;
}

export class OurStoryDto implements IOurStoryDto {
    heading: string | undefined;
    content: string | undefined;
    modules: StoryModuleDto[] | undefined;

    constructor(data?: IOurStoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.content = _data["content"];
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules.push(StoryModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OurStoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OurStoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["content"] = this.content;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): OurStoryDto {
        const json = this.toJSON();
        let result = new OurStoryDto();
        result.init(json);
        return result;
    }
}

export interface IOurStoryDto {
    heading: string | undefined;
    content: string | undefined;
    modules: StoryModuleDto[] | undefined;
}

export class OurTeamDto implements IOurTeamDto {
    heading: string | undefined;
    subheading: string | undefined;
    ourTeamMembers: TeamMemberDto[] | undefined;
    teamGridMembers: TeamMemberDto[] | undefined;

    constructor(data?: IOurTeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.subheading = _data["subheading"];
            if (Array.isArray(_data["ourTeamMembers"])) {
                this.ourTeamMembers = [] as any;
                for (let item of _data["ourTeamMembers"])
                    this.ourTeamMembers.push(TeamMemberDto.fromJS(item));
            }
            if (Array.isArray(_data["teamGridMembers"])) {
                this.teamGridMembers = [] as any;
                for (let item of _data["teamGridMembers"])
                    this.teamGridMembers.push(TeamMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OurTeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new OurTeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["subheading"] = this.subheading;
        if (Array.isArray(this.ourTeamMembers)) {
            data["ourTeamMembers"] = [];
            for (let item of this.ourTeamMembers)
                data["ourTeamMembers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.teamGridMembers)) {
            data["teamGridMembers"] = [];
            for (let item of this.teamGridMembers)
                data["teamGridMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): OurTeamDto {
        const json = this.toJSON();
        let result = new OurTeamDto();
        result.init(json);
        return result;
    }
}

export interface IOurTeamDto {
    heading: string | undefined;
    subheading: string | undefined;
    ourTeamMembers: TeamMemberDto[] | undefined;
    teamGridMembers: TeamMemberDto[] | undefined;
}

export class OverviewDto implements IOverviewDto {
    thisWeek: WeekDataDto;
    previousWeek: WeekDataDto;

    constructor(data?: IOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thisWeek = _data["thisWeek"] ? WeekDataDto.fromJS(_data["thisWeek"]) : undefined as any;
            this.previousWeek = _data["previousWeek"] ? WeekDataDto.fromJS(_data["previousWeek"]) : undefined as any;
        }
    }

    static fromJS(data: any): OverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thisWeek"] = this.thisWeek ? this.thisWeek.toJSON() : undefined as any;
        data["previousWeek"] = this.previousWeek ? this.previousWeek.toJSON() : undefined as any;
        return data;
    }

    clone(): OverviewDto {
        const json = this.toJSON();
        let result = new OverviewDto();
        result.init(json);
        return result;
    }
}

export interface IOverviewDto {
    thisWeek: WeekDataDto;
    previousWeek: WeekDataDto;
}

export class Package implements IPackage {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    type: PackageType;
    packageTypeNote: string | undefined;
    title: string | undefined;
    deletionReason: string | undefined;
    details: string | undefined;
    shortOverview: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    isPublished: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocument: Document;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocument: Document;
    travels: PackageTravel[] | undefined;
    images: PackageImage[] | undefined;
    price: number;
    tourPackageTypeId: string | undefined;
    tourPackageType: AppSettingOption;
    continentId: string | undefined;
    continent: AppSettingOption;
    days: number;
    nights: number;
    endPoint: string | undefined;
    rating: number;
    withFlights: boolean;
    sale: string | undefined;
    description: string | undefined;
    reviewCount: number;
    currency: string | undefined;
    basePrice: number;
    startPoint: string | undefined;
    placeCovered: string | undefined;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    minTravelers: number;
    maxTravelers: number;
    tourInfo: PackageTourInfo[] | undefined;
    highlights: PackageHighlight[] | undefined;
    inclusions: PackageInclusion[] | undefined;
    exclusions: PackageExclusion[] | undefined;
    cancellationPolicies: PackageCancellationPolicy[] | undefined;
    itinerary: PackageItinerary[] | undefined;
    holidayTypes: PackageHolidayType[] | undefined;

    constructor(data?: IPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.type = _data["type"];
            this.packageTypeNote = _data["packageTypeNote"];
            this.title = _data["title"];
            this.deletionReason = _data["deletionReason"];
            this.details = _data["details"];
            this.shortOverview = _data["shortOverview"];
            this.note = _data["note"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.isPublished = _data["isPublished"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureDocument = _data["profilePictureDocument"] ? Document.fromJS(_data["profilePictureDocument"]) : undefined as any;
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.coverPhotoDocument = _data["coverPhotoDocument"] ? Document.fromJS(_data["coverPhotoDocument"]) : undefined as any;
            if (Array.isArray(_data["travels"])) {
                this.travels = [] as any;
                for (let item of _data["travels"])
                    this.travels.push(PackageTravel.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(PackageImage.fromJS(item));
            }
            this.price = _data["price"];
            this.tourPackageTypeId = _data["tourPackageTypeId"];
            this.tourPackageType = _data["tourPackageType"] ? AppSettingOption.fromJS(_data["tourPackageType"]) : undefined as any;
            this.continentId = _data["continentId"];
            this.continent = _data["continent"] ? AppSettingOption.fromJS(_data["continent"]) : undefined as any;
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.endPoint = _data["endPoint"];
            this.rating = _data["rating"];
            this.withFlights = _data["withFlights"];
            this.sale = _data["sale"];
            this.description = _data["description"];
            this.reviewCount = _data["reviewCount"];
            this.currency = _data["currency"];
            this.basePrice = _data["basePrice"];
            this.startPoint = _data["startPoint"];
            this.placeCovered = _data["placeCovered"];
            this.availableFrom = _data["availableFrom"] ? moment(_data["availableFrom"].toString()) : undefined as any;
            this.availableTo = _data["availableTo"] ? moment(_data["availableTo"].toString()) : undefined as any;
            this.minTravelers = _data["minTravelers"];
            this.maxTravelers = _data["maxTravelers"];
            if (Array.isArray(_data["tourInfo"])) {
                this.tourInfo = [] as any;
                for (let item of _data["tourInfo"])
                    this.tourInfo.push(PackageTourInfo.fromJS(item));
            }
            if (Array.isArray(_data["highlights"])) {
                this.highlights = [] as any;
                for (let item of _data["highlights"])
                    this.highlights.push(PackageHighlight.fromJS(item));
            }
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions.push(PackageInclusion.fromJS(item));
            }
            if (Array.isArray(_data["exclusions"])) {
                this.exclusions = [] as any;
                for (let item of _data["exclusions"])
                    this.exclusions.push(PackageExclusion.fromJS(item));
            }
            if (Array.isArray(_data["cancellationPolicies"])) {
                this.cancellationPolicies = [] as any;
                for (let item of _data["cancellationPolicies"])
                    this.cancellationPolicies.push(PackageCancellationPolicy.fromJS(item));
            }
            if (Array.isArray(_data["itinerary"])) {
                this.itinerary = [] as any;
                for (let item of _data["itinerary"])
                    this.itinerary.push(PackageItinerary.fromJS(item));
            }
            if (Array.isArray(_data["holidayTypes"])) {
                this.holidayTypes = [] as any;
                for (let item of _data["holidayTypes"])
                    this.holidayTypes.push(PackageHolidayType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Package {
        data = typeof data === 'object' ? data : {};
        let result = new Package();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["type"] = this.type;
        data["packageTypeNote"] = this.packageTypeNote;
        data["title"] = this.title;
        data["deletionReason"] = this.deletionReason;
        data["details"] = this.details;
        data["shortOverview"] = this.shortOverview;
        data["note"] = this.note;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["isPublished"] = this.isPublished;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureDocument"] = this.profilePictureDocument ? this.profilePictureDocument.toJSON() : undefined as any;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["coverPhotoDocument"] = this.coverPhotoDocument ? this.coverPhotoDocument.toJSON() : undefined as any;
        if (Array.isArray(this.travels)) {
            data["travels"] = [];
            for (let item of this.travels)
                data["travels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["price"] = this.price;
        data["tourPackageTypeId"] = this.tourPackageTypeId;
        data["tourPackageType"] = this.tourPackageType ? this.tourPackageType.toJSON() : undefined as any;
        data["continentId"] = this.continentId;
        data["continent"] = this.continent ? this.continent.toJSON() : undefined as any;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["endPoint"] = this.endPoint;
        data["rating"] = this.rating;
        data["withFlights"] = this.withFlights;
        data["sale"] = this.sale;
        data["description"] = this.description;
        data["reviewCount"] = this.reviewCount;
        data["currency"] = this.currency;
        data["basePrice"] = this.basePrice;
        data["startPoint"] = this.startPoint;
        data["placeCovered"] = this.placeCovered;
        data["availableFrom"] = this.availableFrom ? this.availableFrom.toISOString() : undefined as any;
        data["availableTo"] = this.availableTo ? this.availableTo.toISOString() : undefined as any;
        data["minTravelers"] = this.minTravelers;
        data["maxTravelers"] = this.maxTravelers;
        if (Array.isArray(this.tourInfo)) {
            data["tourInfo"] = [];
            for (let item of this.tourInfo)
                data["tourInfo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.highlights)) {
            data["highlights"] = [];
            for (let item of this.highlights)
                data["highlights"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exclusions)) {
            data["exclusions"] = [];
            for (let item of this.exclusions)
                data["exclusions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cancellationPolicies)) {
            data["cancellationPolicies"] = [];
            for (let item of this.cancellationPolicies)
                data["cancellationPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.itinerary)) {
            data["itinerary"] = [];
            for (let item of this.itinerary)
                data["itinerary"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.holidayTypes)) {
            data["holidayTypes"] = [];
            for (let item of this.holidayTypes)
                data["holidayTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Package {
        const json = this.toJSON();
        let result = new Package();
        result.init(json);
        return result;
    }
}

export interface IPackage {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    type: PackageType;
    packageTypeNote: string | undefined;
    title: string | undefined;
    deletionReason: string | undefined;
    details: string | undefined;
    shortOverview: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    isPublished: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocument: Document;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocument: Document;
    travels: PackageTravel[] | undefined;
    images: PackageImage[] | undefined;
    price: number;
    tourPackageTypeId: string | undefined;
    tourPackageType: AppSettingOption;
    continentId: string | undefined;
    continent: AppSettingOption;
    days: number;
    nights: number;
    endPoint: string | undefined;
    rating: number;
    withFlights: boolean;
    sale: string | undefined;
    description: string | undefined;
    reviewCount: number;
    currency: string | undefined;
    basePrice: number;
    startPoint: string | undefined;
    placeCovered: string | undefined;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    minTravelers: number;
    maxTravelers: number;
    tourInfo: PackageTourInfo[] | undefined;
    highlights: PackageHighlight[] | undefined;
    inclusions: PackageInclusion[] | undefined;
    exclusions: PackageExclusion[] | undefined;
    cancellationPolicies: PackageCancellationPolicy[] | undefined;
    itinerary: PackageItinerary[] | undefined;
    holidayTypes: PackageHolidayType[] | undefined;
}

export class PackageCancellationPolicy implements IPackageCancellationPolicy {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    type: string | undefined;
    refund: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageCancellationPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined as any;
            this.type = _data["type"];
            this.refund = _data["refund"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageCancellationPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new PackageCancellationPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["type"] = this.type;
        data["refund"] = this.refund;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageCancellationPolicy {
        const json = this.toJSON();
        let result = new PackageCancellationPolicy();
        result.init(json);
        return result;
    }
}

export interface IPackageCancellationPolicy {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    type: string | undefined;
    refund: string | undefined;
    displayOrder: number;
}

export class PackageCancellationPolicyDto implements IPackageCancellationPolicyDto {
    id: string;
    packageId: string;
    type: string | undefined;
    refund: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageCancellationPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.type = _data["type"];
            this.refund = _data["refund"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageCancellationPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageCancellationPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["type"] = this.type;
        data["refund"] = this.refund;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageCancellationPolicyDto {
        const json = this.toJSON();
        let result = new PackageCancellationPolicyDto();
        result.init(json);
        return result;
    }
}

export interface IPackageCancellationPolicyDto {
    id: string;
    packageId: string;
    type: string | undefined;
    refund: string | undefined;
    displayOrder: number;
}

export class PackageDto implements IPackageDto {
    id: string;
    type: PackageType;
    packageTypeNote: string | undefined;
    title: string | undefined;
    details: string | undefined;
    shortOverview: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    isPublished: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    travels: PackageTravelDto[] | undefined;
    images: PackageImageDto[] | undefined;
    price: number;
    tourPackageTypeId: string | undefined;
    tourPackageType: AppSettingOptionDto;
    continentId: string | undefined;
    continent: AppSettingOptionDto;
    days: number;
    nights: number;
    rating: number;
    withFlights: boolean;
    endPoint: string | undefined;
    sale: string | undefined;
    description: string | undefined;
    reviewCount: number;
    currency: string | undefined;
    basePrice: number;
    startPoint: string | undefined;
    placeCovered: string | undefined;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    minTravelers: number;
    maxTravelers: number;
    creationTime: moment.Moment;
    tourInfo: PackageTourInfoDto[] | undefined;
    highlights: PackageHighlightDto[] | undefined;
    inclusions: PackageInclusionDto[] | undefined;
    exclusions: PackageExclusionDto[] | undefined;
    cancellationPolicies: PackageCancellationPolicyDto[] | undefined;
    itinerary: PackageItineraryDto[] | undefined;
    holidayTypes: PackageHolidayTypeDto[] | undefined;

    constructor(data?: IPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.packageTypeNote = _data["packageTypeNote"];
            this.title = _data["title"];
            this.details = _data["details"];
            this.shortOverview = _data["shortOverview"];
            this.note = _data["note"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.isPublished = _data["isPublished"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureDocumentUrl = _data["profilePictureDocumentUrl"];
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.coverPhotoDocumentUrl = _data["coverPhotoDocumentUrl"];
            if (Array.isArray(_data["travels"])) {
                this.travels = [] as any;
                for (let item of _data["travels"])
                    this.travels.push(PackageTravelDto.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(PackageImageDto.fromJS(item));
            }
            this.price = _data["price"];
            this.tourPackageTypeId = _data["tourPackageTypeId"];
            this.tourPackageType = _data["tourPackageType"] ? AppSettingOptionDto.fromJS(_data["tourPackageType"]) : undefined as any;
            this.continentId = _data["continentId"];
            this.continent = _data["continent"] ? AppSettingOptionDto.fromJS(_data["continent"]) : undefined as any;
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.rating = _data["rating"];
            this.withFlights = _data["withFlights"];
            this.endPoint = _data["endPoint"];
            this.sale = _data["sale"];
            this.description = _data["description"];
            this.reviewCount = _data["reviewCount"];
            this.currency = _data["currency"];
            this.basePrice = _data["basePrice"];
            this.startPoint = _data["startPoint"];
            this.placeCovered = _data["placeCovered"];
            this.availableFrom = _data["availableFrom"] ? moment(_data["availableFrom"].toString()) : undefined as any;
            this.availableTo = _data["availableTo"] ? moment(_data["availableTo"].toString()) : undefined as any;
            this.minTravelers = _data["minTravelers"];
            this.maxTravelers = _data["maxTravelers"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            if (Array.isArray(_data["tourInfo"])) {
                this.tourInfo = [] as any;
                for (let item of _data["tourInfo"])
                    this.tourInfo.push(PackageTourInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["highlights"])) {
                this.highlights = [] as any;
                for (let item of _data["highlights"])
                    this.highlights.push(PackageHighlightDto.fromJS(item));
            }
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions.push(PackageInclusionDto.fromJS(item));
            }
            if (Array.isArray(_data["exclusions"])) {
                this.exclusions = [] as any;
                for (let item of _data["exclusions"])
                    this.exclusions.push(PackageExclusionDto.fromJS(item));
            }
            if (Array.isArray(_data["cancellationPolicies"])) {
                this.cancellationPolicies = [] as any;
                for (let item of _data["cancellationPolicies"])
                    this.cancellationPolicies.push(PackageCancellationPolicyDto.fromJS(item));
            }
            if (Array.isArray(_data["itinerary"])) {
                this.itinerary = [] as any;
                for (let item of _data["itinerary"])
                    this.itinerary.push(PackageItineraryDto.fromJS(item));
            }
            if (Array.isArray(_data["holidayTypes"])) {
                this.holidayTypes = [] as any;
                for (let item of _data["holidayTypes"])
                    this.holidayTypes.push(PackageHolidayTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["packageTypeNote"] = this.packageTypeNote;
        data["title"] = this.title;
        data["details"] = this.details;
        data["shortOverview"] = this.shortOverview;
        data["note"] = this.note;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["isPublished"] = this.isPublished;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureDocumentUrl"] = this.profilePictureDocumentUrl;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["coverPhotoDocumentUrl"] = this.coverPhotoDocumentUrl;
        if (Array.isArray(this.travels)) {
            data["travels"] = [];
            for (let item of this.travels)
                data["travels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["price"] = this.price;
        data["tourPackageTypeId"] = this.tourPackageTypeId;
        data["tourPackageType"] = this.tourPackageType ? this.tourPackageType.toJSON() : undefined as any;
        data["continentId"] = this.continentId;
        data["continent"] = this.continent ? this.continent.toJSON() : undefined as any;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["rating"] = this.rating;
        data["withFlights"] = this.withFlights;
        data["endPoint"] = this.endPoint;
        data["sale"] = this.sale;
        data["description"] = this.description;
        data["reviewCount"] = this.reviewCount;
        data["currency"] = this.currency;
        data["basePrice"] = this.basePrice;
        data["startPoint"] = this.startPoint;
        data["placeCovered"] = this.placeCovered;
        data["availableFrom"] = this.availableFrom ? this.availableFrom.toISOString() : undefined as any;
        data["availableTo"] = this.availableTo ? this.availableTo.toISOString() : undefined as any;
        data["minTravelers"] = this.minTravelers;
        data["maxTravelers"] = this.maxTravelers;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        if (Array.isArray(this.tourInfo)) {
            data["tourInfo"] = [];
            for (let item of this.tourInfo)
                data["tourInfo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.highlights)) {
            data["highlights"] = [];
            for (let item of this.highlights)
                data["highlights"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exclusions)) {
            data["exclusions"] = [];
            for (let item of this.exclusions)
                data["exclusions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cancellationPolicies)) {
            data["cancellationPolicies"] = [];
            for (let item of this.cancellationPolicies)
                data["cancellationPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.itinerary)) {
            data["itinerary"] = [];
            for (let item of this.itinerary)
                data["itinerary"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.holidayTypes)) {
            data["holidayTypes"] = [];
            for (let item of this.holidayTypes)
                data["holidayTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PackageDto {
        const json = this.toJSON();
        let result = new PackageDto();
        result.init(json);
        return result;
    }
}

export interface IPackageDto {
    id: string;
    type: PackageType;
    packageTypeNote: string | undefined;
    title: string | undefined;
    details: string | undefined;
    shortOverview: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    isPublished: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    travels: PackageTravelDto[] | undefined;
    images: PackageImageDto[] | undefined;
    price: number;
    tourPackageTypeId: string | undefined;
    tourPackageType: AppSettingOptionDto;
    continentId: string | undefined;
    continent: AppSettingOptionDto;
    days: number;
    nights: number;
    rating: number;
    withFlights: boolean;
    endPoint: string | undefined;
    sale: string | undefined;
    description: string | undefined;
    reviewCount: number;
    currency: string | undefined;
    basePrice: number;
    startPoint: string | undefined;
    placeCovered: string | undefined;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    minTravelers: number;
    maxTravelers: number;
    creationTime: moment.Moment;
    tourInfo: PackageTourInfoDto[] | undefined;
    highlights: PackageHighlightDto[] | undefined;
    inclusions: PackageInclusionDto[] | undefined;
    exclusions: PackageExclusionDto[] | undefined;
    cancellationPolicies: PackageCancellationPolicyDto[] | undefined;
    itinerary: PackageItineraryDto[] | undefined;
    holidayTypes: PackageHolidayTypeDto[] | undefined;
}

export class PackageDtoPagedResultDto implements IPackageDtoPagedResultDto {
    items: PackageDto[] | undefined;
    totalCount: number;

    constructor(data?: IPackageDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PackageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PackageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PackageDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PackageDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPackageDtoPagedResultDto {
    items: PackageDto[] | undefined;
    totalCount: number;
}

export class PackageExclusion implements IPackageExclusion {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    exclusion: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageExclusion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined as any;
            this.exclusion = _data["exclusion"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageExclusion {
        data = typeof data === 'object' ? data : {};
        let result = new PackageExclusion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["exclusion"] = this.exclusion;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageExclusion {
        const json = this.toJSON();
        let result = new PackageExclusion();
        result.init(json);
        return result;
    }
}

export interface IPackageExclusion {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    exclusion: string | undefined;
    displayOrder: number;
}

export class PackageExclusionDto implements IPackageExclusionDto {
    id: string;
    packageId: string;
    exclusion: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageExclusionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.exclusion = _data["exclusion"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageExclusionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageExclusionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["exclusion"] = this.exclusion;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageExclusionDto {
        const json = this.toJSON();
        let result = new PackageExclusionDto();
        result.init(json);
        return result;
    }
}

export interface IPackageExclusionDto {
    id: string;
    packageId: string;
    exclusion: string | undefined;
    displayOrder: number;
}

export class PackageHighlight implements IPackageHighlight {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    highlight: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageHighlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined as any;
            this.highlight = _data["highlight"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageHighlight {
        data = typeof data === 'object' ? data : {};
        let result = new PackageHighlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["highlight"] = this.highlight;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageHighlight {
        const json = this.toJSON();
        let result = new PackageHighlight();
        result.init(json);
        return result;
    }
}

export interface IPackageHighlight {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    highlight: string | undefined;
    displayOrder: number;
}

export class PackageHighlightDto implements IPackageHighlightDto {
    id: string;
    packageId: string;
    highlight: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageHighlightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.highlight = _data["highlight"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageHighlightDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageHighlightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["highlight"] = this.highlight;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageHighlightDto {
        const json = this.toJSON();
        let result = new PackageHighlightDto();
        result.init(json);
        return result;
    }
}

export interface IPackageHighlightDto {
    id: string;
    packageId: string;
    highlight: string | undefined;
    displayOrder: number;
}

export class PackageHolidayType implements IPackageHolidayType {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    holidayTypeId: string;
    holidayType: AppSettingOption;
    displayOrder: number;

    constructor(data?: IPackageHolidayType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined as any;
            this.holidayTypeId = _data["holidayTypeId"];
            this.holidayType = _data["holidayType"] ? AppSettingOption.fromJS(_data["holidayType"]) : undefined as any;
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageHolidayType {
        data = typeof data === 'object' ? data : {};
        let result = new PackageHolidayType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["holidayTypeId"] = this.holidayTypeId;
        data["holidayType"] = this.holidayType ? this.holidayType.toJSON() : undefined as any;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageHolidayType {
        const json = this.toJSON();
        let result = new PackageHolidayType();
        result.init(json);
        return result;
    }
}

export interface IPackageHolidayType {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    holidayTypeId: string;
    holidayType: AppSettingOption;
    displayOrder: number;
}

export class PackageHolidayTypeDto implements IPackageHolidayTypeDto {
    id: string;
    packageId: string;
    holidayTypeId: string;
    holidayType: AppSettingOptionDto;
    displayOrder: number;

    constructor(data?: IPackageHolidayTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.holidayTypeId = _data["holidayTypeId"];
            this.holidayType = _data["holidayType"] ? AppSettingOptionDto.fromJS(_data["holidayType"]) : undefined as any;
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageHolidayTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageHolidayTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["holidayTypeId"] = this.holidayTypeId;
        data["holidayType"] = this.holidayType ? this.holidayType.toJSON() : undefined as any;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageHolidayTypeDto {
        const json = this.toJSON();
        let result = new PackageHolidayTypeDto();
        result.init(json);
        return result;
    }
}

export interface IPackageHolidayTypeDto {
    id: string;
    packageId: string;
    holidayTypeId: string;
    holidayType: AppSettingOptionDto;
    displayOrder: number;
}

export class PackageImage implements IPackageImage {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    title: string | undefined;
    sortOrder: number;
    pictureDocumentId: string | undefined;
    pictureDocument: Document;

    constructor(data?: IPackageImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined as any;
            this.title = _data["title"];
            this.sortOrder = _data["sortOrder"];
            this.pictureDocumentId = _data["pictureDocumentId"];
            this.pictureDocument = _data["pictureDocument"] ? Document.fromJS(_data["pictureDocument"]) : undefined as any;
        }
    }

    static fromJS(data: any): PackageImage {
        data = typeof data === 'object' ? data : {};
        let result = new PackageImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["title"] = this.title;
        data["sortOrder"] = this.sortOrder;
        data["pictureDocumentId"] = this.pictureDocumentId;
        data["pictureDocument"] = this.pictureDocument ? this.pictureDocument.toJSON() : undefined as any;
        return data;
    }

    clone(): PackageImage {
        const json = this.toJSON();
        let result = new PackageImage();
        result.init(json);
        return result;
    }
}

export interface IPackageImage {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    title: string | undefined;
    sortOrder: number;
    pictureDocumentId: string | undefined;
    pictureDocument: Document;
}

export class PackageImageDto implements IPackageImageDto {
    id: string;
    title: string | undefined;
    pictureDocumentId: string | undefined;
    pictureDocumentUrl: string | undefined;
    sortOrder: number;
    photo: FileDto;

    constructor(data?: IPackageImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.pictureDocumentId = _data["pictureDocumentId"];
            this.pictureDocumentUrl = _data["pictureDocumentUrl"];
            this.sortOrder = _data["sortOrder"];
            this.photo = _data["photo"] ? FileDto.fromJS(_data["photo"]) : undefined as any;
        }
    }

    static fromJS(data: any): PackageImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["pictureDocumentId"] = this.pictureDocumentId;
        data["pictureDocumentUrl"] = this.pictureDocumentUrl;
        data["sortOrder"] = this.sortOrder;
        data["photo"] = this.photo ? this.photo.toJSON() : undefined as any;
        return data;
    }

    clone(): PackageImageDto {
        const json = this.toJSON();
        let result = new PackageImageDto();
        result.init(json);
        return result;
    }
}

export interface IPackageImageDto {
    id: string;
    title: string | undefined;
    pictureDocumentId: string | undefined;
    pictureDocumentUrl: string | undefined;
    sortOrder: number;
    photo: FileDto;
}

export class PackageInclusion implements IPackageInclusion {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    inclusion: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageInclusion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined as any;
            this.inclusion = _data["inclusion"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageInclusion {
        data = typeof data === 'object' ? data : {};
        let result = new PackageInclusion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["inclusion"] = this.inclusion;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageInclusion {
        const json = this.toJSON();
        let result = new PackageInclusion();
        result.init(json);
        return result;
    }
}

export interface IPackageInclusion {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    inclusion: string | undefined;
    displayOrder: number;
}

export class PackageInclusionDto implements IPackageInclusionDto {
    id: string;
    packageId: string;
    inclusion: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageInclusionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.inclusion = _data["inclusion"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageInclusionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageInclusionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["inclusion"] = this.inclusion;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageInclusionDto {
        const json = this.toJSON();
        let result = new PackageInclusionDto();
        result.init(json);
        return result;
    }
}

export interface IPackageInclusionDto {
    id: string;
    packageId: string;
    inclusion: string | undefined;
    displayOrder: number;
}

export class PackageItinerary implements IPackageItinerary {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    day: number;
    title: string | undefined;
    description: string | undefined;
    displayOrder: number;
    activities: PackageItineraryActivity[] | undefined;

    constructor(data?: IPackageItinerary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined as any;
            this.day = _data["day"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities.push(PackageItineraryActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageItinerary {
        data = typeof data === 'object' ? data : {};
        let result = new PackageItinerary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["day"] = this.day;
        data["title"] = this.title;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PackageItinerary {
        const json = this.toJSON();
        let result = new PackageItinerary();
        result.init(json);
        return result;
    }
}

export interface IPackageItinerary {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    day: number;
    title: string | undefined;
    description: string | undefined;
    displayOrder: number;
    activities: PackageItineraryActivity[] | undefined;
}

export class PackageItineraryActivity implements IPackageItineraryActivity {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageItineraryId: string;
    packageItinerary: PackageItinerary;
    activity: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageItineraryActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageItineraryId = _data["packageItineraryId"];
            this.packageItinerary = _data["packageItinerary"] ? PackageItinerary.fromJS(_data["packageItinerary"]) : undefined as any;
            this.activity = _data["activity"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageItineraryActivity {
        data = typeof data === 'object' ? data : {};
        let result = new PackageItineraryActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageItineraryId"] = this.packageItineraryId;
        data["packageItinerary"] = this.packageItinerary ? this.packageItinerary.toJSON() : undefined as any;
        data["activity"] = this.activity;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageItineraryActivity {
        const json = this.toJSON();
        let result = new PackageItineraryActivity();
        result.init(json);
        return result;
    }
}

export interface IPackageItineraryActivity {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageItineraryId: string;
    packageItinerary: PackageItinerary;
    activity: string | undefined;
    displayOrder: number;
}

export class PackageItineraryActivityDto implements IPackageItineraryActivityDto {
    id: string;
    packageItineraryId: string;
    activity: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageItineraryActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageItineraryId = _data["packageItineraryId"];
            this.activity = _data["activity"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageItineraryActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageItineraryActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageItineraryId"] = this.packageItineraryId;
        data["activity"] = this.activity;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageItineraryActivityDto {
        const json = this.toJSON();
        let result = new PackageItineraryActivityDto();
        result.init(json);
        return result;
    }
}

export interface IPackageItineraryActivityDto {
    id: string;
    packageItineraryId: string;
    activity: string | undefined;
    displayOrder: number;
}

export class PackageItineraryDto implements IPackageItineraryDto {
    id: string;
    packageId: string;
    day: number;
    title: string | undefined;
    description: string | undefined;
    displayOrder: number;
    activities: PackageItineraryActivityDto[] | undefined;

    constructor(data?: IPackageItineraryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.day = _data["day"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities.push(PackageItineraryActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageItineraryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageItineraryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["day"] = this.day;
        data["title"] = this.title;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PackageItineraryDto {
        const json = this.toJSON();
        let result = new PackageItineraryDto();
        result.init(json);
        return result;
    }
}

export interface IPackageItineraryDto {
    id: string;
    packageId: string;
    day: number;
    title: string | undefined;
    description: string | undefined;
    displayOrder: number;
    activities: PackageItineraryActivityDto[] | undefined;
}

export class PackageTourInfo implements IPackageTourInfo {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    title: string | undefined;
    info: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageTourInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined as any;
            this.title = _data["title"];
            this.info = _data["info"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageTourInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTourInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["title"] = this.title;
        data["info"] = this.info;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageTourInfo {
        const json = this.toJSON();
        let result = new PackageTourInfo();
        result.init(json);
        return result;
    }
}

export interface IPackageTourInfo {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    title: string | undefined;
    info: string | undefined;
    displayOrder: number;
}

export class PackageTourInfoDto implements IPackageTourInfoDto {
    id: string;
    packageId: string;
    title: string | undefined;
    info: string | undefined;
    displayOrder: number;

    constructor(data?: IPackageTourInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.title = _data["title"];
            this.info = _data["info"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): PackageTourInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTourInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["title"] = this.title;
        data["info"] = this.info;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): PackageTourInfoDto {
        const json = this.toJSON();
        let result = new PackageTourInfoDto();
        result.init(json);
        return result;
    }
}

export interface IPackageTourInfoDto {
    id: string;
    packageId: string;
    title: string | undefined;
    info: string | undefined;
    displayOrder: number;
}

export class PackageTravel implements IPackageTravel {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    title: string | undefined;
    details: string | undefined;
    travelDate: moment.Moment;
    passengerLimitCount: number;
    price: number;
    currency: string | undefined;
    note: string | undefined;
    status: PackageTravelStatus;
    itineraries: PackageTravelItinerary[] | undefined;
    commisions: PackageTravelCommision[] | undefined;

    constructor(data?: IPackageTravel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined as any;
            this.title = _data["title"];
            this.details = _data["details"];
            this.travelDate = _data["travelDate"] ? moment(_data["travelDate"].toString()) : undefined as any;
            this.passengerLimitCount = _data["passengerLimitCount"];
            this.price = _data["price"];
            this.currency = _data["currency"];
            this.note = _data["note"];
            this.status = _data["status"];
            if (Array.isArray(_data["itineraries"])) {
                this.itineraries = [] as any;
                for (let item of _data["itineraries"])
                    this.itineraries.push(PackageTravelItinerary.fromJS(item));
            }
            if (Array.isArray(_data["commisions"])) {
                this.commisions = [] as any;
                for (let item of _data["commisions"])
                    this.commisions.push(PackageTravelCommision.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageTravel {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTravel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["title"] = this.title;
        data["details"] = this.details;
        data["travelDate"] = this.travelDate ? this.travelDate.toISOString() : undefined as any;
        data["passengerLimitCount"] = this.passengerLimitCount;
        data["price"] = this.price;
        data["currency"] = this.currency;
        data["note"] = this.note;
        data["status"] = this.status;
        if (Array.isArray(this.itineraries)) {
            data["itineraries"] = [];
            for (let item of this.itineraries)
                data["itineraries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.commisions)) {
            data["commisions"] = [];
            for (let item of this.commisions)
                data["commisions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PackageTravel {
        const json = this.toJSON();
        let result = new PackageTravel();
        result.init(json);
        return result;
    }
}

export interface IPackageTravel {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageId: string;
    package: Package;
    title: string | undefined;
    details: string | undefined;
    travelDate: moment.Moment;
    passengerLimitCount: number;
    price: number;
    currency: string | undefined;
    note: string | undefined;
    status: PackageTravelStatus;
    itineraries: PackageTravelItinerary[] | undefined;
    commisions: PackageTravelCommision[] | undefined;
}

export class PackageTravelCommision implements IPackageTravelCommision {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageTravelId: string;
    packageTravel: PackageTravel;
    title: string | undefined;
    amount: number;
    note: string | undefined;

    constructor(data?: IPackageTravelCommision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageTravelId = _data["packageTravelId"];
            this.packageTravel = _data["packageTravel"] ? PackageTravel.fromJS(_data["packageTravel"]) : undefined as any;
            this.title = _data["title"];
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PackageTravelCommision {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTravelCommision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageTravelId"] = this.packageTravelId;
        data["packageTravel"] = this.packageTravel ? this.packageTravel.toJSON() : undefined as any;
        data["title"] = this.title;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }

    clone(): PackageTravelCommision {
        const json = this.toJSON();
        let result = new PackageTravelCommision();
        result.init(json);
        return result;
    }
}

export interface IPackageTravelCommision {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageTravelId: string;
    packageTravel: PackageTravel;
    title: string | undefined;
    amount: number;
    note: string | undefined;
}

export class PackageTravelCommisionDto implements IPackageTravelCommisionDto {
    id: string;
    title: string | undefined;
    amount: number;
    note: string | undefined;

    constructor(data?: IPackageTravelCommisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PackageTravelCommisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTravelCommisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }

    clone(): PackageTravelCommisionDto {
        const json = this.toJSON();
        let result = new PackageTravelCommisionDto();
        result.init(json);
        return result;
    }
}

export interface IPackageTravelCommisionDto {
    id: string;
    title: string | undefined;
    amount: number;
    note: string | undefined;
}

export class PackageTravelDto implements IPackageTravelDto {
    /** Shadowed so JSON can accept Angular `temp_*` ids for unsaved departures (mapped to System.Guid.Empty). */
    id: string;
    title: string | undefined;
    details: string | undefined;
    travelDate: moment.Moment;
    passengerLimitCount: number;
    passengerCount: number;
    isSoldOut: boolean;
    price: number;
    currency: string | undefined;
    note: string | undefined;
    status: PackageTravelStatus;
    itineraries: PackageTravelItineraryDto[] | undefined;
    commisions: PackageTravelCommisionDto[] | undefined;

    constructor(data?: IPackageTravelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.details = _data["details"];
            this.travelDate = _data["travelDate"] ? moment(_data["travelDate"].toString()) : undefined as any;
            this.passengerLimitCount = _data["passengerLimitCount"];
            this.passengerCount = _data["passengerCount"];
            this.isSoldOut = _data["isSoldOut"];
            this.price = _data["price"];
            this.currency = _data["currency"];
            this.note = _data["note"];
            this.status = _data["status"];
            if (Array.isArray(_data["itineraries"])) {
                this.itineraries = [] as any;
                for (let item of _data["itineraries"])
                    this.itineraries.push(PackageTravelItineraryDto.fromJS(item));
            }
            if (Array.isArray(_data["commisions"])) {
                this.commisions = [] as any;
                for (let item of _data["commisions"])
                    this.commisions.push(PackageTravelCommisionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageTravelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTravelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["details"] = this.details;
        data["travelDate"] = this.travelDate ? this.travelDate.toISOString() : undefined as any;
        data["passengerLimitCount"] = this.passengerLimitCount;
        data["passengerCount"] = this.passengerCount;
        data["isSoldOut"] = this.isSoldOut;
        data["price"] = this.price;
        data["currency"] = this.currency;
        data["note"] = this.note;
        data["status"] = this.status;
        if (Array.isArray(this.itineraries)) {
            data["itineraries"] = [];
            for (let item of this.itineraries)
                data["itineraries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.commisions)) {
            data["commisions"] = [];
            for (let item of this.commisions)
                data["commisions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PackageTravelDto {
        const json = this.toJSON();
        let result = new PackageTravelDto();
        result.init(json);
        return result;
    }
}

export interface IPackageTravelDto {
    /** Shadowed so JSON can accept Angular `temp_*` ids for unsaved departures (mapped to System.Guid.Empty). */
    id: string;
    title: string | undefined;
    details: string | undefined;
    travelDate: moment.Moment;
    passengerLimitCount: number;
    passengerCount: number;
    isSoldOut: boolean;
    price: number;
    currency: string | undefined;
    note: string | undefined;
    status: PackageTravelStatus;
    itineraries: PackageTravelItineraryDto[] | undefined;
    commisions: PackageTravelCommisionDto[] | undefined;
}

export class PackageTravelItinerary implements IPackageTravelItinerary {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageTravelId: string;
    packageTravel: PackageTravel;
    title: string | undefined;
    details: string | undefined;
    items: PackageTravelItineraryItem[] | undefined;
    meals: PackageTravelItineraryMeal[] | undefined;

    constructor(data?: IPackageTravelItinerary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageTravelId = _data["packageTravelId"];
            this.packageTravel = _data["packageTravel"] ? PackageTravel.fromJS(_data["packageTravel"]) : undefined as any;
            this.title = _data["title"];
            this.details = _data["details"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PackageTravelItineraryItem.fromJS(item));
            }
            if (Array.isArray(_data["meals"])) {
                this.meals = [] as any;
                for (let item of _data["meals"])
                    this.meals.push(PackageTravelItineraryMeal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageTravelItinerary {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTravelItinerary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageTravelId"] = this.packageTravelId;
        data["packageTravel"] = this.packageTravel ? this.packageTravel.toJSON() : undefined as any;
        data["title"] = this.title;
        data["details"] = this.details;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.meals)) {
            data["meals"] = [];
            for (let item of this.meals)
                data["meals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PackageTravelItinerary {
        const json = this.toJSON();
        let result = new PackageTravelItinerary();
        result.init(json);
        return result;
    }
}

export interface IPackageTravelItinerary {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageTravelId: string;
    packageTravel: PackageTravel;
    title: string | undefined;
    details: string | undefined;
    items: PackageTravelItineraryItem[] | undefined;
    meals: PackageTravelItineraryMeal[] | undefined;
}

export class PackageTravelItineraryDto implements IPackageTravelItineraryDto {
    id: string;
    title: string | undefined;
    details: string | undefined;
    items: PackageTravelItineraryItemDto[] | undefined;
    meals: PackageTravelItineraryMealDto[] | undefined;

    constructor(data?: IPackageTravelItineraryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.details = _data["details"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PackageTravelItineraryItemDto.fromJS(item));
            }
            if (Array.isArray(_data["meals"])) {
                this.meals = [] as any;
                for (let item of _data["meals"])
                    this.meals.push(PackageTravelItineraryMealDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageTravelItineraryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTravelItineraryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["details"] = this.details;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.meals)) {
            data["meals"] = [];
            for (let item of this.meals)
                data["meals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PackageTravelItineraryDto {
        const json = this.toJSON();
        let result = new PackageTravelItineraryDto();
        result.init(json);
        return result;
    }
}

export interface IPackageTravelItineraryDto {
    id: string;
    title: string | undefined;
    details: string | undefined;
    items: PackageTravelItineraryItemDto[] | undefined;
    meals: PackageTravelItineraryMealDto[] | undefined;
}

export class PackageTravelItineraryItem implements IPackageTravelItineraryItem {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageTravelItineraryId: string;
    itinerary: PackageTravelItinerary;
    title: string | undefined;
    time: string | undefined;

    constructor(data?: IPackageTravelItineraryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageTravelItineraryId = _data["packageTravelItineraryId"];
            this.itinerary = _data["itinerary"] ? PackageTravelItinerary.fromJS(_data["itinerary"]) : undefined as any;
            this.title = _data["title"];
            this.time = _data["time"];
        }
    }

    static fromJS(data: any): PackageTravelItineraryItem {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTravelItineraryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageTravelItineraryId"] = this.packageTravelItineraryId;
        data["itinerary"] = this.itinerary ? this.itinerary.toJSON() : undefined as any;
        data["title"] = this.title;
        data["time"] = this.time;
        return data;
    }

    clone(): PackageTravelItineraryItem {
        const json = this.toJSON();
        let result = new PackageTravelItineraryItem();
        result.init(json);
        return result;
    }
}

export interface IPackageTravelItineraryItem {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageTravelItineraryId: string;
    itinerary: PackageTravelItinerary;
    title: string | undefined;
    time: string | undefined;
}

export class PackageTravelItineraryItemDto implements IPackageTravelItineraryItemDto {
    id: string;
    title: string | undefined;
    time: string | undefined;

    constructor(data?: IPackageTravelItineraryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.time = _data["time"];
        }
    }

    static fromJS(data: any): PackageTravelItineraryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTravelItineraryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["time"] = this.time;
        return data;
    }

    clone(): PackageTravelItineraryItemDto {
        const json = this.toJSON();
        let result = new PackageTravelItineraryItemDto();
        result.init(json);
        return result;
    }
}

export interface IPackageTravelItineraryItemDto {
    id: string;
    title: string | undefined;
    time: string | undefined;
}

export class PackageTravelItineraryMeal implements IPackageTravelItineraryMeal {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageTravelItineraryId: string;
    itinerary: PackageTravelItinerary;
    hasBreakFast: boolean;
    hasMorningSnack: boolean;
    hasLunch: boolean;
    hasAfternoonSnack: boolean;
    hasDinner: boolean;

    constructor(data?: IPackageTravelItineraryMeal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.packageTravelItineraryId = _data["packageTravelItineraryId"];
            this.itinerary = _data["itinerary"] ? PackageTravelItinerary.fromJS(_data["itinerary"]) : undefined as any;
            this.hasBreakFast = _data["hasBreakFast"];
            this.hasMorningSnack = _data["hasMorningSnack"];
            this.hasLunch = _data["hasLunch"];
            this.hasAfternoonSnack = _data["hasAfternoonSnack"];
            this.hasDinner = _data["hasDinner"];
        }
    }

    static fromJS(data: any): PackageTravelItineraryMeal {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTravelItineraryMeal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["packageTravelItineraryId"] = this.packageTravelItineraryId;
        data["itinerary"] = this.itinerary ? this.itinerary.toJSON() : undefined as any;
        data["hasBreakFast"] = this.hasBreakFast;
        data["hasMorningSnack"] = this.hasMorningSnack;
        data["hasLunch"] = this.hasLunch;
        data["hasAfternoonSnack"] = this.hasAfternoonSnack;
        data["hasDinner"] = this.hasDinner;
        return data;
    }

    clone(): PackageTravelItineraryMeal {
        const json = this.toJSON();
        let result = new PackageTravelItineraryMeal();
        result.init(json);
        return result;
    }
}

export interface IPackageTravelItineraryMeal {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    packageTravelItineraryId: string;
    itinerary: PackageTravelItinerary;
    hasBreakFast: boolean;
    hasMorningSnack: boolean;
    hasLunch: boolean;
    hasAfternoonSnack: boolean;
    hasDinner: boolean;
}

export class PackageTravelItineraryMealDto implements IPackageTravelItineraryMealDto {
    id: string;
    hasBreakFast: boolean;
    hasMorningSnack: boolean;
    hasLunch: boolean;
    hasAfternoonSnack: boolean;
    hasDinner: boolean;

    constructor(data?: IPackageTravelItineraryMealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasBreakFast = _data["hasBreakFast"];
            this.hasMorningSnack = _data["hasMorningSnack"];
            this.hasLunch = _data["hasLunch"];
            this.hasAfternoonSnack = _data["hasAfternoonSnack"];
            this.hasDinner = _data["hasDinner"];
        }
    }

    static fromJS(data: any): PackageTravelItineraryMealDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTravelItineraryMealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasBreakFast"] = this.hasBreakFast;
        data["hasMorningSnack"] = this.hasMorningSnack;
        data["hasLunch"] = this.hasLunch;
        data["hasAfternoonSnack"] = this.hasAfternoonSnack;
        data["hasDinner"] = this.hasDinner;
        return data;
    }

    clone(): PackageTravelItineraryMealDto {
        const json = this.toJSON();
        let result = new PackageTravelItineraryMealDto();
        result.init(json);
        return result;
    }
}

export interface IPackageTravelItineraryMealDto {
    id: string;
    hasBreakFast: boolean;
    hasMorningSnack: boolean;
    hasLunch: boolean;
    hasAfternoonSnack: boolean;
    hasDinner: boolean;
}

export enum PackageTravelStatus {
    _0 = 0,
    _1 = 1,
}

export enum PackageType {
    _0 = 0,
}

export class PackagesHomepageContentDto implements IPackagesHomepageContentDto {
    heroBanner: HeroBannerDto;
    recentSearches: RecentSearchesDto;
    bestPackages: BestPackagesDto;
    emailSubscribe: EmailSubscribeDto;
    recentToursPackages: RecentToursPackagesDto;
    reviewSection: ReviewSectionDto;
    footer: FooterDto;
    aboutUs: AboutUsDto;
    ourTeam: OurTeamDto;
    ourStory: OurStoryDto;
    meetTeamBanner: MeetTeamBannerDto;
    teamGrid: TeamGridDto;
    callToAction: CallToActionDto;

    constructor(data?: IPackagesHomepageContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heroBanner = _data["heroBanner"] ? HeroBannerDto.fromJS(_data["heroBanner"]) : undefined as any;
            this.recentSearches = _data["recentSearches"] ? RecentSearchesDto.fromJS(_data["recentSearches"]) : undefined as any;
            this.bestPackages = _data["bestPackages"] ? BestPackagesDto.fromJS(_data["bestPackages"]) : undefined as any;
            this.emailSubscribe = _data["emailSubscribe"] ? EmailSubscribeDto.fromJS(_data["emailSubscribe"]) : undefined as any;
            this.recentToursPackages = _data["recentToursPackages"] ? RecentToursPackagesDto.fromJS(_data["recentToursPackages"]) : undefined as any;
            this.reviewSection = _data["reviewSection"] ? ReviewSectionDto.fromJS(_data["reviewSection"]) : undefined as any;
            this.footer = _data["footer"] ? FooterDto.fromJS(_data["footer"]) : undefined as any;
            this.aboutUs = _data["aboutUs"] ? AboutUsDto.fromJS(_data["aboutUs"]) : undefined as any;
            this.ourTeam = _data["ourTeam"] ? OurTeamDto.fromJS(_data["ourTeam"]) : undefined as any;
            this.ourStory = _data["ourStory"] ? OurStoryDto.fromJS(_data["ourStory"]) : undefined as any;
            this.meetTeamBanner = _data["meetTeamBanner"] ? MeetTeamBannerDto.fromJS(_data["meetTeamBanner"]) : undefined as any;
            this.teamGrid = _data["teamGrid"] ? TeamGridDto.fromJS(_data["teamGrid"]) : undefined as any;
            this.callToAction = _data["callToAction"] ? CallToActionDto.fromJS(_data["callToAction"]) : undefined as any;
        }
    }

    static fromJS(data: any): PackagesHomepageContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackagesHomepageContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heroBanner"] = this.heroBanner ? this.heroBanner.toJSON() : undefined as any;
        data["recentSearches"] = this.recentSearches ? this.recentSearches.toJSON() : undefined as any;
        data["bestPackages"] = this.bestPackages ? this.bestPackages.toJSON() : undefined as any;
        data["emailSubscribe"] = this.emailSubscribe ? this.emailSubscribe.toJSON() : undefined as any;
        data["recentToursPackages"] = this.recentToursPackages ? this.recentToursPackages.toJSON() : undefined as any;
        data["reviewSection"] = this.reviewSection ? this.reviewSection.toJSON() : undefined as any;
        data["footer"] = this.footer ? this.footer.toJSON() : undefined as any;
        data["aboutUs"] = this.aboutUs ? this.aboutUs.toJSON() : undefined as any;
        data["ourTeam"] = this.ourTeam ? this.ourTeam.toJSON() : undefined as any;
        data["ourStory"] = this.ourStory ? this.ourStory.toJSON() : undefined as any;
        data["meetTeamBanner"] = this.meetTeamBanner ? this.meetTeamBanner.toJSON() : undefined as any;
        data["teamGrid"] = this.teamGrid ? this.teamGrid.toJSON() : undefined as any;
        data["callToAction"] = this.callToAction ? this.callToAction.toJSON() : undefined as any;
        return data;
    }

    clone(): PackagesHomepageContentDto {
        const json = this.toJSON();
        let result = new PackagesHomepageContentDto();
        result.init(json);
        return result;
    }
}

export interface IPackagesHomepageContentDto {
    heroBanner: HeroBannerDto;
    recentSearches: RecentSearchesDto;
    bestPackages: BestPackagesDto;
    emailSubscribe: EmailSubscribeDto;
    recentToursPackages: RecentToursPackagesDto;
    reviewSection: ReviewSectionDto;
    footer: FooterDto;
    aboutUs: AboutUsDto;
    ourTeam: OurTeamDto;
    ourStory: OurStoryDto;
    meetTeamBanner: MeetTeamBannerDto;
    teamGrid: TeamGridDto;
    callToAction: CallToActionDto;
}

export class PackagesHomepageDto implements IPackagesHomepageDto {
    id: string;
    pageName: string | undefined;
    pageTitle: string | undefined;
    pageDescription: string | undefined;
    pageType: string | undefined;
    contentJson: string | undefined;
    isActive: boolean;

    constructor(data?: IPackagesHomepageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageName = _data["pageName"];
            this.pageTitle = _data["pageTitle"];
            this.pageDescription = _data["pageDescription"];
            this.pageType = _data["pageType"];
            this.contentJson = _data["contentJson"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PackagesHomepageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackagesHomepageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageName"] = this.pageName;
        data["pageTitle"] = this.pageTitle;
        data["pageDescription"] = this.pageDescription;
        data["pageType"] = this.pageType;
        data["contentJson"] = this.contentJson;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): PackagesHomepageDto {
        const json = this.toJSON();
        let result = new PackagesHomepageDto();
        result.init(json);
        return result;
    }
}

export interface IPackagesHomepageDto {
    id: string;
    pageName: string | undefined;
    pageTitle: string | undefined;
    pageDescription: string | undefined;
    pageType: string | undefined;
    contentJson: string | undefined;
    isActive: boolean;
}

export class PagedAuditLogsResultDto implements IPagedAuditLogsResultDto {
    items: AuditLogDto[] | undefined;
    pagination: Pagination;

    constructor(data?: IPagedAuditLogsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditLogDto.fromJS(item));
            }
            this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : undefined as any;
        }
    }

    static fromJS(data: any): PagedAuditLogsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedAuditLogsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        return data;
    }

    clone(): PagedAuditLogsResultDto {
        const json = this.toJSON();
        let result = new PagedAuditLogsResultDto();
        result.init(json);
        return result;
    }
}

export interface IPagedAuditLogsResultDto {
    items: AuditLogDto[] | undefined;
    pagination: Pagination;
}

export class PagedBookingTransactionResultDto implements IPagedBookingTransactionResultDto {
    items: BookingTransactionDto[] | undefined;
    pagination: Pagination;

    constructor(data?: IPagedBookingTransactionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BookingTransactionDto.fromJS(item));
            }
            this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : undefined as any;
        }
    }

    static fromJS(data: any): PagedBookingTransactionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedBookingTransactionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        return data;
    }

    clone(): PagedBookingTransactionResultDto {
        const json = this.toJSON();
        let result = new PagedBookingTransactionResultDto();
        result.init(json);
        return result;
    }
}

export interface IPagedBookingTransactionResultDto {
    items: BookingTransactionDto[] | undefined;
    pagination: Pagination;
}

export class PagedPurchaseOrderResultDto implements IPagedPurchaseOrderResultDto {
    items: PurchaseOrderDto[] | undefined;
    pagination: Pagination;
    totalAmount: number;
    pagedTotalAmount: number;

    constructor(data?: IPagedPurchaseOrderResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PurchaseOrderDto.fromJS(item));
            }
            this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.pagedTotalAmount = _data["pagedTotalAmount"];
        }
    }

    static fromJS(data: any): PagedPurchaseOrderResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedPurchaseOrderResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["pagedTotalAmount"] = this.pagedTotalAmount;
        return data;
    }

    clone(): PagedPurchaseOrderResultDto {
        const json = this.toJSON();
        let result = new PagedPurchaseOrderResultDto();
        result.init(json);
        return result;
    }
}

export interface IPagedPurchaseOrderResultDto {
    items: PurchaseOrderDto[] | undefined;
    pagination: Pagination;
    totalAmount: number;
    pagedTotalAmount: number;
}

export class PagedStatementOfAccountForReportResultDto implements IPagedStatementOfAccountForReportResultDto {
    items: StatementOfAccountForReportDto[] | undefined;
    pagination: Pagination;
    pagedTotalAmount: number;
    pagedTotalPurchaseOrderAmount: number;
    pagedTotalNetProfit: number;
    totalAmount: number;
    totalPurchaseOrderAmount: number;
    totalNetProfit: number;

    constructor(data?: IPagedStatementOfAccountForReportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StatementOfAccountForReportDto.fromJS(item));
            }
            this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : undefined as any;
            this.pagedTotalAmount = _data["pagedTotalAmount"];
            this.pagedTotalPurchaseOrderAmount = _data["pagedTotalPurchaseOrderAmount"];
            this.pagedTotalNetProfit = _data["pagedTotalNetProfit"];
            this.totalAmount = _data["totalAmount"];
            this.totalPurchaseOrderAmount = _data["totalPurchaseOrderAmount"];
            this.totalNetProfit = _data["totalNetProfit"];
        }
    }

    static fromJS(data: any): PagedStatementOfAccountForReportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedStatementOfAccountForReportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        data["pagedTotalAmount"] = this.pagedTotalAmount;
        data["pagedTotalPurchaseOrderAmount"] = this.pagedTotalPurchaseOrderAmount;
        data["pagedTotalNetProfit"] = this.pagedTotalNetProfit;
        data["totalAmount"] = this.totalAmount;
        data["totalPurchaseOrderAmount"] = this.totalPurchaseOrderAmount;
        data["totalNetProfit"] = this.totalNetProfit;
        return data;
    }

    clone(): PagedStatementOfAccountForReportResultDto {
        const json = this.toJSON();
        let result = new PagedStatementOfAccountForReportResultDto();
        result.init(json);
        return result;
    }
}

export interface IPagedStatementOfAccountForReportResultDto {
    items: StatementOfAccountForReportDto[] | undefined;
    pagination: Pagination;
    pagedTotalAmount: number;
    pagedTotalPurchaseOrderAmount: number;
    pagedTotalNetProfit: number;
    totalAmount: number;
    totalPurchaseOrderAmount: number;
    totalNetProfit: number;
}

export class PagedStatementOfAccountResultDto implements IPagedStatementOfAccountResultDto {
    items: StatementOfAccountDto[] | undefined;
    pagination: Pagination;

    constructor(data?: IPagedStatementOfAccountResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StatementOfAccountDto.fromJS(item));
            }
            this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : undefined as any;
        }
    }

    static fromJS(data: any): PagedStatementOfAccountResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedStatementOfAccountResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        return data;
    }

    clone(): PagedStatementOfAccountResultDto {
        const json = this.toJSON();
        let result = new PagedStatementOfAccountResultDto();
        result.init(json);
        return result;
    }
}

export interface IPagedStatementOfAccountResultDto {
    items: StatementOfAccountDto[] | undefined;
    pagination: Pagination;
}

export class Pagination implements IPagination {
    length: number;
    size: number;
    page: number;
    lastPage: number;
    startIndex: number;
    endIndex: number;

    constructor(data?: IPagination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.length = _data["length"];
            this.size = _data["size"];
            this.page = _data["page"];
            this.lastPage = _data["lastPage"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
        }
    }

    static fromJS(data: any): Pagination {
        data = typeof data === 'object' ? data : {};
        let result = new Pagination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        data["size"] = this.size;
        data["page"] = this.page;
        data["lastPage"] = this.lastPage;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        return data;
    }

    clone(): Pagination {
        const json = this.toJSON();
        let result = new Pagination();
        result.init(json);
        return result;
    }
}

export interface IPagination {
    length: number;
    size: number;
    page: number;
    lastPage: number;
    startIndex: number;
    endIndex: number;
}

export class Passenger implements IPassenger {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    surname: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    birthPlace: string | undefined;
    isActive: boolean;
    note: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    fullName: string | undefined;
    title: string | undefined;
    company: string | undefined;
    status: Status;
    deletionReason: string | undefined;
    profilePictureDocumentId: string | undefined;
    profilePictureDocument: Document;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocument: Document;
    userTags: PassengerTag[] | undefined;
    emails: PassengerEmail[] | undefined;
    phoneNumbers: PassengerPhoneNumber[] | undefined;
    passports: Passport[] | undefined;

    constructor(data?: IPassenger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.middleName = _data["middleName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.birthPlace = _data["birthPlace"];
            this.isActive = _data["isActive"];
            this.note = _data["note"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.zipOrPostCode = _data["zipOrPostCode"];
            this.stateOrProvince = _data["stateOrProvince"];
            this.country = _data["country"];
            this.fullName = _data["fullName"];
            this.title = _data["title"];
            this.company = _data["company"];
            this.status = _data["status"];
            this.deletionReason = _data["deletionReason"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureDocument = _data["profilePictureDocument"] ? Document.fromJS(_data["profilePictureDocument"]) : undefined as any;
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.coverPhotoDocument = _data["coverPhotoDocument"] ? Document.fromJS(_data["coverPhotoDocument"]) : undefined as any;
            if (Array.isArray(_data["userTags"])) {
                this.userTags = [] as any;
                for (let item of _data["userTags"])
                    this.userTags.push(PassengerTag.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(PassengerEmail.fromJS(item));
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(PassengerPhoneNumber.fromJS(item));
            }
            if (Array.isArray(_data["passports"])) {
                this.passports = [] as any;
                for (let item of _data["passports"])
                    this.passports.push(Passport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Passenger {
        data = typeof data === 'object' ? data : {};
        let result = new Passenger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["middleName"] = this.middleName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["birthPlace"] = this.birthPlace;
        data["isActive"] = this.isActive;
        data["note"] = this.note;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["zipOrPostCode"] = this.zipOrPostCode;
        data["stateOrProvince"] = this.stateOrProvince;
        data["country"] = this.country;
        data["fullName"] = this.fullName;
        data["title"] = this.title;
        data["company"] = this.company;
        data["status"] = this.status;
        data["deletionReason"] = this.deletionReason;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureDocument"] = this.profilePictureDocument ? this.profilePictureDocument.toJSON() : undefined as any;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["coverPhotoDocument"] = this.coverPhotoDocument ? this.coverPhotoDocument.toJSON() : undefined as any;
        if (Array.isArray(this.userTags)) {
            data["userTags"] = [];
            for (let item of this.userTags)
                data["userTags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.passports)) {
            data["passports"] = [];
            for (let item of this.passports)
                data["passports"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Passenger {
        const json = this.toJSON();
        let result = new Passenger();
        result.init(json);
        return result;
    }
}

export interface IPassenger {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    surname: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    birthPlace: string | undefined;
    isActive: boolean;
    note: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    fullName: string | undefined;
    title: string | undefined;
    company: string | undefined;
    status: Status;
    deletionReason: string | undefined;
    profilePictureDocumentId: string | undefined;
    profilePictureDocument: Document;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocument: Document;
    userTags: PassengerTag[] | undefined;
    emails: PassengerEmail[] | undefined;
    phoneNumbers: PassengerPhoneNumber[] | undefined;
    passports: Passport[] | undefined;
}

export class PassengerDto implements IPassengerDto {
    id: string;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    birthPlace: string | undefined;
    isActive: boolean;
    note: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    tags: PassengerTagDto[] | undefined;
    passports: PassportDto[] | undefined;
    phoneNumbers: PassengerPhoneNumberDto[] | undefined;
    emails: PassengerEmailDto[] | undefined;

    constructor(data?: IPassengerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.middleName = _data["middleName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.birthPlace = _data["birthPlace"];
            this.isActive = _data["isActive"];
            this.note = _data["note"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.zipOrPostCode = _data["zipOrPostCode"];
            this.stateOrProvince = _data["stateOrProvince"];
            this.country = _data["country"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureDocumentUrl = _data["profilePictureDocumentUrl"];
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.coverPhotoDocumentUrl = _data["coverPhotoDocumentUrl"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(PassengerTagDto.fromJS(item));
            }
            if (Array.isArray(_data["passports"])) {
                this.passports = [] as any;
                for (let item of _data["passports"])
                    this.passports.push(PassportDto.fromJS(item));
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(PassengerPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(PassengerEmailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PassengerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["middleName"] = this.middleName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["birthPlace"] = this.birthPlace;
        data["isActive"] = this.isActive;
        data["note"] = this.note;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["zipOrPostCode"] = this.zipOrPostCode;
        data["stateOrProvince"] = this.stateOrProvince;
        data["country"] = this.country;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureDocumentUrl"] = this.profilePictureDocumentUrl;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["coverPhotoDocumentUrl"] = this.coverPhotoDocumentUrl;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.passports)) {
            data["passports"] = [];
            for (let item of this.passports)
                data["passports"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PassengerDto {
        const json = this.toJSON();
        let result = new PassengerDto();
        result.init(json);
        return result;
    }
}

export interface IPassengerDto {
    id: string;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    birthPlace: string | undefined;
    isActive: boolean;
    note: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    tags: PassengerTagDto[] | undefined;
    passports: PassportDto[] | undefined;
    phoneNumbers: PassengerPhoneNumberDto[] | undefined;
    emails: PassengerEmailDto[] | undefined;
}

export class PassengerDtoPagedResultDto implements IPassengerDtoPagedResultDto {
    items: PassengerDto[] | undefined;
    totalCount: number;

    constructor(data?: IPassengerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PassengerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PassengerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PassengerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PassengerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPassengerDtoPagedResultDto {
    items: PassengerDto[] | undefined;
    totalCount: number;
}

export class PassengerEmail implements IPassengerEmail {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    email: string | undefined;
    note: string | undefined;
    passengerId: string;
    isActive: boolean;
    isPrimary: boolean;
    passenger: Passenger;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;

    constructor(data?: IPassengerEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.email = _data["email"];
            this.note = _data["note"];
            this.passengerId = _data["passengerId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.passenger = _data["passenger"] ? Passenger.fromJS(_data["passenger"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PassengerEmail {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["email"] = this.email;
        data["note"] = this.note;
        data["passengerId"] = this.passengerId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["passenger"] = this.passenger ? this.passenger.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        return data;
    }

    clone(): PassengerEmail {
        const json = this.toJSON();
        let result = new PassengerEmail();
        result.init(json);
        return result;
    }
}

export interface IPassengerEmail {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    email: string | undefined;
    note: string | undefined;
    passengerId: string;
    isActive: boolean;
    isPrimary: boolean;
    passenger: Passenger;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
}

export class PassengerEmailDto implements IPassengerEmailDto {
    id: string;
    email: string | undefined;
    note: string | undefined;
    passengerId: string;
    isActive: boolean;
    isPrimary: boolean;
    passenger: PassengerDto;

    constructor(data?: IPassengerEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.note = _data["note"];
            this.passengerId = _data["passengerId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.passenger = _data["passenger"] ? PassengerDto.fromJS(_data["passenger"]) : undefined as any;
        }
    }

    static fromJS(data: any): PassengerEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["note"] = this.note;
        data["passengerId"] = this.passengerId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["passenger"] = this.passenger ? this.passenger.toJSON() : undefined as any;
        return data;
    }

    clone(): PassengerEmailDto {
        const json = this.toJSON();
        let result = new PassengerEmailDto();
        result.init(json);
        return result;
    }
}

export interface IPassengerEmailDto {
    id: string;
    email: string | undefined;
    note: string | undefined;
    passengerId: string;
    isActive: boolean;
    isPrimary: boolean;
    passenger: PassengerDto;
}

export class PassengerPhoneNumber implements IPassengerPhoneNumber {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    passengerId: string;
    isActive: boolean;
    isPrimary: boolean;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    passenger: Passenger;

    constructor(data?: IPassengerPhoneNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.note = _data["note"];
            this.passengerId = _data["passengerId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.deleterUserId = _data["deleterUserId"];
            this.passenger = _data["passenger"] ? Passenger.fromJS(_data["passenger"]) : undefined as any;
        }
    }

    static fromJS(data: any): PassengerPhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerPhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["note"] = this.note;
        data["passengerId"] = this.passengerId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["deleterUserId"] = this.deleterUserId;
        data["passenger"] = this.passenger ? this.passenger.toJSON() : undefined as any;
        return data;
    }

    clone(): PassengerPhoneNumber {
        const json = this.toJSON();
        let result = new PassengerPhoneNumber();
        result.init(json);
        return result;
    }
}

export interface IPassengerPhoneNumber {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    passengerId: string;
    isActive: boolean;
    isPrimary: boolean;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    passenger: Passenger;
}

export class PassengerPhoneNumberDto implements IPassengerPhoneNumberDto {
    id: string;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    passengerId: string;
    passenger: PassengerDto;

    constructor(data?: IPassengerPhoneNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.passengerId = _data["passengerId"];
            this.passenger = _data["passenger"] ? PassengerDto.fromJS(_data["passenger"]) : undefined as any;
        }
    }

    static fromJS(data: any): PassengerPhoneNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerPhoneNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["passengerId"] = this.passengerId;
        data["passenger"] = this.passenger ? this.passenger.toJSON() : undefined as any;
        return data;
    }

    clone(): PassengerPhoneNumberDto {
        const json = this.toJSON();
        let result = new PassengerPhoneNumberDto();
        result.init(json);
        return result;
    }
}

export interface IPassengerPhoneNumberDto {
    id: string;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    passengerId: string;
    passenger: PassengerDto;
}

export class PassengerSearchResultDto implements IPassengerSearchResultDto {
    id: string;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    middleName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    note: string | undefined;
    passportNumber: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    gender: string | undefined;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;

    constructor(data?: IPassengerSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.note = _data["note"];
            this.passportNumber = _data["passportNumber"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.zipOrPostCode = _data["zipOrPostCode"];
            this.stateOrProvince = _data["stateOrProvince"];
            this.country = _data["country"];
            this.gender = _data["gender"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureDocumentUrl = _data["profilePictureDocumentUrl"];
        }
    }

    static fromJS(data: any): PassengerSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["note"] = this.note;
        data["passportNumber"] = this.passportNumber;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["zipOrPostCode"] = this.zipOrPostCode;
        data["stateOrProvince"] = this.stateOrProvince;
        data["country"] = this.country;
        data["gender"] = this.gender;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureDocumentUrl"] = this.profilePictureDocumentUrl;
        return data;
    }

    clone(): PassengerSearchResultDto {
        const json = this.toJSON();
        let result = new PassengerSearchResultDto();
        result.init(json);
        return result;
    }
}

export interface IPassengerSearchResultDto {
    id: string;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    middleName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    note: string | undefined;
    passportNumber: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    gender: string | undefined;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
}

export class PassengerTag implements IPassengerTag {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    passengerId: string;
    passenger: Passenger;
    tagId: string;
    tag: Tag;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;

    constructor(data?: IPassengerTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.passengerId = _data["passengerId"];
            this.passenger = _data["passenger"] ? Passenger.fromJS(_data["passenger"]) : undefined as any;
            this.tagId = _data["tagId"];
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.deleterUserId = _data["deleterUserId"];
        }
    }

    static fromJS(data: any): PassengerTag {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["passengerId"] = this.passengerId;
        data["passenger"] = this.passenger ? this.passenger.toJSON() : undefined as any;
        data["tagId"] = this.tagId;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["deleterUserId"] = this.deleterUserId;
        return data;
    }

    clone(): PassengerTag {
        const json = this.toJSON();
        let result = new PassengerTag();
        result.init(json);
        return result;
    }
}

export interface IPassengerTag {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    passengerId: string;
    passenger: Passenger;
    tagId: string;
    tag: Tag;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
}

export class PassengerTagDto implements IPassengerTagDto {
    id: string;
    passengerId: string;
    tagId: string;
    tag: TagDto;

    constructor(data?: IPassengerTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.passengerId = _data["passengerId"];
            this.tagId = _data["tagId"];
            this.tag = _data["tag"] ? TagDto.fromJS(_data["tag"]) : undefined as any;
        }
    }

    static fromJS(data: any): PassengerTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["passengerId"] = this.passengerId;
        data["tagId"] = this.tagId;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined as any;
        return data;
    }

    clone(): PassengerTagDto {
        const json = this.toJSON();
        let result = new PassengerTagDto();
        result.init(json);
        return result;
    }
}

export interface IPassengerTagDto {
    id: string;
    passengerId: string;
    tagId: string;
    tag: TagDto;
}

export class Passport implements IPassport {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    issuingCountry: string | undefined;
    documentType: string | undefined;
    documentNo: string | undefined;
    issuedDate: moment.Moment;
    expirationDate: moment.Moment;
    name: string | undefined;
    surname: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    birthPlace: string | undefined;
    issuingAuthority: string | undefined;
    nationality: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    passengerId: string;
    passenger: Passenger;
    documentId: string | undefined;
    document: Document;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;

    constructor(data?: IPassport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.issuingCountry = _data["issuingCountry"];
            this.documentType = _data["documentType"];
            this.documentNo = _data["documentNo"];
            this.issuedDate = _data["issuedDate"] ? moment(_data["issuedDate"].toString()) : undefined as any;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : undefined as any;
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.middleName = _data["middleName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.birthPlace = _data["birthPlace"];
            this.issuingAuthority = _data["issuingAuthority"];
            this.nationality = _data["nationality"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.passengerId = _data["passengerId"];
            this.passenger = _data["passenger"] ? Passenger.fromJS(_data["passenger"]) : undefined as any;
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.deleterUserId = _data["deleterUserId"];
        }
    }

    static fromJS(data: any): Passport {
        data = typeof data === 'object' ? data : {};
        let result = new Passport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["issuingCountry"] = this.issuingCountry;
        data["documentType"] = this.documentType;
        data["documentNo"] = this.documentNo;
        data["issuedDate"] = this.issuedDate ? this.issuedDate.toISOString() : undefined as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["middleName"] = this.middleName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["birthPlace"] = this.birthPlace;
        data["issuingAuthority"] = this.issuingAuthority;
        data["nationality"] = this.nationality;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["passengerId"] = this.passengerId;
        data["passenger"] = this.passenger ? this.passenger.toJSON() : undefined as any;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["deleterUserId"] = this.deleterUserId;
        return data;
    }

    clone(): Passport {
        const json = this.toJSON();
        let result = new Passport();
        result.init(json);
        return result;
    }
}

export interface IPassport {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    issuingCountry: string | undefined;
    documentType: string | undefined;
    documentNo: string | undefined;
    issuedDate: moment.Moment;
    expirationDate: moment.Moment;
    name: string | undefined;
    surname: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    birthPlace: string | undefined;
    issuingAuthority: string | undefined;
    nationality: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    passengerId: string;
    passenger: Passenger;
    documentId: string | undefined;
    document: Document;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
}

export class PassportDto implements IPassportDto {
    id: string;
    issuingCountry: string | undefined;
    documentType: string | undefined;
    documentNo: string | undefined;
    issuedDate: moment.Moment;
    expirationDate: moment.Moment;
    name: string | undefined;
    surname: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    birthPlace: string | undefined;
    issuingAuthority: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    nationality: string | undefined;
    documentId: string | undefined;
    documentUrl: string | undefined;
    passengerId: string | undefined;

    constructor(data?: IPassportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issuingCountry = _data["issuingCountry"];
            this.documentType = _data["documentType"];
            this.documentNo = _data["documentNo"];
            this.issuedDate = _data["issuedDate"] ? moment(_data["issuedDate"].toString()) : undefined as any;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : undefined as any;
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.middleName = _data["middleName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.birthPlace = _data["birthPlace"];
            this.issuingAuthority = _data["issuingAuthority"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.nationality = _data["nationality"];
            this.documentId = _data["documentId"];
            this.documentUrl = _data["documentUrl"];
            this.passengerId = _data["passengerId"];
        }
    }

    static fromJS(data: any): PassportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issuingCountry"] = this.issuingCountry;
        data["documentType"] = this.documentType;
        data["documentNo"] = this.documentNo;
        data["issuedDate"] = this.issuedDate ? this.issuedDate.toISOString() : undefined as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["middleName"] = this.middleName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["birthPlace"] = this.birthPlace;
        data["issuingAuthority"] = this.issuingAuthority;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["nationality"] = this.nationality;
        data["documentId"] = this.documentId;
        data["documentUrl"] = this.documentUrl;
        data["passengerId"] = this.passengerId;
        return data;
    }

    clone(): PassportDto {
        const json = this.toJSON();
        let result = new PassportDto();
        result.init(json);
        return result;
    }
}

export interface IPassportDto {
    id: string;
    issuingCountry: string | undefined;
    documentType: string | undefined;
    documentNo: string | undefined;
    issuedDate: moment.Moment;
    expirationDate: moment.Moment;
    name: string | undefined;
    surname: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    birthPlace: string | undefined;
    issuingAuthority: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    nationality: string | undefined;
    documentId: string | undefined;
    documentUrl: string | undefined;
    passengerId: string | undefined;
}

export class PassportDtoPagedResultDto implements IPassportDtoPagedResultDto {
    items: PassportDto[] | undefined;
    totalCount: number;

    constructor(data?: IPassportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PassportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PassportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PassportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PassportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPassportDtoPagedResultDto {
    items: PassportDto[] | undefined;
    totalCount: number;
}

export class PaymentApiDto implements IPaymentApiDto {
    /** TravelPort order ID */
    bookingReference: string | undefined;
    /** PNR / GDS locator code */
    pnr: string | undefined;
    /** Ticketed | Pending | Failed */
    status: string | undefined;
    /** Issued e-ticket number(s) */
    ticketNumbers: string[] | undefined;
    amount: number;
    currency: string | undefined;
    authorizationCode: string | undefined;

    constructor(data?: IPaymentApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingReference = _data["bookingReference"];
            this.pnr = _data["pnr"];
            this.status = _data["status"];
            if (Array.isArray(_data["ticketNumbers"])) {
                this.ticketNumbers = [] as any;
                for (let item of _data["ticketNumbers"])
                    this.ticketNumbers.push(item);
            }
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.authorizationCode = _data["authorizationCode"];
        }
    }

    static fromJS(data: any): PaymentApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingReference"] = this.bookingReference;
        data["pnr"] = this.pnr;
        data["status"] = this.status;
        if (Array.isArray(this.ticketNumbers)) {
            data["ticketNumbers"] = [];
            for (let item of this.ticketNumbers)
                data["ticketNumbers"].push(item);
        }
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["authorizationCode"] = this.authorizationCode;
        return data;
    }

    clone(): PaymentApiDto {
        const json = this.toJSON();
        let result = new PaymentApiDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentApiDto {
    /** TravelPort order ID */
    bookingReference: string | undefined;
    /** PNR / GDS locator code */
    pnr: string | undefined;
    /** Ticketed | Pending | Failed */
    status: string | undefined;
    /** Issued e-ticket number(s) */
    ticketNumbers: string[] | undefined;
    amount: number;
    currency: string | undefined;
    authorizationCode: string | undefined;
}

export class PaymentApiRequest implements IPaymentApiRequest {
    /** The booking reference (TravelPort order ID) returned from /api/flights/book */
    bookingReference: string;
    /** PNR / locator code returned from /api/flights/book */
    pnr: string;
    amount: number;
    currency: string;
    card: PaymentCardApiRequest;
    billingAddress: PaymentBillingAddressApiRequest;

    constructor(data?: IPaymentApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.card = new PaymentCardApiRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingReference = _data["bookingReference"];
            this.pnr = _data["pnr"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.card = _data["card"] ? PaymentCardApiRequest.fromJS(_data["card"]) : new PaymentCardApiRequest();
            this.billingAddress = _data["billingAddress"] ? PaymentBillingAddressApiRequest.fromJS(_data["billingAddress"]) : undefined as any;
        }
    }

    static fromJS(data: any): PaymentApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingReference"] = this.bookingReference;
        data["pnr"] = this.pnr;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : undefined as any;
        return data;
    }

    clone(): PaymentApiRequest {
        const json = this.toJSON();
        let result = new PaymentApiRequest();
        result.init(json);
        return result;
    }
}

export interface IPaymentApiRequest {
    /** The booking reference (TravelPort order ID) returned from /api/flights/book */
    bookingReference: string;
    /** PNR / locator code returned from /api/flights/book */
    pnr: string;
    amount: number;
    currency: string;
    card: PaymentCardApiRequest;
    billingAddress: PaymentBillingAddressApiRequest;
}

export class PaymentBillingAddressApiRequest implements IPaymentBillingAddressApiRequest {
    street: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    country: string | undefined;
    state: string | undefined;

    constructor(data?: IPaymentBillingAddressApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.country = _data["country"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): PaymentBillingAddressApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBillingAddressApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        data["state"] = this.state;
        return data;
    }

    clone(): PaymentBillingAddressApiRequest {
        const json = this.toJSON();
        let result = new PaymentBillingAddressApiRequest();
        result.init(json);
        return result;
    }
}

export interface IPaymentBillingAddressApiRequest {
    street: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    country: string | undefined;
    state: string | undefined;
}

export class PaymentCardApiRequest implements IPaymentCardApiRequest {
    /** Card type code: VI | CA | AX | DS | DC */
    cardCode: string;
    cardNumber: string;
    /** MM — e.g. "12" */
    expiryMonth: string;
    /** YYYY — e.g. "2028" */
    expiryYear: string;
    cardHolderName: string;
    cvv: string | undefined;

    constructor(data?: IPaymentCardApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardCode = _data["cardCode"];
            this.cardNumber = _data["cardNumber"];
            this.expiryMonth = _data["expiryMonth"];
            this.expiryYear = _data["expiryYear"];
            this.cardHolderName = _data["cardHolderName"];
            this.cvv = _data["cvv"];
        }
    }

    static fromJS(data: any): PaymentCardApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentCardApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardCode"] = this.cardCode;
        data["cardNumber"] = this.cardNumber;
        data["expiryMonth"] = this.expiryMonth;
        data["expiryYear"] = this.expiryYear;
        data["cardHolderName"] = this.cardHolderName;
        data["cvv"] = this.cvv;
        return data;
    }

    clone(): PaymentCardApiRequest {
        const json = this.toJSON();
        let result = new PaymentCardApiRequest();
        result.init(json);
        return result;
    }
}

export interface IPaymentCardApiRequest {
    /** Card type code: VI | CA | AX | DS | DC */
    cardCode: string;
    cardNumber: string;
    /** MM — e.g. "12" */
    expiryMonth: string;
    /** YYYY — e.g. "2028" */
    expiryYear: string;
    cardHolderName: string;
    cvv: string | undefined;
}

export class PermissionDto implements IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PhoneNumber implements IPhoneNumber {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    userId: number;
    isActive: boolean;
    isPrimary: boolean;
    user: User;

    constructor(data?: IPhoneNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.note = _data["note"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): PhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["note"] = this.note;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }

    clone(): PhoneNumber {
        const json = this.toJSON();
        let result = new PhoneNumber();
        result.init(json);
        return result;
    }
}

export interface IPhoneNumber {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    userId: number;
    isActive: boolean;
    isPrimary: boolean;
    user: User;
}

export class PhoneNumberDto implements IPhoneNumberDto {
    id: string;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    userId: number;
    isActive: boolean;
    isPrimary: boolean;

    constructor(data?: IPhoneNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.note = _data["note"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): PhoneNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["note"] = this.note;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        return data;
    }

    clone(): PhoneNumberDto {
        const json = this.toJSON();
        let result = new PhoneNumberDto();
        result.init(json);
        return result;
    }
}

export interface IPhoneNumberDto {
    id: string;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    userId: number;
    isActive: boolean;
    isPrimary: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;
}

export class ProcessedDocument implements IProcessedDocument {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    typeId: string | undefined;
    type: AppSettingOption;
    note: string | undefined;

    constructor(data?: IProcessedDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.bookingId = _data["bookingId"];
            this.booking = _data["booking"] ? Booking.fromJS(_data["booking"]) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ProcessedDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["bookingId"] = this.bookingId;
        data["booking"] = this.booking ? this.booking.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["note"] = this.note;
        return data;
    }

    clone(): ProcessedDocument {
        const json = this.toJSON();
        let result = new ProcessedDocument();
        result.init(json);
        return result;
    }
}

export interface IProcessedDocument {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    typeId: string | undefined;
    type: AppSettingOption;
    note: string | undefined;
}

export class ProcessedPackage implements IProcessedPackage {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    typeId: string | undefined;
    type: AppSettingOption;
    isVisaRequired: boolean;
    title: string | undefined;
    packageId: string | undefined;
    package: Package;
    packageTravelId: string | undefined;
    packageTravel: PackageTravel;
    agentId: string | undefined;
    agent: Agent;
    resaAgentId: number | undefined;
    resaAgent: User;
    salesAgentId: number | undefined;
    salesAgent: User;
    note: string | undefined;
    manualTravelDate: moment.Moment | undefined;
    manualPackageTitle: string | undefined;
    willAvailTravelInsurance: boolean;
    addOns: ProcessedPackageAddOn[] | undefined;
    assignedRooms: ProcessedPackageRoom[] | undefined;

    constructor(data?: IProcessedPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.bookingId = _data["bookingId"];
            this.booking = _data["booking"] ? Booking.fromJS(_data["booking"]) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.isVisaRequired = _data["isVisaRequired"];
            this.title = _data["title"];
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined as any;
            this.packageTravelId = _data["packageTravelId"];
            this.packageTravel = _data["packageTravel"] ? PackageTravel.fromJS(_data["packageTravel"]) : undefined as any;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            this.resaAgentId = _data["resaAgentId"];
            this.resaAgent = _data["resaAgent"] ? User.fromJS(_data["resaAgent"]) : undefined as any;
            this.salesAgentId = _data["salesAgentId"];
            this.salesAgent = _data["salesAgent"] ? User.fromJS(_data["salesAgent"]) : undefined as any;
            this.note = _data["note"];
            this.manualTravelDate = _data["manualTravelDate"] ? moment(_data["manualTravelDate"].toString()) : undefined as any;
            this.manualPackageTitle = _data["manualPackageTitle"];
            this.willAvailTravelInsurance = _data["willAvailTravelInsurance"];
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns.push(ProcessedPackageAddOn.fromJS(item));
            }
            if (Array.isArray(_data["assignedRooms"])) {
                this.assignedRooms = [] as any;
                for (let item of _data["assignedRooms"])
                    this.assignedRooms.push(ProcessedPackageRoom.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessedPackage {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["bookingId"] = this.bookingId;
        data["booking"] = this.booking ? this.booking.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["isVisaRequired"] = this.isVisaRequired;
        data["title"] = this.title;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["packageTravelId"] = this.packageTravelId;
        data["packageTravel"] = this.packageTravel ? this.packageTravel.toJSON() : undefined as any;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["resaAgentId"] = this.resaAgentId;
        data["resaAgent"] = this.resaAgent ? this.resaAgent.toJSON() : undefined as any;
        data["salesAgentId"] = this.salesAgentId;
        data["salesAgent"] = this.salesAgent ? this.salesAgent.toJSON() : undefined as any;
        data["note"] = this.note;
        data["manualTravelDate"] = this.manualTravelDate ? this.manualTravelDate.toISOString() : undefined as any;
        data["manualPackageTitle"] = this.manualPackageTitle;
        data["willAvailTravelInsurance"] = this.willAvailTravelInsurance;
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignedRooms)) {
            data["assignedRooms"] = [];
            for (let item of this.assignedRooms)
                data["assignedRooms"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ProcessedPackage {
        const json = this.toJSON();
        let result = new ProcessedPackage();
        result.init(json);
        return result;
    }
}

export interface IProcessedPackage {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    typeId: string | undefined;
    type: AppSettingOption;
    isVisaRequired: boolean;
    title: string | undefined;
    packageId: string | undefined;
    package: Package;
    packageTravelId: string | undefined;
    packageTravel: PackageTravel;
    agentId: string | undefined;
    agent: Agent;
    resaAgentId: number | undefined;
    resaAgent: User;
    salesAgentId: number | undefined;
    salesAgent: User;
    note: string | undefined;
    manualTravelDate: moment.Moment | undefined;
    manualPackageTitle: string | undefined;
    willAvailTravelInsurance: boolean;
    addOns: ProcessedPackageAddOn[] | undefined;
    assignedRooms: ProcessedPackageRoom[] | undefined;
}

export class ProcessedPackageAddOn implements IProcessedPackageAddOn {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    processedPackageId: string | undefined;
    package: ProcessedPackage;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;

    constructor(data?: IProcessedPackageAddOn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.processedPackageId = _data["processedPackageId"];
            this.package = _data["package"] ? ProcessedPackage.fromJS(_data["package"]) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.note = _data["note"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): ProcessedPackageAddOn {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedPackageAddOn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["processedPackageId"] = this.processedPackageId;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["note"] = this.note;
        data["price"] = this.price;
        return data;
    }

    clone(): ProcessedPackageAddOn {
        const json = this.toJSON();
        let result = new ProcessedPackageAddOn();
        result.init(json);
        return result;
    }
}

export interface IProcessedPackageAddOn {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    processedPackageId: string | undefined;
    package: ProcessedPackage;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;
}

export class ProcessedPackageRoom implements IProcessedPackageRoom {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedPackageId: string;
    processedPackage: ProcessedPackage;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    attachDocumentId: string | undefined;
    attachDocument: Document;

    constructor(data?: IProcessedPackageRoom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.processedPackageId = _data["processedPackageId"];
            this.processedPackage = _data["processedPackage"] ? ProcessedPackage.fromJS(_data["processedPackage"]) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.note = _data["note"];
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocument = _data["attachDocument"] ? Document.fromJS(_data["attachDocument"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProcessedPackageRoom {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedPackageRoom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["processedPackageId"] = this.processedPackageId;
        data["processedPackage"] = this.processedPackage ? this.processedPackage.toJSON() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["note"] = this.note;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocument"] = this.attachDocument ? this.attachDocument.toJSON() : undefined as any;
        return data;
    }

    clone(): ProcessedPackageRoom {
        const json = this.toJSON();
        let result = new ProcessedPackageRoom();
        result.init(json);
        return result;
    }
}

export interface IProcessedPackageRoom {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedPackageId: string;
    processedPackage: ProcessedPackage;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    attachDocumentId: string | undefined;
    attachDocument: Document;
}

export class ProcessedTicket implements IProcessedTicket {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    bookingId: string;
    booking: Booking;
    flights: ProcessedTicketFlight[] | undefined;
    rates: ProcessedTicketRate[] | undefined;
    adultCount: number;
    childCount: number;
    infantCount: number;
    note: string | undefined;

    constructor(data?: IProcessedTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.bookingId = _data["bookingId"];
            this.booking = _data["booking"] ? Booking.fromJS(_data["booking"]) : undefined as any;
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights.push(ProcessedTicketFlight.fromJS(item));
            }
            if (Array.isArray(_data["rates"])) {
                this.rates = [] as any;
                for (let item of _data["rates"])
                    this.rates.push(ProcessedTicketRate.fromJS(item));
            }
            this.adultCount = _data["adultCount"];
            this.childCount = _data["childCount"];
            this.infantCount = _data["infantCount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ProcessedTicket {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["bookingId"] = this.bookingId;
        data["booking"] = this.booking ? this.booking.toJSON() : undefined as any;
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rates)) {
            data["rates"] = [];
            for (let item of this.rates)
                data["rates"].push(item ? item.toJSON() : undefined as any);
        }
        data["adultCount"] = this.adultCount;
        data["childCount"] = this.childCount;
        data["infantCount"] = this.infantCount;
        data["note"] = this.note;
        return data;
    }

    clone(): ProcessedTicket {
        const json = this.toJSON();
        let result = new ProcessedTicket();
        result.init(json);
        return result;
    }
}

export interface IProcessedTicket {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    bookingId: string;
    booking: Booking;
    flights: ProcessedTicketFlight[] | undefined;
    rates: ProcessedTicketRate[] | undefined;
    adultCount: number;
    childCount: number;
    infantCount: number;
    note: string | undefined;
}

export class ProcessedTicketFlight implements IProcessedTicketFlight {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    ticketId: string | undefined;
    ticket: ProcessedTicket;
    typeId: string | undefined;
    type: AppSettingOption;
    name: string | undefined;
    flightDetails: ProcessedTicketFlightDetail[] | undefined;

    constructor(data?: IProcessedTicketFlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.ticketId = _data["ticketId"];
            this.ticket = _data["ticket"] ? ProcessedTicket.fromJS(_data["ticket"]) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.name = _data["name"];
            if (Array.isArray(_data["flightDetails"])) {
                this.flightDetails = [] as any;
                for (let item of _data["flightDetails"])
                    this.flightDetails.push(ProcessedTicketFlightDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessedTicketFlight {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedTicketFlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["ticketId"] = this.ticketId;
        data["ticket"] = this.ticket ? this.ticket.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["name"] = this.name;
        if (Array.isArray(this.flightDetails)) {
            data["flightDetails"] = [];
            for (let item of this.flightDetails)
                data["flightDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ProcessedTicketFlight {
        const json = this.toJSON();
        let result = new ProcessedTicketFlight();
        result.init(json);
        return result;
    }
}

export interface IProcessedTicketFlight {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    ticketId: string | undefined;
    ticket: ProcessedTicket;
    typeId: string | undefined;
    type: AppSettingOption;
    name: string | undefined;
    flightDetails: ProcessedTicketFlightDetail[] | undefined;
}

export class ProcessedTicketFlightDetail implements IProcessedTicketFlightDetail {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedTicketFlightId: string | undefined;
    flight: ProcessedTicketFlight;
    typeId: string | undefined;
    type: AppSettingOption;
    order: number;
    airline: string | undefined;
    flightNo: string | undefined;
    from: string | undefined;
    to: string | undefined;
    estimatedTimeDeparture: moment.Moment;
    estimatedTimeArrival: moment.Moment;

    constructor(data?: IProcessedTicketFlightDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.processedTicketFlightId = _data["processedTicketFlightId"];
            this.flight = _data["flight"] ? ProcessedTicketFlight.fromJS(_data["flight"]) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.order = _data["order"];
            this.airline = _data["airline"];
            this.flightNo = _data["flightNo"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.estimatedTimeDeparture = _data["estimatedTimeDeparture"] ? moment(_data["estimatedTimeDeparture"].toString()) : undefined as any;
            this.estimatedTimeArrival = _data["estimatedTimeArrival"] ? moment(_data["estimatedTimeArrival"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ProcessedTicketFlightDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedTicketFlightDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["processedTicketFlightId"] = this.processedTicketFlightId;
        data["flight"] = this.flight ? this.flight.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["order"] = this.order;
        data["airline"] = this.airline;
        data["flightNo"] = this.flightNo;
        data["from"] = this.from;
        data["to"] = this.to;
        data["estimatedTimeDeparture"] = this.estimatedTimeDeparture ? this.estimatedTimeDeparture.toISOString() : undefined as any;
        data["estimatedTimeArrival"] = this.estimatedTimeArrival ? this.estimatedTimeArrival.toISOString() : undefined as any;
        return data;
    }

    clone(): ProcessedTicketFlightDetail {
        const json = this.toJSON();
        let result = new ProcessedTicketFlightDetail();
        result.init(json);
        return result;
    }
}

export interface IProcessedTicketFlightDetail {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedTicketFlightId: string | undefined;
    flight: ProcessedTicketFlight;
    typeId: string | undefined;
    type: AppSettingOption;
    order: number;
    airline: string | undefined;
    flightNo: string | undefined;
    from: string | undefined;
    to: string | undefined;
    estimatedTimeDeparture: moment.Moment;
    estimatedTimeArrival: moment.Moment;
}

export class ProcessedTicketRate implements IProcessedTicketRate {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    note: string | undefined;
    pricePerPax: number;
    totalPrice: number;
    addOns: ProcessedTicketRateAddOn[] | undefined;

    constructor(data?: IProcessedTicketRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.note = _data["note"];
            this.pricePerPax = _data["pricePerPax"];
            this.totalPrice = _data["totalPrice"];
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns.push(ProcessedTicketRateAddOn.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessedTicketRate {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedTicketRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["note"] = this.note;
        data["pricePerPax"] = this.pricePerPax;
        data["totalPrice"] = this.totalPrice;
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ProcessedTicketRate {
        const json = this.toJSON();
        let result = new ProcessedTicketRate();
        result.init(json);
        return result;
    }
}

export interface IProcessedTicketRate {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    note: string | undefined;
    pricePerPax: number;
    totalPrice: number;
    addOns: ProcessedTicketRateAddOn[] | undefined;
}

export class ProcessedTicketRateAddOn implements IProcessedTicketRateAddOn {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    name: string | undefined;
    description: string | undefined;
    price: number | undefined;

    constructor(data?: IProcessedTicketRateAddOn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): ProcessedTicketRateAddOn {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedTicketRateAddOn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        return data;
    }

    clone(): ProcessedTicketRateAddOn {
        const json = this.toJSON();
        let result = new ProcessedTicketRateAddOn();
        result.init(json);
        return result;
    }
}

export interface IProcessedTicketRateAddOn {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    typeId: string | undefined;
    type: AppSettingOption;
    name: string | undefined;
    description: string | undefined;
    price: number | undefined;
}

export class ProcessedVisa implements IProcessedVisa {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    typeId: string | undefined;
    type: AppSettingOption;
    statusId: string | undefined;
    status: AppSettingOption;
    statusAttachments: ProcessedVisaStatus[] | undefined;
    embassyId: string | undefined;
    embassy: AppSettingOption;
    requirements: ProcessedVisaRequirement[] | undefined;
    note: string | undefined;

    constructor(data?: IProcessedVisa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.bookingId = _data["bookingId"];
            this.booking = _data["booking"] ? Booking.fromJS(_data["booking"]) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? AppSettingOption.fromJS(_data["status"]) : undefined as any;
            if (Array.isArray(_data["statusAttachments"])) {
                this.statusAttachments = [] as any;
                for (let item of _data["statusAttachments"])
                    this.statusAttachments.push(ProcessedVisaStatus.fromJS(item));
            }
            this.embassyId = _data["embassyId"];
            this.embassy = _data["embassy"] ? AppSettingOption.fromJS(_data["embassy"]) : undefined as any;
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements.push(ProcessedVisaRequirement.fromJS(item));
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ProcessedVisa {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedVisa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["bookingId"] = this.bookingId;
        data["booking"] = this.booking ? this.booking.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        if (Array.isArray(this.statusAttachments)) {
            data["statusAttachments"] = [];
            for (let item of this.statusAttachments)
                data["statusAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["embassyId"] = this.embassyId;
        data["embassy"] = this.embassy ? this.embassy.toJSON() : undefined as any;
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item ? item.toJSON() : undefined as any);
        }
        data["note"] = this.note;
        return data;
    }

    clone(): ProcessedVisa {
        const json = this.toJSON();
        let result = new ProcessedVisa();
        result.init(json);
        return result;
    }
}

export interface IProcessedVisa {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    typeId: string | undefined;
    type: AppSettingOption;
    statusId: string | undefined;
    status: AppSettingOption;
    statusAttachments: ProcessedVisaStatus[] | undefined;
    embassyId: string | undefined;
    embassy: AppSettingOption;
    requirements: ProcessedVisaRequirement[] | undefined;
    note: string | undefined;
}

export class ProcessedVisaRequirement implements IProcessedVisaRequirement {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedVisaId: string | undefined;
    processedVisa: ProcessedVisa;
    typeId: string | undefined;
    type: AppSettingOption;
    isFulfilled: boolean;
    attachments: ProcessedVisaRequirementAttachment[] | undefined;
    passengerId: string | undefined;
    passenger: Passenger;

    constructor(data?: IProcessedVisaRequirement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.processedVisaId = _data["processedVisaId"];
            this.processedVisa = _data["processedVisa"] ? ProcessedVisa.fromJS(_data["processedVisa"]) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            this.isFulfilled = _data["isFulfilled"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(ProcessedVisaRequirementAttachment.fromJS(item));
            }
            this.passengerId = _data["passengerId"];
            this.passenger = _data["passenger"] ? Passenger.fromJS(_data["passenger"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProcessedVisaRequirement {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedVisaRequirement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["processedVisaId"] = this.processedVisaId;
        data["processedVisa"] = this.processedVisa ? this.processedVisa.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["isFulfilled"] = this.isFulfilled;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["passengerId"] = this.passengerId;
        data["passenger"] = this.passenger ? this.passenger.toJSON() : undefined as any;
        return data;
    }

    clone(): ProcessedVisaRequirement {
        const json = this.toJSON();
        let result = new ProcessedVisaRequirement();
        result.init(json);
        return result;
    }
}

export interface IProcessedVisaRequirement {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedVisaId: string | undefined;
    processedVisa: ProcessedVisa;
    typeId: string | undefined;
    type: AppSettingOption;
    isFulfilled: boolean;
    attachments: ProcessedVisaRequirementAttachment[] | undefined;
    passengerId: string | undefined;
    passenger: Passenger;
}

export class ProcessedVisaRequirementAttachment implements IProcessedVisaRequirementAttachment {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedVisaRequirementId: string | undefined;
    processedVisaRequirement: ProcessedVisaRequirement;
    attachDocumentId: string | undefined;
    attachDocument: Document;

    constructor(data?: IProcessedVisaRequirementAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.processedVisaRequirementId = _data["processedVisaRequirementId"];
            this.processedVisaRequirement = _data["processedVisaRequirement"] ? ProcessedVisaRequirement.fromJS(_data["processedVisaRequirement"]) : undefined as any;
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocument = _data["attachDocument"] ? Document.fromJS(_data["attachDocument"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProcessedVisaRequirementAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedVisaRequirementAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["processedVisaRequirementId"] = this.processedVisaRequirementId;
        data["processedVisaRequirement"] = this.processedVisaRequirement ? this.processedVisaRequirement.toJSON() : undefined as any;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocument"] = this.attachDocument ? this.attachDocument.toJSON() : undefined as any;
        return data;
    }

    clone(): ProcessedVisaRequirementAttachment {
        const json = this.toJSON();
        let result = new ProcessedVisaRequirementAttachment();
        result.init(json);
        return result;
    }
}

export interface IProcessedVisaRequirementAttachment {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedVisaRequirementId: string | undefined;
    processedVisaRequirement: ProcessedVisaRequirement;
    attachDocumentId: string | undefined;
    attachDocument: Document;
}

export class ProcessedVisaStatus implements IProcessedVisaStatus {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedVisaId: string | undefined;
    processedVisa: ProcessedVisa;
    typeId: string | undefined;
    type: AppSettingOption;
    attachments: ProcessedVisaStatusAttachment[] | undefined;

    constructor(data?: IProcessedVisaStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.processedVisaId = _data["processedVisaId"];
            this.processedVisa = _data["processedVisa"] ? ProcessedVisa.fromJS(_data["processedVisa"]) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(ProcessedVisaStatusAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessedVisaStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedVisaStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["processedVisaId"] = this.processedVisaId;
        data["processedVisa"] = this.processedVisa ? this.processedVisa.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ProcessedVisaStatus {
        const json = this.toJSON();
        let result = new ProcessedVisaStatus();
        result.init(json);
        return result;
    }
}

export interface IProcessedVisaStatus {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedVisaId: string | undefined;
    processedVisa: ProcessedVisa;
    typeId: string | undefined;
    type: AppSettingOption;
    attachments: ProcessedVisaStatusAttachment[] | undefined;
}

export class ProcessedVisaStatusAttachment implements IProcessedVisaStatusAttachment {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedVisaRequirementId: string | undefined;
    processedVisaStatus: ProcessedVisaRequirement;
    attachDocumentId: string | undefined;
    attachDocument: Document;

    constructor(data?: IProcessedVisaStatusAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.processedVisaRequirementId = _data["processedVisaRequirementId"];
            this.processedVisaStatus = _data["processedVisaStatus"] ? ProcessedVisaRequirement.fromJS(_data["processedVisaStatus"]) : undefined as any;
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocument = _data["attachDocument"] ? Document.fromJS(_data["attachDocument"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProcessedVisaStatusAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedVisaStatusAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["processedVisaRequirementId"] = this.processedVisaRequirementId;
        data["processedVisaStatus"] = this.processedVisaStatus ? this.processedVisaStatus.toJSON() : undefined as any;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocument"] = this.attachDocument ? this.attachDocument.toJSON() : undefined as any;
        return data;
    }

    clone(): ProcessedVisaStatusAttachment {
        const json = this.toJSON();
        let result = new ProcessedVisaStatusAttachment();
        result.init(json);
        return result;
    }
}

export interface IProcessedVisaStatusAttachment {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    processedVisaRequirementId: string | undefined;
    processedVisaStatus: ProcessedVisaRequirement;
    attachDocumentId: string | undefined;
    attachDocument: Document;
}

/** DTO for progressing through booking steps with auto-save */
export class ProgressStepDto implements IProgressStepDto {
    customerBookingId: string;
    nextStep: number;
    /** Form data to save before progressing (JSON format) */
    formData: string | undefined;
    /** Updated traveler information */
    travelers: CreateCustomerTravelerDto[] | undefined;
    /** Contact information updates */
    contactEmail: string | undefined;
    contactPhone: string | undefined;

    constructor(data?: IProgressStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerBookingId = _data["customerBookingId"];
            this.nextStep = _data["nextStep"];
            this.formData = _data["formData"];
            if (Array.isArray(_data["travelers"])) {
                this.travelers = [] as any;
                for (let item of _data["travelers"])
                    this.travelers.push(CreateCustomerTravelerDto.fromJS(item));
            }
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
        }
    }

    static fromJS(data: any): ProgressStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerBookingId"] = this.customerBookingId;
        data["nextStep"] = this.nextStep;
        data["formData"] = this.formData;
        if (Array.isArray(this.travelers)) {
            data["travelers"] = [];
            for (let item of this.travelers)
                data["travelers"].push(item ? item.toJSON() : undefined as any);
        }
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        return data;
    }

    clone(): ProgressStepDto {
        const json = this.toJSON();
        let result = new ProgressStepDto();
        result.init(json);
        return result;
    }
}

/** DTO for progressing through booking steps with auto-save */
export interface IProgressStepDto {
    customerBookingId: string;
    nextStep: number;
    /** Form data to save before progressing (JSON format) */
    formData: string | undefined;
    /** Updated traveler information */
    travelers: CreateCustomerTravelerDto[] | undefined;
    /** Contact information updates */
    contactEmail: string | undefined;
    contactPhone: string | undefined;
}

export class PublicCustomerPaymentReceiptDto implements IPublicCustomerPaymentReceiptDto {
    id: string;
    receiptNumber: string | undefined;
    amount: number;
    currency: string | undefined;
    paymentDate: moment.Moment;
    uploadDate: moment.Moment;
    receiptType: CustomerPaymentReceiptType;
    status: CustomerPaymentReceiptStatus;
    notes: string | undefined;
    rejectionReason: string | undefined;
    customerBookingId: string;
    verifiedByUserId: number | undefined;
    verificationDate: moment.Moment | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    fileSize: number;
    fileUrl: string | undefined;
    ipAddress: string | undefined;
    userAgent: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IPublicCustomerPaymentReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receiptNumber = _data["receiptNumber"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : undefined as any;
            this.uploadDate = _data["uploadDate"] ? moment(_data["uploadDate"].toString()) : undefined as any;
            this.receiptType = _data["receiptType"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.rejectionReason = _data["rejectionReason"];
            this.customerBookingId = _data["customerBookingId"];
            this.verifiedByUserId = _data["verifiedByUserId"];
            this.verificationDate = _data["verificationDate"] ? moment(_data["verificationDate"].toString()) : undefined as any;
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileSize = _data["fileSize"];
            this.fileUrl = _data["fileUrl"];
            this.ipAddress = _data["ipAddress"];
            this.userAgent = _data["userAgent"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): PublicCustomerPaymentReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicCustomerPaymentReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receiptNumber"] = this.receiptNumber;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined as any;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : undefined as any;
        data["receiptType"] = this.receiptType;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["rejectionReason"] = this.rejectionReason;
        data["customerBookingId"] = this.customerBookingId;
        data["verifiedByUserId"] = this.verifiedByUserId;
        data["verificationDate"] = this.verificationDate ? this.verificationDate.toISOString() : undefined as any;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["ipAddress"] = this.ipAddress;
        data["userAgent"] = this.userAgent;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        return data;
    }

    clone(): PublicCustomerPaymentReceiptDto {
        const json = this.toJSON();
        let result = new PublicCustomerPaymentReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IPublicCustomerPaymentReceiptDto {
    id: string;
    receiptNumber: string | undefined;
    amount: number;
    currency: string | undefined;
    paymentDate: moment.Moment;
    uploadDate: moment.Moment;
    receiptType: CustomerPaymentReceiptType;
    status: CustomerPaymentReceiptStatus;
    notes: string | undefined;
    rejectionReason: string | undefined;
    customerBookingId: string;
    verifiedByUserId: number | undefined;
    verificationDate: moment.Moment | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    fileSize: number;
    fileUrl: string | undefined;
    ipAddress: string | undefined;
    userAgent: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class PublicUserDetails implements IPublicUserDetails {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    profilePhotoUrl: string | undefined;
    profilePictureDocumentId: string | undefined;

    constructor(data?: IPublicUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.profilePhotoUrl = _data["profilePhotoUrl"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
        }
    }

    static fromJS(data: any): PublicUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PublicUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["profilePhotoUrl"] = this.profilePhotoUrl;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        return data;
    }

    clone(): PublicUserDetails {
        const json = this.toJSON();
        let result = new PublicUserDetails();
        result.init(json);
        return result;
    }
}

export interface IPublicUserDetails {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    profilePhotoUrl: string | undefined;
    profilePictureDocumentId: string | undefined;
}

export class PurchaseOrderDto implements IPurchaseOrderDto {
    id: string;
    bookingId: string;
    bookingRef: string | undefined;
    status: AppSettingOptionDto;
    supplier: SupplierDto;
    paymentDue: moment.Moment | undefined;
    purchaseOrderNumber: string | undefined;
    totalAmount: number;
    phpToUsdRate: number;
    note: string | undefined;
    handlerName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    creatorUser: string | undefined;
    lastModifierUser: string | undefined;
    lastModificationTime: moment.Moment;
    creationTime: moment.Moment;
    totalPaidAmount: number;
    remainingBalance: number;
    particulars: PurchaseOrderParticularDto[] | undefined;
    receipts: PurchaseOrderReceiptDto[] | undefined;

    constructor(data?: IPurchaseOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bookingId = _data["bookingId"];
            this.bookingRef = _data["bookingRef"];
            this.status = _data["status"] ? AppSettingOptionDto.fromJS(_data["status"]) : undefined as any;
            this.supplier = _data["supplier"] ? SupplierDto.fromJS(_data["supplier"]) : undefined as any;
            this.paymentDue = _data["paymentDue"] ? moment(_data["paymentDue"].toString()) : undefined as any;
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.totalAmount = _data["totalAmount"];
            this.phpToUsdRate = _data["phpToUsdRate"];
            this.note = _data["note"];
            this.handlerName = _data["handlerName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.creatorUser = _data["creatorUser"];
            this.lastModifierUser = _data["lastModifierUser"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.totalPaidAmount = _data["totalPaidAmount"];
            this.remainingBalance = _data["remainingBalance"];
            if (Array.isArray(_data["particulars"])) {
                this.particulars = [] as any;
                for (let item of _data["particulars"])
                    this.particulars.push(PurchaseOrderParticularDto.fromJS(item));
            }
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts.push(PurchaseOrderReceiptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookingId"] = this.bookingId;
        data["bookingRef"] = this.bookingRef;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        data["paymentDue"] = this.paymentDue ? this.paymentDue.toISOString() : undefined as any;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["totalAmount"] = this.totalAmount;
        data["phpToUsdRate"] = this.phpToUsdRate;
        data["note"] = this.note;
        data["handlerName"] = this.handlerName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["creatorUser"] = this.creatorUser;
        data["lastModifierUser"] = this.lastModifierUser;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["totalPaidAmount"] = this.totalPaidAmount;
        data["remainingBalance"] = this.remainingBalance;
        if (Array.isArray(this.particulars)) {
            data["particulars"] = [];
            for (let item of this.particulars)
                data["particulars"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PurchaseOrderDto {
        const json = this.toJSON();
        let result = new PurchaseOrderDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrderDto {
    id: string;
    bookingId: string;
    bookingRef: string | undefined;
    status: AppSettingOptionDto;
    supplier: SupplierDto;
    paymentDue: moment.Moment | undefined;
    purchaseOrderNumber: string | undefined;
    totalAmount: number;
    phpToUsdRate: number;
    note: string | undefined;
    handlerName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    creatorUser: string | undefined;
    lastModifierUser: string | undefined;
    lastModificationTime: moment.Moment;
    creationTime: moment.Moment;
    totalPaidAmount: number;
    remainingBalance: number;
    particulars: PurchaseOrderParticularDto[] | undefined;
    receipts: PurchaseOrderReceiptDto[] | undefined;
}

export class PurchaseOrderDtoPagedResultDto implements IPurchaseOrderDtoPagedResultDto {
    items: PurchaseOrderDto[] | undefined;
    totalCount: number;

    constructor(data?: IPurchaseOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PurchaseOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PurchaseOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PurchaseOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PurchaseOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrderDtoPagedResultDto {
    items: PurchaseOrderDto[] | undefined;
    totalCount: number;
}

export class PurchaseOrderParticularDto implements IPurchaseOrderParticularDto {
    id: string;
    name: string | undefined;
    price: number;
    quantity: number;
    total: number;
    isDeduction: boolean;
    sortOrder: number;

    constructor(data?: IPurchaseOrderParticularDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.total = _data["total"];
            this.isDeduction = _data["isDeduction"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): PurchaseOrderParticularDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderParticularDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        data["isDeduction"] = this.isDeduction;
        data["sortOrder"] = this.sortOrder;
        return data;
    }

    clone(): PurchaseOrderParticularDto {
        const json = this.toJSON();
        let result = new PurchaseOrderParticularDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrderParticularDto {
    id: string;
    name: string | undefined;
    price: number;
    quantity: number;
    total: number;
    isDeduction: boolean;
    sortOrder: number;
}

export class PurchaseOrderReceiptAttachmentDto implements IPurchaseOrderReceiptAttachmentDto {
    id: string;
    purchaseOrderReceiptId: string;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    creationTime: moment.Moment | undefined;
    size: number;

    constructor(data?: IPurchaseOrderReceiptAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseOrderReceiptId = _data["purchaseOrderReceiptId"];
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocumentUrl = _data["attachDocumentUrl"];
            this.attachDocumentName = _data["attachDocumentName"];
            this.attachDocumentFileType = _data["attachDocumentFileType"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): PurchaseOrderReceiptAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderReceiptAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseOrderReceiptId"] = this.purchaseOrderReceiptId;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocumentUrl"] = this.attachDocumentUrl;
        data["attachDocumentName"] = this.attachDocumentName;
        data["attachDocumentFileType"] = this.attachDocumentFileType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["size"] = this.size;
        return data;
    }

    clone(): PurchaseOrderReceiptAttachmentDto {
        const json = this.toJSON();
        let result = new PurchaseOrderReceiptAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrderReceiptAttachmentDto {
    id: string;
    purchaseOrderReceiptId: string;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    creationTime: moment.Moment | undefined;
    size: number;
}

export class PurchaseOrderReceiptDto implements IPurchaseOrderReceiptDto {
    id: string;
    amount: number;
    note: string | undefined;
    creationTime: moment.Moment;
    attachments: PurchaseOrderReceiptAttachmentDto[] | undefined;

    constructor(data?: IPurchaseOrderReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.note = _data["note"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(PurchaseOrderReceiptAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseOrderReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["note"] = this.note;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PurchaseOrderReceiptDto {
        const json = this.toJSON();
        let result = new PurchaseOrderReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrderReceiptDto {
    id: string;
    amount: number;
    note: string | undefined;
    creationTime: moment.Moment;
    attachments: PurchaseOrderReceiptAttachmentDto[] | undefined;
}

export class QuickAddPassengerDto implements IQuickAddPassengerDto {
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    dateOfBirth: moment.Moment | undefined;

    constructor(data?: IQuickAddPassengerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): QuickAddPassengerDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuickAddPassengerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        return data;
    }

    clone(): QuickAddPassengerDto {
        const json = this.toJSON();
        let result = new QuickAddPassengerDto();
        result.init(json);
        return result;
    }
}

export interface IQuickAddPassengerDto {
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    dateOfBirth: moment.Moment | undefined;
}

export class RateLimitInfoDto implements IRateLimitInfoDto {
    recentRequests: number;
    maxRecentRequests: number;
    recentWindowSeconds: number;
    dailyRequests: number;
    maxDailyRequests: number;
    dailyWindowSeconds: number;

    constructor(data?: IRateLimitInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recentRequests = _data["recentRequests"];
            this.maxRecentRequests = _data["maxRecentRequests"];
            this.recentWindowSeconds = _data["recentWindowSeconds"];
            this.dailyRequests = _data["dailyRequests"];
            this.maxDailyRequests = _data["maxDailyRequests"];
            this.dailyWindowSeconds = _data["dailyWindowSeconds"];
        }
    }

    static fromJS(data: any): RateLimitInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RateLimitInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recentRequests"] = this.recentRequests;
        data["maxRecentRequests"] = this.maxRecentRequests;
        data["recentWindowSeconds"] = this.recentWindowSeconds;
        data["dailyRequests"] = this.dailyRequests;
        data["maxDailyRequests"] = this.maxDailyRequests;
        data["dailyWindowSeconds"] = this.dailyWindowSeconds;
        return data;
    }

    clone(): RateLimitInfoDto {
        const json = this.toJSON();
        let result = new RateLimitInfoDto();
        result.init(json);
        return result;
    }
}

export interface IRateLimitInfoDto {
    recentRequests: number;
    maxRecentRequests: number;
    recentWindowSeconds: number;
    dailyRequests: number;
    maxDailyRequests: number;
    dailyWindowSeconds: number;
}

export class RecentSearchesDto implements IRecentSearchesDto {
    heading: string | undefined;
    searchTerms: string[] | undefined;

    constructor(data?: IRecentSearchesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            if (Array.isArray(_data["searchTerms"])) {
                this.searchTerms = [] as any;
                for (let item of _data["searchTerms"])
                    this.searchTerms.push(item);
            }
        }
    }

    static fromJS(data: any): RecentSearchesDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecentSearchesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        if (Array.isArray(this.searchTerms)) {
            data["searchTerms"] = [];
            for (let item of this.searchTerms)
                data["searchTerms"].push(item);
        }
        return data;
    }

    clone(): RecentSearchesDto {
        const json = this.toJSON();
        let result = new RecentSearchesDto();
        result.init(json);
        return result;
    }
}

export interface IRecentSearchesDto {
    heading: string | undefined;
    searchTerms: string[] | undefined;
}

export class RecentToursPackagesDto implements IRecentToursPackagesDto {
    heading: string | undefined;

    constructor(data?: IRecentToursPackagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
        }
    }

    static fromJS(data: any): RecentToursPackagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecentToursPackagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        return data;
    }

    clone(): RecentToursPackagesDto {
        const json = this.toJSON();
        let result = new RecentToursPackagesDto();
        result.init(json);
        return result;
    }
}

export interface IRecentToursPackagesDto {
    heading: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class ReviewAuthorImageDto implements IReviewAuthorImageDto {
    reviewId: string | undefined;
    authorImageFile: FileDto;

    constructor(data?: IReviewAuthorImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reviewId = _data["reviewId"];
            this.authorImageFile = _data["authorImageFile"] ? FileDto.fromJS(_data["authorImageFile"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReviewAuthorImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewAuthorImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewId"] = this.reviewId;
        data["authorImageFile"] = this.authorImageFile ? this.authorImageFile.toJSON() : undefined as any;
        return data;
    }

    clone(): ReviewAuthorImageDto {
        const json = this.toJSON();
        let result = new ReviewAuthorImageDto();
        result.init(json);
        return result;
    }
}

export interface IReviewAuthorImageDto {
    reviewId: string | undefined;
    authorImageFile: FileDto;
}

export class ReviewItemDto implements IReviewItemDto {
    id: string | undefined;
    customerName: string | undefined;
    reviewText: string | undefined;
    rating: number;
    profileImageUrl: string | undefined;
    order: number;

    constructor(data?: IReviewItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerName = _data["customerName"];
            this.reviewText = _data["reviewText"];
            this.rating = _data["rating"];
            this.profileImageUrl = _data["profileImageUrl"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): ReviewItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerName"] = this.customerName;
        data["reviewText"] = this.reviewText;
        data["rating"] = this.rating;
        data["profileImageUrl"] = this.profileImageUrl;
        data["order"] = this.order;
        return data;
    }

    clone(): ReviewItemDto {
        const json = this.toJSON();
        let result = new ReviewItemDto();
        result.init(json);
        return result;
    }
}

export interface IReviewItemDto {
    id: string | undefined;
    customerName: string | undefined;
    reviewText: string | undefined;
    rating: number;
    profileImageUrl: string | undefined;
    order: number;
}

export class ReviewSectionDto implements IReviewSectionDto {
    heading: string | undefined;
    buttonText: string | undefined;
    mainImageUrl: string | undefined;
    supportingImage1Url: string | undefined;
    supportingImage2Url: string | undefined;
    reviews: ReviewItemDto[] | undefined;

    constructor(data?: IReviewSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.buttonText = _data["buttonText"];
            this.mainImageUrl = _data["mainImageUrl"];
            this.supportingImage1Url = _data["supportingImage1Url"];
            this.supportingImage2Url = _data["supportingImage2Url"];
            if (Array.isArray(_data["reviews"])) {
                this.reviews = [] as any;
                for (let item of _data["reviews"])
                    this.reviews.push(ReviewItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReviewSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["buttonText"] = this.buttonText;
        data["mainImageUrl"] = this.mainImageUrl;
        data["supportingImage1Url"] = this.supportingImage1Url;
        data["supportingImage2Url"] = this.supportingImage2Url;
        if (Array.isArray(this.reviews)) {
            data["reviews"] = [];
            for (let item of this.reviews)
                data["reviews"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ReviewSectionDto {
        const json = this.toJSON();
        let result = new ReviewSectionDto();
        result.init(json);
        return result;
    }
}

export interface IReviewSectionDto {
    heading: string | undefined;
    buttonText: string | undefined;
    mainImageUrl: string | undefined;
    supportingImage1Url: string | undefined;
    supportingImage2Url: string | undefined;
    reviews: ReviewItemDto[] | undefined;
}

export class RoleDto implements IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class RoomBookingApiDto implements IRoomBookingApiDto {
    rateKey: string;
    guests: GuestApiDto[] | undefined;

    constructor(data?: IRoomBookingApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rateKey = _data["rateKey"];
            if (Array.isArray(_data["guests"])) {
                this.guests = [] as any;
                for (let item of _data["guests"])
                    this.guests.push(GuestApiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoomBookingApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomBookingApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rateKey"] = this.rateKey;
        if (Array.isArray(this.guests)) {
            data["guests"] = [];
            for (let item of this.guests)
                data["guests"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): RoomBookingApiDto {
        const json = this.toJSON();
        let result = new RoomBookingApiDto();
        result.init(json);
        return result;
    }
}

export interface IRoomBookingApiDto {
    rateKey: string;
    guests: GuestApiDto[] | undefined;
}

export class RoomOccupancyApiDto implements IRoomOccupancyApiDto {
    adults: number;
    childrenAges: number[] | undefined;

    constructor(data?: IRoomOccupancyApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adults = _data["adults"];
            if (Array.isArray(_data["childrenAges"])) {
                this.childrenAges = [] as any;
                for (let item of _data["childrenAges"])
                    this.childrenAges.push(item);
            }
        }
    }

    static fromJS(data: any): RoomOccupancyApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomOccupancyApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adults"] = this.adults;
        if (Array.isArray(this.childrenAges)) {
            data["childrenAges"] = [];
            for (let item of this.childrenAges)
                data["childrenAges"].push(item);
        }
        return data;
    }

    clone(): RoomOccupancyApiDto {
        const json = this.toJSON();
        let result = new RoomOccupancyApiDto();
        result.init(json);
        return result;
    }
}

export interface IRoomOccupancyApiDto {
    adults: number;
    childrenAges: number[] | undefined;
}

export class ScannedDocumentDto implements IScannedDocumentDto {
    mrzCode: string | undefined;
    documentNumber: string | undefined;
    dateOfBirth: string | undefined;
    sex: string | undefined;
    dateOfExpiry: string | undefined;
    surname: string | undefined;
    givenNames: string | undefined;
    placeOfBirth: string | undefined;
    nationality: string | undefined;
    dateOfIssue: string | undefined;
    issuingCountry: string | undefined;
    croppedDocumentFile: FileDto;
    faceDocumentFile: FileDto;

    constructor(data?: IScannedDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mrzCode = _data["mrzCode"];
            this.documentNumber = _data["documentNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.sex = _data["sex"];
            this.dateOfExpiry = _data["dateOfExpiry"];
            this.surname = _data["surname"];
            this.givenNames = _data["givenNames"];
            this.placeOfBirth = _data["placeOfBirth"];
            this.nationality = _data["nationality"];
            this.dateOfIssue = _data["dateOfIssue"];
            this.issuingCountry = _data["issuingCountry"];
            this.croppedDocumentFile = _data["croppedDocumentFile"] ? FileDto.fromJS(_data["croppedDocumentFile"]) : undefined as any;
            this.faceDocumentFile = _data["faceDocumentFile"] ? FileDto.fromJS(_data["faceDocumentFile"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScannedDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannedDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mrzCode"] = this.mrzCode;
        data["documentNumber"] = this.documentNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["sex"] = this.sex;
        data["dateOfExpiry"] = this.dateOfExpiry;
        data["surname"] = this.surname;
        data["givenNames"] = this.givenNames;
        data["placeOfBirth"] = this.placeOfBirth;
        data["nationality"] = this.nationality;
        data["dateOfIssue"] = this.dateOfIssue;
        data["issuingCountry"] = this.issuingCountry;
        data["croppedDocumentFile"] = this.croppedDocumentFile ? this.croppedDocumentFile.toJSON() : undefined as any;
        data["faceDocumentFile"] = this.faceDocumentFile ? this.faceDocumentFile.toJSON() : undefined as any;
        return data;
    }

    clone(): ScannedDocumentDto {
        const json = this.toJSON();
        let result = new ScannedDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IScannedDocumentDto {
    mrzCode: string | undefined;
    documentNumber: string | undefined;
    dateOfBirth: string | undefined;
    sex: string | undefined;
    dateOfExpiry: string | undefined;
    surname: string | undefined;
    givenNames: string | undefined;
    placeOfBirth: string | undefined;
    nationality: string | undefined;
    dateOfIssue: string | undefined;
    issuingCountry: string | undefined;
    croppedDocumentFile: FileDto;
    faceDocumentFile: FileDto;
}

export class ScannedDocumentResponseDto implements IScannedDocumentResponseDto {
    referenceCode: string | undefined;
    message: string | undefined;
    isSuccess: boolean;

    constructor(data?: IScannedDocumentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceCode = _data["referenceCode"];
            this.message = _data["message"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): ScannedDocumentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannedDocumentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceCode"] = this.referenceCode;
        data["message"] = this.message;
        data["isSuccess"] = this.isSuccess;
        return data;
    }

    clone(): ScannedDocumentResponseDto {
        const json = this.toJSON();
        let result = new ScannedDocumentResponseDto();
        result.init(json);
        return result;
    }
}

export interface IScannedDocumentResponseDto {
    referenceCode: string | undefined;
    message: string | undefined;
    isSuccess: boolean;
}

export class ScannedPassportDto implements IScannedPassportDto {
    id: string;
    mrzCode: string | undefined;
    documentNumber: string | undefined;
    dateOfBirth: string | undefined;
    sex: string | undefined;
    dateOfExpiry: string | undefined;
    surname: string | undefined;
    givenNames: string | undefined;
    placeOfBirth: string | undefined;
    nationality: string | undefined;
    dateOfIssue: string | undefined;
    issuingAuthority: string | undefined;
    issuingCountry: string | undefined;
    referenceNumber: string | undefined;
    passengerId: string | undefined;
    croppedDocumentFileId: string | undefined;
    croppedDocumentFileUrl: string | undefined;
    faceDocumentFileId: string | undefined;
    faceDocumentFileUrl: string | undefined;

    constructor(data?: IScannedPassportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mrzCode = _data["mrzCode"];
            this.documentNumber = _data["documentNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.sex = _data["sex"];
            this.dateOfExpiry = _data["dateOfExpiry"];
            this.surname = _data["surname"];
            this.givenNames = _data["givenNames"];
            this.placeOfBirth = _data["placeOfBirth"];
            this.nationality = _data["nationality"];
            this.dateOfIssue = _data["dateOfIssue"];
            this.issuingAuthority = _data["issuingAuthority"];
            this.issuingCountry = _data["issuingCountry"];
            this.referenceNumber = _data["referenceNumber"];
            this.passengerId = _data["passengerId"];
            this.croppedDocumentFileId = _data["croppedDocumentFileId"];
            this.croppedDocumentFileUrl = _data["croppedDocumentFileUrl"];
            this.faceDocumentFileId = _data["faceDocumentFileId"];
            this.faceDocumentFileUrl = _data["faceDocumentFileUrl"];
        }
    }

    static fromJS(data: any): ScannedPassportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannedPassportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mrzCode"] = this.mrzCode;
        data["documentNumber"] = this.documentNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["sex"] = this.sex;
        data["dateOfExpiry"] = this.dateOfExpiry;
        data["surname"] = this.surname;
        data["givenNames"] = this.givenNames;
        data["placeOfBirth"] = this.placeOfBirth;
        data["nationality"] = this.nationality;
        data["dateOfIssue"] = this.dateOfIssue;
        data["issuingAuthority"] = this.issuingAuthority;
        data["issuingCountry"] = this.issuingCountry;
        data["referenceNumber"] = this.referenceNumber;
        data["passengerId"] = this.passengerId;
        data["croppedDocumentFileId"] = this.croppedDocumentFileId;
        data["croppedDocumentFileUrl"] = this.croppedDocumentFileUrl;
        data["faceDocumentFileId"] = this.faceDocumentFileId;
        data["faceDocumentFileUrl"] = this.faceDocumentFileUrl;
        return data;
    }

    clone(): ScannedPassportDto {
        const json = this.toJSON();
        let result = new ScannedPassportDto();
        result.init(json);
        return result;
    }
}

export interface IScannedPassportDto {
    id: string;
    mrzCode: string | undefined;
    documentNumber: string | undefined;
    dateOfBirth: string | undefined;
    sex: string | undefined;
    dateOfExpiry: string | undefined;
    surname: string | undefined;
    givenNames: string | undefined;
    placeOfBirth: string | undefined;
    nationality: string | undefined;
    dateOfIssue: string | undefined;
    issuingAuthority: string | undefined;
    issuingCountry: string | undefined;
    referenceNumber: string | undefined;
    passengerId: string | undefined;
    croppedDocumentFileId: string | undefined;
    croppedDocumentFileUrl: string | undefined;
    faceDocumentFileId: string | undefined;
    faceDocumentFileUrl: string | undefined;
}

export class SelectedPackageDto implements ISelectedPackageDto {
    id: string;
    title: string | undefined;
    price: number;
    basePrice: number;
    days: number;
    nights: number;
    rating: number;
    currency: string | undefined;
    tourPackageType: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    images: PackageImageDto[] | undefined;

    constructor(data?: ISelectedPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.price = _data["price"];
            this.basePrice = _data["basePrice"];
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.rating = _data["rating"];
            this.currency = _data["currency"];
            this.tourPackageType = _data["tourPackageType"];
            this.coverPhotoDocumentUrl = _data["coverPhotoDocumentUrl"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(PackageImageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectedPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["price"] = this.price;
        data["basePrice"] = this.basePrice;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["rating"] = this.rating;
        data["currency"] = this.currency;
        data["tourPackageType"] = this.tourPackageType;
        data["coverPhotoDocumentUrl"] = this.coverPhotoDocumentUrl;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): SelectedPackageDto {
        const json = this.toJSON();
        let result = new SelectedPackageDto();
        result.init(json);
        return result;
    }
}

export interface ISelectedPackageDto {
    id: string;
    title: string | undefined;
    price: number;
    basePrice: number;
    days: number;
    nights: number;
    rating: number;
    currency: string | undefined;
    tourPackageType: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    images: PackageImageDto[] | undefined;
}

export class SendStayConfirmationEmailRequest implements ISendStayConfirmationEmailRequest {
    email: string;

    constructor(data?: ISendStayConfirmationEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SendStayConfirmationEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendStayConfirmationEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }

    clone(): SendStayConfirmationEmailRequest {
        const json = this.toJSON();
        let result = new SendStayConfirmationEmailRequest();
        result.init(json);
        return result;
    }
}

export interface ISendStayConfirmationEmailRequest {
    email: string;
}

export class SendStayConfirmationEmailResultDto implements ISendStayConfirmationEmailResultDto {
    message: string | undefined;

    constructor(data?: ISendStayConfirmationEmailResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendStayConfirmationEmailResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendStayConfirmationEmailResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }

    clone(): SendStayConfirmationEmailResultDto {
        const json = this.toJSON();
        let result = new SendStayConfirmationEmailResultDto();
        result.init(json);
        return result;
    }
}

export interface ISendStayConfirmationEmailResultDto {
    message: string | undefined;
}

export class SeriesDto implements ISeriesDto {
    thisWeek: SeriesItemDto[] | undefined;
    previousWeek: SeriesItemDto[] | undefined;

    constructor(data?: ISeriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["thisWeek"])) {
                this.thisWeek = [] as any;
                for (let item of _data["thisWeek"])
                    this.thisWeek.push(SeriesItemDto.fromJS(item));
            }
            if (Array.isArray(_data["previousWeek"])) {
                this.previousWeek = [] as any;
                for (let item of _data["previousWeek"])
                    this.previousWeek.push(SeriesItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.thisWeek)) {
            data["thisWeek"] = [];
            for (let item of this.thisWeek)
                data["thisWeek"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.previousWeek)) {
            data["previousWeek"] = [];
            for (let item of this.previousWeek)
                data["previousWeek"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): SeriesDto {
        const json = this.toJSON();
        let result = new SeriesDto();
        result.init(json);
        return result;
    }
}

export interface ISeriesDto {
    thisWeek: SeriesItemDto[] | undefined;
    previousWeek: SeriesItemDto[] | undefined;
}

export class SeriesItemDto implements ISeriesItemDto {
    name: string | undefined;
    type: string | undefined;
    data: number[] | undefined;

    constructor(data?: ISeriesItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(item);
            }
        }
    }

    static fromJS(data: any): SeriesItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }

    clone(): SeriesItemDto {
        const json = this.toJSON();
        let result = new SeriesItemDto();
        result.init(json);
        return result;
    }
}

export interface ISeriesItemDto {
    name: string | undefined;
    type: string | undefined;
    data: number[] | undefined;
}

export enum ServicesNameType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

/** DTO for session recovery */
export class SessionRecoveryRequestDto implements ISessionRecoveryRequestDto {
    /** User ID (for authenticated users) */
    userId: number | undefined;
    /** Session ID (for anonymous users) */
    sessionId: string | undefined;
    /** Tour ID to recover draft for */
    tourId: number | undefined;

    constructor(data?: ISessionRecoveryRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.sessionId = _data["sessionId"];
            this.tourId = _data["tourId"];
        }
    }

    static fromJS(data: any): SessionRecoveryRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionRecoveryRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["sessionId"] = this.sessionId;
        data["tourId"] = this.tourId;
        return data;
    }

    clone(): SessionRecoveryRequestDto {
        const json = this.toJSON();
        let result = new SessionRecoveryRequestDto();
        result.init(json);
        return result;
    }
}

/** DTO for session recovery */
export interface ISessionRecoveryRequestDto {
    /** User ID (for authenticated users) */
    userId: number | undefined;
    /** Session ID (for anonymous users) */
    sessionId: string | undefined;
    /** Tour ID to recover draft for */
    tourId: number | undefined;
}

export class Setting implements ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
}

export enum SettingsOptionType {
    _0 = 0,
    _1 = 1,
}

export class SignInWithTokenInput implements ISignInWithTokenInput {
    accessToken: string | undefined;

    constructor(data?: ISignInWithTokenInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): SignInWithTokenInput {
        data = typeof data === 'object' ? data : {};
        let result = new SignInWithTokenInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        return data;
    }

    clone(): SignInWithTokenInput {
        const json = this.toJSON();
        let result = new SignInWithTokenInput();
        result.init(json);
        return result;
    }
}

export interface ISignInWithTokenInput {
    accessToken: string | undefined;
}

export class SocialMediaLinkDto implements ISocialMediaLinkDto {
    id: string | undefined;
    platform: string | undefined;
    url: string | undefined;
    iconUrl: string | undefined;
    order: number;

    constructor(data?: ISocialMediaLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.platform = _data["platform"];
            this.url = _data["url"];
            this.iconUrl = _data["iconUrl"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): SocialMediaLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialMediaLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["platform"] = this.platform;
        data["url"] = this.url;
        data["iconUrl"] = this.iconUrl;
        data["order"] = this.order;
        return data;
    }

    clone(): SocialMediaLinkDto {
        const json = this.toJSON();
        let result = new SocialMediaLinkDto();
        result.init(json);
        return result;
    }
}

export interface ISocialMediaLinkDto {
    id: string | undefined;
    platform: string | undefined;
    url: string | undefined;
    iconUrl: string | undefined;
    order: number;
}

export class StatementOfAccount implements IStatementOfAccount {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    statusId: string;
    status: AppSettingOption;
    agentId: string;
    agent: Agent;
    paymentDue: moment.Moment | undefined;
    statementNumber: string | undefined;
    previousStatementNumber: string | undefined;
    statementNumberModifiedAt: moment.Moment | undefined;
    statementNumberModifiedByUserId: number | undefined;
    statementNumberModifiedByUser: User;
    deletionReason: string | undefined;
    totalAmount: number;
    downPayment: number;
    phpToUsdRate: number;
    note: string | undefined;
    bookingRef: string | undefined;
    isInstallment: boolean;
    isBiPaymentTerm: boolean;
    creatorUser: User;
    lastModifierUser: User;
    particulars: StatementOfAccountParticular[] | undefined;
    receipts: StatementOfAccountReceipt[] | undefined;
    parentStatementOfAccountId: string | undefined;
    parentStatementOfAccount: StatementOfAccount;
    childStatementOfAccounts: StatementOfAccount[] | undefined;

    constructor(data?: IStatementOfAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.bookingId = _data["bookingId"];
            this.booking = _data["booking"] ? Booking.fromJS(_data["booking"]) : undefined as any;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? AppSettingOption.fromJS(_data["status"]) : undefined as any;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            this.paymentDue = _data["paymentDue"] ? moment(_data["paymentDue"].toString()) : undefined as any;
            this.statementNumber = _data["statementNumber"];
            this.previousStatementNumber = _data["previousStatementNumber"];
            this.statementNumberModifiedAt = _data["statementNumberModifiedAt"] ? moment(_data["statementNumberModifiedAt"].toString()) : undefined as any;
            this.statementNumberModifiedByUserId = _data["statementNumberModifiedByUserId"];
            this.statementNumberModifiedByUser = _data["statementNumberModifiedByUser"] ? User.fromJS(_data["statementNumberModifiedByUser"]) : undefined as any;
            this.deletionReason = _data["deletionReason"];
            this.totalAmount = _data["totalAmount"];
            this.downPayment = _data["downPayment"];
            this.phpToUsdRate = _data["phpToUsdRate"];
            this.note = _data["note"];
            this.bookingRef = _data["bookingRef"];
            this.isInstallment = _data["isInstallment"];
            this.isBiPaymentTerm = _data["isBiPaymentTerm"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : undefined as any;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : undefined as any;
            if (Array.isArray(_data["particulars"])) {
                this.particulars = [] as any;
                for (let item of _data["particulars"])
                    this.particulars.push(StatementOfAccountParticular.fromJS(item));
            }
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts.push(StatementOfAccountReceipt.fromJS(item));
            }
            this.parentStatementOfAccountId = _data["parentStatementOfAccountId"];
            this.parentStatementOfAccount = _data["parentStatementOfAccount"] ? StatementOfAccount.fromJS(_data["parentStatementOfAccount"]) : undefined as any;
            if (Array.isArray(_data["childStatementOfAccounts"])) {
                this.childStatementOfAccounts = [] as any;
                for (let item of _data["childStatementOfAccounts"])
                    this.childStatementOfAccounts.push(StatementOfAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatementOfAccount {
        data = typeof data === 'object' ? data : {};
        let result = new StatementOfAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["bookingId"] = this.bookingId;
        data["booking"] = this.booking ? this.booking.toJSON() : undefined as any;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["paymentDue"] = this.paymentDue ? this.paymentDue.toISOString() : undefined as any;
        data["statementNumber"] = this.statementNumber;
        data["previousStatementNumber"] = this.previousStatementNumber;
        data["statementNumberModifiedAt"] = this.statementNumberModifiedAt ? this.statementNumberModifiedAt.toISOString() : undefined as any;
        data["statementNumberModifiedByUserId"] = this.statementNumberModifiedByUserId;
        data["statementNumberModifiedByUser"] = this.statementNumberModifiedByUser ? this.statementNumberModifiedByUser.toJSON() : undefined as any;
        data["deletionReason"] = this.deletionReason;
        data["totalAmount"] = this.totalAmount;
        data["downPayment"] = this.downPayment;
        data["phpToUsdRate"] = this.phpToUsdRate;
        data["note"] = this.note;
        data["bookingRef"] = this.bookingRef;
        data["isInstallment"] = this.isInstallment;
        data["isBiPaymentTerm"] = this.isBiPaymentTerm;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined as any;
        if (Array.isArray(this.particulars)) {
            data["particulars"] = [];
            for (let item of this.particulars)
                data["particulars"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentStatementOfAccountId"] = this.parentStatementOfAccountId;
        data["parentStatementOfAccount"] = this.parentStatementOfAccount ? this.parentStatementOfAccount.toJSON() : undefined as any;
        if (Array.isArray(this.childStatementOfAccounts)) {
            data["childStatementOfAccounts"] = [];
            for (let item of this.childStatementOfAccounts)
                data["childStatementOfAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): StatementOfAccount {
        const json = this.toJSON();
        let result = new StatementOfAccount();
        result.init(json);
        return result;
    }
}

export interface IStatementOfAccount {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    bookingId: string;
    booking: Booking;
    statusId: string;
    status: AppSettingOption;
    agentId: string;
    agent: Agent;
    paymentDue: moment.Moment | undefined;
    statementNumber: string | undefined;
    previousStatementNumber: string | undefined;
    statementNumberModifiedAt: moment.Moment | undefined;
    statementNumberModifiedByUserId: number | undefined;
    statementNumberModifiedByUser: User;
    deletionReason: string | undefined;
    totalAmount: number;
    downPayment: number;
    phpToUsdRate: number;
    note: string | undefined;
    bookingRef: string | undefined;
    isInstallment: boolean;
    isBiPaymentTerm: boolean;
    creatorUser: User;
    lastModifierUser: User;
    particulars: StatementOfAccountParticular[] | undefined;
    receipts: StatementOfAccountReceipt[] | undefined;
    parentStatementOfAccountId: string | undefined;
    parentStatementOfAccount: StatementOfAccount;
    childStatementOfAccounts: StatementOfAccount[] | undefined;
}

export class StatementOfAccountDto implements IStatementOfAccountDto {
    id: string;
    bookingId: string;
    status: AppSettingOptionDto;
    agent: AgentDto;
    bookingRef: string | undefined;
    productCode: string | undefined;
    paymentDue: moment.Moment | undefined;
    statementNumber: string | undefined;
    previousStatementNumber: string | undefined;
    statementNumberModifiedAt: moment.Moment | undefined;
    statementNumberModifiedBy: string | undefined;
    totalAmount: number;
    downPayment: number;
    phpToUsdRate: number;
    totalPaidAmount: number;
    remainingBalance: number;
    note: string | undefined;
    creatorUser: string | undefined;
    isInstallment: boolean;
    isBiPaymentTerm: boolean;
    lastModifierUser: string | undefined;
    lastModificationTime: moment.Moment;
    creationTime: moment.Moment;
    particulars: StatementOfAccountParticularDto[] | undefined;
    childStatementOfAccounts: StatementOfAccountDto[] | undefined;
    receipts: StatementOfAccountReceiptDto[] | undefined;
    parentStatementOfAccountId: string | undefined;
    parentStatementOfAccount: StatementOfAccountDto;
    statementOfAccounts: StatementOfAccountDto[] | undefined;

    constructor(data?: IStatementOfAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bookingId = _data["bookingId"];
            this.status = _data["status"] ? AppSettingOptionDto.fromJS(_data["status"]) : undefined as any;
            this.agent = _data["agent"] ? AgentDto.fromJS(_data["agent"]) : undefined as any;
            this.bookingRef = _data["bookingRef"];
            this.productCode = _data["productCode"];
            this.paymentDue = _data["paymentDue"] ? moment(_data["paymentDue"].toString()) : undefined as any;
            this.statementNumber = _data["statementNumber"];
            this.previousStatementNumber = _data["previousStatementNumber"];
            this.statementNumberModifiedAt = _data["statementNumberModifiedAt"] ? moment(_data["statementNumberModifiedAt"].toString()) : undefined as any;
            this.statementNumberModifiedBy = _data["statementNumberModifiedBy"];
            this.totalAmount = _data["totalAmount"];
            this.downPayment = _data["downPayment"];
            this.phpToUsdRate = _data["phpToUsdRate"];
            this.totalPaidAmount = _data["totalPaidAmount"];
            this.remainingBalance = _data["remainingBalance"];
            this.note = _data["note"];
            this.creatorUser = _data["creatorUser"];
            this.isInstallment = _data["isInstallment"];
            this.isBiPaymentTerm = _data["isBiPaymentTerm"];
            this.lastModifierUser = _data["lastModifierUser"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            if (Array.isArray(_data["particulars"])) {
                this.particulars = [] as any;
                for (let item of _data["particulars"])
                    this.particulars.push(StatementOfAccountParticularDto.fromJS(item));
            }
            if (Array.isArray(_data["childStatementOfAccounts"])) {
                this.childStatementOfAccounts = [] as any;
                for (let item of _data["childStatementOfAccounts"])
                    this.childStatementOfAccounts.push(StatementOfAccountDto.fromJS(item));
            }
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts.push(StatementOfAccountReceiptDto.fromJS(item));
            }
            this.parentStatementOfAccountId = _data["parentStatementOfAccountId"];
            this.parentStatementOfAccount = _data["parentStatementOfAccount"] ? StatementOfAccountDto.fromJS(_data["parentStatementOfAccount"]) : undefined as any;
            if (Array.isArray(_data["statementOfAccounts"])) {
                this.statementOfAccounts = [] as any;
                for (let item of _data["statementOfAccounts"])
                    this.statementOfAccounts.push(StatementOfAccountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatementOfAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatementOfAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookingId"] = this.bookingId;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["bookingRef"] = this.bookingRef;
        data["productCode"] = this.productCode;
        data["paymentDue"] = this.paymentDue ? this.paymentDue.toISOString() : undefined as any;
        data["statementNumber"] = this.statementNumber;
        data["previousStatementNumber"] = this.previousStatementNumber;
        data["statementNumberModifiedAt"] = this.statementNumberModifiedAt ? this.statementNumberModifiedAt.toISOString() : undefined as any;
        data["statementNumberModifiedBy"] = this.statementNumberModifiedBy;
        data["totalAmount"] = this.totalAmount;
        data["downPayment"] = this.downPayment;
        data["phpToUsdRate"] = this.phpToUsdRate;
        data["totalPaidAmount"] = this.totalPaidAmount;
        data["remainingBalance"] = this.remainingBalance;
        data["note"] = this.note;
        data["creatorUser"] = this.creatorUser;
        data["isInstallment"] = this.isInstallment;
        data["isBiPaymentTerm"] = this.isBiPaymentTerm;
        data["lastModifierUser"] = this.lastModifierUser;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        if (Array.isArray(this.particulars)) {
            data["particulars"] = [];
            for (let item of this.particulars)
                data["particulars"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.childStatementOfAccounts)) {
            data["childStatementOfAccounts"] = [];
            for (let item of this.childStatementOfAccounts)
                data["childStatementOfAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentStatementOfAccountId"] = this.parentStatementOfAccountId;
        data["parentStatementOfAccount"] = this.parentStatementOfAccount ? this.parentStatementOfAccount.toJSON() : undefined as any;
        if (Array.isArray(this.statementOfAccounts)) {
            data["statementOfAccounts"] = [];
            for (let item of this.statementOfAccounts)
                data["statementOfAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): StatementOfAccountDto {
        const json = this.toJSON();
        let result = new StatementOfAccountDto();
        result.init(json);
        return result;
    }
}

export interface IStatementOfAccountDto {
    id: string;
    bookingId: string;
    status: AppSettingOptionDto;
    agent: AgentDto;
    bookingRef: string | undefined;
    productCode: string | undefined;
    paymentDue: moment.Moment | undefined;
    statementNumber: string | undefined;
    previousStatementNumber: string | undefined;
    statementNumberModifiedAt: moment.Moment | undefined;
    statementNumberModifiedBy: string | undefined;
    totalAmount: number;
    downPayment: number;
    phpToUsdRate: number;
    totalPaidAmount: number;
    remainingBalance: number;
    note: string | undefined;
    creatorUser: string | undefined;
    isInstallment: boolean;
    isBiPaymentTerm: boolean;
    lastModifierUser: string | undefined;
    lastModificationTime: moment.Moment;
    creationTime: moment.Moment;
    particulars: StatementOfAccountParticularDto[] | undefined;
    childStatementOfAccounts: StatementOfAccountDto[] | undefined;
    receipts: StatementOfAccountReceiptDto[] | undefined;
    parentStatementOfAccountId: string | undefined;
    parentStatementOfAccount: StatementOfAccountDto;
    statementOfAccounts: StatementOfAccountDto[] | undefined;
}

export class StatementOfAccountDtoPagedResultDto implements IStatementOfAccountDtoPagedResultDto {
    items: StatementOfAccountDto[] | undefined;
    totalCount: number;

    constructor(data?: IStatementOfAccountDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StatementOfAccountDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StatementOfAccountDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatementOfAccountDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StatementOfAccountDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StatementOfAccountDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStatementOfAccountDtoPagedResultDto {
    items: StatementOfAccountDto[] | undefined;
    totalCount: number;
}

export class StatementOfAccountForReportDto implements IStatementOfAccountForReportDto {
    id: string;
    bookingId: string;
    status: AppSettingOptionDto;
    agent: AgentDto;
    bookingRef: string | undefined;
    bookingType: AppSettingOptionDto;
    statementNumber: string | undefined;
    noOfPassenger: number;
    totalAmount: number;
    phpToUsdRate: number;
    totalPaidAmount: number;
    remainingBalance: number;
    totalPurchaseOrderAmount: number;
    netProfit: number;
    creatorUser: string | undefined;
    isInstallment: boolean;
    isBiPaymentTerm: boolean;
    lastModifierUser: string | undefined;
    lastModificationTime: moment.Moment;
    creationTime: moment.Moment;
    parentStatementOfAccountId: string | undefined;

    constructor(data?: IStatementOfAccountForReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bookingId = _data["bookingId"];
            this.status = _data["status"] ? AppSettingOptionDto.fromJS(_data["status"]) : undefined as any;
            this.agent = _data["agent"] ? AgentDto.fromJS(_data["agent"]) : undefined as any;
            this.bookingRef = _data["bookingRef"];
            this.bookingType = _data["bookingType"] ? AppSettingOptionDto.fromJS(_data["bookingType"]) : undefined as any;
            this.statementNumber = _data["statementNumber"];
            this.noOfPassenger = _data["noOfPassenger"];
            this.totalAmount = _data["totalAmount"];
            this.phpToUsdRate = _data["phpToUsdRate"];
            this.totalPaidAmount = _data["totalPaidAmount"];
            this.remainingBalance = _data["remainingBalance"];
            this.totalPurchaseOrderAmount = _data["totalPurchaseOrderAmount"];
            this.netProfit = _data["netProfit"];
            this.creatorUser = _data["creatorUser"];
            this.isInstallment = _data["isInstallment"];
            this.isBiPaymentTerm = _data["isBiPaymentTerm"];
            this.lastModifierUser = _data["lastModifierUser"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.parentStatementOfAccountId = _data["parentStatementOfAccountId"];
        }
    }

    static fromJS(data: any): StatementOfAccountForReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatementOfAccountForReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookingId"] = this.bookingId;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["bookingRef"] = this.bookingRef;
        data["bookingType"] = this.bookingType ? this.bookingType.toJSON() : undefined as any;
        data["statementNumber"] = this.statementNumber;
        data["noOfPassenger"] = this.noOfPassenger;
        data["totalAmount"] = this.totalAmount;
        data["phpToUsdRate"] = this.phpToUsdRate;
        data["totalPaidAmount"] = this.totalPaidAmount;
        data["remainingBalance"] = this.remainingBalance;
        data["totalPurchaseOrderAmount"] = this.totalPurchaseOrderAmount;
        data["netProfit"] = this.netProfit;
        data["creatorUser"] = this.creatorUser;
        data["isInstallment"] = this.isInstallment;
        data["isBiPaymentTerm"] = this.isBiPaymentTerm;
        data["lastModifierUser"] = this.lastModifierUser;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["parentStatementOfAccountId"] = this.parentStatementOfAccountId;
        return data;
    }

    clone(): StatementOfAccountForReportDto {
        const json = this.toJSON();
        let result = new StatementOfAccountForReportDto();
        result.init(json);
        return result;
    }
}

export interface IStatementOfAccountForReportDto {
    id: string;
    bookingId: string;
    status: AppSettingOptionDto;
    agent: AgentDto;
    bookingRef: string | undefined;
    bookingType: AppSettingOptionDto;
    statementNumber: string | undefined;
    noOfPassenger: number;
    totalAmount: number;
    phpToUsdRate: number;
    totalPaidAmount: number;
    remainingBalance: number;
    totalPurchaseOrderAmount: number;
    netProfit: number;
    creatorUser: string | undefined;
    isInstallment: boolean;
    isBiPaymentTerm: boolean;
    lastModifierUser: string | undefined;
    lastModificationTime: moment.Moment;
    creationTime: moment.Moment;
    parentStatementOfAccountId: string | undefined;
}

export class StatementOfAccountParticular implements IStatementOfAccountParticular {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    statementOfAccountId: string;
    statementOfAccount: StatementOfAccount;
    name: string | undefined;
    price: number;
    quantity: number;
    total: number;
    isDeduction: boolean;
    sortOrder: number;
    isEditingDisabled: boolean;

    constructor(data?: IStatementOfAccountParticular) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.statementOfAccountId = _data["statementOfAccountId"];
            this.statementOfAccount = _data["statementOfAccount"] ? StatementOfAccount.fromJS(_data["statementOfAccount"]) : undefined as any;
            this.name = _data["name"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.total = _data["total"];
            this.isDeduction = _data["isDeduction"];
            this.sortOrder = _data["sortOrder"];
            this.isEditingDisabled = _data["isEditingDisabled"];
        }
    }

    static fromJS(data: any): StatementOfAccountParticular {
        data = typeof data === 'object' ? data : {};
        let result = new StatementOfAccountParticular();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["statementOfAccountId"] = this.statementOfAccountId;
        data["statementOfAccount"] = this.statementOfAccount ? this.statementOfAccount.toJSON() : undefined as any;
        data["name"] = this.name;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        data["isDeduction"] = this.isDeduction;
        data["sortOrder"] = this.sortOrder;
        data["isEditingDisabled"] = this.isEditingDisabled;
        return data;
    }

    clone(): StatementOfAccountParticular {
        const json = this.toJSON();
        let result = new StatementOfAccountParticular();
        result.init(json);
        return result;
    }
}

export interface IStatementOfAccountParticular {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    statementOfAccountId: string;
    statementOfAccount: StatementOfAccount;
    name: string | undefined;
    price: number;
    quantity: number;
    total: number;
    isDeduction: boolean;
    sortOrder: number;
    isEditingDisabled: boolean;
}

export class StatementOfAccountParticularDto implements IStatementOfAccountParticularDto {
    id: string;
    name: string | undefined;
    price: number;
    quantity: number;
    total: number;
    isDeduction: boolean;
    sortOrder: number;
    isEditingDisabled: boolean;

    constructor(data?: IStatementOfAccountParticularDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.total = _data["total"];
            this.isDeduction = _data["isDeduction"];
            this.sortOrder = _data["sortOrder"];
            this.isEditingDisabled = _data["isEditingDisabled"];
        }
    }

    static fromJS(data: any): StatementOfAccountParticularDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatementOfAccountParticularDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        data["isDeduction"] = this.isDeduction;
        data["sortOrder"] = this.sortOrder;
        data["isEditingDisabled"] = this.isEditingDisabled;
        return data;
    }

    clone(): StatementOfAccountParticularDto {
        const json = this.toJSON();
        let result = new StatementOfAccountParticularDto();
        result.init(json);
        return result;
    }
}

export interface IStatementOfAccountParticularDto {
    id: string;
    name: string | undefined;
    price: number;
    quantity: number;
    total: number;
    isDeduction: boolean;
    sortOrder: number;
    isEditingDisabled: boolean;
}

export class StatementOfAccountReceipt implements IStatementOfAccountReceipt {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    statementOfAccountId: string;
    statementOfAccount: StatementOfAccount;
    amount: number;
    note: string | undefined;
    receiptNo: string | undefined;
    attachments: StatementOfAccountReceiptAttachment[] | undefined;

    constructor(data?: IStatementOfAccountReceipt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.statementOfAccountId = _data["statementOfAccountId"];
            this.statementOfAccount = _data["statementOfAccount"] ? StatementOfAccount.fromJS(_data["statementOfAccount"]) : undefined as any;
            this.amount = _data["amount"];
            this.note = _data["note"];
            this.receiptNo = _data["receiptNo"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(StatementOfAccountReceiptAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatementOfAccountReceipt {
        data = typeof data === 'object' ? data : {};
        let result = new StatementOfAccountReceipt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["statementOfAccountId"] = this.statementOfAccountId;
        data["statementOfAccount"] = this.statementOfAccount ? this.statementOfAccount.toJSON() : undefined as any;
        data["amount"] = this.amount;
        data["note"] = this.note;
        data["receiptNo"] = this.receiptNo;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): StatementOfAccountReceipt {
        const json = this.toJSON();
        let result = new StatementOfAccountReceipt();
        result.init(json);
        return result;
    }
}

export interface IStatementOfAccountReceipt {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    statementOfAccountId: string;
    statementOfAccount: StatementOfAccount;
    amount: number;
    note: string | undefined;
    receiptNo: string | undefined;
    attachments: StatementOfAccountReceiptAttachment[] | undefined;
}

export class StatementOfAccountReceiptAttachment implements IStatementOfAccountReceiptAttachment {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    statementOfAccountReceiptId: string;
    statementOfAccountReceipt: StatementOfAccountReceipt;
    attachDocumentId: string | undefined;
    attachDocument: Document;

    constructor(data?: IStatementOfAccountReceiptAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.statementOfAccountReceiptId = _data["statementOfAccountReceiptId"];
            this.statementOfAccountReceipt = _data["statementOfAccountReceipt"] ? StatementOfAccountReceipt.fromJS(_data["statementOfAccountReceipt"]) : undefined as any;
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocument = _data["attachDocument"] ? Document.fromJS(_data["attachDocument"]) : undefined as any;
        }
    }

    static fromJS(data: any): StatementOfAccountReceiptAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new StatementOfAccountReceiptAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["statementOfAccountReceiptId"] = this.statementOfAccountReceiptId;
        data["statementOfAccountReceipt"] = this.statementOfAccountReceipt ? this.statementOfAccountReceipt.toJSON() : undefined as any;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocument"] = this.attachDocument ? this.attachDocument.toJSON() : undefined as any;
        return data;
    }

    clone(): StatementOfAccountReceiptAttachment {
        const json = this.toJSON();
        let result = new StatementOfAccountReceiptAttachment();
        result.init(json);
        return result;
    }
}

export interface IStatementOfAccountReceiptAttachment {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    statementOfAccountReceiptId: string;
    statementOfAccountReceipt: StatementOfAccountReceipt;
    attachDocumentId: string | undefined;
    attachDocument: Document;
}

export class StatementOfAccountReceiptAttachmentDto implements IStatementOfAccountReceiptAttachmentDto {
    id: string;
    statementOfAccountReceiptId: string;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    creationTime: moment.Moment | undefined;
    size: number;

    constructor(data?: IStatementOfAccountReceiptAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statementOfAccountReceiptId = _data["statementOfAccountReceiptId"];
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocumentUrl = _data["attachDocumentUrl"];
            this.attachDocumentName = _data["attachDocumentName"];
            this.attachDocumentFileType = _data["attachDocumentFileType"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): StatementOfAccountReceiptAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatementOfAccountReceiptAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statementOfAccountReceiptId"] = this.statementOfAccountReceiptId;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocumentUrl"] = this.attachDocumentUrl;
        data["attachDocumentName"] = this.attachDocumentName;
        data["attachDocumentFileType"] = this.attachDocumentFileType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["size"] = this.size;
        return data;
    }

    clone(): StatementOfAccountReceiptAttachmentDto {
        const json = this.toJSON();
        let result = new StatementOfAccountReceiptAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface IStatementOfAccountReceiptAttachmentDto {
    id: string;
    statementOfAccountReceiptId: string;
    attachDocumentId: string | undefined;
    attachDocumentUrl: string | undefined;
    attachDocumentName: string | undefined;
    attachDocumentFileType: string | undefined;
    creationTime: moment.Moment | undefined;
    size: number;
}

export class StatementOfAccountReceiptDto implements IStatementOfAccountReceiptDto {
    id: string;
    amount: number;
    note: string | undefined;
    creationTime: moment.Moment;
    attachments: StatementOfAccountReceiptAttachmentDto[] | undefined;

    constructor(data?: IStatementOfAccountReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.note = _data["note"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(StatementOfAccountReceiptAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatementOfAccountReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatementOfAccountReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["note"] = this.note;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): StatementOfAccountReceiptDto {
        const json = this.toJSON();
        let result = new StatementOfAccountReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IStatementOfAccountReceiptDto {
    id: string;
    amount: number;
    note: string | undefined;
    creationTime: moment.Moment;
    attachments: StatementOfAccountReceiptAttachmentDto[] | undefined;
}

export enum Status {
    _0 = 0,
    _1 = 1,
}

export class StayAvailabilityApiDto implements IStayAvailabilityApiDto {
    hotelCode: string | undefined;
    hotelName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    categoryCode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    thumbnailUrl: string | undefined;
    /** Content gallery URLs for list-card carousel (Giata bigger). Empty when Content not synced. */
    imageUrls: string[] | undefined;
    /** D5-3: HotelBeds accommodation type code when Content synced. */
    accommodationTypeCode: string | undefined;
    /** D5-3: Guest-facing accommodation label (e.g. Hotel, Apartment). */
    accommodationType: string | undefined;
    /** D5-3: Top amenity descriptions for list filters/cards. */
    amenityDescriptions: string[] | undefined;
    /** Lowest marked-up room rate for this hotel. */
    minSellingRate: number;
    currency: string | undefined;
    rooms: StayRoomApiDto[] | undefined;

    constructor(data?: IStayAvailabilityApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hotelCode = _data["hotelCode"];
            this.hotelName = _data["hotelName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.categoryCode = _data["categoryCode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls.push(item);
            }
            this.accommodationTypeCode = _data["accommodationTypeCode"];
            this.accommodationType = _data["accommodationType"];
            if (Array.isArray(_data["amenityDescriptions"])) {
                this.amenityDescriptions = [] as any;
                for (let item of _data["amenityDescriptions"])
                    this.amenityDescriptions.push(item);
            }
            this.minSellingRate = _data["minSellingRate"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms.push(StayRoomApiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StayAvailabilityApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayAvailabilityApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hotelCode"] = this.hotelCode;
        data["hotelName"] = this.hotelName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["categoryCode"] = this.categoryCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["thumbnailUrl"] = this.thumbnailUrl;
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        data["accommodationTypeCode"] = this.accommodationTypeCode;
        data["accommodationType"] = this.accommodationType;
        if (Array.isArray(this.amenityDescriptions)) {
            data["amenityDescriptions"] = [];
            for (let item of this.amenityDescriptions)
                data["amenityDescriptions"].push(item);
        }
        data["minSellingRate"] = this.minSellingRate;
        data["currency"] = this.currency;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): StayAvailabilityApiDto {
        const json = this.toJSON();
        let result = new StayAvailabilityApiDto();
        result.init(json);
        return result;
    }
}

export interface IStayAvailabilityApiDto {
    hotelCode: string | undefined;
    hotelName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    categoryCode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    thumbnailUrl: string | undefined;
    /** Content gallery URLs for list-card carousel (Giata bigger). Empty when Content not synced. */
    imageUrls: string[] | undefined;
    /** D5-3: HotelBeds accommodation type code when Content synced. */
    accommodationTypeCode: string | undefined;
    /** D5-3: Guest-facing accommodation label (e.g. Hotel, Apartment). */
    accommodationType: string | undefined;
    /** D5-3: Top amenity descriptions for list filters/cards. */
    amenityDescriptions: string[] | undefined;
    /** Lowest marked-up room rate for this hotel. */
    minSellingRate: number;
    currency: string | undefined;
    rooms: StayRoomApiDto[] | undefined;
}

export class StayBookingApiDto implements IStayBookingApiDto {
    bookingReference: string | undefined;
    supplierReference: string | undefined;
    status: string | undefined;
    bookedAt: moment.Moment;
    hotelCode: string | undefined;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    nights: number;
    totalCost: number;
    currency: string | undefined;
    rooms: BookedRoomApiDto[] | undefined;
    leadGuest: GuestApiDto;
    cancellationPolicy: StayCancellationApiDto;

    constructor(data?: IStayBookingApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingReference = _data["bookingReference"];
            this.supplierReference = _data["supplierReference"];
            this.status = _data["status"];
            this.bookedAt = _data["bookedAt"] ? moment(_data["bookedAt"].toString()) : undefined as any;
            this.hotelCode = _data["hotelCode"];
            this.hotelName = _data["hotelName"];
            this.checkIn = _data["checkIn"] ? moment(_data["checkIn"].toString()) : undefined as any;
            this.checkOut = _data["checkOut"] ? moment(_data["checkOut"].toString()) : undefined as any;
            this.nights = _data["nights"];
            this.totalCost = _data["totalCost"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms.push(BookedRoomApiDto.fromJS(item));
            }
            this.leadGuest = _data["leadGuest"] ? GuestApiDto.fromJS(_data["leadGuest"]) : undefined as any;
            this.cancellationPolicy = _data["cancellationPolicy"] ? StayCancellationApiDto.fromJS(_data["cancellationPolicy"]) : undefined as any;
        }
    }

    static fromJS(data: any): StayBookingApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayBookingApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingReference"] = this.bookingReference;
        data["supplierReference"] = this.supplierReference;
        data["status"] = this.status;
        data["bookedAt"] = this.bookedAt ? this.bookedAt.toISOString() : undefined as any;
        data["hotelCode"] = this.hotelCode;
        data["hotelName"] = this.hotelName;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : undefined as any;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : undefined as any;
        data["nights"] = this.nights;
        data["totalCost"] = this.totalCost;
        data["currency"] = this.currency;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item ? item.toJSON() : undefined as any);
        }
        data["leadGuest"] = this.leadGuest ? this.leadGuest.toJSON() : undefined as any;
        data["cancellationPolicy"] = this.cancellationPolicy ? this.cancellationPolicy.toJSON() : undefined as any;
        return data;
    }

    clone(): StayBookingApiDto {
        const json = this.toJSON();
        let result = new StayBookingApiDto();
        result.init(json);
        return result;
    }
}

export interface IStayBookingApiDto {
    bookingReference: string | undefined;
    supplierReference: string | undefined;
    status: string | undefined;
    bookedAt: moment.Moment;
    hotelCode: string | undefined;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    nights: number;
    totalCost: number;
    currency: string | undefined;
    rooms: BookedRoomApiDto[] | undefined;
    leadGuest: GuestApiDto;
    cancellationPolicy: StayCancellationApiDto;
}

export class StayBookingApiRequest implements IStayBookingApiRequest {
    rooms: RoomBookingApiDto[];
    leadGuest: GuestApiDto;
    specialRequests: string | undefined;
    clientReference: string | undefined;

    constructor(data?: IStayBookingApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.rooms = [];
            this.leadGuest = new GuestApiDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms.push(RoomBookingApiDto.fromJS(item));
            }
            this.leadGuest = _data["leadGuest"] ? GuestApiDto.fromJS(_data["leadGuest"]) : new GuestApiDto();
            this.specialRequests = _data["specialRequests"];
            this.clientReference = _data["clientReference"];
        }
    }

    static fromJS(data: any): StayBookingApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StayBookingApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item ? item.toJSON() : undefined as any);
        }
        data["leadGuest"] = this.leadGuest ? this.leadGuest.toJSON() : undefined as any;
        data["specialRequests"] = this.specialRequests;
        data["clientReference"] = this.clientReference;
        return data;
    }

    clone(): StayBookingApiRequest {
        const json = this.toJSON();
        let result = new StayBookingApiRequest();
        result.init(json);
        return result;
    }
}

export interface IStayBookingApiRequest {
    rooms: RoomBookingApiDto[];
    leadGuest: GuestApiDto;
    specialRequests: string | undefined;
    clientReference: string | undefined;
}

export class StayBookingEmailModel implements IStayBookingEmailModel {
    draftId: string;
    clientReference: string | undefined;
    hotelBedsReference: string | undefined;
    guestFullName: string | undefined;
    guestEmail: string | undefined;
    guestPhone: string | undefined;
    hotelName: string | undefined;
    destinationLabel: string | undefined;
    propertyAddress: string | undefined;
    dateRangeLabel: string | undefined;
    shortCheckInDate: string | undefined;
    shortCheckOutDate: string | undefined;
    directionsUrl: string | undefined;
    hotelImageUrl: string | undefined;
    roomName: string | undefined;
    boardTypeLabel: string | undefined;
    checkInDate: string | undefined;
    checkOutDate: string | undefined;
    voucherCheckInDate: string | undefined;
    voucherCheckOutDate: string | undefined;
    checkInTimeLabel: string | undefined;
    checkOutTimeLabel: string | undefined;
    nights: number;
    roomCount: number;
    adultCount: number;
    childCount: number;
    adultsLabel: string | undefined;
    childrenLabel: string | undefined;
    nightsRoomSummary: string | undefined;
    paidAmountFormatted: string | undefined;
    paidAtFormatted: string | undefined;
    paymentTypeLabel: string | undefined;
    specialRequests: string | undefined;
    manageBookingUrl: string | undefined;
    supportEmail: string | undefined;
    publicSiteHost: string | undefined;
    preheaderText: string | undefined;
    subject: string | undefined;
    currentYear: string | undefined;
    readonly voucherFileName: string | undefined;

    constructor(data?: IStayBookingEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftId = _data["draftId"];
            this.clientReference = _data["clientReference"];
            this.hotelBedsReference = _data["hotelBedsReference"];
            this.guestFullName = _data["guestFullName"];
            this.guestEmail = _data["guestEmail"];
            this.guestPhone = _data["guestPhone"];
            this.hotelName = _data["hotelName"];
            this.destinationLabel = _data["destinationLabel"];
            this.propertyAddress = _data["propertyAddress"];
            this.dateRangeLabel = _data["dateRangeLabel"];
            this.shortCheckInDate = _data["shortCheckInDate"];
            this.shortCheckOutDate = _data["shortCheckOutDate"];
            this.directionsUrl = _data["directionsUrl"];
            this.hotelImageUrl = _data["hotelImageUrl"];
            this.roomName = _data["roomName"];
            this.boardTypeLabel = _data["boardTypeLabel"];
            this.checkInDate = _data["checkInDate"];
            this.checkOutDate = _data["checkOutDate"];
            this.voucherCheckInDate = _data["voucherCheckInDate"];
            this.voucherCheckOutDate = _data["voucherCheckOutDate"];
            this.checkInTimeLabel = _data["checkInTimeLabel"];
            this.checkOutTimeLabel = _data["checkOutTimeLabel"];
            this.nights = _data["nights"];
            this.roomCount = _data["roomCount"];
            this.adultCount = _data["adultCount"];
            this.childCount = _data["childCount"];
            this.adultsLabel = _data["adultsLabel"];
            this.childrenLabel = _data["childrenLabel"];
            this.nightsRoomSummary = _data["nightsRoomSummary"];
            this.paidAmountFormatted = _data["paidAmountFormatted"];
            this.paidAtFormatted = _data["paidAtFormatted"];
            this.paymentTypeLabel = _data["paymentTypeLabel"];
            this.specialRequests = _data["specialRequests"];
            this.manageBookingUrl = _data["manageBookingUrl"];
            this.supportEmail = _data["supportEmail"];
            this.publicSiteHost = _data["publicSiteHost"];
            this.preheaderText = _data["preheaderText"];
            this.subject = _data["subject"];
            this.currentYear = _data["currentYear"];
            (this as any).voucherFileName = _data["voucherFileName"];
        }
    }

    static fromJS(data: any): StayBookingEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new StayBookingEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftId"] = this.draftId;
        data["clientReference"] = this.clientReference;
        data["hotelBedsReference"] = this.hotelBedsReference;
        data["guestFullName"] = this.guestFullName;
        data["guestEmail"] = this.guestEmail;
        data["guestPhone"] = this.guestPhone;
        data["hotelName"] = this.hotelName;
        data["destinationLabel"] = this.destinationLabel;
        data["propertyAddress"] = this.propertyAddress;
        data["dateRangeLabel"] = this.dateRangeLabel;
        data["shortCheckInDate"] = this.shortCheckInDate;
        data["shortCheckOutDate"] = this.shortCheckOutDate;
        data["directionsUrl"] = this.directionsUrl;
        data["hotelImageUrl"] = this.hotelImageUrl;
        data["roomName"] = this.roomName;
        data["boardTypeLabel"] = this.boardTypeLabel;
        data["checkInDate"] = this.checkInDate;
        data["checkOutDate"] = this.checkOutDate;
        data["voucherCheckInDate"] = this.voucherCheckInDate;
        data["voucherCheckOutDate"] = this.voucherCheckOutDate;
        data["checkInTimeLabel"] = this.checkInTimeLabel;
        data["checkOutTimeLabel"] = this.checkOutTimeLabel;
        data["nights"] = this.nights;
        data["roomCount"] = this.roomCount;
        data["adultCount"] = this.adultCount;
        data["childCount"] = this.childCount;
        data["adultsLabel"] = this.adultsLabel;
        data["childrenLabel"] = this.childrenLabel;
        data["nightsRoomSummary"] = this.nightsRoomSummary;
        data["paidAmountFormatted"] = this.paidAmountFormatted;
        data["paidAtFormatted"] = this.paidAtFormatted;
        data["paymentTypeLabel"] = this.paymentTypeLabel;
        data["specialRequests"] = this.specialRequests;
        data["manageBookingUrl"] = this.manageBookingUrl;
        data["supportEmail"] = this.supportEmail;
        data["publicSiteHost"] = this.publicSiteHost;
        data["preheaderText"] = this.preheaderText;
        data["subject"] = this.subject;
        data["currentYear"] = this.currentYear;
        data["voucherFileName"] = this.voucherFileName;
        return data;
    }

    clone(): StayBookingEmailModel {
        const json = this.toJSON();
        let result = new StayBookingEmailModel();
        result.init(json);
        return result;
    }
}

export interface IStayBookingEmailModel {
    draftId: string;
    clientReference: string | undefined;
    hotelBedsReference: string | undefined;
    guestFullName: string | undefined;
    guestEmail: string | undefined;
    guestPhone: string | undefined;
    hotelName: string | undefined;
    destinationLabel: string | undefined;
    propertyAddress: string | undefined;
    dateRangeLabel: string | undefined;
    shortCheckInDate: string | undefined;
    shortCheckOutDate: string | undefined;
    directionsUrl: string | undefined;
    hotelImageUrl: string | undefined;
    roomName: string | undefined;
    boardTypeLabel: string | undefined;
    checkInDate: string | undefined;
    checkOutDate: string | undefined;
    voucherCheckInDate: string | undefined;
    voucherCheckOutDate: string | undefined;
    checkInTimeLabel: string | undefined;
    checkOutTimeLabel: string | undefined;
    nights: number;
    roomCount: number;
    adultCount: number;
    childCount: number;
    adultsLabel: string | undefined;
    childrenLabel: string | undefined;
    nightsRoomSummary: string | undefined;
    paidAmountFormatted: string | undefined;
    paidAtFormatted: string | undefined;
    paymentTypeLabel: string | undefined;
    specialRequests: string | undefined;
    manageBookingUrl: string | undefined;
    supportEmail: string | undefined;
    publicSiteHost: string | undefined;
    preheaderText: string | undefined;
    subject: string | undefined;
    currentYear: string | undefined;
    voucherFileName: string | undefined;
}

export class StayCancellationApiDto implements IStayCancellationApiDto {
    deadline: moment.Moment | undefined;
    penaltyAmount: number | undefined;
    isNonRefundable: boolean;
    description: string | undefined;

    constructor(data?: IStayCancellationApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deadline = _data["deadline"] ? moment(_data["deadline"].toString()) : undefined as any;
            this.penaltyAmount = _data["penaltyAmount"];
            this.isNonRefundable = _data["isNonRefundable"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): StayCancellationApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayCancellationApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deadline"] = this.deadline ? this.deadline.toISOString() : undefined as any;
        data["penaltyAmount"] = this.penaltyAmount;
        data["isNonRefundable"] = this.isNonRefundable;
        data["description"] = this.description;
        return data;
    }

    clone(): StayCancellationApiDto {
        const json = this.toJSON();
        let result = new StayCancellationApiDto();
        result.init(json);
        return result;
    }
}

export interface IStayCancellationApiDto {
    deadline: moment.Moment | undefined;
    penaltyAmount: number | undefined;
    isNonRefundable: boolean;
    description: string | undefined;
}

export class StayCancellationDetailsDto implements IStayCancellationDetailsDto {
    bookingReference: string | undefined;
    cancellationReference: string | undefined;
    status: string | undefined;
    refundAmount: number;
    currency: string | undefined;
    cancelledAt: moment.Moment | undefined;

    constructor(data?: IStayCancellationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingReference = _data["bookingReference"];
            this.cancellationReference = _data["cancellationReference"];
            this.status = _data["status"];
            this.refundAmount = _data["refundAmount"];
            this.currency = _data["currency"];
            this.cancelledAt = _data["cancelledAt"] ? moment(_data["cancelledAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StayCancellationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayCancellationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingReference"] = this.bookingReference;
        data["cancellationReference"] = this.cancellationReference;
        data["status"] = this.status;
        data["refundAmount"] = this.refundAmount;
        data["currency"] = this.currency;
        data["cancelledAt"] = this.cancelledAt ? this.cancelledAt.toISOString() : undefined as any;
        return data;
    }

    clone(): StayCancellationDetailsDto {
        const json = this.toJSON();
        let result = new StayCancellationDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IStayCancellationDetailsDto {
    bookingReference: string | undefined;
    cancellationReference: string | undefined;
    status: string | undefined;
    refundAmount: number;
    currency: string | undefined;
    cancelledAt: moment.Moment | undefined;
}

export class StayCancellationPreviewDto implements IStayCancellationPreviewDto {
    refundAmount: number;
    penaltyAmount: number;
    currency: string | undefined;
    isNonRefundable: boolean;
    policyLabel: string | undefined;
    amountsDisclaimer: string | undefined;
    supplierPreviewUnavailable: boolean;

    constructor(data?: IStayCancellationPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refundAmount = _data["refundAmount"];
            this.penaltyAmount = _data["penaltyAmount"];
            this.currency = _data["currency"];
            this.isNonRefundable = _data["isNonRefundable"];
            this.policyLabel = _data["policyLabel"];
            this.amountsDisclaimer = _data["amountsDisclaimer"];
            this.supplierPreviewUnavailable = _data["supplierPreviewUnavailable"];
        }
    }

    static fromJS(data: any): StayCancellationPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayCancellationPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refundAmount"] = this.refundAmount;
        data["penaltyAmount"] = this.penaltyAmount;
        data["currency"] = this.currency;
        data["isNonRefundable"] = this.isNonRefundable;
        data["policyLabel"] = this.policyLabel;
        data["amountsDisclaimer"] = this.amountsDisclaimer;
        data["supplierPreviewUnavailable"] = this.supplierPreviewUnavailable;
        return data;
    }

    clone(): StayCancellationPreviewDto {
        const json = this.toJSON();
        let result = new StayCancellationPreviewDto();
        result.init(json);
        return result;
    }
}

export interface IStayCancellationPreviewDto {
    refundAmount: number;
    penaltyAmount: number;
    currency: string | undefined;
    isNonRefundable: boolean;
    policyLabel: string | undefined;
    amountsDisclaimer: string | undefined;
    supplierPreviewUnavailable: boolean;
}

export enum StayCancellationRefundStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class StayCancellationRequest implements IStayCancellationRequest {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    stayCustomerBookingId: string;
    status: StayCancellationRequestStatus;
    guestReason: string | undefined;
    policyLabelSnapshot: string | undefined;
    adminDecisionReason: string | undefined;
    requestedAt: moment.Moment;
    decidedAt: moment.Moment | undefined;
    decidedByUserId: number | undefined;
    previewRefundAmount: number | undefined;
    previewPenaltyAmount: number | undefined;
    previewCurrency: string | undefined;
    refundStatus: StayCancellationRefundStatus;
    refundCompletedAt: moment.Moment | undefined;
    refundCompletedByUserId: number | undefined;
    refundNotes: string | undefined;
    requestReceivedEmailSentAt: moment.Moment | undefined;
    approvedEmailSentAt: moment.Moment | undefined;
    declinedEmailSentAt: moment.Moment | undefined;
    closedNotCancellableEmailSentAt: moment.Moment | undefined;
    stayCustomerBooking: StayCustomerBooking;

    constructor(data?: IStayCancellationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.stayCustomerBookingId = _data["stayCustomerBookingId"];
            this.status = _data["status"];
            this.guestReason = _data["guestReason"];
            this.policyLabelSnapshot = _data["policyLabelSnapshot"];
            this.adminDecisionReason = _data["adminDecisionReason"];
            this.requestedAt = _data["requestedAt"] ? moment(_data["requestedAt"].toString()) : undefined as any;
            this.decidedAt = _data["decidedAt"] ? moment(_data["decidedAt"].toString()) : undefined as any;
            this.decidedByUserId = _data["decidedByUserId"];
            this.previewRefundAmount = _data["previewRefundAmount"];
            this.previewPenaltyAmount = _data["previewPenaltyAmount"];
            this.previewCurrency = _data["previewCurrency"];
            this.refundStatus = _data["refundStatus"];
            this.refundCompletedAt = _data["refundCompletedAt"] ? moment(_data["refundCompletedAt"].toString()) : undefined as any;
            this.refundCompletedByUserId = _data["refundCompletedByUserId"];
            this.refundNotes = _data["refundNotes"];
            this.requestReceivedEmailSentAt = _data["requestReceivedEmailSentAt"] ? moment(_data["requestReceivedEmailSentAt"].toString()) : undefined as any;
            this.approvedEmailSentAt = _data["approvedEmailSentAt"] ? moment(_data["approvedEmailSentAt"].toString()) : undefined as any;
            this.declinedEmailSentAt = _data["declinedEmailSentAt"] ? moment(_data["declinedEmailSentAt"].toString()) : undefined as any;
            this.closedNotCancellableEmailSentAt = _data["closedNotCancellableEmailSentAt"] ? moment(_data["closedNotCancellableEmailSentAt"].toString()) : undefined as any;
            this.stayCustomerBooking = _data["stayCustomerBooking"] ? StayCustomerBooking.fromJS(_data["stayCustomerBooking"]) : undefined as any;
        }
    }

    static fromJS(data: any): StayCancellationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StayCancellationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["stayCustomerBookingId"] = this.stayCustomerBookingId;
        data["status"] = this.status;
        data["guestReason"] = this.guestReason;
        data["policyLabelSnapshot"] = this.policyLabelSnapshot;
        data["adminDecisionReason"] = this.adminDecisionReason;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toISOString() : undefined as any;
        data["decidedAt"] = this.decidedAt ? this.decidedAt.toISOString() : undefined as any;
        data["decidedByUserId"] = this.decidedByUserId;
        data["previewRefundAmount"] = this.previewRefundAmount;
        data["previewPenaltyAmount"] = this.previewPenaltyAmount;
        data["previewCurrency"] = this.previewCurrency;
        data["refundStatus"] = this.refundStatus;
        data["refundCompletedAt"] = this.refundCompletedAt ? this.refundCompletedAt.toISOString() : undefined as any;
        data["refundCompletedByUserId"] = this.refundCompletedByUserId;
        data["refundNotes"] = this.refundNotes;
        data["requestReceivedEmailSentAt"] = this.requestReceivedEmailSentAt ? this.requestReceivedEmailSentAt.toISOString() : undefined as any;
        data["approvedEmailSentAt"] = this.approvedEmailSentAt ? this.approvedEmailSentAt.toISOString() : undefined as any;
        data["declinedEmailSentAt"] = this.declinedEmailSentAt ? this.declinedEmailSentAt.toISOString() : undefined as any;
        data["closedNotCancellableEmailSentAt"] = this.closedNotCancellableEmailSentAt ? this.closedNotCancellableEmailSentAt.toISOString() : undefined as any;
        data["stayCustomerBooking"] = this.stayCustomerBooking ? this.stayCustomerBooking.toJSON() : undefined as any;
        return data;
    }

    clone(): StayCancellationRequest {
        const json = this.toJSON();
        let result = new StayCancellationRequest();
        result.init(json);
        return result;
    }
}

export interface IStayCancellationRequest {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    stayCustomerBookingId: string;
    status: StayCancellationRequestStatus;
    guestReason: string | undefined;
    policyLabelSnapshot: string | undefined;
    adminDecisionReason: string | undefined;
    requestedAt: moment.Moment;
    decidedAt: moment.Moment | undefined;
    decidedByUserId: number | undefined;
    previewRefundAmount: number | undefined;
    previewPenaltyAmount: number | undefined;
    previewCurrency: string | undefined;
    refundStatus: StayCancellationRefundStatus;
    refundCompletedAt: moment.Moment | undefined;
    refundCompletedByUserId: number | undefined;
    refundNotes: string | undefined;
    requestReceivedEmailSentAt: moment.Moment | undefined;
    approvedEmailSentAt: moment.Moment | undefined;
    declinedEmailSentAt: moment.Moment | undefined;
    closedNotCancellableEmailSentAt: moment.Moment | undefined;
    stayCustomerBooking: StayCustomerBooking;
}

export class StayCancellationRequestDetailDto implements IStayCancellationRequestDetailDto {
    id: string;
    stayCustomerBookingId: string;
    status: string | undefined;
    guestReason: string | undefined;
    policyLabelSnapshot: string | undefined;
    adminDecisionReason: string | undefined;
    requestedAt: moment.Moment;
    decidedAt: moment.Moment | undefined;
    decidedByUserId: number | undefined;
    previewRefundAmount: number | undefined;
    previewPenaltyAmount: number | undefined;
    previewCurrency: string | undefined;
    refundStatus: string | undefined;
    refundCompletedAt: moment.Moment | undefined;
    refundCompletedByUserId: number | undefined;
    refundNotes: string | undefined;

    constructor(data?: IStayCancellationRequestDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stayCustomerBookingId = _data["stayCustomerBookingId"];
            this.status = _data["status"];
            this.guestReason = _data["guestReason"];
            this.policyLabelSnapshot = _data["policyLabelSnapshot"];
            this.adminDecisionReason = _data["adminDecisionReason"];
            this.requestedAt = _data["requestedAt"] ? moment(_data["requestedAt"].toString()) : undefined as any;
            this.decidedAt = _data["decidedAt"] ? moment(_data["decidedAt"].toString()) : undefined as any;
            this.decidedByUserId = _data["decidedByUserId"];
            this.previewRefundAmount = _data["previewRefundAmount"];
            this.previewPenaltyAmount = _data["previewPenaltyAmount"];
            this.previewCurrency = _data["previewCurrency"];
            this.refundStatus = _data["refundStatus"];
            this.refundCompletedAt = _data["refundCompletedAt"] ? moment(_data["refundCompletedAt"].toString()) : undefined as any;
            this.refundCompletedByUserId = _data["refundCompletedByUserId"];
            this.refundNotes = _data["refundNotes"];
        }
    }

    static fromJS(data: any): StayCancellationRequestDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayCancellationRequestDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stayCustomerBookingId"] = this.stayCustomerBookingId;
        data["status"] = this.status;
        data["guestReason"] = this.guestReason;
        data["policyLabelSnapshot"] = this.policyLabelSnapshot;
        data["adminDecisionReason"] = this.adminDecisionReason;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toISOString() : undefined as any;
        data["decidedAt"] = this.decidedAt ? this.decidedAt.toISOString() : undefined as any;
        data["decidedByUserId"] = this.decidedByUserId;
        data["previewRefundAmount"] = this.previewRefundAmount;
        data["previewPenaltyAmount"] = this.previewPenaltyAmount;
        data["previewCurrency"] = this.previewCurrency;
        data["refundStatus"] = this.refundStatus;
        data["refundCompletedAt"] = this.refundCompletedAt ? this.refundCompletedAt.toISOString() : undefined as any;
        data["refundCompletedByUserId"] = this.refundCompletedByUserId;
        data["refundNotes"] = this.refundNotes;
        return data;
    }

    clone(): StayCancellationRequestDetailDto {
        const json = this.toJSON();
        let result = new StayCancellationRequestDetailDto();
        result.init(json);
        return result;
    }
}

export interface IStayCancellationRequestDetailDto {
    id: string;
    stayCustomerBookingId: string;
    status: string | undefined;
    guestReason: string | undefined;
    policyLabelSnapshot: string | undefined;
    adminDecisionReason: string | undefined;
    requestedAt: moment.Moment;
    decidedAt: moment.Moment | undefined;
    decidedByUserId: number | undefined;
    previewRefundAmount: number | undefined;
    previewPenaltyAmount: number | undefined;
    previewCurrency: string | undefined;
    refundStatus: string | undefined;
    refundCompletedAt: moment.Moment | undefined;
    refundCompletedByUserId: number | undefined;
    refundNotes: string | undefined;
}

export class StayCancellationRequestDetailWithBookingDto implements IStayCancellationRequestDetailWithBookingDto {
    id: string;
    stayCustomerBookingId: string;
    status: string | undefined;
    guestReason: string | undefined;
    policyLabelSnapshot: string | undefined;
    adminDecisionReason: string | undefined;
    requestedAt: moment.Moment;
    decidedAt: moment.Moment | undefined;
    decidedByUserId: number | undefined;
    previewRefundAmount: number | undefined;
    previewPenaltyAmount: number | undefined;
    previewCurrency: string | undefined;
    refundStatus: string | undefined;
    refundCompletedAt: moment.Moment | undefined;
    refundCompletedByUserId: number | undefined;
    refundNotes: string | undefined;
    booking: BookingSummaryDto;
    supplierCancelBlocked: boolean;
    suggestedCloseReason: string | undefined;

    constructor(data?: IStayCancellationRequestDetailWithBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stayCustomerBookingId = _data["stayCustomerBookingId"];
            this.status = _data["status"];
            this.guestReason = _data["guestReason"];
            this.policyLabelSnapshot = _data["policyLabelSnapshot"];
            this.adminDecisionReason = _data["adminDecisionReason"];
            this.requestedAt = _data["requestedAt"] ? moment(_data["requestedAt"].toString()) : undefined as any;
            this.decidedAt = _data["decidedAt"] ? moment(_data["decidedAt"].toString()) : undefined as any;
            this.decidedByUserId = _data["decidedByUserId"];
            this.previewRefundAmount = _data["previewRefundAmount"];
            this.previewPenaltyAmount = _data["previewPenaltyAmount"];
            this.previewCurrency = _data["previewCurrency"];
            this.refundStatus = _data["refundStatus"];
            this.refundCompletedAt = _data["refundCompletedAt"] ? moment(_data["refundCompletedAt"].toString()) : undefined as any;
            this.refundCompletedByUserId = _data["refundCompletedByUserId"];
            this.refundNotes = _data["refundNotes"];
            this.booking = _data["booking"] ? BookingSummaryDto.fromJS(_data["booking"]) : undefined as any;
            this.supplierCancelBlocked = _data["supplierCancelBlocked"];
            this.suggestedCloseReason = _data["suggestedCloseReason"];
        }
    }

    static fromJS(data: any): StayCancellationRequestDetailWithBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayCancellationRequestDetailWithBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stayCustomerBookingId"] = this.stayCustomerBookingId;
        data["status"] = this.status;
        data["guestReason"] = this.guestReason;
        data["policyLabelSnapshot"] = this.policyLabelSnapshot;
        data["adminDecisionReason"] = this.adminDecisionReason;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toISOString() : undefined as any;
        data["decidedAt"] = this.decidedAt ? this.decidedAt.toISOString() : undefined as any;
        data["decidedByUserId"] = this.decidedByUserId;
        data["previewRefundAmount"] = this.previewRefundAmount;
        data["previewPenaltyAmount"] = this.previewPenaltyAmount;
        data["previewCurrency"] = this.previewCurrency;
        data["refundStatus"] = this.refundStatus;
        data["refundCompletedAt"] = this.refundCompletedAt ? this.refundCompletedAt.toISOString() : undefined as any;
        data["refundCompletedByUserId"] = this.refundCompletedByUserId;
        data["refundNotes"] = this.refundNotes;
        data["booking"] = this.booking ? this.booking.toJSON() : undefined as any;
        data["supplierCancelBlocked"] = this.supplierCancelBlocked;
        data["suggestedCloseReason"] = this.suggestedCloseReason;
        return data;
    }

    clone(): StayCancellationRequestDetailWithBookingDto {
        const json = this.toJSON();
        let result = new StayCancellationRequestDetailWithBookingDto();
        result.init(json);
        return result;
    }
}

export interface IStayCancellationRequestDetailWithBookingDto {
    id: string;
    stayCustomerBookingId: string;
    status: string | undefined;
    guestReason: string | undefined;
    policyLabelSnapshot: string | undefined;
    adminDecisionReason: string | undefined;
    requestedAt: moment.Moment;
    decidedAt: moment.Moment | undefined;
    decidedByUserId: number | undefined;
    previewRefundAmount: number | undefined;
    previewPenaltyAmount: number | undefined;
    previewCurrency: string | undefined;
    refundStatus: string | undefined;
    refundCompletedAt: moment.Moment | undefined;
    refundCompletedByUserId: number | undefined;
    refundNotes: string | undefined;
    booking: BookingSummaryDto;
    supplierCancelBlocked: boolean;
    suggestedCloseReason: string | undefined;
}

export class StayCancellationRequestDto implements IStayCancellationRequestDto {
    email: string | undefined;
    /** Required true for POST cancel (not required for preview). */
    confirm: boolean;
    /** Guest self-service cancel reason category (required for guest instant cancel). */
    reasonCategory: string | undefined;
    /** Required when TravelM8Express.Portal.Services.Stays.Dto.StayCancellationRequestDto.ReasonCategory is Other. */
    reasonDetail: string | undefined;

    constructor(data?: IStayCancellationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.confirm = _data["confirm"];
            this.reasonCategory = _data["reasonCategory"];
            this.reasonDetail = _data["reasonDetail"];
        }
    }

    static fromJS(data: any): StayCancellationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayCancellationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["confirm"] = this.confirm;
        data["reasonCategory"] = this.reasonCategory;
        data["reasonDetail"] = this.reasonDetail;
        return data;
    }

    clone(): StayCancellationRequestDto {
        const json = this.toJSON();
        let result = new StayCancellationRequestDto();
        result.init(json);
        return result;
    }
}

export interface IStayCancellationRequestDto {
    email: string | undefined;
    /** Required true for POST cancel (not required for preview). */
    confirm: boolean;
    /** Guest self-service cancel reason category (required for guest instant cancel). */
    reasonCategory: string | undefined;
    /** Required when TravelM8Express.Portal.Services.Stays.Dto.StayCancellationRequestDto.ReasonCategory is Other. */
    reasonDetail: string | undefined;
}

export class StayCancellationRequestListItemDto implements IStayCancellationRequestListItemDto {
    id: string;
    status: string | undefined;
    requestedAt: moment.Moment;
    guestReason: string | undefined;
    refundStatus: string | undefined;
    supplierCancelBlocked: boolean;
    booking: BookingSummaryDto;

    constructor(data?: IStayCancellationRequestListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.requestedAt = _data["requestedAt"] ? moment(_data["requestedAt"].toString()) : undefined as any;
            this.guestReason = _data["guestReason"];
            this.refundStatus = _data["refundStatus"];
            this.supplierCancelBlocked = _data["supplierCancelBlocked"];
            this.booking = _data["booking"] ? BookingSummaryDto.fromJS(_data["booking"]) : undefined as any;
        }
    }

    static fromJS(data: any): StayCancellationRequestListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayCancellationRequestListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toISOString() : undefined as any;
        data["guestReason"] = this.guestReason;
        data["refundStatus"] = this.refundStatus;
        data["supplierCancelBlocked"] = this.supplierCancelBlocked;
        data["booking"] = this.booking ? this.booking.toJSON() : undefined as any;
        return data;
    }

    clone(): StayCancellationRequestListItemDto {
        const json = this.toJSON();
        let result = new StayCancellationRequestListItemDto();
        result.init(json);
        return result;
    }
}

export interface IStayCancellationRequestListItemDto {
    id: string;
    status: string | undefined;
    requestedAt: moment.Moment;
    guestReason: string | undefined;
    refundStatus: string | undefined;
    supplierCancelBlocked: boolean;
    booking: BookingSummaryDto;
}

export class StayCancellationRequestListItemDtoPagedResultDto implements IStayCancellationRequestListItemDtoPagedResultDto {
    items: StayCancellationRequestListItemDto[] | undefined;
    totalCount: number;

    constructor(data?: IStayCancellationRequestListItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StayCancellationRequestListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StayCancellationRequestListItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayCancellationRequestListItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StayCancellationRequestListItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StayCancellationRequestListItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStayCancellationRequestListItemDtoPagedResultDto {
    items: StayCancellationRequestListItemDto[] | undefined;
    totalCount: number;
}

export enum StayCancellationRequestStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class StayCheckoutDraftRequest implements IStayCheckoutDraftRequest {
    rateKey: string | undefined;
    sessionId: string | undefined;
    hotelCode: number;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    currency: string | undefined;
    sellingPrice: number;
    netRate: number;
    leadGuest: GuestApiDto;
    rooms: CheckoutRoomRequest[] | undefined;
    specialRequests: string | undefined;

    constructor(data?: IStayCheckoutDraftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rateKey = _data["rateKey"];
            this.sessionId = _data["sessionId"];
            this.hotelCode = _data["hotelCode"];
            this.hotelName = _data["hotelName"];
            this.checkIn = _data["checkIn"] ? moment(_data["checkIn"].toString()) : undefined as any;
            this.checkOut = _data["checkOut"] ? moment(_data["checkOut"].toString()) : undefined as any;
            this.currency = _data["currency"];
            this.sellingPrice = _data["sellingPrice"];
            this.netRate = _data["netRate"];
            this.leadGuest = _data["leadGuest"] ? GuestApiDto.fromJS(_data["leadGuest"]) : undefined as any;
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms.push(CheckoutRoomRequest.fromJS(item));
            }
            this.specialRequests = _data["specialRequests"];
        }
    }

    static fromJS(data: any): StayCheckoutDraftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StayCheckoutDraftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rateKey"] = this.rateKey;
        data["sessionId"] = this.sessionId;
        data["hotelCode"] = this.hotelCode;
        data["hotelName"] = this.hotelName;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : undefined as any;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : undefined as any;
        data["currency"] = this.currency;
        data["sellingPrice"] = this.sellingPrice;
        data["netRate"] = this.netRate;
        data["leadGuest"] = this.leadGuest ? this.leadGuest.toJSON() : undefined as any;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item ? item.toJSON() : undefined as any);
        }
        data["specialRequests"] = this.specialRequests;
        return data;
    }

    clone(): StayCheckoutDraftRequest {
        const json = this.toJSON();
        let result = new StayCheckoutDraftRequest();
        result.init(json);
        return result;
    }
}

export interface IStayCheckoutDraftRequest {
    rateKey: string | undefined;
    sessionId: string | undefined;
    hotelCode: number;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    currency: string | undefined;
    sellingPrice: number;
    netRate: number;
    leadGuest: GuestApiDto;
    rooms: CheckoutRoomRequest[] | undefined;
    specialRequests: string | undefined;
}

export class StayCheckoutDto implements IStayCheckoutDto {
    id: string;
    status: string | undefined;
    rateKey: string | undefined;
    hotelCode: number;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    paymentType: string | undefined;
    netRate: number;
    sellingPrice: number;
    currency: string | undefined;
    stripePaymentIntentId: string | undefined;
    paidAmount: number | undefined;
    paidAt: moment.Moment | undefined;
    hotelBedsReference: string | undefined;
    clientReference: string | undefined;
    supplierError: string | undefined;
    refundIssuedAt: moment.Moment | undefined;
    guestDataJson: string | undefined;
    expiresAt: moment.Moment;
    isExpired: boolean;
    roomName: string | undefined;
    roomCode: string | undefined;
    boardType: string | undefined;
    destinationCode: string | undefined;
    destinationLabel: string | undefined;
    cancelledAt: moment.Moment | undefined;
    cancellationRefundAmount: number | undefined;
    cancellationPenaltyAmount: number | undefined;
    cancelRefundIssuedAt: moment.Moment | undefined;
    isNonRefundable: boolean;
    cancellationPolicy: StayCancellationApiDto;
    cancellationPolicyLabel: string | undefined;
    allowGuestSelfServiceCancel: boolean;
    /** Undo countdown duration for guest self-service cancel (seconds). */
    selfServiceCancelGracePeriodSeconds: number;
    guestSelfCancelReasonCategory: string | undefined;
    guestSelfCancelReasonDetail: string | undefined;
    /** False when check-in has passed or booking is not Confirmed. */
    canSubmitCancellationRequest: boolean;

    constructor(data?: IStayCheckoutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.rateKey = _data["rateKey"];
            this.hotelCode = _data["hotelCode"];
            this.hotelName = _data["hotelName"];
            this.checkIn = _data["checkIn"] ? moment(_data["checkIn"].toString()) : undefined as any;
            this.checkOut = _data["checkOut"] ? moment(_data["checkOut"].toString()) : undefined as any;
            this.paymentType = _data["paymentType"];
            this.netRate = _data["netRate"];
            this.sellingPrice = _data["sellingPrice"];
            this.currency = _data["currency"];
            this.stripePaymentIntentId = _data["stripePaymentIntentId"];
            this.paidAmount = _data["paidAmount"];
            this.paidAt = _data["paidAt"] ? moment(_data["paidAt"].toString()) : undefined as any;
            this.hotelBedsReference = _data["hotelBedsReference"];
            this.clientReference = _data["clientReference"];
            this.supplierError = _data["supplierError"];
            this.refundIssuedAt = _data["refundIssuedAt"] ? moment(_data["refundIssuedAt"].toString()) : undefined as any;
            this.guestDataJson = _data["guestDataJson"];
            this.expiresAt = _data["expiresAt"] ? moment(_data["expiresAt"].toString()) : undefined as any;
            this.isExpired = _data["isExpired"];
            this.roomName = _data["roomName"];
            this.roomCode = _data["roomCode"];
            this.boardType = _data["boardType"];
            this.destinationCode = _data["destinationCode"];
            this.destinationLabel = _data["destinationLabel"];
            this.cancelledAt = _data["cancelledAt"] ? moment(_data["cancelledAt"].toString()) : undefined as any;
            this.cancellationRefundAmount = _data["cancellationRefundAmount"];
            this.cancellationPenaltyAmount = _data["cancellationPenaltyAmount"];
            this.cancelRefundIssuedAt = _data["cancelRefundIssuedAt"] ? moment(_data["cancelRefundIssuedAt"].toString()) : undefined as any;
            this.isNonRefundable = _data["isNonRefundable"];
            this.cancellationPolicy = _data["cancellationPolicy"] ? StayCancellationApiDto.fromJS(_data["cancellationPolicy"]) : undefined as any;
            this.cancellationPolicyLabel = _data["cancellationPolicyLabel"];
            this.allowGuestSelfServiceCancel = _data["allowGuestSelfServiceCancel"];
            this.selfServiceCancelGracePeriodSeconds = _data["selfServiceCancelGracePeriodSeconds"];
            this.guestSelfCancelReasonCategory = _data["guestSelfCancelReasonCategory"];
            this.guestSelfCancelReasonDetail = _data["guestSelfCancelReasonDetail"];
            this.canSubmitCancellationRequest = _data["canSubmitCancellationRequest"];
        }
    }

    static fromJS(data: any): StayCheckoutDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayCheckoutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["rateKey"] = this.rateKey;
        data["hotelCode"] = this.hotelCode;
        data["hotelName"] = this.hotelName;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : undefined as any;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : undefined as any;
        data["paymentType"] = this.paymentType;
        data["netRate"] = this.netRate;
        data["sellingPrice"] = this.sellingPrice;
        data["currency"] = this.currency;
        data["stripePaymentIntentId"] = this.stripePaymentIntentId;
        data["paidAmount"] = this.paidAmount;
        data["paidAt"] = this.paidAt ? this.paidAt.toISOString() : undefined as any;
        data["hotelBedsReference"] = this.hotelBedsReference;
        data["clientReference"] = this.clientReference;
        data["supplierError"] = this.supplierError;
        data["refundIssuedAt"] = this.refundIssuedAt ? this.refundIssuedAt.toISOString() : undefined as any;
        data["guestDataJson"] = this.guestDataJson;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["isExpired"] = this.isExpired;
        data["roomName"] = this.roomName;
        data["roomCode"] = this.roomCode;
        data["boardType"] = this.boardType;
        data["destinationCode"] = this.destinationCode;
        data["destinationLabel"] = this.destinationLabel;
        data["cancelledAt"] = this.cancelledAt ? this.cancelledAt.toISOString() : undefined as any;
        data["cancellationRefundAmount"] = this.cancellationRefundAmount;
        data["cancellationPenaltyAmount"] = this.cancellationPenaltyAmount;
        data["cancelRefundIssuedAt"] = this.cancelRefundIssuedAt ? this.cancelRefundIssuedAt.toISOString() : undefined as any;
        data["isNonRefundable"] = this.isNonRefundable;
        data["cancellationPolicy"] = this.cancellationPolicy ? this.cancellationPolicy.toJSON() : undefined as any;
        data["cancellationPolicyLabel"] = this.cancellationPolicyLabel;
        data["allowGuestSelfServiceCancel"] = this.allowGuestSelfServiceCancel;
        data["selfServiceCancelGracePeriodSeconds"] = this.selfServiceCancelGracePeriodSeconds;
        data["guestSelfCancelReasonCategory"] = this.guestSelfCancelReasonCategory;
        data["guestSelfCancelReasonDetail"] = this.guestSelfCancelReasonDetail;
        data["canSubmitCancellationRequest"] = this.canSubmitCancellationRequest;
        return data;
    }

    clone(): StayCheckoutDto {
        const json = this.toJSON();
        let result = new StayCheckoutDto();
        result.init(json);
        return result;
    }
}

export interface IStayCheckoutDto {
    id: string;
    status: string | undefined;
    rateKey: string | undefined;
    hotelCode: number;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    paymentType: string | undefined;
    netRate: number;
    sellingPrice: number;
    currency: string | undefined;
    stripePaymentIntentId: string | undefined;
    paidAmount: number | undefined;
    paidAt: moment.Moment | undefined;
    hotelBedsReference: string | undefined;
    clientReference: string | undefined;
    supplierError: string | undefined;
    refundIssuedAt: moment.Moment | undefined;
    guestDataJson: string | undefined;
    expiresAt: moment.Moment;
    isExpired: boolean;
    roomName: string | undefined;
    roomCode: string | undefined;
    boardType: string | undefined;
    destinationCode: string | undefined;
    destinationLabel: string | undefined;
    cancelledAt: moment.Moment | undefined;
    cancellationRefundAmount: number | undefined;
    cancellationPenaltyAmount: number | undefined;
    cancelRefundIssuedAt: moment.Moment | undefined;
    isNonRefundable: boolean;
    cancellationPolicy: StayCancellationApiDto;
    cancellationPolicyLabel: string | undefined;
    allowGuestSelfServiceCancel: boolean;
    /** Undo countdown duration for guest self-service cancel (seconds). */
    selfServiceCancelGracePeriodSeconds: number;
    guestSelfCancelReasonCategory: string | undefined;
    guestSelfCancelReasonDetail: string | undefined;
    /** False when check-in has passed or booking is not Confirmed. */
    canSubmitCancellationRequest: boolean;
}

export class StayCheckoutInitRequest implements IStayCheckoutInitRequest {
    sessionId: string | undefined;
    rateKey: string | undefined;
    hotelCode: number;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    currency: string | undefined;
    sellingPrice: number;
    netRate: number;
    /** Occupancy per room — no guest PII at init. */
    rooms: CheckoutOccupancyRequest[] | undefined;
    selection: CheckoutSelectionRequest;

    constructor(data?: IStayCheckoutInitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.rateKey = _data["rateKey"];
            this.hotelCode = _data["hotelCode"];
            this.hotelName = _data["hotelName"];
            this.checkIn = _data["checkIn"] ? moment(_data["checkIn"].toString()) : undefined as any;
            this.checkOut = _data["checkOut"] ? moment(_data["checkOut"].toString()) : undefined as any;
            this.currency = _data["currency"];
            this.sellingPrice = _data["sellingPrice"];
            this.netRate = _data["netRate"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms.push(CheckoutOccupancyRequest.fromJS(item));
            }
            this.selection = _data["selection"] ? CheckoutSelectionRequest.fromJS(_data["selection"]) : undefined as any;
        }
    }

    static fromJS(data: any): StayCheckoutInitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StayCheckoutInitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["rateKey"] = this.rateKey;
        data["hotelCode"] = this.hotelCode;
        data["hotelName"] = this.hotelName;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : undefined as any;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : undefined as any;
        data["currency"] = this.currency;
        data["sellingPrice"] = this.sellingPrice;
        data["netRate"] = this.netRate;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item ? item.toJSON() : undefined as any);
        }
        data["selection"] = this.selection ? this.selection.toJSON() : undefined as any;
        return data;
    }

    clone(): StayCheckoutInitRequest {
        const json = this.toJSON();
        let result = new StayCheckoutInitRequest();
        result.init(json);
        return result;
    }
}

export interface IStayCheckoutInitRequest {
    sessionId: string | undefined;
    rateKey: string | undefined;
    hotelCode: number;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    currency: string | undefined;
    sellingPrice: number;
    netRate: number;
    /** Occupancy per room — no guest PII at init. */
    rooms: CheckoutOccupancyRequest[] | undefined;
    selection: CheckoutSelectionRequest;
}

export class StayCustomerBooking implements IStayCustomerBooking {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number | undefined;
    sessionId: string | undefined;
    status: StayCustomerBookingStatus;
    rateKey: string | undefined;
    hotelCode: number;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    paymentType: string | undefined;
    netRate: number;
    sellingPrice: number;
    currency: string | undefined;
    stripePaymentIntentId: string | undefined;
    stripeChargeId: string | undefined;
    paidAmount: number | undefined;
    paidAt: moment.Moment | undefined;
    hotelBedsReference: string | undefined;
    clientReference: string | undefined;
    supplierError: string | undefined;
    confirmationEmailSentAt: moment.Moment | undefined;
    refundIssuedAt: moment.Moment | undefined;
    stripeRefundId: string | undefined;
    failureEmailSentAt: moment.Moment | undefined;
    paymentFailedEmailSentAt: moment.Moment | undefined;
    confirmingEmailSentAt: moment.Moment | undefined;
    preStayReminder7SentAt: moment.Moment | undefined;
    preStayReminder3SentAt: moment.Moment | undefined;
    preStayReminder1SentAt: moment.Moment | undefined;
    cancelledAt: moment.Moment | undefined;
    hotelBedsCancellationReference: string | undefined;
    cancellationRefundAmount: number | undefined;
    cancellationPenaltyAmount: number | undefined;
    cancelRefundIssuedAt: moment.Moment | undefined;
    stripeCancelRefundId: string | undefined;
    cancellationEmailSentAt: moment.Moment | undefined;
    activeCancellationRequestId: string | undefined;
    guestSelfCancelReasonCategory: string | undefined;
    guestSelfCancelReasonDetail: string | undefined;
    guestDataJson: string | undefined;
    lastAccessedAt: moment.Moment;
    expiresAt: moment.Moment;
    user: User;
    activeCancellationRequest: StayCancellationRequest;
    readonly isDraftTtlExpired: boolean;
    readonly isCheckoutExpired: boolean;
    readonly isExpired: boolean;

    constructor(data?: IStayCustomerBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.sessionId = _data["sessionId"];
            this.status = _data["status"];
            this.rateKey = _data["rateKey"];
            this.hotelCode = _data["hotelCode"];
            this.hotelName = _data["hotelName"];
            this.checkIn = _data["checkIn"] ? moment(_data["checkIn"].toString()) : undefined as any;
            this.checkOut = _data["checkOut"] ? moment(_data["checkOut"].toString()) : undefined as any;
            this.paymentType = _data["paymentType"];
            this.netRate = _data["netRate"];
            this.sellingPrice = _data["sellingPrice"];
            this.currency = _data["currency"];
            this.stripePaymentIntentId = _data["stripePaymentIntentId"];
            this.stripeChargeId = _data["stripeChargeId"];
            this.paidAmount = _data["paidAmount"];
            this.paidAt = _data["paidAt"] ? moment(_data["paidAt"].toString()) : undefined as any;
            this.hotelBedsReference = _data["hotelBedsReference"];
            this.clientReference = _data["clientReference"];
            this.supplierError = _data["supplierError"];
            this.confirmationEmailSentAt = _data["confirmationEmailSentAt"] ? moment(_data["confirmationEmailSentAt"].toString()) : undefined as any;
            this.refundIssuedAt = _data["refundIssuedAt"] ? moment(_data["refundIssuedAt"].toString()) : undefined as any;
            this.stripeRefundId = _data["stripeRefundId"];
            this.failureEmailSentAt = _data["failureEmailSentAt"] ? moment(_data["failureEmailSentAt"].toString()) : undefined as any;
            this.paymentFailedEmailSentAt = _data["paymentFailedEmailSentAt"] ? moment(_data["paymentFailedEmailSentAt"].toString()) : undefined as any;
            this.confirmingEmailSentAt = _data["confirmingEmailSentAt"] ? moment(_data["confirmingEmailSentAt"].toString()) : undefined as any;
            this.preStayReminder7SentAt = _data["preStayReminder7SentAt"] ? moment(_data["preStayReminder7SentAt"].toString()) : undefined as any;
            this.preStayReminder3SentAt = _data["preStayReminder3SentAt"] ? moment(_data["preStayReminder3SentAt"].toString()) : undefined as any;
            this.preStayReminder1SentAt = _data["preStayReminder1SentAt"] ? moment(_data["preStayReminder1SentAt"].toString()) : undefined as any;
            this.cancelledAt = _data["cancelledAt"] ? moment(_data["cancelledAt"].toString()) : undefined as any;
            this.hotelBedsCancellationReference = _data["hotelBedsCancellationReference"];
            this.cancellationRefundAmount = _data["cancellationRefundAmount"];
            this.cancellationPenaltyAmount = _data["cancellationPenaltyAmount"];
            this.cancelRefundIssuedAt = _data["cancelRefundIssuedAt"] ? moment(_data["cancelRefundIssuedAt"].toString()) : undefined as any;
            this.stripeCancelRefundId = _data["stripeCancelRefundId"];
            this.cancellationEmailSentAt = _data["cancellationEmailSentAt"] ? moment(_data["cancellationEmailSentAt"].toString()) : undefined as any;
            this.activeCancellationRequestId = _data["activeCancellationRequestId"];
            this.guestSelfCancelReasonCategory = _data["guestSelfCancelReasonCategory"];
            this.guestSelfCancelReasonDetail = _data["guestSelfCancelReasonDetail"];
            this.guestDataJson = _data["guestDataJson"];
            this.lastAccessedAt = _data["lastAccessedAt"] ? moment(_data["lastAccessedAt"].toString()) : undefined as any;
            this.expiresAt = _data["expiresAt"] ? moment(_data["expiresAt"].toString()) : undefined as any;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.activeCancellationRequest = _data["activeCancellationRequest"] ? StayCancellationRequest.fromJS(_data["activeCancellationRequest"]) : undefined as any;
            (this as any).isDraftTtlExpired = _data["isDraftTtlExpired"];
            (this as any).isCheckoutExpired = _data["isCheckoutExpired"];
            (this as any).isExpired = _data["isExpired"];
        }
    }

    static fromJS(data: any): StayCustomerBooking {
        data = typeof data === 'object' ? data : {};
        let result = new StayCustomerBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["sessionId"] = this.sessionId;
        data["status"] = this.status;
        data["rateKey"] = this.rateKey;
        data["hotelCode"] = this.hotelCode;
        data["hotelName"] = this.hotelName;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : undefined as any;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : undefined as any;
        data["paymentType"] = this.paymentType;
        data["netRate"] = this.netRate;
        data["sellingPrice"] = this.sellingPrice;
        data["currency"] = this.currency;
        data["stripePaymentIntentId"] = this.stripePaymentIntentId;
        data["stripeChargeId"] = this.stripeChargeId;
        data["paidAmount"] = this.paidAmount;
        data["paidAt"] = this.paidAt ? this.paidAt.toISOString() : undefined as any;
        data["hotelBedsReference"] = this.hotelBedsReference;
        data["clientReference"] = this.clientReference;
        data["supplierError"] = this.supplierError;
        data["confirmationEmailSentAt"] = this.confirmationEmailSentAt ? this.confirmationEmailSentAt.toISOString() : undefined as any;
        data["refundIssuedAt"] = this.refundIssuedAt ? this.refundIssuedAt.toISOString() : undefined as any;
        data["stripeRefundId"] = this.stripeRefundId;
        data["failureEmailSentAt"] = this.failureEmailSentAt ? this.failureEmailSentAt.toISOString() : undefined as any;
        data["paymentFailedEmailSentAt"] = this.paymentFailedEmailSentAt ? this.paymentFailedEmailSentAt.toISOString() : undefined as any;
        data["confirmingEmailSentAt"] = this.confirmingEmailSentAt ? this.confirmingEmailSentAt.toISOString() : undefined as any;
        data["preStayReminder7SentAt"] = this.preStayReminder7SentAt ? this.preStayReminder7SentAt.toISOString() : undefined as any;
        data["preStayReminder3SentAt"] = this.preStayReminder3SentAt ? this.preStayReminder3SentAt.toISOString() : undefined as any;
        data["preStayReminder1SentAt"] = this.preStayReminder1SentAt ? this.preStayReminder1SentAt.toISOString() : undefined as any;
        data["cancelledAt"] = this.cancelledAt ? this.cancelledAt.toISOString() : undefined as any;
        data["hotelBedsCancellationReference"] = this.hotelBedsCancellationReference;
        data["cancellationRefundAmount"] = this.cancellationRefundAmount;
        data["cancellationPenaltyAmount"] = this.cancellationPenaltyAmount;
        data["cancelRefundIssuedAt"] = this.cancelRefundIssuedAt ? this.cancelRefundIssuedAt.toISOString() : undefined as any;
        data["stripeCancelRefundId"] = this.stripeCancelRefundId;
        data["cancellationEmailSentAt"] = this.cancellationEmailSentAt ? this.cancellationEmailSentAt.toISOString() : undefined as any;
        data["activeCancellationRequestId"] = this.activeCancellationRequestId;
        data["guestSelfCancelReasonCategory"] = this.guestSelfCancelReasonCategory;
        data["guestSelfCancelReasonDetail"] = this.guestSelfCancelReasonDetail;
        data["guestDataJson"] = this.guestDataJson;
        data["lastAccessedAt"] = this.lastAccessedAt ? this.lastAccessedAt.toISOString() : undefined as any;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["activeCancellationRequest"] = this.activeCancellationRequest ? this.activeCancellationRequest.toJSON() : undefined as any;
        data["isDraftTtlExpired"] = this.isDraftTtlExpired;
        data["isCheckoutExpired"] = this.isCheckoutExpired;
        data["isExpired"] = this.isExpired;
        return data;
    }

    clone(): StayCustomerBooking {
        const json = this.toJSON();
        let result = new StayCustomerBooking();
        result.init(json);
        return result;
    }
}

export interface IStayCustomerBooking {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number | undefined;
    sessionId: string | undefined;
    status: StayCustomerBookingStatus;
    rateKey: string | undefined;
    hotelCode: number;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    paymentType: string | undefined;
    netRate: number;
    sellingPrice: number;
    currency: string | undefined;
    stripePaymentIntentId: string | undefined;
    stripeChargeId: string | undefined;
    paidAmount: number | undefined;
    paidAt: moment.Moment | undefined;
    hotelBedsReference: string | undefined;
    clientReference: string | undefined;
    supplierError: string | undefined;
    confirmationEmailSentAt: moment.Moment | undefined;
    refundIssuedAt: moment.Moment | undefined;
    stripeRefundId: string | undefined;
    failureEmailSentAt: moment.Moment | undefined;
    paymentFailedEmailSentAt: moment.Moment | undefined;
    confirmingEmailSentAt: moment.Moment | undefined;
    preStayReminder7SentAt: moment.Moment | undefined;
    preStayReminder3SentAt: moment.Moment | undefined;
    preStayReminder1SentAt: moment.Moment | undefined;
    cancelledAt: moment.Moment | undefined;
    hotelBedsCancellationReference: string | undefined;
    cancellationRefundAmount: number | undefined;
    cancellationPenaltyAmount: number | undefined;
    cancelRefundIssuedAt: moment.Moment | undefined;
    stripeCancelRefundId: string | undefined;
    cancellationEmailSentAt: moment.Moment | undefined;
    activeCancellationRequestId: string | undefined;
    guestSelfCancelReasonCategory: string | undefined;
    guestSelfCancelReasonDetail: string | undefined;
    guestDataJson: string | undefined;
    lastAccessedAt: moment.Moment;
    expiresAt: moment.Moment;
    user: User;
    activeCancellationRequest: StayCancellationRequest;
    isDraftTtlExpired: boolean;
    isCheckoutExpired: boolean;
    isExpired: boolean;
}

export enum StayCustomerBookingStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class StayDestinationSuggestionDto implements IStayDestinationSuggestionDto {
    /** HotelBeds destination code (e.g. "PMI" for Palma) */
    code: string | undefined;
    /** Display label (e.g. "Palma, Majorca, Spain") */
    label: string | undefined;
    /** ISO country code (e.g. "ES") */
    countryCode: string | undefined;

    constructor(data?: IStayDestinationSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.label = _data["label"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): StayDestinationSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayDestinationSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["label"] = this.label;
        data["countryCode"] = this.countryCode;
        return data;
    }

    clone(): StayDestinationSuggestionDto {
        const json = this.toJSON();
        let result = new StayDestinationSuggestionDto();
        result.init(json);
        return result;
    }
}

export interface IStayDestinationSuggestionDto {
    /** HotelBeds destination code (e.g. "PMI" for Palma) */
    code: string | undefined;
    /** Display label (e.g. "Palma, Majorca, Spain") */
    label: string | undefined;
    /** ISO country code (e.g. "ES") */
    countryCode: string | undefined;
}

export class StayHotelAmenityDto implements IStayHotelAmenityDto {
    description: string | undefined;
    facilityCode: number | undefined;
    groupCode: number | undefined;
    groupName: string | undefined;
    indFee: boolean | undefined;
    number: number | undefined;
    timeFrom: string | undefined;
    timeTo: string | undefined;

    constructor(data?: IStayHotelAmenityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.facilityCode = _data["facilityCode"];
            this.groupCode = _data["groupCode"];
            this.groupName = _data["groupName"];
            this.indFee = _data["indFee"];
            this.number = _data["number"];
            this.timeFrom = _data["timeFrom"];
            this.timeTo = _data["timeTo"];
        }
    }

    static fromJS(data: any): StayHotelAmenityDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayHotelAmenityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["facilityCode"] = this.facilityCode;
        data["groupCode"] = this.groupCode;
        data["groupName"] = this.groupName;
        data["indFee"] = this.indFee;
        data["number"] = this.number;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        return data;
    }

    clone(): StayHotelAmenityDto {
        const json = this.toJSON();
        let result = new StayHotelAmenityDto();
        result.init(json);
        return result;
    }
}

export interface IStayHotelAmenityDto {
    description: string | undefined;
    facilityCode: number | undefined;
    groupCode: number | undefined;
    groupName: string | undefined;
    indFee: boolean | undefined;
    number: number | undefined;
    timeFrom: string | undefined;
    timeTo: string | undefined;
}

export class StayHotelCatalogBoardDto implements IStayHotelCatalogBoardDto {
    code: string | undefined;
    name: string | undefined;

    constructor(data?: IStayHotelCatalogBoardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StayHotelCatalogBoardDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayHotelCatalogBoardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }

    clone(): StayHotelCatalogBoardDto {
        const json = this.toJSON();
        let result = new StayHotelCatalogBoardDto();
        result.init(json);
        return result;
    }
}

export interface IStayHotelCatalogBoardDto {
    code: string | undefined;
    name: string | undefined;
}

export class StayHotelContentDto implements IStayHotelContentDto {
    hotelCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    address: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    postalCode: string | undefined;
    zoneCode: string | undefined;
    zoneName: string | undefined;
    locationLabel: string | undefined;
    phone: string | undefined;
    web: string | undefined;
    accommodationTypeCode: string | undefined;
    accommodationType: string | undefined;
    categoryCode: string | undefined;
    category: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    checkIn: string | undefined;
    checkOut: string | undefined;
    detailsSyncedAt: moment.Moment | undefined;
    catalogSyncedAt: moment.Moment | undefined;
    images: StayHotelImageDto[] | undefined;
    amenities: StayHotelAmenityDto[] | undefined;
    rooms: StayHotelRoomContentDto[] | undefined;
    interestPoints: StayHotelInterestPointDto[] | undefined;
    segments: string[] | undefined;
    /** Admin-only catalog meal plans (not sellable rates). */
    catalogBoards: StayHotelCatalogBoardDto[] | undefined;

    constructor(data?: IStayHotelContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hotelCode = _data["hotelCode"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.postalCode = _data["postalCode"];
            this.zoneCode = _data["zoneCode"];
            this.zoneName = _data["zoneName"];
            this.locationLabel = _data["locationLabel"];
            this.phone = _data["phone"];
            this.web = _data["web"];
            this.accommodationTypeCode = _data["accommodationTypeCode"];
            this.accommodationType = _data["accommodationType"];
            this.categoryCode = _data["categoryCode"];
            this.category = _data["category"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.checkIn = _data["checkIn"];
            this.checkOut = _data["checkOut"];
            this.detailsSyncedAt = _data["detailsSyncedAt"] ? moment(_data["detailsSyncedAt"].toString()) : undefined as any;
            this.catalogSyncedAt = _data["catalogSyncedAt"] ? moment(_data["catalogSyncedAt"].toString()) : undefined as any;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(StayHotelImageDto.fromJS(item));
            }
            if (Array.isArray(_data["amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["amenities"])
                    this.amenities.push(StayHotelAmenityDto.fromJS(item));
            }
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms.push(StayHotelRoomContentDto.fromJS(item));
            }
            if (Array.isArray(_data["interestPoints"])) {
                this.interestPoints = [] as any;
                for (let item of _data["interestPoints"])
                    this.interestPoints.push(StayHotelInterestPointDto.fromJS(item));
            }
            if (Array.isArray(_data["segments"])) {
                this.segments = [] as any;
                for (let item of _data["segments"])
                    this.segments.push(item);
            }
            if (Array.isArray(_data["catalogBoards"])) {
                this.catalogBoards = [] as any;
                for (let item of _data["catalogBoards"])
                    this.catalogBoards.push(StayHotelCatalogBoardDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StayHotelContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayHotelContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hotelCode"] = this.hotelCode;
        data["name"] = this.name;
        data["description"] = this.description;
        data["address"] = this.address;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["postalCode"] = this.postalCode;
        data["zoneCode"] = this.zoneCode;
        data["zoneName"] = this.zoneName;
        data["locationLabel"] = this.locationLabel;
        data["phone"] = this.phone;
        data["web"] = this.web;
        data["accommodationTypeCode"] = this.accommodationTypeCode;
        data["accommodationType"] = this.accommodationType;
        data["categoryCode"] = this.categoryCode;
        data["category"] = this.category;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["checkIn"] = this.checkIn;
        data["checkOut"] = this.checkOut;
        data["detailsSyncedAt"] = this.detailsSyncedAt ? this.detailsSyncedAt.toISOString() : undefined as any;
        data["catalogSyncedAt"] = this.catalogSyncedAt ? this.catalogSyncedAt.toISOString() : undefined as any;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.amenities)) {
            data["amenities"] = [];
            for (let item of this.amenities)
                data["amenities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.interestPoints)) {
            data["interestPoints"] = [];
            for (let item of this.interestPoints)
                data["interestPoints"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.segments)) {
            data["segments"] = [];
            for (let item of this.segments)
                data["segments"].push(item);
        }
        if (Array.isArray(this.catalogBoards)) {
            data["catalogBoards"] = [];
            for (let item of this.catalogBoards)
                data["catalogBoards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): StayHotelContentDto {
        const json = this.toJSON();
        let result = new StayHotelContentDto();
        result.init(json);
        return result;
    }
}

export interface IStayHotelContentDto {
    hotelCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    address: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    postalCode: string | undefined;
    zoneCode: string | undefined;
    zoneName: string | undefined;
    locationLabel: string | undefined;
    phone: string | undefined;
    web: string | undefined;
    accommodationTypeCode: string | undefined;
    accommodationType: string | undefined;
    categoryCode: string | undefined;
    category: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    checkIn: string | undefined;
    checkOut: string | undefined;
    detailsSyncedAt: moment.Moment | undefined;
    catalogSyncedAt: moment.Moment | undefined;
    images: StayHotelImageDto[] | undefined;
    amenities: StayHotelAmenityDto[] | undefined;
    rooms: StayHotelRoomContentDto[] | undefined;
    interestPoints: StayHotelInterestPointDto[] | undefined;
    segments: string[] | undefined;
    /** Admin-only catalog meal plans (not sellable rates). */
    catalogBoards: StayHotelCatalogBoardDto[] | undefined;
}

export class StayHotelImageDto implements IStayHotelImageDto {
    url: string | undefined;
    type: string | undefined;
    order: number;
    roomCode: string | undefined;

    constructor(data?: IStayHotelImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.type = _data["type"];
            this.order = _data["order"];
            this.roomCode = _data["roomCode"];
        }
    }

    static fromJS(data: any): StayHotelImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayHotelImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["type"] = this.type;
        data["order"] = this.order;
        data["roomCode"] = this.roomCode;
        return data;
    }

    clone(): StayHotelImageDto {
        const json = this.toJSON();
        let result = new StayHotelImageDto();
        result.init(json);
        return result;
    }
}

export interface IStayHotelImageDto {
    url: string | undefined;
    type: string | undefined;
    order: number;
    roomCode: string | undefined;
}

export class StayHotelInterestPointDto implements IStayHotelInterestPointDto {
    name: string | undefined;
    distance: string | undefined;
    order: number;

    constructor(data?: IStayHotelInterestPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.distance = _data["distance"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): StayHotelInterestPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayHotelInterestPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["distance"] = this.distance;
        data["order"] = this.order;
        return data;
    }

    clone(): StayHotelInterestPointDto {
        const json = this.toJSON();
        let result = new StayHotelInterestPointDto();
        result.init(json);
        return result;
    }
}

export interface IStayHotelInterestPointDto {
    name: string | undefined;
    distance: string | undefined;
    order: number;
}

export class StayHotelRoomContentDto implements IStayHotelRoomContentDto {
    roomCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    minPax: number | undefined;
    maxPax: number | undefined;
    maxAdults: number | undefined;
    maxChildren: number | undefined;
    images: StayHotelImageDto[] | undefined;
    /** Flat feature labels (backward compatible for card sidebar). */
    features: string[] | undefined;
    /** Room facilities with Content facility-group labels for modal grouping. */
    featureItems: StayHotelRoomFeatureDto[] | undefined;

    constructor(data?: IStayHotelRoomContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomCode = _data["roomCode"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.minPax = _data["minPax"];
            this.maxPax = _data["maxPax"];
            this.maxAdults = _data["maxAdults"];
            this.maxChildren = _data["maxChildren"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(StayHotelImageDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(item);
            }
            if (Array.isArray(_data["featureItems"])) {
                this.featureItems = [] as any;
                for (let item of _data["featureItems"])
                    this.featureItems.push(StayHotelRoomFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StayHotelRoomContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayHotelRoomContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomCode"] = this.roomCode;
        data["name"] = this.name;
        data["description"] = this.description;
        data["minPax"] = this.minPax;
        data["maxPax"] = this.maxPax;
        data["maxAdults"] = this.maxAdults;
        data["maxChildren"] = this.maxChildren;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        if (Array.isArray(this.featureItems)) {
            data["featureItems"] = [];
            for (let item of this.featureItems)
                data["featureItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): StayHotelRoomContentDto {
        const json = this.toJSON();
        let result = new StayHotelRoomContentDto();
        result.init(json);
        return result;
    }
}

export interface IStayHotelRoomContentDto {
    roomCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    minPax: number | undefined;
    maxPax: number | undefined;
    maxAdults: number | undefined;
    maxChildren: number | undefined;
    images: StayHotelImageDto[] | undefined;
    /** Flat feature labels (backward compatible for card sidebar). */
    features: string[] | undefined;
    /** Room facilities with Content facility-group labels for modal grouping. */
    featureItems: StayHotelRoomFeatureDto[] | undefined;
}

export class StayHotelRoomFeatureDto implements IStayHotelRoomFeatureDto {
    description: string | undefined;
    groupCode: number | undefined;
    groupName: string | undefined;

    constructor(data?: IStayHotelRoomFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.groupCode = _data["groupCode"];
            this.groupName = _data["groupName"];
        }
    }

    static fromJS(data: any): StayHotelRoomFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayHotelRoomFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["groupCode"] = this.groupCode;
        data["groupName"] = this.groupName;
        return data;
    }

    clone(): StayHotelRoomFeatureDto {
        const json = this.toJSON();
        let result = new StayHotelRoomFeatureDto();
        result.init(json);
        return result;
    }
}

export interface IStayHotelRoomFeatureDto {
    description: string | undefined;
    groupCode: number | undefined;
    groupName: string | undefined;
}

export class StayPaymentIntentDto implements IStayPaymentIntentDto {
    clientSecret: string | undefined;
    paymentIntentId: string | undefined;

    constructor(data?: IStayPaymentIntentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientSecret = _data["clientSecret"];
            this.paymentIntentId = _data["paymentIntentId"];
        }
    }

    static fromJS(data: any): StayPaymentIntentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayPaymentIntentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientSecret"] = this.clientSecret;
        data["paymentIntentId"] = this.paymentIntentId;
        return data;
    }

    clone(): StayPaymentIntentDto {
        const json = this.toJSON();
        let result = new StayPaymentIntentDto();
        result.init(json);
        return result;
    }
}

export interface IStayPaymentIntentDto {
    clientSecret: string | undefined;
    paymentIntentId: string | undefined;
}

export class StayRateApiDto implements IStayRateApiDto {
    /** Opaque key — pass back to GetRateAsync or BookAsync. */
    rateKey: string | undefined;
    boardType: string | undefined;
    /** HotelBeds boardName when present (e.g. BED AND BREAKFAST). */
    boardTypeName: string | undefined;
    /** Marked-up price shown to the customer. */
    sellingRate: number;
    netRate: number;
    currency: string | undefined;
    isNonRefundable: boolean;
    cancellationPolicy: StayCancellationApiDto;
    /** Payment type (PREPAID, AT_HOTEL) */
    paymentType: string | undefined;
    /** If true, requires direct payment data (not supported for online checkout) */
    paymentDataRequired: boolean;
    /** HotelBeds composite rateCommentsId from availability. */
    rateCommentsId: string | undefined;
    /** Resolved guest-facing rate comment text. */
    rateComments: string | undefined;
    hotelCode: number;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;

    constructor(data?: IStayRateApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rateKey = _data["rateKey"];
            this.boardType = _data["boardType"];
            this.boardTypeName = _data["boardTypeName"];
            this.sellingRate = _data["sellingRate"];
            this.netRate = _data["netRate"];
            this.currency = _data["currency"];
            this.isNonRefundable = _data["isNonRefundable"];
            this.cancellationPolicy = _data["cancellationPolicy"] ? StayCancellationApiDto.fromJS(_data["cancellationPolicy"]) : undefined as any;
            this.paymentType = _data["paymentType"];
            this.paymentDataRequired = _data["paymentDataRequired"];
            this.rateCommentsId = _data["rateCommentsId"];
            this.rateComments = _data["rateComments"];
            this.hotelCode = _data["hotelCode"];
            this.hotelName = _data["hotelName"];
            this.checkIn = _data["checkIn"] ? moment(_data["checkIn"].toString()) : undefined as any;
            this.checkOut = _data["checkOut"] ? moment(_data["checkOut"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StayRateApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayRateApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rateKey"] = this.rateKey;
        data["boardType"] = this.boardType;
        data["boardTypeName"] = this.boardTypeName;
        data["sellingRate"] = this.sellingRate;
        data["netRate"] = this.netRate;
        data["currency"] = this.currency;
        data["isNonRefundable"] = this.isNonRefundable;
        data["cancellationPolicy"] = this.cancellationPolicy ? this.cancellationPolicy.toJSON() : undefined as any;
        data["paymentType"] = this.paymentType;
        data["paymentDataRequired"] = this.paymentDataRequired;
        data["rateCommentsId"] = this.rateCommentsId;
        data["rateComments"] = this.rateComments;
        data["hotelCode"] = this.hotelCode;
        data["hotelName"] = this.hotelName;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : undefined as any;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : undefined as any;
        return data;
    }

    clone(): StayRateApiDto {
        const json = this.toJSON();
        let result = new StayRateApiDto();
        result.init(json);
        return result;
    }
}

export interface IStayRateApiDto {
    /** Opaque key — pass back to GetRateAsync or BookAsync. */
    rateKey: string | undefined;
    boardType: string | undefined;
    /** HotelBeds boardName when present (e.g. BED AND BREAKFAST). */
    boardTypeName: string | undefined;
    /** Marked-up price shown to the customer. */
    sellingRate: number;
    netRate: number;
    currency: string | undefined;
    isNonRefundable: boolean;
    cancellationPolicy: StayCancellationApiDto;
    /** Payment type (PREPAID, AT_HOTEL) */
    paymentType: string | undefined;
    /** If true, requires direct payment data (not supported for online checkout) */
    paymentDataRequired: boolean;
    /** HotelBeds composite rateCommentsId from availability. */
    rateCommentsId: string | undefined;
    /** Resolved guest-facing rate comment text. */
    rateComments: string | undefined;
    hotelCode: number;
    hotelName: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
}

export class StayRoomApiDto implements IStayRoomApiDto {
    roomCode: string | undefined;
    roomName: string | undefined;
    roomDescription: string | undefined;
    maxOccupancy: number;
    rates: StayRateApiDto[] | undefined;

    constructor(data?: IStayRoomApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomCode = _data["roomCode"];
            this.roomName = _data["roomName"];
            this.roomDescription = _data["roomDescription"];
            this.maxOccupancy = _data["maxOccupancy"];
            if (Array.isArray(_data["rates"])) {
                this.rates = [] as any;
                for (let item of _data["rates"])
                    this.rates.push(StayRateApiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StayRoomApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayRoomApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomCode"] = this.roomCode;
        data["roomName"] = this.roomName;
        data["roomDescription"] = this.roomDescription;
        data["maxOccupancy"] = this.maxOccupancy;
        if (Array.isArray(this.rates)) {
            data["rates"] = [];
            for (let item of this.rates)
                data["rates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): StayRoomApiDto {
        const json = this.toJSON();
        let result = new StayRoomApiDto();
        result.init(json);
        return result;
    }
}

export interface IStayRoomApiDto {
    roomCode: string | undefined;
    roomName: string | undefined;
    roomDescription: string | undefined;
    maxOccupancy: number;
    rates: StayRateApiDto[] | undefined;
}

export class StaySearchApiRequest implements IStaySearchApiRequest {
    destinationCode: string;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    rooms: RoomOccupancyApiDto[];
    hotelCode: string | undefined;
    currency: string | undefined;

    constructor(data?: IStaySearchApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.rooms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationCode = _data["destinationCode"];
            this.checkIn = _data["checkIn"] ? moment(_data["checkIn"].toString()) : undefined as any;
            this.checkOut = _data["checkOut"] ? moment(_data["checkOut"].toString()) : undefined as any;
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms.push(RoomOccupancyApiDto.fromJS(item));
            }
            this.hotelCode = _data["hotelCode"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): StaySearchApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StaySearchApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationCode"] = this.destinationCode;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : undefined as any;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : undefined as any;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item ? item.toJSON() : undefined as any);
        }
        data["hotelCode"] = this.hotelCode;
        data["currency"] = this.currency;
        return data;
    }

    clone(): StaySearchApiRequest {
        const json = this.toJSON();
        let result = new StaySearchApiRequest();
        result.init(json);
        return result;
    }
}

export interface IStaySearchApiRequest {
    destinationCode: string;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    rooms: RoomOccupancyApiDto[];
    hotelCode: string | undefined;
    currency: string | undefined;
}

/** Public stay search payload. TravelM8Express.Portal.Services.Stays.Dto.StaySearchApiResultDto.EmptyReason is set only when TravelM8Express.Portal.Services.Stays.Dto.StaySearchApiResultDto.Hotels is empty. */
export class StaySearchApiResultDto implements IStaySearchApiResultDto {
    hotels: StayAvailabilityApiDto[] | undefined;
    /** `catalog` — no synced hotels for destination;
            `availability` — catalog present but supplier returned no rates for the dates. */
    emptyReason: string | undefined;

    constructor(data?: IStaySearchApiResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hotels"])) {
                this.hotels = [] as any;
                for (let item of _data["hotels"])
                    this.hotels.push(StayAvailabilityApiDto.fromJS(item));
            }
            this.emptyReason = _data["emptyReason"];
        }
    }

    static fromJS(data: any): StaySearchApiResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaySearchApiResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hotels)) {
            data["hotels"] = [];
            for (let item of this.hotels)
                data["hotels"].push(item ? item.toJSON() : undefined as any);
        }
        data["emptyReason"] = this.emptyReason;
        return data;
    }

    clone(): StaySearchApiResultDto {
        const json = this.toJSON();
        let result = new StaySearchApiResultDto();
        result.init(json);
        return result;
    }
}

/** Public stay search payload. TravelM8Express.Portal.Services.Stays.Dto.StaySearchApiResultDto.EmptyReason is set only when TravelM8Express.Portal.Services.Stays.Dto.StaySearchApiResultDto.Hotels is empty. */
export interface IStaySearchApiResultDto {
    hotels: StayAvailabilityApiDto[] | undefined;
    /** `catalog` — no synced hotels for destination;
            `availability` — catalog present but supplier returned no rates for the dates. */
    emptyReason: string | undefined;
}

/** Controls HotelBeds cancel + optional Stripe refund and E6 email when executing supplier cancellation. C-REQ-1 approve uses SkipStripeRefund=true for manual refund; SendCancellationEmail=false when E6b is sent instead. */
export class StaySupplierCancelOptions implements IStaySupplierCancelOptions {
    skipStripeRefund: boolean;
    sendCancellationEmail: boolean;
    guestSelfCancelReasonCategory: string | undefined;
    guestSelfCancelReasonDetail: string | undefined;

    constructor(data?: IStaySupplierCancelOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skipStripeRefund = _data["skipStripeRefund"];
            this.sendCancellationEmail = _data["sendCancellationEmail"];
            this.guestSelfCancelReasonCategory = _data["guestSelfCancelReasonCategory"];
            this.guestSelfCancelReasonDetail = _data["guestSelfCancelReasonDetail"];
        }
    }

    static fromJS(data: any): StaySupplierCancelOptions {
        data = typeof data === 'object' ? data : {};
        let result = new StaySupplierCancelOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skipStripeRefund"] = this.skipStripeRefund;
        data["sendCancellationEmail"] = this.sendCancellationEmail;
        data["guestSelfCancelReasonCategory"] = this.guestSelfCancelReasonCategory;
        data["guestSelfCancelReasonDetail"] = this.guestSelfCancelReasonDetail;
        return data;
    }

    clone(): StaySupplierCancelOptions {
        const json = this.toJSON();
        let result = new StaySupplierCancelOptions();
        result.init(json);
        return result;
    }
}

/** Controls HotelBeds cancel + optional Stripe refund and E6 email when executing supplier cancellation. C-REQ-1 approve uses SkipStripeRefund=true for manual refund; SendCancellationEmail=false when E6b is sent instead. */
export interface IStaySupplierCancelOptions {
    skipStripeRefund: boolean;
    sendCancellationEmail: boolean;
    guestSelfCancelReasonCategory: string | undefined;
    guestSelfCancelReasonDetail: string | undefined;
}

export class StoryModuleDto implements IStoryModuleDto {
    id: string | undefined;
    title: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    order: number;

    constructor(data?: IStoryModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): StoryModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoryModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["order"] = this.order;
        return data;
    }

    clone(): StoryModuleDto {
        const json = this.toJSON();
        let result = new StoryModuleDto();
        result.init(json);
        return result;
    }
}

export interface IStoryModuleDto {
    id: string | undefined;
    title: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    order: number;
}

export class StoryModuleImageDto implements IStoryModuleImageDto {
    moduleId: string | undefined;
    imageFile: FileDto;

    constructor(data?: IStoryModuleImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.imageFile = _data["imageFile"] ? FileDto.fromJS(_data["imageFile"]) : undefined as any;
        }
    }

    static fromJS(data: any): StoryModuleImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoryModuleImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["imageFile"] = this.imageFile ? this.imageFile.toJSON() : undefined as any;
        return data;
    }

    clone(): StoryModuleImageDto {
        const json = this.toJSON();
        let result = new StoryModuleImageDto();
        result.init(json);
        return result;
    }
}

export interface IStoryModuleImageDto {
    moduleId: string | undefined;
    imageFile: FileDto;
}

export class SubmitStayCancellationRequestInput implements ISubmitStayCancellationRequestInput {
    email: string | undefined;
    reason: string;

    constructor(data?: ISubmitStayCancellationRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): SubmitStayCancellationRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitStayCancellationRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["reason"] = this.reason;
        return data;
    }

    clone(): SubmitStayCancellationRequestInput {
        const json = this.toJSON();
        let result = new SubmitStayCancellationRequestInput();
        result.init(json);
        return result;
    }
}

export interface ISubmitStayCancellationRequestInput {
    email: string | undefined;
    reason: string;
}

export class Supplier implements ISupplier {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    supplierTypeId: string | undefined;
    supplierType: AppSettingOption;
    name: string | undefined;
    deletionReason: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocument: Document;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocument: Document;
    users: User[] | undefined;
    files: SupplierFile[] | undefined;
    emails: SupplierEmail[] | undefined;
    phoneNumbers: SupplierPhoneNumber[] | undefined;
    rateAttachments: SupplierRateAttachment[] | undefined;

    constructor(data?: ISupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.supplierTypeId = _data["supplierTypeId"];
            this.supplierType = _data["supplierType"] ? AppSettingOption.fromJS(_data["supplierType"]) : undefined as any;
            this.name = _data["name"];
            this.deletionReason = _data["deletionReason"];
            this.contactPerson = _data["contactPerson"];
            this.designation = _data["designation"];
            this.note = _data["note"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureDocument = _data["profilePictureDocument"] ? Document.fromJS(_data["profilePictureDocument"]) : undefined as any;
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.coverPhotoDocument = _data["coverPhotoDocument"] ? Document.fromJS(_data["coverPhotoDocument"]) : undefined as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users.push(User.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(SupplierFile.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(SupplierEmail.fromJS(item));
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(SupplierPhoneNumber.fromJS(item));
            }
            if (Array.isArray(_data["rateAttachments"])) {
                this.rateAttachments = [] as any;
                for (let item of _data["rateAttachments"])
                    this.rateAttachments.push(SupplierRateAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Supplier {
        data = typeof data === 'object' ? data : {};
        let result = new Supplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["supplierTypeId"] = this.supplierTypeId;
        data["supplierType"] = this.supplierType ? this.supplierType.toJSON() : undefined as any;
        data["name"] = this.name;
        data["deletionReason"] = this.deletionReason;
        data["contactPerson"] = this.contactPerson;
        data["designation"] = this.designation;
        data["note"] = this.note;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureDocument"] = this.profilePictureDocument ? this.profilePictureDocument.toJSON() : undefined as any;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["coverPhotoDocument"] = this.coverPhotoDocument ? this.coverPhotoDocument.toJSON() : undefined as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rateAttachments)) {
            data["rateAttachments"] = [];
            for (let item of this.rateAttachments)
                data["rateAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Supplier {
        const json = this.toJSON();
        let result = new Supplier();
        result.init(json);
        return result;
    }
}

export interface ISupplier {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    supplierTypeId: string | undefined;
    supplierType: AppSettingOption;
    name: string | undefined;
    deletionReason: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocument: Document;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocument: Document;
    users: User[] | undefined;
    files: SupplierFile[] | undefined;
    emails: SupplierEmail[] | undefined;
    phoneNumbers: SupplierPhoneNumber[] | undefined;
    rateAttachments: SupplierRateAttachment[] | undefined;
}

export class SupplierDto implements ISupplierDto {
    id: string;
    supplierType: AppSettingOptionDto;
    name: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    isDeleted: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    phoneNumbers: SupplierPhoneNumberDto[] | undefined;
    emails: SupplierEmailDto[] | undefined;

    constructor(data?: ISupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supplierType = _data["supplierType"] ? AppSettingOptionDto.fromJS(_data["supplierType"]) : undefined as any;
            this.name = _data["name"];
            this.contactPerson = _data["contactPerson"];
            this.designation = _data["designation"];
            this.note = _data["note"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureDocumentUrl = _data["profilePictureDocumentUrl"];
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.coverPhotoDocumentUrl = _data["coverPhotoDocumentUrl"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(SupplierPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(SupplierEmailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierType"] = this.supplierType ? this.supplierType.toJSON() : undefined as any;
        data["name"] = this.name;
        data["contactPerson"] = this.contactPerson;
        data["designation"] = this.designation;
        data["note"] = this.note;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureDocumentUrl"] = this.profilePictureDocumentUrl;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["coverPhotoDocumentUrl"] = this.coverPhotoDocumentUrl;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): SupplierDto {
        const json = this.toJSON();
        let result = new SupplierDto();
        result.init(json);
        return result;
    }
}

export interface ISupplierDto {
    id: string;
    supplierType: AppSettingOptionDto;
    name: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    isDeleted: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    phoneNumbers: SupplierPhoneNumberDto[] | undefined;
    emails: SupplierEmailDto[] | undefined;
}

export class SupplierDtoPagedResultDto implements ISupplierDtoPagedResultDto {
    items: SupplierDto[] | undefined;
    totalCount: number;

    constructor(data?: ISupplierDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SupplierDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SupplierDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SupplierDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SupplierDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISupplierDtoPagedResultDto {
    items: SupplierDto[] | undefined;
    totalCount: number;
}

export class SupplierEmail implements ISupplierEmail {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    email: string | undefined;
    note: string | undefined;
    supplierId: string;
    isActive: boolean;
    isPrimary: boolean;
    supplier: Supplier;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;

    constructor(data?: ISupplierEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.email = _data["email"];
            this.note = _data["note"];
            this.supplierId = _data["supplierId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.deleterUserId = _data["deleterUserId"];
        }
    }

    static fromJS(data: any): SupplierEmail {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["email"] = this.email;
        data["note"] = this.note;
        data["supplierId"] = this.supplierId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["deleterUserId"] = this.deleterUserId;
        return data;
    }

    clone(): SupplierEmail {
        const json = this.toJSON();
        let result = new SupplierEmail();
        result.init(json);
        return result;
    }
}

export interface ISupplierEmail {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    email: string | undefined;
    note: string | undefined;
    supplierId: string;
    isActive: boolean;
    isPrimary: boolean;
    supplier: Supplier;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
}

export class SupplierEmailDto implements ISupplierEmailDto {
    id: string;
    email: string | undefined;
    note: string | undefined;
    supplierId: string;
    isPrimary: boolean | undefined;
    isActive: boolean;
    supplierDto: SupplierDto;

    constructor(data?: ISupplierEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.note = _data["note"];
            this.supplierId = _data["supplierId"];
            this.isPrimary = _data["isPrimary"];
            this.isActive = _data["isActive"];
            this.supplierDto = _data["supplierDto"] ? SupplierDto.fromJS(_data["supplierDto"]) : undefined as any;
        }
    }

    static fromJS(data: any): SupplierEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["note"] = this.note;
        data["supplierId"] = this.supplierId;
        data["isPrimary"] = this.isPrimary;
        data["isActive"] = this.isActive;
        data["supplierDto"] = this.supplierDto ? this.supplierDto.toJSON() : undefined as any;
        return data;
    }

    clone(): SupplierEmailDto {
        const json = this.toJSON();
        let result = new SupplierEmailDto();
        result.init(json);
        return result;
    }
}

export interface ISupplierEmailDto {
    id: string;
    email: string | undefined;
    note: string | undefined;
    supplierId: string;
    isPrimary: boolean | undefined;
    isActive: boolean;
    supplierDto: SupplierDto;
}

export class SupplierFile implements ISupplierFile {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    supplierId: string;
    supplier: Supplier;
    documentId: string | undefined;
    document: Document;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;

    constructor(data?: ISupplierFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.supplierId = _data["supplierId"];
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : undefined as any;
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.deleterUserId = _data["deleterUserId"];
        }
    }

    static fromJS(data: any): SupplierFile {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["supplierId"] = this.supplierId;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["deleterUserId"] = this.deleterUserId;
        return data;
    }

    clone(): SupplierFile {
        const json = this.toJSON();
        let result = new SupplierFile();
        result.init(json);
        return result;
    }
}

export interface ISupplierFile {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    supplierId: string;
    supplier: Supplier;
    documentId: string | undefined;
    document: Document;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
}

export class SupplierPhoneNumber implements ISupplierPhoneNumber {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    supplierId: string;
    supplier: Supplier;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;

    constructor(data?: ISupplierPhoneNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.supplierId = _data["supplierId"];
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.deleterUserId = _data["deleterUserId"];
        }
    }

    static fromJS(data: any): SupplierPhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierPhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["supplierId"] = this.supplierId;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["deleterUserId"] = this.deleterUserId;
        return data;
    }

    clone(): SupplierPhoneNumber {
        const json = this.toJSON();
        let result = new SupplierPhoneNumber();
        result.init(json);
        return result;
    }
}

export interface ISupplierPhoneNumber {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    supplierId: string;
    supplier: Supplier;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
}

export class SupplierPhoneNumberDto implements ISupplierPhoneNumberDto {
    id: string;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    supplierId: string;
    supplier: SupplierDto;

    constructor(data?: ISupplierPhoneNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.supplierId = _data["supplierId"];
            this.supplier = _data["supplier"] ? SupplierDto.fromJS(_data["supplier"]) : undefined as any;
        }
    }

    static fromJS(data: any): SupplierPhoneNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierPhoneNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["supplierId"] = this.supplierId;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        return data;
    }

    clone(): SupplierPhoneNumberDto {
        const json = this.toJSON();
        let result = new SupplierPhoneNumberDto();
        result.init(json);
        return result;
    }
}

export interface ISupplierPhoneNumberDto {
    id: string;
    countryCode: string | undefined;
    number: string | undefined;
    note: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    supplierId: string;
    supplier: SupplierDto;
}

export class SupplierRateAttachment implements ISupplierRateAttachment {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    description: string | undefined;
    bookingId: string;
    booking: Booking;
    attachDocumentId: string | undefined;
    attachDocument: Document;
    typeId: string | undefined;
    type: AppSettingOption;

    constructor(data?: ISupplierRateAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.description = _data["description"];
            this.bookingId = _data["bookingId"];
            this.booking = _data["booking"] ? Booking.fromJS(_data["booking"]) : undefined as any;
            this.attachDocumentId = _data["attachDocumentId"];
            this.attachDocument = _data["attachDocument"] ? Document.fromJS(_data["attachDocument"]) : undefined as any;
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? AppSettingOption.fromJS(_data["type"]) : undefined as any;
        }
    }

    static fromJS(data: any): SupplierRateAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierRateAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["description"] = this.description;
        data["bookingId"] = this.bookingId;
        data["booking"] = this.booking ? this.booking.toJSON() : undefined as any;
        data["attachDocumentId"] = this.attachDocumentId;
        data["attachDocument"] = this.attachDocument ? this.attachDocument.toJSON() : undefined as any;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        return data;
    }

    clone(): SupplierRateAttachment {
        const json = this.toJSON();
        let result = new SupplierRateAttachment();
        result.init(json);
        return result;
    }
}

export interface ISupplierRateAttachment {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    description: string | undefined;
    bookingId: string;
    booking: Booking;
    attachDocumentId: string | undefined;
    attachDocument: Document;
    typeId: string | undefined;
    type: AppSettingOption;
}

export class Tag implements ITag {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;

    constructor(data?: ITag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["name"] = this.name;
        return data;
    }

    clone(): Tag {
        const json = this.toJSON();
        let result = new Tag();
        result.init(json);
        return result;
    }
}

export interface ITag {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
}

export class TagDto implements ITagDto {
    id: string;
    name: string | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): TagDto {
        const json = this.toJSON();
        let result = new TagDto();
        result.init(json);
        return result;
    }
}

export interface ITagDto {
    id: string;
    name: string | undefined;
}

export class TeamGridDto implements ITeamGridDto {
    teamMembers: TeamMemberDto[] | undefined;

    constructor(data?: ITeamGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["teamMembers"])) {
                this.teamMembers = [] as any;
                for (let item of _data["teamMembers"])
                    this.teamMembers.push(TeamMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.teamMembers)) {
            data["teamMembers"] = [];
            for (let item of this.teamMembers)
                data["teamMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TeamGridDto {
        const json = this.toJSON();
        let result = new TeamGridDto();
        result.init(json);
        return result;
    }
}

export interface ITeamGridDto {
    teamMembers: TeamMemberDto[] | undefined;
}

export class TeamMemberDto implements ITeamMemberDto {
    id: string | undefined;
    fullName: string | undefined;
    position: string | undefined;
    profilePicture: string | undefined;
    order: number;

    constructor(data?: ITeamMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.position = _data["position"];
            this.profilePicture = _data["profilePicture"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): TeamMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["position"] = this.position;
        data["profilePicture"] = this.profilePicture;
        data["order"] = this.order;
        return data;
    }

    clone(): TeamMemberDto {
        const json = this.toJSON();
        let result = new TeamMemberDto();
        result.init(json);
        return result;
    }
}

export interface ITeamMemberDto {
    id: string | undefined;
    fullName: string | undefined;
    position: string | undefined;
    profilePicture: string | undefined;
    order: number;
}

export class TeamMemberImageDto implements ITeamMemberImageDto {
    memberId: string | undefined;
    imageFile: FileDto;

    constructor(data?: ITeamMemberImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.imageFile = _data["imageFile"] ? FileDto.fromJS(_data["imageFile"]) : undefined as any;
        }
    }

    static fromJS(data: any): TeamMemberImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["imageFile"] = this.imageFile ? this.imageFile.toJSON() : undefined as any;
        return data;
    }

    clone(): TeamMemberImageDto {
        const json = this.toJSON();
        let result = new TeamMemberImageDto();
        result.init(json);
        return result;
    }
}

export interface ITeamMemberImageDto {
    memberId: string | undefined;
    imageFile: FileDto;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TermsOfServiceDto implements ITermsOfServiceDto {
    flights: string;
    hotels: string;
    cabs: string;
    packages: string;

    constructor(data?: ITermsOfServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flights = _data["flights"];
            this.hotels = _data["hotels"];
            this.cabs = _data["cabs"];
            this.packages = _data["packages"];
        }
    }

    static fromJS(data: any): TermsOfServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TermsOfServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flights"] = this.flights;
        data["hotels"] = this.hotels;
        data["cabs"] = this.cabs;
        data["packages"] = this.packages;
        return data;
    }

    clone(): TermsOfServiceDto {
        const json = this.toJSON();
        let result = new TermsOfServiceDto();
        result.init(json);
        return result;
    }
}

export interface ITermsOfServiceDto {
    flights: string;
    hotels: string;
    cabs: string;
    packages: string;
}

export class TestMarkupInputDto implements ITestMarkupInputDto {
    netPrice: number;
    supplierName: string | undefined;
    productType: MarkupProductType;
    cabinClass: string | undefined;
    destinationRegion: string | undefined;

    constructor(data?: ITestMarkupInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.netPrice = _data["netPrice"];
            this.supplierName = _data["supplierName"];
            this.productType = _data["productType"];
            this.cabinClass = _data["cabinClass"];
            this.destinationRegion = _data["destinationRegion"];
        }
    }

    static fromJS(data: any): TestMarkupInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestMarkupInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["netPrice"] = this.netPrice;
        data["supplierName"] = this.supplierName;
        data["productType"] = this.productType;
        data["cabinClass"] = this.cabinClass;
        data["destinationRegion"] = this.destinationRegion;
        return data;
    }

    clone(): TestMarkupInputDto {
        const json = this.toJSON();
        let result = new TestMarkupInputDto();
        result.init(json);
        return result;
    }
}

export interface ITestMarkupInputDto {
    netPrice: number;
    supplierName: string | undefined;
    productType: MarkupProductType;
    cabinClass: string | undefined;
    destinationRegion: string | undefined;
}

export class TestMarkupResultDto implements ITestMarkupResultDto {
    netPrice: number;
    markupAmount: number;
    sellingPrice: number;
    appliedRuleName: string | undefined;
    appliedRuleDescription: string | undefined;
    noRuleMatched: boolean;

    constructor(data?: ITestMarkupResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.netPrice = _data["netPrice"];
            this.markupAmount = _data["markupAmount"];
            this.sellingPrice = _data["sellingPrice"];
            this.appliedRuleName = _data["appliedRuleName"];
            this.appliedRuleDescription = _data["appliedRuleDescription"];
            this.noRuleMatched = _data["noRuleMatched"];
        }
    }

    static fromJS(data: any): TestMarkupResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestMarkupResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["netPrice"] = this.netPrice;
        data["markupAmount"] = this.markupAmount;
        data["sellingPrice"] = this.sellingPrice;
        data["appliedRuleName"] = this.appliedRuleName;
        data["appliedRuleDescription"] = this.appliedRuleDescription;
        data["noRuleMatched"] = this.noRuleMatched;
        return data;
    }

    clone(): TestMarkupResultDto {
        const json = this.toJSON();
        let result = new TestMarkupResultDto();
        result.init(json);
        return result;
    }
}

export interface ITestMarkupResultDto {
    netPrice: number;
    markupAmount: number;
    sellingPrice: number;
    appliedRuleName: string | undefined;
    appliedRuleDescription: string | undefined;
    noRuleMatched: boolean;
}

/** DTO for toggling tour like */
export class ToggleTourLikeDto implements IToggleTourLikeDto {
    packageId: string;
    sessionId: string | undefined;

    constructor(data?: IToggleTourLikeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): ToggleTourLikeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleTourLikeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["sessionId"] = this.sessionId;
        return data;
    }

    clone(): ToggleTourLikeDto {
        const json = this.toJSON();
        let result = new ToggleTourLikeDto();
        result.init(json);
        return result;
    }
}

/** DTO for toggling tour like */
export interface IToggleTourLikeDto {
    packageId: string;
    sessionId: string | undefined;
}

export class TopAgentDto implements ITopAgentDto {
    agentId: string;
    agentName: string | undefined;
    totalBookings: number;

    constructor(data?: ITopAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.totalBookings = _data["totalBookings"];
        }
    }

    static fromJS(data: any): TopAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["totalBookings"] = this.totalBookings;
        return data;
    }

    clone(): TopAgentDto {
        const json = this.toJSON();
        let result = new TopAgentDto();
        result.init(json);
        return result;
    }
}

export interface ITopAgentDto {
    agentId: string;
    agentName: string | undefined;
    totalBookings: number;
}

export class TopPackageDto implements ITopPackageDto {
    packageId: string;
    packageName: string | undefined;
    totalBookings: number;

    constructor(data?: ITopPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.packageName = _data["packageName"];
            this.totalBookings = _data["totalBookings"];
        }
    }

    static fromJS(data: any): TopPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["packageName"] = this.packageName;
        data["totalBookings"] = this.totalBookings;
        return data;
    }

    clone(): TopPackageDto {
        const json = this.toJSON();
        let result = new TopPackageDto();
        result.init(json);
        return result;
    }
}

export interface ITopPackageDto {
    packageId: string;
    packageName: string | undefined;
    totalBookings: number;
}

export class TopPerformersDto implements ITopPerformersDto {
    topSellingPackages: TopPackageDto[] | undefined;
    topAgents: TopAgentDto[] | undefined;

    constructor(data?: ITopPerformersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["topSellingPackages"])) {
                this.topSellingPackages = [] as any;
                for (let item of _data["topSellingPackages"])
                    this.topSellingPackages.push(TopPackageDto.fromJS(item));
            }
            if (Array.isArray(_data["topAgents"])) {
                this.topAgents = [] as any;
                for (let item of _data["topAgents"])
                    this.topAgents.push(TopAgentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TopPerformersDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopPerformersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.topSellingPackages)) {
            data["topSellingPackages"] = [];
            for (let item of this.topSellingPackages)
                data["topSellingPackages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.topAgents)) {
            data["topAgents"] = [];
            for (let item of this.topAgents)
                data["topAgents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TopPerformersDto {
        const json = this.toJSON();
        let result = new TopPerformersDto();
        result.init(json);
        return result;
    }
}

export interface ITopPerformersDto {
    topSellingPackages: TopPackageDto[] | undefined;
    topAgents: TopAgentDto[] | undefined;
}

/** DTO for tour benefits/features */
export class TourBenefitsDto implements ITourBenefitsDto {
    flight: number | undefined;
    hotel: number | undefined;
    activities: number | undefined;

    constructor(data?: ITourBenefitsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flight = _data["flight"];
            this.hotel = _data["hotel"];
            this.activities = _data["activities"];
        }
    }

    static fromJS(data: any): TourBenefitsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourBenefitsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flight"] = this.flight;
        data["hotel"] = this.hotel;
        data["activities"] = this.activities;
        return data;
    }

    clone(): TourBenefitsDto {
        const json = this.toJSON();
        let result = new TourBenefitsDto();
        result.init(json);
        return result;
    }
}

/** DTO for tour benefits/features */
export interface ITourBenefitsDto {
    flight: number | undefined;
    hotel: number | undefined;
    activities: number | undefined;
}

/** DTO for tour booking confirmation response */
export class TourBookingConfirmationDto implements ITourBookingConfirmationDto {
    bookingId: string | undefined;
    bookingReference: string | undefined;
    tourName: string | undefined;
    totalAmount: number;
    bookingDate: string | undefined;
    travelDate: string | undefined;
    status: string | undefined;
    travelers: TravelerDto[] | undefined;
    contactInfo: ContactInfoDto;
    tourSummary: TourSummaryDto;

    constructor(data?: ITourBookingConfirmationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.bookingReference = _data["bookingReference"];
            this.tourName = _data["tourName"];
            this.totalAmount = _data["totalAmount"];
            this.bookingDate = _data["bookingDate"];
            this.travelDate = _data["travelDate"];
            this.status = _data["status"];
            if (Array.isArray(_data["travelers"])) {
                this.travelers = [] as any;
                for (let item of _data["travelers"])
                    this.travelers.push(TravelerDto.fromJS(item));
            }
            this.contactInfo = _data["contactInfo"] ? ContactInfoDto.fromJS(_data["contactInfo"]) : undefined as any;
            this.tourSummary = _data["tourSummary"] ? TourSummaryDto.fromJS(_data["tourSummary"]) : undefined as any;
        }
    }

    static fromJS(data: any): TourBookingConfirmationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourBookingConfirmationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["bookingReference"] = this.bookingReference;
        data["tourName"] = this.tourName;
        data["totalAmount"] = this.totalAmount;
        data["bookingDate"] = this.bookingDate;
        data["travelDate"] = this.travelDate;
        data["status"] = this.status;
        if (Array.isArray(this.travelers)) {
            data["travelers"] = [];
            for (let item of this.travelers)
                data["travelers"].push(item ? item.toJSON() : undefined as any);
        }
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : undefined as any;
        data["tourSummary"] = this.tourSummary ? this.tourSummary.toJSON() : undefined as any;
        return data;
    }

    clone(): TourBookingConfirmationDto {
        const json = this.toJSON();
        let result = new TourBookingConfirmationDto();
        result.init(json);
        return result;
    }
}

/** DTO for tour booking confirmation response */
export interface ITourBookingConfirmationDto {
    bookingId: string | undefined;
    bookingReference: string | undefined;
    tourName: string | undefined;
    totalAmount: number;
    bookingDate: string | undefined;
    travelDate: string | undefined;
    status: string | undefined;
    travelers: TravelerDto[] | undefined;
    contactInfo: ContactInfoDto;
    tourSummary: TourSummaryDto;
}

/** DTO for tour cards in grid/listing view Matches frontend TourCardType interface */
export class TourCardDto implements ITourCardDto {
    id: string;
    name: string | undefined;
    date: string | undefined;
    type: string | undefined;
    sale: string | undefined;
    days: number;
    nights: number;
    benefits: TourBenefitsDto;
    price: number;
    image: string | undefined;
    disc: boolean;
    likeCount: number;
    continent: string | undefined;
    holidayTypes: string[] | undefined;
    dateMatchType: DateMatchType;
    matchedTravelDate: string | undefined;
    daysFromSearchDate: number | undefined;
    proximityText: string | undefined;
    availableDatesInRange: AvailableDateDto[] | undefined;

    constructor(data?: ITourCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.date = _data["date"];
            this.type = _data["type"];
            this.sale = _data["sale"];
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.benefits = _data["benefits"] ? TourBenefitsDto.fromJS(_data["benefits"]) : undefined as any;
            this.price = _data["price"];
            this.image = _data["image"];
            this.disc = _data["disc"];
            this.likeCount = _data["likeCount"];
            this.continent = _data["continent"];
            if (Array.isArray(_data["holidayTypes"])) {
                this.holidayTypes = [] as any;
                for (let item of _data["holidayTypes"])
                    this.holidayTypes.push(item);
            }
            this.dateMatchType = _data["dateMatchType"];
            this.matchedTravelDate = _data["matchedTravelDate"];
            this.daysFromSearchDate = _data["daysFromSearchDate"];
            this.proximityText = _data["proximityText"];
            if (Array.isArray(_data["availableDatesInRange"])) {
                this.availableDatesInRange = [] as any;
                for (let item of _data["availableDatesInRange"])
                    this.availableDatesInRange.push(AvailableDateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TourCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["date"] = this.date;
        data["type"] = this.type;
        data["sale"] = this.sale;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["benefits"] = this.benefits ? this.benefits.toJSON() : undefined as any;
        data["price"] = this.price;
        data["image"] = this.image;
        data["disc"] = this.disc;
        data["likeCount"] = this.likeCount;
        data["continent"] = this.continent;
        if (Array.isArray(this.holidayTypes)) {
            data["holidayTypes"] = [];
            for (let item of this.holidayTypes)
                data["holidayTypes"].push(item);
        }
        data["dateMatchType"] = this.dateMatchType;
        data["matchedTravelDate"] = this.matchedTravelDate;
        data["daysFromSearchDate"] = this.daysFromSearchDate;
        data["proximityText"] = this.proximityText;
        if (Array.isArray(this.availableDatesInRange)) {
            data["availableDatesInRange"] = [];
            for (let item of this.availableDatesInRange)
                data["availableDatesInRange"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TourCardDto {
        const json = this.toJSON();
        let result = new TourCardDto();
        result.init(json);
        return result;
    }
}

/** DTO for tour cards in grid/listing view Matches frontend TourCardType interface */
export interface ITourCardDto {
    id: string;
    name: string | undefined;
    date: string | undefined;
    type: string | undefined;
    sale: string | undefined;
    days: number;
    nights: number;
    benefits: TourBenefitsDto;
    price: number;
    image: string | undefined;
    disc: boolean;
    likeCount: number;
    continent: string | undefined;
    holidayTypes: string[] | undefined;
    dateMatchType: DateMatchType;
    matchedTravelDate: string | undefined;
    daysFromSearchDate: number | undefined;
    proximityText: string | undefined;
    availableDatesInRange: AvailableDateDto[] | undefined;
}

/** DTO for tour categories displayed on homepage Matches frontend CategoryType interface */
export class TourCategoryDto implements ITourCategoryDto {
    name: string | undefined;
    image: string | undefined;
    places: string | undefined;

    constructor(data?: ITourCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.image = _data["image"];
            this.places = _data["places"];
        }
    }

    static fromJS(data: any): TourCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["image"] = this.image;
        data["places"] = this.places;
        return data;
    }

    clone(): TourCategoryDto {
        const json = this.toJSON();
        let result = new TourCategoryDto();
        result.init(json);
        return result;
    }
}

/** DTO for tour categories displayed on homepage Matches frontend CategoryType interface */
export interface ITourCategoryDto {
    name: string | undefined;
    image: string | undefined;
    places: string | undefined;
}

/** DTO for tour detail page Matches frontend tour detail data structure */
export class TourDetailDto implements ITourDetailDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    price: number;
    rating: number;
    reviewCount: number;
    days: number;
    nights: number;
    images: string[] | undefined;
    likeCount: number;
    tourInfo: TourInfoDto[] | undefined;
    highlights: string[] | undefined;
    inclusions: string[] | undefined;
    exclusions: string[] | undefined;
    continent: string | undefined;
    holidayTypes: string[] | undefined;
    itinerary: ItineraryDayDto[] | undefined;
    cancellationPolicy: CancellationPolicyDto[] | undefined;

    constructor(data?: ITourDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.rating = _data["rating"];
            this.reviewCount = _data["reviewCount"];
            this.days = _data["days"];
            this.nights = _data["nights"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(item);
            }
            this.likeCount = _data["likeCount"];
            if (Array.isArray(_data["tourInfo"])) {
                this.tourInfo = [] as any;
                for (let item of _data["tourInfo"])
                    this.tourInfo.push(TourInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["highlights"])) {
                this.highlights = [] as any;
                for (let item of _data["highlights"])
                    this.highlights.push(item);
            }
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions.push(item);
            }
            if (Array.isArray(_data["exclusions"])) {
                this.exclusions = [] as any;
                for (let item of _data["exclusions"])
                    this.exclusions.push(item);
            }
            this.continent = _data["continent"];
            if (Array.isArray(_data["holidayTypes"])) {
                this.holidayTypes = [] as any;
                for (let item of _data["holidayTypes"])
                    this.holidayTypes.push(item);
            }
            if (Array.isArray(_data["itinerary"])) {
                this.itinerary = [] as any;
                for (let item of _data["itinerary"])
                    this.itinerary.push(ItineraryDayDto.fromJS(item));
            }
            if (Array.isArray(_data["cancellationPolicy"])) {
                this.cancellationPolicy = [] as any;
                for (let item of _data["cancellationPolicy"])
                    this.cancellationPolicy.push(CancellationPolicyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TourDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["rating"] = this.rating;
        data["reviewCount"] = this.reviewCount;
        data["days"] = this.days;
        data["nights"] = this.nights;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["likeCount"] = this.likeCount;
        if (Array.isArray(this.tourInfo)) {
            data["tourInfo"] = [];
            for (let item of this.tourInfo)
                data["tourInfo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.highlights)) {
            data["highlights"] = [];
            for (let item of this.highlights)
                data["highlights"].push(item);
        }
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item);
        }
        if (Array.isArray(this.exclusions)) {
            data["exclusions"] = [];
            for (let item of this.exclusions)
                data["exclusions"].push(item);
        }
        data["continent"] = this.continent;
        if (Array.isArray(this.holidayTypes)) {
            data["holidayTypes"] = [];
            for (let item of this.holidayTypes)
                data["holidayTypes"].push(item);
        }
        if (Array.isArray(this.itinerary)) {
            data["itinerary"] = [];
            for (let item of this.itinerary)
                data["itinerary"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cancellationPolicy)) {
            data["cancellationPolicy"] = [];
            for (let item of this.cancellationPolicy)
                data["cancellationPolicy"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TourDetailDto {
        const json = this.toJSON();
        let result = new TourDetailDto();
        result.init(json);
        return result;
    }
}

/** DTO for tour detail page Matches frontend tour detail data structure */
export interface ITourDetailDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    price: number;
    rating: number;
    reviewCount: number;
    days: number;
    nights: number;
    images: string[] | undefined;
    likeCount: number;
    tourInfo: TourInfoDto[] | undefined;
    highlights: string[] | undefined;
    inclusions: string[] | undefined;
    exclusions: string[] | undefined;
    continent: string | undefined;
    holidayTypes: string[] | undefined;
    itinerary: ItineraryDayDto[] | undefined;
    cancellationPolicy: CancellationPolicyDto[] | undefined;
}

export class TourInfoDto implements ITourInfoDto {
    title: string | undefined;
    info: string | undefined;

    constructor(data?: ITourInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.info = _data["info"];
        }
    }

    static fromJS(data: any): TourInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["info"] = this.info;
        return data;
    }

    clone(): TourInfoDto {
        const json = this.toJSON();
        let result = new TourInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITourInfoDto {
    title: string | undefined;
    info: string | undefined;
}

export class TourInquiryDto implements ITourInquiryDto {
    id: string;
    email: string;
    contactNumber: string;
    destination: string;
    adultCount: number;
    childCount: number;
    travelDateFrom: moment.Moment;
    travelDateTo: moment.Moment;
    notes: string | undefined;
    packageId: string;
    packageTitle: string;
    status: TourInquiryStatus;
    adminNote: string | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: ITourInquiryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.contactNumber = _data["contactNumber"];
            this.destination = _data["destination"];
            this.adultCount = _data["adultCount"];
            this.childCount = _data["childCount"];
            this.travelDateFrom = _data["travelDateFrom"] ? moment(_data["travelDateFrom"].toString()) : undefined as any;
            this.travelDateTo = _data["travelDateTo"] ? moment(_data["travelDateTo"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.packageId = _data["packageId"];
            this.packageTitle = _data["packageTitle"];
            this.status = _data["status"];
            this.adminNote = _data["adminNote"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TourInquiryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourInquiryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["contactNumber"] = this.contactNumber;
        data["destination"] = this.destination;
        data["adultCount"] = this.adultCount;
        data["childCount"] = this.childCount;
        data["travelDateFrom"] = this.travelDateFrom ? this.travelDateFrom.toISOString() : undefined as any;
        data["travelDateTo"] = this.travelDateTo ? this.travelDateTo.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["packageId"] = this.packageId;
        data["packageTitle"] = this.packageTitle;
        data["status"] = this.status;
        data["adminNote"] = this.adminNote;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): TourInquiryDto {
        const json = this.toJSON();
        let result = new TourInquiryDto();
        result.init(json);
        return result;
    }
}

export interface ITourInquiryDto {
    id: string;
    email: string;
    contactNumber: string;
    destination: string;
    adultCount: number;
    childCount: number;
    travelDateFrom: moment.Moment;
    travelDateTo: moment.Moment;
    notes: string | undefined;
    packageId: string;
    packageTitle: string;
    status: TourInquiryStatus;
    adminNote: string | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export enum TourInquiryStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

/** DTO for tour like count and status Used by public API endpoints */
export class TourLikeCountDto implements ITourLikeCountDto {
    packageId: string;
    likeCount: number;
    isLiked: boolean;

    constructor(data?: ITourLikeCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.likeCount = _data["likeCount"];
            this.isLiked = _data["isLiked"];
        }
    }

    static fromJS(data: any): TourLikeCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourLikeCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["likeCount"] = this.likeCount;
        data["isLiked"] = this.isLiked;
        return data;
    }

    clone(): TourLikeCountDto {
        const json = this.toJSON();
        let result = new TourLikeCountDto();
        result.init(json);
        return result;
    }
}

/** DTO for tour like count and status Used by public API endpoints */
export interface ITourLikeCountDto {
    packageId: string;
    likeCount: number;
    isLiked: boolean;
}

/** DTO for tour packages displayed on homepage Matches frontend TourPackageType interface */
export class TourPackageDto implements ITourPackageDto {
    id: string;
    name: string | undefined;
    price: number;
    type: string | undefined;
    rating: number;
    days: number;
    nights: number;
    image: string | undefined;
    isNew: boolean;
    likeCount: number;
    holidayTypes: string[] | undefined;

    constructor(data?: ITourPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.type = _data["type"];
            this.rating = _data["rating"];
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.image = _data["image"];
            this.isNew = _data["isNew"];
            this.likeCount = _data["likeCount"];
            if (Array.isArray(_data["holidayTypes"])) {
                this.holidayTypes = [] as any;
                for (let item of _data["holidayTypes"])
                    this.holidayTypes.push(item);
            }
        }
    }

    static fromJS(data: any): TourPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["type"] = this.type;
        data["rating"] = this.rating;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["image"] = this.image;
        data["isNew"] = this.isNew;
        data["likeCount"] = this.likeCount;
        if (Array.isArray(this.holidayTypes)) {
            data["holidayTypes"] = [];
            for (let item of this.holidayTypes)
                data["holidayTypes"].push(item);
        }
        return data;
    }

    clone(): TourPackageDto {
        const json = this.toJSON();
        let result = new TourPackageDto();
        result.init(json);
        return result;
    }
}

/** DTO for tour packages displayed on homepage Matches frontend TourPackageType interface */
export interface ITourPackageDto {
    id: string;
    name: string | undefined;
    price: number;
    type: string | undefined;
    rating: number;
    days: number;
    nights: number;
    image: string | undefined;
    isNew: boolean;
    likeCount: number;
    holidayTypes: string[] | undefined;
}

/** DTO for tour search and filtering parameters */
export class TourSearchDto implements ITourSearchDto {
    location: string | undefined;
    date: string | undefined;
    tourType: string | undefined;
    tourName: string | undefined;
    priceMin: number | undefined;
    priceMax: number | undefined;
    durationMin: number | undefined;
    durationMax: number | undefined;
    withFlights: boolean | undefined;
    continent: string | undefined;
    holidayTypes: string[] | undefined;
    sortBy: string | undefined;
    sortOrder: string | undefined;
    page: number;
    pageSize: number;

    constructor(data?: ITourSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.date = _data["date"];
            this.tourType = _data["tourType"];
            this.tourName = _data["tourName"];
            this.priceMin = _data["priceMin"];
            this.priceMax = _data["priceMax"];
            this.durationMin = _data["durationMin"];
            this.durationMax = _data["durationMax"];
            this.withFlights = _data["withFlights"];
            this.continent = _data["continent"];
            if (Array.isArray(_data["holidayTypes"])) {
                this.holidayTypes = [] as any;
                for (let item of _data["holidayTypes"])
                    this.holidayTypes.push(item);
            }
            this.sortBy = _data["sortBy"];
            this.sortOrder = _data["sortOrder"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): TourSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["date"] = this.date;
        data["tourType"] = this.tourType;
        data["tourName"] = this.tourName;
        data["priceMin"] = this.priceMin;
        data["priceMax"] = this.priceMax;
        data["durationMin"] = this.durationMin;
        data["durationMax"] = this.durationMax;
        data["withFlights"] = this.withFlights;
        data["continent"] = this.continent;
        if (Array.isArray(this.holidayTypes)) {
            data["holidayTypes"] = [];
            for (let item of this.holidayTypes)
                data["holidayTypes"].push(item);
        }
        data["sortBy"] = this.sortBy;
        data["sortOrder"] = this.sortOrder;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }

    clone(): TourSearchDto {
        const json = this.toJSON();
        let result = new TourSearchDto();
        result.init(json);
        return result;
    }
}

/** DTO for tour search and filtering parameters */
export interface ITourSearchDto {
    location: string | undefined;
    date: string | undefined;
    tourType: string | undefined;
    tourName: string | undefined;
    priceMin: number | undefined;
    priceMax: number | undefined;
    durationMin: number | undefined;
    durationMax: number | undefined;
    withFlights: boolean | undefined;
    continent: string | undefined;
    holidayTypes: string[] | undefined;
    sortBy: string | undefined;
    sortOrder: string | undefined;
    page: number;
    pageSize: number;
}

/** Response DTO for tour search results with enhanced UX fields */
export class TourSearchResponseDto implements ITourSearchResponseDto {
    tours: TourCardDto[] | undefined;
    totalCount: number;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    message: string | undefined;
    suggestions: string[] | undefined;
    searchCriteria: TourSearchDto;
    warning: string | undefined;
    error: string | undefined;
    originalSearch: TourSearchDto;
    searchedDate: string | undefined;
    exactMatchCount: number;
    nearbyMatchCount: number;
    sameMonthMatchCount: number;

    constructor(data?: ITourSearchResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tours"])) {
                this.tours = [] as any;
                for (let item of _data["tours"])
                    this.tours.push(TourCardDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.message = _data["message"];
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions.push(item);
            }
            this.searchCriteria = _data["searchCriteria"] ? TourSearchDto.fromJS(_data["searchCriteria"]) : undefined as any;
            this.warning = _data["warning"];
            this.error = _data["error"];
            this.originalSearch = _data["originalSearch"] ? TourSearchDto.fromJS(_data["originalSearch"]) : undefined as any;
            this.searchedDate = _data["searchedDate"];
            this.exactMatchCount = _data["exactMatchCount"];
            this.nearbyMatchCount = _data["nearbyMatchCount"];
            this.sameMonthMatchCount = _data["sameMonthMatchCount"];
        }
    }

    static fromJS(data: any): TourSearchResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourSearchResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tours)) {
            data["tours"] = [];
            for (let item of this.tours)
                data["tours"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["message"] = this.message;
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item);
        }
        data["searchCriteria"] = this.searchCriteria ? this.searchCriteria.toJSON() : undefined as any;
        data["warning"] = this.warning;
        data["error"] = this.error;
        data["originalSearch"] = this.originalSearch ? this.originalSearch.toJSON() : undefined as any;
        data["searchedDate"] = this.searchedDate;
        data["exactMatchCount"] = this.exactMatchCount;
        data["nearbyMatchCount"] = this.nearbyMatchCount;
        data["sameMonthMatchCount"] = this.sameMonthMatchCount;
        return data;
    }

    clone(): TourSearchResponseDto {
        const json = this.toJSON();
        let result = new TourSearchResponseDto();
        result.init(json);
        return result;
    }
}

/** Response DTO for tour search results with enhanced UX fields */
export interface ITourSearchResponseDto {
    tours: TourCardDto[] | undefined;
    totalCount: number;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    message: string | undefined;
    suggestions: string[] | undefined;
    searchCriteria: TourSearchDto;
    warning: string | undefined;
    error: string | undefined;
    originalSearch: TourSearchDto;
    searchedDate: string | undefined;
    exactMatchCount: number;
    nearbyMatchCount: number;
    sameMonthMatchCount: number;
}

export class TourSummaryDto implements ITourSummaryDto {
    name: string | undefined;
    days: number;
    nights: number;
    startDate: string | undefined;
    endDate: string | undefined;
    pricePerPerson: number;
    totalTravelers: number;

    constructor(data?: ITourSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.pricePerPerson = _data["pricePerPerson"];
            this.totalTravelers = _data["totalTravelers"];
        }
    }

    static fromJS(data: any): TourSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TourSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["pricePerPerson"] = this.pricePerPerson;
        data["totalTravelers"] = this.totalTravelers;
        return data;
    }

    clone(): TourSummaryDto {
        const json = this.toJSON();
        let result = new TourSummaryDto();
        result.init(json);
        return result;
    }
}

export interface ITourSummaryDto {
    name: string | undefined;
    days: number;
    nights: number;
    startDate: string | undefined;
    endDate: string | undefined;
    pricePerPerson: number;
    totalTravelers: number;
}

/** DTO for traveler information */
export class TravelerDto implements ITravelerDto {
    title: string;
    firstName: string;
    lastName: string;
    email: string | undefined;
    phone: string | undefined;
    dateOfBirth: string | undefined;
    passportNumber: string | undefined;

    constructor(data?: ITravelerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.passportNumber = _data["passportNumber"];
        }
    }

    static fromJS(data: any): TravelerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TravelerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["dateOfBirth"] = this.dateOfBirth;
        data["passportNumber"] = this.passportNumber;
        return data;
    }

    clone(): TravelerDto {
        const json = this.toJSON();
        let result = new TravelerDto();
        result.init(json);
        return result;
    }
}

/** DTO for traveler information */
export interface ITravelerDto {
    title: string;
    firstName: string;
    lastName: string;
    email: string | undefined;
    phone: string | undefined;
    dateOfBirth: string | undefined;
    passportNumber: string | undefined;
}

export class TriggerHotelBedsContentSyncResultDto implements ITriggerHotelBedsContentSyncResultDto {
    runId: string;
    message: string | undefined;
    alreadyRunning: boolean;
    /** Codes requested for hotelByCode (comma-parsed). */
    requestedHotelCodes: string | undefined;
    requestedHotelCodeCount: number;

    constructor(data?: ITriggerHotelBedsContentSyncResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runId = _data["runId"];
            this.message = _data["message"];
            this.alreadyRunning = _data["alreadyRunning"];
            this.requestedHotelCodes = _data["requestedHotelCodes"];
            this.requestedHotelCodeCount = _data["requestedHotelCodeCount"];
        }
    }

    static fromJS(data: any): TriggerHotelBedsContentSyncResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerHotelBedsContentSyncResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runId"] = this.runId;
        data["message"] = this.message;
        data["alreadyRunning"] = this.alreadyRunning;
        data["requestedHotelCodes"] = this.requestedHotelCodes;
        data["requestedHotelCodeCount"] = this.requestedHotelCodeCount;
        return data;
    }

    clone(): TriggerHotelBedsContentSyncResultDto {
        const json = this.toJSON();
        let result = new TriggerHotelBedsContentSyncResultDto();
        result.init(json);
        return result;
    }
}

export interface ITriggerHotelBedsContentSyncResultDto {
    runId: string;
    message: string | undefined;
    alreadyRunning: boolean;
    /** Codes requested for hotelByCode (comma-parsed). */
    requestedHotelCodes: string | undefined;
    requestedHotelCodeCount: number;
}

export class UpdateAgentDto implements IUpdateAgentDto {
    id: string;
    agentTypeId: string;
    name: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    isDotAccredited: boolean;
    dotAccreditationExpiryDate: moment.Moment | undefined;
    status: Status;
    isActive: boolean;
    profilePictureDocumentId: string | undefined;
    coverPhotoDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    phoneNumbers: AgentPhoneNumberDto[] | undefined;
    emails: AgentEmailDto[] | undefined;

    constructor(data?: IUpdateAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentTypeId = _data["agentTypeId"];
            this.name = _data["name"];
            this.contactPerson = _data["contactPerson"];
            this.designation = _data["designation"];
            this.note = _data["note"];
            this.isDotAccredited = _data["isDotAccredited"];
            this.dotAccreditationExpiryDate = _data["dotAccreditationExpiryDate"] ? moment(_data["dotAccreditationExpiryDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.profilePictureDocumentUrl = _data["profilePictureDocumentUrl"];
            this.coverPhotoDocumentUrl = _data["coverPhotoDocumentUrl"];
            this.coverPhoto = _data["coverPhoto"] ? FileDto.fromJS(_data["coverPhoto"]) : undefined as any;
            this.profilePhoto = _data["profilePhoto"] ? FileDto.fromJS(_data["profilePhoto"]) : undefined as any;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(AgentPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(AgentEmailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentTypeId"] = this.agentTypeId;
        data["name"] = this.name;
        data["contactPerson"] = this.contactPerson;
        data["designation"] = this.designation;
        data["note"] = this.note;
        data["isDotAccredited"] = this.isDotAccredited;
        data["dotAccreditationExpiryDate"] = this.dotAccreditationExpiryDate ? this.dotAccreditationExpiryDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["profilePictureDocumentUrl"] = this.profilePictureDocumentUrl;
        data["coverPhotoDocumentUrl"] = this.coverPhotoDocumentUrl;
        data["coverPhoto"] = this.coverPhoto ? this.coverPhoto.toJSON() : undefined as any;
        data["profilePhoto"] = this.profilePhoto ? this.profilePhoto.toJSON() : undefined as any;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateAgentDto {
        const json = this.toJSON();
        let result = new UpdateAgentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAgentDto {
    id: string;
    agentTypeId: string;
    name: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    isDotAccredited: boolean;
    dotAccreditationExpiryDate: moment.Moment | undefined;
    status: Status;
    isActive: boolean;
    profilePictureDocumentId: string | undefined;
    coverPhotoDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    phoneNumbers: AgentPhoneNumberDto[] | undefined;
    emails: AgentEmailDto[] | undefined;
}

export class UpdateAppSettingDto implements IUpdateAppSettingDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean;
    optionType: SettingsOptionType;
    icon: string | undefined;
    note: string | undefined;
    options: UpdateAppSettingOptionDto[] | undefined;

    constructor(data?: IUpdateAppSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.optionType = _data["optionType"];
            this.icon = _data["icon"];
            this.note = _data["note"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options.push(UpdateAppSettingOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAppSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["optionType"] = this.optionType;
        data["icon"] = this.icon;
        data["note"] = this.note;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateAppSettingDto {
        const json = this.toJSON();
        let result = new UpdateAppSettingDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAppSettingDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean;
    optionType: SettingsOptionType;
    icon: string | undefined;
    note: string | undefined;
    options: UpdateAppSettingOptionDto[] | undefined;
}

export class UpdateAppSettingOptionDto implements IUpdateAppSettingOptionDto {
    id: string;
    name: string | undefined;
    order: number;
    value: string | undefined;
    isActive: boolean;
    appSettingId: string;

    constructor(data?: IUpdateAppSettingOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.value = _data["value"];
            this.isActive = _data["isActive"];
            this.appSettingId = _data["appSettingId"];
        }
    }

    static fromJS(data: any): UpdateAppSettingOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppSettingOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["order"] = this.order;
        data["value"] = this.value;
        data["isActive"] = this.isActive;
        data["appSettingId"] = this.appSettingId;
        return data;
    }

    clone(): UpdateAppSettingOptionDto {
        const json = this.toJSON();
        let result = new UpdateAppSettingOptionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAppSettingOptionDto {
    id: string;
    name: string | undefined;
    order: number;
    value: string | undefined;
    isActive: boolean;
    appSettingId: string;
}

export class UpdateBookingDto implements IUpdateBookingDto {
    id: string;
    statusId: string | undefined;
    createAttachments: CreateBookingAttachmentDto[] | undefined;
    deleteAttachments: string[] | undefined;
    createClients: CreateBookingClientDto[] | undefined;
    deleteClients: string[] | undefined;
    processedPackage: UpdateProcessedPackageDto;
    processedVisa: UpdateProcessedVisaDto;
    processedDocument: UpdateProcessedDocumentDto;
    processedTicket: UpdateProcessedTicketDto;

    constructor(data?: IUpdateBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusId = _data["statusId"];
            if (Array.isArray(_data["createAttachments"])) {
                this.createAttachments = [] as any;
                for (let item of _data["createAttachments"])
                    this.createAttachments.push(CreateBookingAttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["deleteAttachments"])) {
                this.deleteAttachments = [] as any;
                for (let item of _data["deleteAttachments"])
                    this.deleteAttachments.push(item);
            }
            if (Array.isArray(_data["createClients"])) {
                this.createClients = [] as any;
                for (let item of _data["createClients"])
                    this.createClients.push(CreateBookingClientDto.fromJS(item));
            }
            if (Array.isArray(_data["deleteClients"])) {
                this.deleteClients = [] as any;
                for (let item of _data["deleteClients"])
                    this.deleteClients.push(item);
            }
            this.processedPackage = _data["processedPackage"] ? UpdateProcessedPackageDto.fromJS(_data["processedPackage"]) : undefined as any;
            this.processedVisa = _data["processedVisa"] ? UpdateProcessedVisaDto.fromJS(_data["processedVisa"]) : undefined as any;
            this.processedDocument = _data["processedDocument"] ? UpdateProcessedDocumentDto.fromJS(_data["processedDocument"]) : undefined as any;
            this.processedTicket = _data["processedTicket"] ? UpdateProcessedTicketDto.fromJS(_data["processedTicket"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        if (Array.isArray(this.createAttachments)) {
            data["createAttachments"] = [];
            for (let item of this.createAttachments)
                data["createAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleteAttachments)) {
            data["deleteAttachments"] = [];
            for (let item of this.deleteAttachments)
                data["deleteAttachments"].push(item);
        }
        if (Array.isArray(this.createClients)) {
            data["createClients"] = [];
            for (let item of this.createClients)
                data["createClients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleteClients)) {
            data["deleteClients"] = [];
            for (let item of this.deleteClients)
                data["deleteClients"].push(item);
        }
        data["processedPackage"] = this.processedPackage ? this.processedPackage.toJSON() : undefined as any;
        data["processedVisa"] = this.processedVisa ? this.processedVisa.toJSON() : undefined as any;
        data["processedDocument"] = this.processedDocument ? this.processedDocument.toJSON() : undefined as any;
        data["processedTicket"] = this.processedTicket ? this.processedTicket.toJSON() : undefined as any;
        return data;
    }

    clone(): UpdateBookingDto {
        const json = this.toJSON();
        let result = new UpdateBookingDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateBookingDto {
    id: string;
    statusId: string | undefined;
    createAttachments: CreateBookingAttachmentDto[] | undefined;
    deleteAttachments: string[] | undefined;
    createClients: CreateBookingClientDto[] | undefined;
    deleteClients: string[] | undefined;
    processedPackage: UpdateProcessedPackageDto;
    processedVisa: UpdateProcessedVisaDto;
    processedDocument: UpdateProcessedDocumentDto;
    processedTicket: UpdateProcessedTicketDto;
}

export class UpdateBookingStatusDto implements IUpdateBookingStatusDto {
    bookingId: string;
    statusId: string;

    constructor(data?: IUpdateBookingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): UpdateBookingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["statusId"] = this.statusId;
        return data;
    }

    clone(): UpdateBookingStatusDto {
        const json = this.toJSON();
        let result = new UpdateBookingStatusDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateBookingStatusDto {
    bookingId: string;
    statusId: string;
}

export class UpdateCmsPageDto implements IUpdateCmsPageDto {
    id: string;
    pageName: string | undefined;
    pageTitle: string | undefined;
    pageDescription: string | undefined;
    pageType: string | undefined;
    contentJson: string | undefined;
    slug: string | undefined;
    isActive: boolean;
    sortOrder: number;
    metaTitle: string | undefined;
    metaDescription: string | undefined;
    metaKeywords: string | undefined;

    constructor(data?: IUpdateCmsPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageName = _data["pageName"];
            this.pageTitle = _data["pageTitle"];
            this.pageDescription = _data["pageDescription"];
            this.pageType = _data["pageType"];
            this.contentJson = _data["contentJson"];
            this.slug = _data["slug"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
        }
    }

    static fromJS(data: any): UpdateCmsPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCmsPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageName"] = this.pageName;
        data["pageTitle"] = this.pageTitle;
        data["pageDescription"] = this.pageDescription;
        data["pageType"] = this.pageType;
        data["contentJson"] = this.contentJson;
        data["slug"] = this.slug;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        return data;
    }

    clone(): UpdateCmsPageDto {
        const json = this.toJSON();
        let result = new UpdateCmsPageDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCmsPageDto {
    id: string;
    pageName: string | undefined;
    pageTitle: string | undefined;
    pageDescription: string | undefined;
    pageType: string | undefined;
    contentJson: string | undefined;
    slug: string | undefined;
    isActive: boolean;
    sortOrder: number;
    metaTitle: string | undefined;
    metaDescription: string | undefined;
    metaKeywords: string | undefined;
}

export class UpdateContactInquiryStatusDto implements IUpdateContactInquiryStatusDto {
    id: string;
    status: ContactInquiryStatus;
    adminNotes: string | undefined;
    responseMessage: string | undefined;

    constructor(data?: IUpdateContactInquiryStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.adminNotes = _data["adminNotes"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): UpdateContactInquiryStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactInquiryStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["adminNotes"] = this.adminNotes;
        data["responseMessage"] = this.responseMessage;
        return data;
    }

    clone(): UpdateContactInquiryStatusDto {
        const json = this.toJSON();
        let result = new UpdateContactInquiryStatusDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateContactInquiryStatusDto {
    id: string;
    status: ContactInquiryStatus;
    adminNotes: string | undefined;
    responseMessage: string | undefined;
}

/** DTO for updating a customer booking */
export class UpdateCustomerBookingDto implements IUpdateCustomerBookingDto {
    id: string;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    totalAmount: number | undefined;
    travelDate: moment.Moment | undefined;
    days: number | undefined;
    nights: number | undefined;
    currentStep: number | undefined;
    formDataJson: string | undefined;
    notes: string | undefined;
    travelers: CreateCustomerTravelerDto[] | undefined;

    constructor(data?: IUpdateCustomerBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.totalAmount = _data["totalAmount"];
            this.travelDate = _data["travelDate"] ? moment(_data["travelDate"].toString()) : undefined as any;
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.currentStep = _data["currentStep"];
            this.formDataJson = _data["formDataJson"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["travelers"])) {
                this.travelers = [] as any;
                for (let item of _data["travelers"])
                    this.travelers.push(CreateCustomerTravelerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCustomerBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["totalAmount"] = this.totalAmount;
        data["travelDate"] = this.travelDate ? this.travelDate.toISOString() : undefined as any;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["currentStep"] = this.currentStep;
        data["formDataJson"] = this.formDataJson;
        data["notes"] = this.notes;
        if (Array.isArray(this.travelers)) {
            data["travelers"] = [];
            for (let item of this.travelers)
                data["travelers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateCustomerBookingDto {
        const json = this.toJSON();
        let result = new UpdateCustomerBookingDto();
        result.init(json);
        return result;
    }
}

/** DTO for updating a customer booking */
export interface IUpdateCustomerBookingDto {
    id: string;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    totalAmount: number | undefined;
    travelDate: moment.Moment | undefined;
    days: number | undefined;
    nights: number | undefined;
    currentStep: number | undefined;
    formDataJson: string | undefined;
    notes: string | undefined;
    travelers: CreateCustomerTravelerDto[] | undefined;
}

export class UpdateCustomerBookingStatusDto implements IUpdateCustomerBookingStatusDto {
    id: string;
    status: CustomerBookingStatus;
    notes: string | undefined;
    rejectionReason: string | undefined;

    constructor(data?: IUpdateCustomerBookingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.rejectionReason = _data["rejectionReason"];
        }
    }

    static fromJS(data: any): UpdateCustomerBookingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerBookingStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["rejectionReason"] = this.rejectionReason;
        return data;
    }

    clone(): UpdateCustomerBookingStatusDto {
        const json = this.toJSON();
        let result = new UpdateCustomerBookingStatusDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCustomerBookingStatusDto {
    id: string;
    status: CustomerBookingStatus;
    notes: string | undefined;
    rejectionReason: string | undefined;
}

export class UpdateHotelBedsContentSyncSettingsDto implements IUpdateHotelBedsContentSyncSettingsDto {
    isAutoSyncEnabled: boolean;
    referenceDataSyncIntervalHours: number;

    constructor(data?: IUpdateHotelBedsContentSyncSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAutoSyncEnabled = _data["isAutoSyncEnabled"];
            this.referenceDataSyncIntervalHours = _data["referenceDataSyncIntervalHours"];
        }
    }

    static fromJS(data: any): UpdateHotelBedsContentSyncSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHotelBedsContentSyncSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAutoSyncEnabled"] = this.isAutoSyncEnabled;
        data["referenceDataSyncIntervalHours"] = this.referenceDataSyncIntervalHours;
        return data;
    }

    clone(): UpdateHotelBedsContentSyncSettingsDto {
        const json = this.toJSON();
        let result = new UpdateHotelBedsContentSyncSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHotelBedsContentSyncSettingsDto {
    isAutoSyncEnabled: boolean;
    referenceDataSyncIntervalHours: number;
}

export class UpdateMarkupRuleDto implements IUpdateMarkupRuleDto {
    id: string;
    name: string;
    description: string | undefined;
    supplierName: string | undefined;
    productType: MarkupProductType;
    cabinClass: string | undefined;
    destinationRegion: string | undefined;
    markupType: MarkupType;
    markupValue: number;
    priority: number;
    validFrom: moment.Moment | undefined;
    validTo: moment.Moment | undefined;
    isActive: boolean;

    constructor(data?: IUpdateMarkupRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.supplierName = _data["supplierName"];
            this.productType = _data["productType"];
            this.cabinClass = _data["cabinClass"];
            this.destinationRegion = _data["destinationRegion"];
            this.markupType = _data["markupType"];
            this.markupValue = _data["markupValue"];
            this.priority = _data["priority"];
            this.validFrom = _data["validFrom"] ? moment(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? moment(_data["validTo"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateMarkupRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMarkupRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["supplierName"] = this.supplierName;
        data["productType"] = this.productType;
        data["cabinClass"] = this.cabinClass;
        data["destinationRegion"] = this.destinationRegion;
        data["markupType"] = this.markupType;
        data["markupValue"] = this.markupValue;
        data["priority"] = this.priority;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateMarkupRuleDto {
        const json = this.toJSON();
        let result = new UpdateMarkupRuleDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMarkupRuleDto {
    id: string;
    name: string;
    description: string | undefined;
    supplierName: string | undefined;
    productType: MarkupProductType;
    cabinClass: string | undefined;
    destinationRegion: string | undefined;
    markupType: MarkupType;
    markupValue: number;
    priority: number;
    validFrom: moment.Moment | undefined;
    validTo: moment.Moment | undefined;
    isActive: boolean;
}

export class UpdatePackageDto implements IUpdatePackageDto {
    id: string;
    type: PackageType;
    packageTypeNote: string | undefined;
    title: string | undefined;
    details: string | undefined;
    shortOverview: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    isPublished: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    travels: PackageTravelDto[] | undefined;
    images: PackageImageDto[] | undefined;
    price: number;
    tourPackageTypeId: string | undefined;
    continentId: string | undefined;
    days: number;
    nights: number;
    endPoint: string | undefined;
    rating: number;
    withFlights: boolean;
    sale: string | undefined;
    description: string | undefined;
    reviewCount: number;
    currency: string | undefined;
    basePrice: number;
    startPoint: string | undefined;
    placeCovered: string | undefined;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    minTravelers: number;
    maxTravelers: number;
    tourInfo: PackageTourInfoDto[] | undefined;
    highlights: PackageHighlightDto[] | undefined;
    inclusions: PackageInclusionDto[] | undefined;
    exclusions: PackageExclusionDto[] | undefined;
    cancellationPolicies: PackageCancellationPolicyDto[] | undefined;
    itinerary: PackageItineraryDto[] | undefined;
    holidayTypes: PackageHolidayTypeDto[] | undefined;

    constructor(data?: IUpdatePackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.packageTypeNote = _data["packageTypeNote"];
            this.title = _data["title"];
            this.details = _data["details"];
            this.shortOverview = _data["shortOverview"];
            this.note = _data["note"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.isPublished = _data["isPublished"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureDocumentUrl = _data["profilePictureDocumentUrl"];
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.coverPhotoDocumentUrl = _data["coverPhotoDocumentUrl"];
            this.coverPhoto = _data["coverPhoto"] ? FileDto.fromJS(_data["coverPhoto"]) : undefined as any;
            this.profilePhoto = _data["profilePhoto"] ? FileDto.fromJS(_data["profilePhoto"]) : undefined as any;
            if (Array.isArray(_data["travels"])) {
                this.travels = [] as any;
                for (let item of _data["travels"])
                    this.travels.push(PackageTravelDto.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(PackageImageDto.fromJS(item));
            }
            this.price = _data["price"];
            this.tourPackageTypeId = _data["tourPackageTypeId"];
            this.continentId = _data["continentId"];
            this.days = _data["days"];
            this.nights = _data["nights"];
            this.endPoint = _data["endPoint"];
            this.rating = _data["rating"];
            this.withFlights = _data["withFlights"];
            this.sale = _data["sale"];
            this.description = _data["description"];
            this.reviewCount = _data["reviewCount"];
            this.currency = _data["currency"];
            this.basePrice = _data["basePrice"];
            this.startPoint = _data["startPoint"];
            this.placeCovered = _data["placeCovered"];
            this.availableFrom = _data["availableFrom"] ? moment(_data["availableFrom"].toString()) : undefined as any;
            this.availableTo = _data["availableTo"] ? moment(_data["availableTo"].toString()) : undefined as any;
            this.minTravelers = _data["minTravelers"];
            this.maxTravelers = _data["maxTravelers"];
            if (Array.isArray(_data["tourInfo"])) {
                this.tourInfo = [] as any;
                for (let item of _data["tourInfo"])
                    this.tourInfo.push(PackageTourInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["highlights"])) {
                this.highlights = [] as any;
                for (let item of _data["highlights"])
                    this.highlights.push(PackageHighlightDto.fromJS(item));
            }
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions.push(PackageInclusionDto.fromJS(item));
            }
            if (Array.isArray(_data["exclusions"])) {
                this.exclusions = [] as any;
                for (let item of _data["exclusions"])
                    this.exclusions.push(PackageExclusionDto.fromJS(item));
            }
            if (Array.isArray(_data["cancellationPolicies"])) {
                this.cancellationPolicies = [] as any;
                for (let item of _data["cancellationPolicies"])
                    this.cancellationPolicies.push(PackageCancellationPolicyDto.fromJS(item));
            }
            if (Array.isArray(_data["itinerary"])) {
                this.itinerary = [] as any;
                for (let item of _data["itinerary"])
                    this.itinerary.push(PackageItineraryDto.fromJS(item));
            }
            if (Array.isArray(_data["holidayTypes"])) {
                this.holidayTypes = [] as any;
                for (let item of _data["holidayTypes"])
                    this.holidayTypes.push(PackageHolidayTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["packageTypeNote"] = this.packageTypeNote;
        data["title"] = this.title;
        data["details"] = this.details;
        data["shortOverview"] = this.shortOverview;
        data["note"] = this.note;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["isPublished"] = this.isPublished;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureDocumentUrl"] = this.profilePictureDocumentUrl;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["coverPhotoDocumentUrl"] = this.coverPhotoDocumentUrl;
        data["coverPhoto"] = this.coverPhoto ? this.coverPhoto.toJSON() : undefined as any;
        data["profilePhoto"] = this.profilePhoto ? this.profilePhoto.toJSON() : undefined as any;
        if (Array.isArray(this.travels)) {
            data["travels"] = [];
            for (let item of this.travels)
                data["travels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["price"] = this.price;
        data["tourPackageTypeId"] = this.tourPackageTypeId;
        data["continentId"] = this.continentId;
        data["days"] = this.days;
        data["nights"] = this.nights;
        data["endPoint"] = this.endPoint;
        data["rating"] = this.rating;
        data["withFlights"] = this.withFlights;
        data["sale"] = this.sale;
        data["description"] = this.description;
        data["reviewCount"] = this.reviewCount;
        data["currency"] = this.currency;
        data["basePrice"] = this.basePrice;
        data["startPoint"] = this.startPoint;
        data["placeCovered"] = this.placeCovered;
        data["availableFrom"] = this.availableFrom ? this.availableFrom.toISOString() : undefined as any;
        data["availableTo"] = this.availableTo ? this.availableTo.toISOString() : undefined as any;
        data["minTravelers"] = this.minTravelers;
        data["maxTravelers"] = this.maxTravelers;
        if (Array.isArray(this.tourInfo)) {
            data["tourInfo"] = [];
            for (let item of this.tourInfo)
                data["tourInfo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.highlights)) {
            data["highlights"] = [];
            for (let item of this.highlights)
                data["highlights"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exclusions)) {
            data["exclusions"] = [];
            for (let item of this.exclusions)
                data["exclusions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cancellationPolicies)) {
            data["cancellationPolicies"] = [];
            for (let item of this.cancellationPolicies)
                data["cancellationPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.itinerary)) {
            data["itinerary"] = [];
            for (let item of this.itinerary)
                data["itinerary"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.holidayTypes)) {
            data["holidayTypes"] = [];
            for (let item of this.holidayTypes)
                data["holidayTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdatePackageDto {
        const json = this.toJSON();
        let result = new UpdatePackageDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePackageDto {
    id: string;
    type: PackageType;
    packageTypeNote: string | undefined;
    title: string | undefined;
    details: string | undefined;
    shortOverview: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    isPublished: boolean;
    profilePictureDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    travels: PackageTravelDto[] | undefined;
    images: PackageImageDto[] | undefined;
    price: number;
    tourPackageTypeId: string | undefined;
    continentId: string | undefined;
    days: number;
    nights: number;
    endPoint: string | undefined;
    rating: number;
    withFlights: boolean;
    sale: string | undefined;
    description: string | undefined;
    reviewCount: number;
    currency: string | undefined;
    basePrice: number;
    startPoint: string | undefined;
    placeCovered: string | undefined;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    minTravelers: number;
    maxTravelers: number;
    tourInfo: PackageTourInfoDto[] | undefined;
    highlights: PackageHighlightDto[] | undefined;
    inclusions: PackageInclusionDto[] | undefined;
    exclusions: PackageExclusionDto[] | undefined;
    cancellationPolicies: PackageCancellationPolicyDto[] | undefined;
    itinerary: PackageItineraryDto[] | undefined;
    holidayTypes: PackageHolidayTypeDto[] | undefined;
}

export class UpdatePassengerDto implements IUpdatePassengerDto {
    id: string;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    birthPlace: string | undefined;
    isActive: boolean;
    note: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    profilePictureDocumentId: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    passports: PassportDto[] | undefined;
    phoneNumbers: PassengerPhoneNumberDto[] | undefined;
    emails: PassengerEmailDto[] | undefined;

    constructor(data?: IUpdatePassengerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.middleName = _data["middleName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.birthPlace = _data["birthPlace"];
            this.isActive = _data["isActive"];
            this.note = _data["note"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.zipOrPostCode = _data["zipOrPostCode"];
            this.stateOrProvince = _data["stateOrProvince"];
            this.country = _data["country"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.coverPhoto = _data["coverPhoto"] ? FileDto.fromJS(_data["coverPhoto"]) : undefined as any;
            this.profilePhoto = _data["profilePhoto"] ? FileDto.fromJS(_data["profilePhoto"]) : undefined as any;
            if (Array.isArray(_data["passports"])) {
                this.passports = [] as any;
                for (let item of _data["passports"])
                    this.passports.push(PassportDto.fromJS(item));
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(PassengerPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(PassengerEmailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePassengerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePassengerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["middleName"] = this.middleName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["birthPlace"] = this.birthPlace;
        data["isActive"] = this.isActive;
        data["note"] = this.note;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["zipOrPostCode"] = this.zipOrPostCode;
        data["stateOrProvince"] = this.stateOrProvince;
        data["country"] = this.country;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["coverPhoto"] = this.coverPhoto ? this.coverPhoto.toJSON() : undefined as any;
        data["profilePhoto"] = this.profilePhoto ? this.profilePhoto.toJSON() : undefined as any;
        if (Array.isArray(this.passports)) {
            data["passports"] = [];
            for (let item of this.passports)
                data["passports"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdatePassengerDto {
        const json = this.toJSON();
        let result = new UpdatePassengerDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePassengerDto {
    id: string;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    middleName: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: string | undefined;
    birthPlace: string | undefined;
    isActive: boolean;
    note: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    profilePictureDocumentId: string | undefined;
    coverPhotoDocumentId: string | undefined;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    passports: PassportDto[] | undefined;
    phoneNumbers: PassengerPhoneNumberDto[] | undefined;
    emails: PassengerEmailDto[] | undefined;
}

export class UpdatePassengerTagDto implements IUpdatePassengerTagDto {
    id: string;
    passengerId: string;
    tagId: string | undefined;
    tag: TagDto;

    constructor(data?: IUpdatePassengerTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.passengerId = _data["passengerId"];
            this.tagId = _data["tagId"];
            this.tag = _data["tag"] ? TagDto.fromJS(_data["tag"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdatePassengerTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePassengerTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["passengerId"] = this.passengerId;
        data["tagId"] = this.tagId;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined as any;
        return data;
    }

    clone(): UpdatePassengerTagDto {
        const json = this.toJSON();
        let result = new UpdatePassengerTagDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePassengerTagDto {
    id: string;
    passengerId: string;
    tagId: string | undefined;
    tag: TagDto;
}

export class UpdateProcessedDocumentDto implements IUpdateProcessedDocumentDto {
    id: string;
    typeId: string | undefined;
    note: string | undefined;

    constructor(data?: IUpdateProcessedDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateProcessedDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcessedDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateProcessedDocumentDto {
        const json = this.toJSON();
        let result = new UpdateProcessedDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProcessedDocumentDto {
    id: string;
    typeId: string | undefined;
    note: string | undefined;
}

export class UpdateProcessedPackageAddOnDto implements IUpdateProcessedPackageAddOnDto {
    id: string;
    typeId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;

    constructor(data?: IUpdateProcessedPackageAddOnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.note = _data["note"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): UpdateProcessedPackageAddOnDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcessedPackageAddOnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["note"] = this.note;
        data["price"] = this.price;
        return data;
    }

    clone(): UpdateProcessedPackageAddOnDto {
        const json = this.toJSON();
        let result = new UpdateProcessedPackageAddOnDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProcessedPackageAddOnDto {
    id: string;
    typeId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    note: string | undefined;
    price: number | undefined;
}

export class UpdateProcessedPackageDto implements IUpdateProcessedPackageDto {
    id: string;
    typeId: string | undefined;
    isVisaRequired: boolean;
    packageId: string | undefined;
    agentId: string | undefined;
    resaAgentId: number | undefined;
    salesAgentId: number | undefined;
    packageTravelId: string | undefined;
    note: string | undefined;
    manualTravelDate: moment.Moment | undefined;
    manualPackageTitle: string | undefined;
    willAvailTravelInsurance: boolean;
    createAddOns: CreateProcessedPackageAddOnDto[] | undefined;
    updateAddOns: UpdateProcessedPackageAddOnDto[] | undefined;
    deleteAddOns: string[] | undefined;
    createAssignedRooms: CreateProcessedPackageRoomDto[] | undefined;
    deleteAssignedRooms: string[] | undefined;

    constructor(data?: IUpdateProcessedPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.isVisaRequired = _data["isVisaRequired"];
            this.packageId = _data["packageId"];
            this.agentId = _data["agentId"];
            this.resaAgentId = _data["resaAgentId"];
            this.salesAgentId = _data["salesAgentId"];
            this.packageTravelId = _data["packageTravelId"];
            this.note = _data["note"];
            this.manualTravelDate = _data["manualTravelDate"] ? moment(_data["manualTravelDate"].toString()) : undefined as any;
            this.manualPackageTitle = _data["manualPackageTitle"];
            this.willAvailTravelInsurance = _data["willAvailTravelInsurance"];
            if (Array.isArray(_data["createAddOns"])) {
                this.createAddOns = [] as any;
                for (let item of _data["createAddOns"])
                    this.createAddOns.push(CreateProcessedPackageAddOnDto.fromJS(item));
            }
            if (Array.isArray(_data["updateAddOns"])) {
                this.updateAddOns = [] as any;
                for (let item of _data["updateAddOns"])
                    this.updateAddOns.push(UpdateProcessedPackageAddOnDto.fromJS(item));
            }
            if (Array.isArray(_data["deleteAddOns"])) {
                this.deleteAddOns = [] as any;
                for (let item of _data["deleteAddOns"])
                    this.deleteAddOns.push(item);
            }
            if (Array.isArray(_data["createAssignedRooms"])) {
                this.createAssignedRooms = [] as any;
                for (let item of _data["createAssignedRooms"])
                    this.createAssignedRooms.push(CreateProcessedPackageRoomDto.fromJS(item));
            }
            if (Array.isArray(_data["deleteAssignedRooms"])) {
                this.deleteAssignedRooms = [] as any;
                for (let item of _data["deleteAssignedRooms"])
                    this.deleteAssignedRooms.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProcessedPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcessedPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["isVisaRequired"] = this.isVisaRequired;
        data["packageId"] = this.packageId;
        data["agentId"] = this.agentId;
        data["resaAgentId"] = this.resaAgentId;
        data["salesAgentId"] = this.salesAgentId;
        data["packageTravelId"] = this.packageTravelId;
        data["note"] = this.note;
        data["manualTravelDate"] = this.manualTravelDate ? this.manualTravelDate.toISOString() : undefined as any;
        data["manualPackageTitle"] = this.manualPackageTitle;
        data["willAvailTravelInsurance"] = this.willAvailTravelInsurance;
        if (Array.isArray(this.createAddOns)) {
            data["createAddOns"] = [];
            for (let item of this.createAddOns)
                data["createAddOns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.updateAddOns)) {
            data["updateAddOns"] = [];
            for (let item of this.updateAddOns)
                data["updateAddOns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleteAddOns)) {
            data["deleteAddOns"] = [];
            for (let item of this.deleteAddOns)
                data["deleteAddOns"].push(item);
        }
        if (Array.isArray(this.createAssignedRooms)) {
            data["createAssignedRooms"] = [];
            for (let item of this.createAssignedRooms)
                data["createAssignedRooms"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleteAssignedRooms)) {
            data["deleteAssignedRooms"] = [];
            for (let item of this.deleteAssignedRooms)
                data["deleteAssignedRooms"].push(item);
        }
        return data;
    }

    clone(): UpdateProcessedPackageDto {
        const json = this.toJSON();
        let result = new UpdateProcessedPackageDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProcessedPackageDto {
    id: string;
    typeId: string | undefined;
    isVisaRequired: boolean;
    packageId: string | undefined;
    agentId: string | undefined;
    resaAgentId: number | undefined;
    salesAgentId: number | undefined;
    packageTravelId: string | undefined;
    note: string | undefined;
    manualTravelDate: moment.Moment | undefined;
    manualPackageTitle: string | undefined;
    willAvailTravelInsurance: boolean;
    createAddOns: CreateProcessedPackageAddOnDto[] | undefined;
    updateAddOns: UpdateProcessedPackageAddOnDto[] | undefined;
    deleteAddOns: string[] | undefined;
    createAssignedRooms: CreateProcessedPackageRoomDto[] | undefined;
    deleteAssignedRooms: string[] | undefined;
}

export class UpdateProcessedTicketDto implements IUpdateProcessedTicketDto {
    id: string;
    typeId: string | undefined;
    adultCount: number;
    childCount: number;
    infantCount: number;
    note: string | undefined;
    createFlights: CreateProcessedTicketFlightDto[] | undefined;
    deleteFlights: string[] | undefined;
    createRates: CreateProcessedTicketRateDto[] | undefined;
    deleteRates: string[] | undefined;

    constructor(data?: IUpdateProcessedTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.adultCount = _data["adultCount"];
            this.childCount = _data["childCount"];
            this.infantCount = _data["infantCount"];
            this.note = _data["note"];
            if (Array.isArray(_data["createFlights"])) {
                this.createFlights = [] as any;
                for (let item of _data["createFlights"])
                    this.createFlights.push(CreateProcessedTicketFlightDto.fromJS(item));
            }
            if (Array.isArray(_data["deleteFlights"])) {
                this.deleteFlights = [] as any;
                for (let item of _data["deleteFlights"])
                    this.deleteFlights.push(item);
            }
            if (Array.isArray(_data["createRates"])) {
                this.createRates = [] as any;
                for (let item of _data["createRates"])
                    this.createRates.push(CreateProcessedTicketRateDto.fromJS(item));
            }
            if (Array.isArray(_data["deleteRates"])) {
                this.deleteRates = [] as any;
                for (let item of _data["deleteRates"])
                    this.deleteRates.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProcessedTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcessedTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["adultCount"] = this.adultCount;
        data["childCount"] = this.childCount;
        data["infantCount"] = this.infantCount;
        data["note"] = this.note;
        if (Array.isArray(this.createFlights)) {
            data["createFlights"] = [];
            for (let item of this.createFlights)
                data["createFlights"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleteFlights)) {
            data["deleteFlights"] = [];
            for (let item of this.deleteFlights)
                data["deleteFlights"].push(item);
        }
        if (Array.isArray(this.createRates)) {
            data["createRates"] = [];
            for (let item of this.createRates)
                data["createRates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleteRates)) {
            data["deleteRates"] = [];
            for (let item of this.deleteRates)
                data["deleteRates"].push(item);
        }
        return data;
    }

    clone(): UpdateProcessedTicketDto {
        const json = this.toJSON();
        let result = new UpdateProcessedTicketDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProcessedTicketDto {
    id: string;
    typeId: string | undefined;
    adultCount: number;
    childCount: number;
    infantCount: number;
    note: string | undefined;
    createFlights: CreateProcessedTicketFlightDto[] | undefined;
    deleteFlights: string[] | undefined;
    createRates: CreateProcessedTicketRateDto[] | undefined;
    deleteRates: string[] | undefined;
}

export class UpdateProcessedVisaDto implements IUpdateProcessedVisaDto {
    id: string;
    typeId: string | undefined;
    statusId: string | undefined;
    embassyId: string | undefined;
    createRequirements: CreateProcessedVisaRequirementDto[] | undefined;
    updateRequirements: UpdateProcessedVisaRequirementDto[] | undefined;
    deleteRequirements: string[] | undefined;
    createStatusAttachments: CreateProcessedVisaStatusDto[] | undefined;
    deleteStatusAttachments: string[] | undefined;
    note: string | undefined;

    constructor(data?: IUpdateProcessedVisaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.embassyId = _data["embassyId"];
            if (Array.isArray(_data["createRequirements"])) {
                this.createRequirements = [] as any;
                for (let item of _data["createRequirements"])
                    this.createRequirements.push(CreateProcessedVisaRequirementDto.fromJS(item));
            }
            if (Array.isArray(_data["updateRequirements"])) {
                this.updateRequirements = [] as any;
                for (let item of _data["updateRequirements"])
                    this.updateRequirements.push(UpdateProcessedVisaRequirementDto.fromJS(item));
            }
            if (Array.isArray(_data["deleteRequirements"])) {
                this.deleteRequirements = [] as any;
                for (let item of _data["deleteRequirements"])
                    this.deleteRequirements.push(item);
            }
            if (Array.isArray(_data["createStatusAttachments"])) {
                this.createStatusAttachments = [] as any;
                for (let item of _data["createStatusAttachments"])
                    this.createStatusAttachments.push(CreateProcessedVisaStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["deleteStatusAttachments"])) {
                this.deleteStatusAttachments = [] as any;
                for (let item of _data["deleteStatusAttachments"])
                    this.deleteStatusAttachments.push(item);
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateProcessedVisaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcessedVisaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["embassyId"] = this.embassyId;
        if (Array.isArray(this.createRequirements)) {
            data["createRequirements"] = [];
            for (let item of this.createRequirements)
                data["createRequirements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.updateRequirements)) {
            data["updateRequirements"] = [];
            for (let item of this.updateRequirements)
                data["updateRequirements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleteRequirements)) {
            data["deleteRequirements"] = [];
            for (let item of this.deleteRequirements)
                data["deleteRequirements"].push(item);
        }
        if (Array.isArray(this.createStatusAttachments)) {
            data["createStatusAttachments"] = [];
            for (let item of this.createStatusAttachments)
                data["createStatusAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleteStatusAttachments)) {
            data["deleteStatusAttachments"] = [];
            for (let item of this.deleteStatusAttachments)
                data["deleteStatusAttachments"].push(item);
        }
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateProcessedVisaDto {
        const json = this.toJSON();
        let result = new UpdateProcessedVisaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProcessedVisaDto {
    id: string;
    typeId: string | undefined;
    statusId: string | undefined;
    embassyId: string | undefined;
    createRequirements: CreateProcessedVisaRequirementDto[] | undefined;
    updateRequirements: UpdateProcessedVisaRequirementDto[] | undefined;
    deleteRequirements: string[] | undefined;
    createStatusAttachments: CreateProcessedVisaStatusDto[] | undefined;
    deleteStatusAttachments: string[] | undefined;
    note: string | undefined;
}

export class UpdateProcessedVisaRequirementDto implements IUpdateProcessedVisaRequirementDto {
    id: string;
    typeId: string | undefined;
    isFulfilled: boolean;
    passengerId: string | undefined;
    attachments: CreateProcessedVisaRequirementAttachmentDto[] | undefined;

    constructor(data?: IUpdateProcessedVisaRequirementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.isFulfilled = _data["isFulfilled"];
            this.passengerId = _data["passengerId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(CreateProcessedVisaRequirementAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateProcessedVisaRequirementDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcessedVisaRequirementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["isFulfilled"] = this.isFulfilled;
        data["passengerId"] = this.passengerId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateProcessedVisaRequirementDto {
        const json = this.toJSON();
        let result = new UpdateProcessedVisaRequirementDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProcessedVisaRequirementDto {
    id: string;
    typeId: string | undefined;
    isFulfilled: boolean;
    passengerId: string | undefined;
    attachments: CreateProcessedVisaRequirementAttachmentDto[] | undefined;
}

export class UpdatePurchaseOrderDto implements IUpdatePurchaseOrderDto {
    id: string;
    bookingId: string;
    bookingRef: string | undefined;
    statusId: string;
    paymentStatusId: string;
    supplierId: string;
    embassyFeeId: string | undefined;
    paymentDue: moment.Moment | undefined;
    totalAmount: number;
    phpToUsdRate: number;
    purchaseOrderNumber: string | undefined;
    note: string | undefined;
    handlerName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    particulars: PurchaseOrderParticularDto[] | undefined;
    receipts: PurchaseOrderReceiptDto[] | undefined;

    constructor(data?: IUpdatePurchaseOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bookingId = _data["bookingId"];
            this.bookingRef = _data["bookingRef"];
            this.statusId = _data["statusId"];
            this.paymentStatusId = _data["paymentStatusId"];
            this.supplierId = _data["supplierId"];
            this.embassyFeeId = _data["embassyFeeId"];
            this.paymentDue = _data["paymentDue"] ? moment(_data["paymentDue"].toString()) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.phpToUsdRate = _data["phpToUsdRate"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.note = _data["note"];
            this.handlerName = _data["handlerName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["particulars"])) {
                this.particulars = [] as any;
                for (let item of _data["particulars"])
                    this.particulars.push(PurchaseOrderParticularDto.fromJS(item));
            }
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts.push(PurchaseOrderReceiptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePurchaseOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookingId"] = this.bookingId;
        data["bookingRef"] = this.bookingRef;
        data["statusId"] = this.statusId;
        data["paymentStatusId"] = this.paymentStatusId;
        data["supplierId"] = this.supplierId;
        data["embassyFeeId"] = this.embassyFeeId;
        data["paymentDue"] = this.paymentDue ? this.paymentDue.toISOString() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["phpToUsdRate"] = this.phpToUsdRate;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["note"] = this.note;
        data["handlerName"] = this.handlerName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.particulars)) {
            data["particulars"] = [];
            for (let item of this.particulars)
                data["particulars"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdatePurchaseOrderDto {
        const json = this.toJSON();
        let result = new UpdatePurchaseOrderDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePurchaseOrderDto {
    id: string;
    bookingId: string;
    bookingRef: string | undefined;
    statusId: string;
    paymentStatusId: string;
    supplierId: string;
    embassyFeeId: string | undefined;
    paymentDue: moment.Moment | undefined;
    totalAmount: number;
    phpToUsdRate: number;
    purchaseOrderNumber: string | undefined;
    note: string | undefined;
    handlerName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    particulars: PurchaseOrderParticularDto[] | undefined;
    receipts: PurchaseOrderReceiptDto[] | undefined;
}

export class UpdateStatementNumberInput implements IUpdateStatementNumberInput {
    id: string;
    statementNumber: string;

    constructor(data?: IUpdateStatementNumberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statementNumber = _data["statementNumber"];
        }
    }

    static fromJS(data: any): UpdateStatementNumberInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatementNumberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statementNumber"] = this.statementNumber;
        return data;
    }

    clone(): UpdateStatementNumberInput {
        const json = this.toJSON();
        let result = new UpdateStatementNumberInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateStatementNumberInput {
    id: string;
    statementNumber: string;
}

export class UpdateStatementOfAccountDto implements IUpdateStatementOfAccountDto {
    id: string;
    bookingId: string;
    statusId: string;
    agentId: string;
    bookingRef: string | undefined;
    paymentDue: moment.Moment | undefined;
    totalAmount: number;
    downPayment: number;
    phpToUsdRate: number;
    statementNumber: string | undefined;
    note: string | undefined;
    isInstallment: boolean;
    isBiPaymentTerm: boolean;
    parentStatementOfAccountId: string | undefined;
    updateChildStatementOfAccounts: boolean;
    particulars: StatementOfAccountParticularDto[] | undefined;
    installmentSchedules: CreateInstallmentSchedule[] | undefined;

    constructor(data?: IUpdateStatementOfAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bookingId = _data["bookingId"];
            this.statusId = _data["statusId"];
            this.agentId = _data["agentId"];
            this.bookingRef = _data["bookingRef"];
            this.paymentDue = _data["paymentDue"] ? moment(_data["paymentDue"].toString()) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.downPayment = _data["downPayment"];
            this.phpToUsdRate = _data["phpToUsdRate"];
            this.statementNumber = _data["statementNumber"];
            this.note = _data["note"];
            this.isInstallment = _data["isInstallment"];
            this.isBiPaymentTerm = _data["isBiPaymentTerm"];
            this.parentStatementOfAccountId = _data["parentStatementOfAccountId"];
            this.updateChildStatementOfAccounts = _data["updateChildStatementOfAccounts"];
            if (Array.isArray(_data["particulars"])) {
                this.particulars = [] as any;
                for (let item of _data["particulars"])
                    this.particulars.push(StatementOfAccountParticularDto.fromJS(item));
            }
            if (Array.isArray(_data["installmentSchedules"])) {
                this.installmentSchedules = [] as any;
                for (let item of _data["installmentSchedules"])
                    this.installmentSchedules.push(CreateInstallmentSchedule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateStatementOfAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatementOfAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookingId"] = this.bookingId;
        data["statusId"] = this.statusId;
        data["agentId"] = this.agentId;
        data["bookingRef"] = this.bookingRef;
        data["paymentDue"] = this.paymentDue ? this.paymentDue.toISOString() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["downPayment"] = this.downPayment;
        data["phpToUsdRate"] = this.phpToUsdRate;
        data["statementNumber"] = this.statementNumber;
        data["note"] = this.note;
        data["isInstallment"] = this.isInstallment;
        data["isBiPaymentTerm"] = this.isBiPaymentTerm;
        data["parentStatementOfAccountId"] = this.parentStatementOfAccountId;
        data["updateChildStatementOfAccounts"] = this.updateChildStatementOfAccounts;
        if (Array.isArray(this.particulars)) {
            data["particulars"] = [];
            for (let item of this.particulars)
                data["particulars"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.installmentSchedules)) {
            data["installmentSchedules"] = [];
            for (let item of this.installmentSchedules)
                data["installmentSchedules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateStatementOfAccountDto {
        const json = this.toJSON();
        let result = new UpdateStatementOfAccountDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateStatementOfAccountDto {
    id: string;
    bookingId: string;
    statusId: string;
    agentId: string;
    bookingRef: string | undefined;
    paymentDue: moment.Moment | undefined;
    totalAmount: number;
    downPayment: number;
    phpToUsdRate: number;
    statementNumber: string | undefined;
    note: string | undefined;
    isInstallment: boolean;
    isBiPaymentTerm: boolean;
    parentStatementOfAccountId: string | undefined;
    updateChildStatementOfAccounts: boolean;
    particulars: StatementOfAccountParticularDto[] | undefined;
    installmentSchedules: CreateInstallmentSchedule[] | undefined;
}

export class UpdateSupplierDto implements IUpdateSupplierDto {
    id: string;
    supplierTypeId: string | undefined;
    name: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    profilePictureDocumentId: string | undefined;
    coverPhotoDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    phoneNumbers: SupplierPhoneNumberDto[] | undefined;
    emails: SupplierEmailDto[] | undefined;
    createSupplierRateAttachments: CreateSupplierRateAttachmentDto[] | undefined;
    deleteSupplierRateAttachments: string[] | undefined;

    constructor(data?: IUpdateSupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supplierTypeId = _data["supplierTypeId"];
            this.name = _data["name"];
            this.contactPerson = _data["contactPerson"];
            this.designation = _data["designation"];
            this.note = _data["note"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.profilePictureDocumentUrl = _data["profilePictureDocumentUrl"];
            this.coverPhotoDocumentUrl = _data["coverPhotoDocumentUrl"];
            this.coverPhoto = _data["coverPhoto"] ? FileDto.fromJS(_data["coverPhoto"]) : undefined as any;
            this.profilePhoto = _data["profilePhoto"] ? FileDto.fromJS(_data["profilePhoto"]) : undefined as any;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(SupplierPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(SupplierEmailDto.fromJS(item));
            }
            if (Array.isArray(_data["createSupplierRateAttachments"])) {
                this.createSupplierRateAttachments = [] as any;
                for (let item of _data["createSupplierRateAttachments"])
                    this.createSupplierRateAttachments.push(CreateSupplierRateAttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["deleteSupplierRateAttachments"])) {
                this.deleteSupplierRateAttachments = [] as any;
                for (let item of _data["deleteSupplierRateAttachments"])
                    this.deleteSupplierRateAttachments.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierTypeId"] = this.supplierTypeId;
        data["name"] = this.name;
        data["contactPerson"] = this.contactPerson;
        data["designation"] = this.designation;
        data["note"] = this.note;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["profilePictureDocumentUrl"] = this.profilePictureDocumentUrl;
        data["coverPhotoDocumentUrl"] = this.coverPhotoDocumentUrl;
        data["coverPhoto"] = this.coverPhoto ? this.coverPhoto.toJSON() : undefined as any;
        data["profilePhoto"] = this.profilePhoto ? this.profilePhoto.toJSON() : undefined as any;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.createSupplierRateAttachments)) {
            data["createSupplierRateAttachments"] = [];
            for (let item of this.createSupplierRateAttachments)
                data["createSupplierRateAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleteSupplierRateAttachments)) {
            data["deleteSupplierRateAttachments"] = [];
            for (let item of this.deleteSupplierRateAttachments)
                data["deleteSupplierRateAttachments"].push(item);
        }
        return data;
    }

    clone(): UpdateSupplierDto {
        const json = this.toJSON();
        let result = new UpdateSupplierDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSupplierDto {
    id: string;
    supplierTypeId: string | undefined;
    name: string | undefined;
    contactPerson: string | undefined;
    designation: string | undefined;
    note: string | undefined;
    status: Status;
    isActive: boolean;
    profilePictureDocumentId: string | undefined;
    coverPhotoDocumentId: string | undefined;
    profilePictureDocumentUrl: string | undefined;
    coverPhotoDocumentUrl: string | undefined;
    coverPhoto: FileDto;
    profilePhoto: FileDto;
    phoneNumbers: SupplierPhoneNumberDto[] | undefined;
    emails: SupplierEmailDto[] | undefined;
    createSupplierRateAttachments: CreateSupplierRateAttachmentDto[] | undefined;
    deleteSupplierRateAttachments: string[] | undefined;
}

export class UpdateTourInquiryStatusDto implements IUpdateTourInquiryStatusDto {
    id: string;
    status: TourInquiryStatus;
    adminNote: string | undefined;

    constructor(data?: IUpdateTourInquiryStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.adminNote = _data["adminNote"];
        }
    }

    static fromJS(data: any): UpdateTourInquiryStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTourInquiryStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["adminNote"] = this.adminNote;
        return data;
    }

    clone(): UpdateTourInquiryStatusDto {
        const json = this.toJSON();
        let result = new UpdateTourInquiryStatusDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTourInquiryStatusDto {
    id: string;
    status: TourInquiryStatus;
    adminNote: string | undefined;
}

export class User implements IUser {
    id: number;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    isActive: boolean;
    fullName: string | undefined;
    notes: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    company: string | undefined;
    title: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    phoneNumber: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    isPhoneNumberConfirmed: boolean;
    gender: string | undefined;
    profilePictureDocumentId: string | undefined;
    profilePictureDocument: Document;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocument: Document;
    supplierId: string | undefined;
    supplier: Supplier;
    agentId: string | undefined;
    agent: Agent;
    themeSettings: string | undefined;
    phoneNumbers: PhoneNumber[] | undefined;
    emails: UserEmail[] | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : undefined as any;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : undefined as any;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : undefined as any;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : undefined as any;
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.notes = _data["notes"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            this.company = _data["company"];
            this.title = _data["title"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : undefined as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.phoneNumber = _data["phoneNumber"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.zipOrPostCode = _data["zipOrPostCode"];
            this.stateOrProvince = _data["stateOrProvince"];
            this.country = _data["country"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.gender = _data["gender"];
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.profilePictureDocument = _data["profilePictureDocument"] ? Document.fromJS(_data["profilePictureDocument"]) : undefined as any;
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.coverPhotoDocument = _data["coverPhotoDocument"] ? Document.fromJS(_data["coverPhotoDocument"]) : undefined as any;
            this.supplierId = _data["supplierId"];
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : undefined as any;
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            this.themeSettings = _data["themeSettings"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(PhoneNumber.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(UserEmail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : undefined as any;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item ? item.toJSON() : undefined as any);
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item ? item.toJSON() : undefined as any);
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : undefined as any;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["notes"] = this.notes;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["company"] = this.company;
        data["title"] = this.title;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["phoneNumber"] = this.phoneNumber;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["zipOrPostCode"] = this.zipOrPostCode;
        data["stateOrProvince"] = this.stateOrProvince;
        data["country"] = this.country;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["gender"] = this.gender;
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["profilePictureDocument"] = this.profilePictureDocument ? this.profilePictureDocument.toJSON() : undefined as any;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["coverPhotoDocument"] = this.coverPhotoDocument ? this.coverPhotoDocument.toJSON() : undefined as any;
        data["supplierId"] = this.supplierId;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["themeSettings"] = this.themeSettings;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id: number;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    isActive: boolean;
    fullName: string | undefined;
    notes: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    company: string | undefined;
    title: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    phoneNumber: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    isPhoneNumberConfirmed: boolean;
    gender: string | undefined;
    profilePictureDocumentId: string | undefined;
    profilePictureDocument: Document;
    coverPhotoDocumentId: string | undefined;
    coverPhotoDocument: Document;
    supplierId: string | undefined;
    supplier: Supplier;
    agentId: string | undefined;
    agent: Agent;
    themeSettings: string | undefined;
    phoneNumbers: PhoneNumber[] | undefined;
    emails: UserEmail[] | undefined;
}

export class UserClaim implements IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
}

export class UserDto implements IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    title: string | undefined;
    company: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    gender: string | undefined;
    notes: string | undefined;
    tags: string | undefined;
    avatar: string | undefined;
    background: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    roleNames: string[] | undefined;
    roleDisplayNames: string[] | undefined;
    profilePictureDocumentId: string | undefined;
    coverPhotoDocumentId: string | undefined;
    profilePictureDocument: DocumentDto;
    coverPhotoDocument: DocumentDto;
    updateCoverPhoto: FileDto;
    updateProfilePhoto: FileDto;
    phoneNumbers: PhoneNumberDto[] | undefined;
    emails: UserEmailDto[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : undefined as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.title = _data["title"];
            this.company = _data["company"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.zipOrPostCode = _data["zipOrPostCode"];
            this.stateOrProvince = _data["stateOrProvince"];
            this.country = _data["country"];
            this.gender = _data["gender"];
            this.notes = _data["notes"];
            this.tags = _data["tags"];
            this.avatar = _data["avatar"];
            this.background = _data["background"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : undefined as any;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            if (Array.isArray(_data["roleDisplayNames"])) {
                this.roleDisplayNames = [] as any;
                for (let item of _data["roleDisplayNames"])
                    this.roleDisplayNames.push(item);
            }
            this.profilePictureDocumentId = _data["profilePictureDocumentId"];
            this.coverPhotoDocumentId = _data["coverPhotoDocumentId"];
            this.profilePictureDocument = _data["profilePictureDocument"] ? DocumentDto.fromJS(_data["profilePictureDocument"]) : undefined as any;
            this.coverPhotoDocument = _data["coverPhotoDocument"] ? DocumentDto.fromJS(_data["coverPhotoDocument"]) : undefined as any;
            this.updateCoverPhoto = _data["updateCoverPhoto"] ? FileDto.fromJS(_data["updateCoverPhoto"]) : undefined as any;
            this.updateProfilePhoto = _data["updateProfilePhoto"] ? FileDto.fromJS(_data["updateProfilePhoto"]) : undefined as any;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(PhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(UserEmailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["title"] = this.title;
        data["company"] = this.company;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["zipOrPostCode"] = this.zipOrPostCode;
        data["stateOrProvince"] = this.stateOrProvince;
        data["country"] = this.country;
        data["gender"] = this.gender;
        data["notes"] = this.notes;
        data["tags"] = this.tags;
        data["avatar"] = this.avatar;
        data["background"] = this.background;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.roleDisplayNames)) {
            data["roleDisplayNames"] = [];
            for (let item of this.roleDisplayNames)
                data["roleDisplayNames"].push(item);
        }
        data["profilePictureDocumentId"] = this.profilePictureDocumentId;
        data["coverPhotoDocumentId"] = this.coverPhotoDocumentId;
        data["profilePictureDocument"] = this.profilePictureDocument ? this.profilePictureDocument.toJSON() : undefined as any;
        data["coverPhotoDocument"] = this.coverPhotoDocument ? this.coverPhotoDocument.toJSON() : undefined as any;
        data["updateCoverPhoto"] = this.updateCoverPhoto ? this.updateCoverPhoto.toJSON() : undefined as any;
        data["updateProfilePhoto"] = this.updateProfilePhoto ? this.updateProfilePhoto.toJSON() : undefined as any;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    title: string | undefined;
    company: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: string | undefined;
    zipOrPostCode: string | undefined;
    stateOrProvince: string | undefined;
    country: string | undefined;
    gender: string | undefined;
    notes: string | undefined;
    tags: string | undefined;
    avatar: string | undefined;
    background: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    roleNames: string[] | undefined;
    roleDisplayNames: string[] | undefined;
    profilePictureDocumentId: string | undefined;
    coverPhotoDocumentId: string | undefined;
    profilePictureDocument: DocumentDto;
    coverPhotoDocument: DocumentDto;
    updateCoverPhoto: FileDto;
    updateProfilePhoto: FileDto;
    phoneNumbers: PhoneNumberDto[] | undefined;
    emails: UserEmailDto[] | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserEmail implements IUserEmail {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    email: string | undefined;
    note: string | undefined;
    userId: number;
    isActive: boolean;
    isPrimary: boolean;
    user: User;

    constructor(data?: IUserEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined as any;
            this.email = _data["email"];
            this.note = _data["note"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserEmail {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined as any;
        data["email"] = this.email;
        data["note"] = this.note;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }

    clone(): UserEmail {
        const json = this.toJSON();
        let result = new UserEmail();
        result.init(json);
        return result;
    }
}

export interface IUserEmail {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    email: string | undefined;
    note: string | undefined;
    userId: number;
    isActive: boolean;
    isPrimary: boolean;
    user: User;
}

export class UserEmailDto implements IUserEmailDto {
    id: string;
    email: string | undefined;
    note: string | undefined;
    userId: number;
    isActive: boolean;
    isPrimary: boolean;

    constructor(data?: IUserEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.note = _data["note"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): UserEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["note"] = this.note;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["isPrimary"] = this.isPrimary;
        return data;
    }

    clone(): UserEmailDto {
        const json = this.toJSON();
        let result = new UserEmailDto();
        result.init(json);
        return result;
    }
}

export interface IUserEmailDto {
    id: string;
    email: string | undefined;
    note: string | undefined;
    userId: number;
    isActive: boolean;
    isPrimary: boolean;
}

export class UserInfoDto implements IUserInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    role: string | undefined;
    token: string | undefined;

    constructor(data?: IUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["role"] = this.role;
        data["token"] = this.token;
        return data;
    }

    clone(): UserInfoDto {
        const json = this.toJSON();
        let result = new UserInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    role: string | undefined;
    token: string | undefined;
}

export class UserLogin implements IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    avatar: string | undefined;
    background: string | undefined;
    status: string | undefined;
    roles: string[] | undefined;
    themeSettings: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.avatar = _data["avatar"];
            this.background = _data["background"];
            this.status = _data["status"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
            this.themeSettings = _data["themeSettings"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["avatar"] = this.avatar;
        data["background"] = this.background;
        data["status"] = this.status;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["themeSettings"] = this.themeSettings;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    avatar: string | undefined;
    background: string | undefined;
    status: string | undefined;
    roles: string[] | undefined;
    themeSettings: string | undefined;
}

export class UserMinDto implements IUserMinDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;

    constructor(data?: IUserMinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
        }
    }

    static fromJS(data: any): UserMinDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserMinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        return data;
    }

    clone(): UserMinDto {
        const json = this.toJSON();
        let result = new UserMinDto();
        result.init(json);
        return result;
    }
}

export interface IUserMinDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;
}

export class UserRole implements IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;
}

export class UserToken implements IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : undefined as any;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
}

export class VerifyPaymentReceiptDto implements IVerifyPaymentReceiptDto {
    id: string;
    status: CustomerPaymentReceiptStatus;
    notes: string | undefined;
    rejectionReason: string | undefined;

    constructor(data?: IVerifyPaymentReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.rejectionReason = _data["rejectionReason"];
        }
    }

    static fromJS(data: any): VerifyPaymentReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPaymentReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["rejectionReason"] = this.rejectionReason;
        return data;
    }

    clone(): VerifyPaymentReceiptDto {
        const json = this.toJSON();
        let result = new VerifyPaymentReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IVerifyPaymentReceiptDto {
    id: string;
    status: CustomerPaymentReceiptStatus;
    notes: string | undefined;
    rejectionReason: string | undefined;
}

export class VisaRequirementsDto implements IVisaRequirementsDto {
    requirements: MinProcessedVisaRequirementDto[] | undefined;
    requirementOptions: AppSettingOptionDto[] | undefined;

    constructor(data?: IVisaRequirementsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements.push(MinProcessedVisaRequirementDto.fromJS(item));
            }
            if (Array.isArray(_data["requirementOptions"])) {
                this.requirementOptions = [] as any;
                for (let item of _data["requirementOptions"])
                    this.requirementOptions.push(AppSettingOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VisaRequirementsDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisaRequirementsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.requirementOptions)) {
            data["requirementOptions"] = [];
            for (let item of this.requirementOptions)
                data["requirementOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): VisaRequirementsDto {
        const json = this.toJSON();
        let result = new VisaRequirementsDto();
        result.init(json);
        return result;
    }
}

export interface IVisaRequirementsDto {
    requirements: MinProcessedVisaRequirementDto[] | undefined;
    requirementOptions: AppSettingOptionDto[] | undefined;
}

export class WeekDataDto implements IWeekDataDto {
    new: number;
    completed: number;
    cancelled: number;

    constructor(data?: IWeekDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.new = _data["new"];
            this.completed = _data["completed"];
            this.cancelled = _data["cancelled"];
        }
    }

    static fromJS(data: any): WeekDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeekDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["new"] = this.new;
        data["completed"] = this.completed;
        data["cancelled"] = this.cancelled;
        return data;
    }

    clone(): WeekDataDto {
        const json = this.toJSON();
        let result = new WeekDataDto();
        result.init(json);
        return result;
    }
}

export interface IWeekDataDto {
    new: number;
    completed: number;
    cancelled: number;
}

export class WithdrawStayCancellationRequestInput implements IWithdrawStayCancellationRequestInput {
    email: string | undefined;

    constructor(data?: IWithdrawStayCancellationRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): WithdrawStayCancellationRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawStayCancellationRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }

    clone(): WithdrawStayCancellationRequestInput {
        const json = this.toJSON();
        let result = new WithdrawStayCancellationRequestInput();
        result.init(json);
        return result;
    }
}

export interface IWithdrawStayCancellationRequestInput {
    email: string | undefined;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}